import * as i0 from '@angular/core';
import { Directive, Input, HostBinding, Component } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import * as i1 from '@angular/platform-browser';

;
const sizeMap = {
    small: 16,
    medium: 32,
    large: 64
};
function closestNaturalHeight(naturalHeights, height) {
    return naturalHeights
        .map(naturalHeight => parseInt(naturalHeight, 10))
        .reduce((acc, naturalHeight) => (naturalHeight <= height ? naturalHeight : acc), parseInt(naturalHeights[0], 10));
}
function toDOMString(data, size = 'medium', extraAttributes = {}) {
    const height = sizeMap[size];
    const naturalHeight = closestNaturalHeight(Object.keys(data), height);
    const { width, paths } = data[naturalHeight.toString()];
    const elWidth = height * (width / naturalHeight);
    return `<svg
    height="${height}px"
    width="${elWidth}px"
    ${Object.keys(extraAttributes).reduce((total, attr) => `${total} ${attr}="${extraAttributes[attr]}"`, '')}
  >
    ${paths.map(p => `<path d="${p}"></path>`)}
  </svg>`;
}

class OpOcticonComponentBase {
    get ariaHidden() {
        return !this.ariaLabel;
    }
    get focusable() {
        return this.tabIndex >= 0;
    }
    get style() {
        return {
            display: 'inline-block',
            'user-select': 'none',
            'vertical-align': this.verticalAlign,
            overflow: 'visible'
        };
    }
    ;
    get viewBox() {
        return `0 0 ${this.naturalWidth} ${this.naturalHeight}`;
    }
    get naturalHeight() {
        return closestNaturalHeight(Object.keys(this.SVGData), this.height);
    }
    get height() {
        return sizeMap[this.size];
    }
    get naturalWidth() {
        return this.SVGData[this.naturalHeight].width;
    }
    get width() {
        return this.height * (this.naturalWidth / this.naturalHeight);
    }
    get paths() {
        return this.SVGData[this.naturalHeight].paths;
    }
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.size = 'medium';
        this.verticalAlign = 'text-bottom';
        this.title = '';
        this.role = 'img';
        this.fill = 'currentColor';
        this.id = '';
        this.tabIndex = -1;
        this.ariaLabel = '';
        this.arialabelledby = '';
        this.baseClassName = true;
        this.SVGData = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpOcticonComponentBase, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.4", type: OpOcticonComponentBase, inputs: { size: "size", verticalAlign: "verticalAlign", title: "title", fill: "fill", id: "id", tabIndex: "tabIndex", ariaLabel: ["aria-label", "ariaLabel"], arialabelledby: ["aria-labelledby", "arialabelledby"] }, host: { properties: { "attr.role": "this.role", "attr.fill": "this.fill", "attr.id": "this.id", "attr.tabindex": "this.tabIndex", "attr.aria-label": "this.ariaLabel", "attr.aria-labelledby": "this.arialabelledby", "class.octicon": "this.baseClassName", "attr.aria-hidden": "this.ariaHidden", "attr.focusable": "this.focusable", "style": "this.style", "attr.viewBox": "this.viewBox", "attr.height": "this.height", "attr.width": "this.width" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpOcticonComponentBase, decorators: [{
            type: Directive,
            args: [{}]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; }, propDecorators: { size: [{
                type: Input
            }], verticalAlign: [{
                type: Input
            }], title: [{
                type: Input
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], fill: [{
                type: HostBinding,
                args: ['attr.fill']
            }, {
                type: Input
            }], id: [{
                type: HostBinding,
                args: ['attr.id']
            }, {
                type: Input
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }, {
                type: Input
            }], ariaLabel: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }, {
                type: Input,
                args: ['aria-label']
            }], arialabelledby: [{
                type: HostBinding,
                args: ['attr.aria-labelledby']
            }, {
                type: Input,
                args: ['aria-labelledby']
            }], baseClassName: [{
                type: HostBinding,
                args: ['class.octicon']
            }], ariaHidden: [{
                type: HostBinding,
                args: ['attr.aria-hidden']
            }], focusable: [{
                type: HostBinding,
                args: ['attr.focusable']
            }], style: [{
                type: HostBinding,
                args: ['style']
            }], viewBox: [{
                type: HostBinding,
                args: ['attr.viewBox']
            }], height: [{
                type: HostBinding,
                args: ['attr.height']
            }], width: [{
                type: HostBinding,
                args: ['attr.width']
            }] } });

/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
const accessibilityIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.923 5.302c.063.063.122.129.178.198H14A.75.75 0 0 1 14 7h-3.3l.578 5.163.362 2.997a.75.75 0 0 1-1.49.18L9.868 13H6.132l-.282 2.34a.75.75 0 0 1-1.49-.18l.362-2.997L5.3 7H2a.75.75 0 0 1 0-1.5h3.9a2.54 2.54 0 0 1 .176-.198 3 3 0 1 1 3.847 0ZM9.2 7.073h-.001a1.206 1.206 0 0 0-2.398 0L6.305 11.5h3.39ZM9.5 3a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 3Z"]
    }
};
class AccessibilityIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = accessibilityIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AccessibilityIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: AccessibilityIconComponent, isStandalone: true, selector: "svg[accessibility-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AccessibilityIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[accessibility-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const accessibilityInsetIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm2 4a2 2 0 1 0-2.95 1.76 1.87 1.87 0 0 0-.32.24H3.75a.75.75 0 0 0 0 1.5h2.363l-.607 5.67a.75.75 0 1 0 1.49.16l.25-2.33h1.508l.25 2.33a.75.75 0 0 0 1.492-.16L9.888 7.5h2.362a.75.75 0 0 0 0-1.5H9.27a1.98 1.98 0 0 0-.32-.24A2 2 0 0 0 10 4Z"]
    }
};
class AccessibilityInsetIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = accessibilityInsetIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AccessibilityInsetIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: AccessibilityInsetIconComponent, isStandalone: true, selector: "svg[accessibility-inset-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AccessibilityInsetIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[accessibility-inset-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const alertIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575Zm1.763.707a.25.25 0 0 0-.44 0L1.698 13.132a.25.25 0 0 0 .22.368h12.164a.25.25 0 0 0 .22-.368Zm.53 3.996v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M13 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.25-8.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z", "M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752Zm3.03.751a1.002 1.002 0 0 0-1.732 0L2.168 19.499A1.002 1.002 0 0 0 3.034 21h17.932a1.002 1.002 0 0 0 .866-1.5L12.866 3.994Z"]
    }
};
class AlertIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = alertIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AlertIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: AlertIconComponent, isStandalone: true, selector: "svg[alert-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AlertIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[alert-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const alertFillIconData = {
    "12": {
        "width": 12,
        "paths": ["M4.855.708c.5-.896 1.79-.896 2.29 0l4.675 8.351a1.312 1.312 0 0 1-1.146 1.954H1.33A1.313 1.313 0 0 1 .183 9.058ZM7 7V3H5v4Zm-1 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"]
    },
    "16": {
        "width": 16,
        "paths": ["M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575ZM8 5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5A.75.75 0 0 0 8 5Zm1 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752ZM12 8.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 8.5Zm1 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"]
    }
};
class AlertFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = alertFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AlertFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: AlertFillIconComponent, isStandalone: true, selector: "svg[alert-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AlertFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[alert-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const appsIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 3.25c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0 1 5.75 7.5h-2.5A1.75 1.75 0 0 1 1.5 5.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 8.5 5.75Zm-7 7c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75ZM3.25 3a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5A.25.25 0 0 0 6 5.75v-2.5A.25.25 0 0 0 5.75 3Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm-7 7a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Z"]
    }
};
class AppsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = appsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AppsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: AppsIconComponent, isStandalone: true, selector: "svg[apps-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: AppsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[apps-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const archiveIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v1.5A1.75 1.75 0 0 1 14.25 6H1.75A1.75 1.75 0 0 1 0 4.25ZM1.75 7a.75.75 0 0 1 .75.75v5.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-5.5a.75.75 0 0 1 1.5 0v5.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25v-5.5A.75.75 0 0 1 1.75 7Zm0-4.5a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25ZM6.25 8h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2.75 2h18.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 21.25 9H2.75A1.75 1.75 0 0 1 1 7.25v-3.5C1 2.784 1.784 2 2.75 2Zm18.5 1.5H2.75a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25ZM2.75 10a.75.75 0 0 1 .75.75v9.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-9.5a.75.75 0 0 1 1.5 0v9.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-9.5a.75.75 0 0 1 .75-.75Z", "M9.75 11.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"]
    }
};
class ArchiveIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = archiveIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArchiveIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArchiveIconComponent, isStandalone: true, selector: "svg[archive-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArchiveIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[archive-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowBothIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.72 3.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L2.56 7h10.88l-2.22-2.22a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l2.22-2.22H2.56l2.22 2.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-3.5-3.5a.75.75 0 0 1 0-1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.78 5.97a.75.75 0 0 0-1.06 0l-5.25 5.25a.75.75 0 0 0 0 1.06l5.25 5.25a.75.75 0 0 0 1.06-1.06L3.81 12.5h16.38l-3.97 3.97a.75.75 0 1 0 1.06 1.06l5.25-5.25a.75.75 0 0 0 0-1.06l-5.25-5.25a.75.75 0 1 0-1.06 1.06L20.19 11H3.81l3.97-3.97a.75.75 0 0 0 0-1.06Z"]
    }
};
class ArrowBothIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowBothIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowBothIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowBothIconComponent, isStandalone: true, selector: "svg[arrow-both-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowBothIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-both-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowDownIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.03 8.22a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.47 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l2.97 2.97V3.75a.75.75 0 0 1 1.5 0v7.44l2.97-2.97a.75.75 0 0 1 1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.97 13.22a.75.75 0 0 1 1.06 0L11 18.19V3.75a.75.75 0 0 1 1.5 0v14.44l4.97-4.97a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-6.25 6.25a.75.75 0 0 1-1.06 0l-6.25-6.25a.75.75 0 0 1 0-1.06Z"]
    }
};
class ArrowDownIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowDownIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowDownIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowDownIconComponent, isStandalone: true, selector: "svg[arrow-down-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowDownIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-down-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowDownLeftIconData = {
    "16": {
        "width": 16,
        "paths": ["M11.78 4.22a.75.75 0 0 1 0 1.06l-5.26 5.26h4.2a.75.75 0 0 1 0 1.5H4.71a.75.75 0 0 1-.75-.75V5.28a.75.75 0 0 1 1.5 0v4.2l5.26-5.26a.75.75 0 0 1 1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.75 8.5a.75.75 0 0 1 .75.75v7.19L16.72 6.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L7.56 17.5h7.19a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75Z"]
    }
};
class ArrowDownLeftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowDownLeftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowDownLeftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowDownLeftIconComponent, isStandalone: true, selector: "svg[arrow-down-left-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowDownLeftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-down-left-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowDownRightIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.22 4.179a.75.75 0 0 1 1.06 0l5.26 5.26v-4.2a.75.75 0 0 1 1.5 0v6.01a.75.75 0 0 1-.75.75H5.28a.75.75 0 0 1 0-1.5h4.2L4.22 5.24a.75.75 0 0 1 0-1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M18.25 8.5a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h7.19L6.22 7.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L17.5 16.44V9.25a.75.75 0 0 1 .75-.75Z"]
    }
};
class ArrowDownRightIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowDownRightIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowDownRightIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowDownRightIconComponent, isStandalone: true, selector: "svg[arrow-down-right-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowDownRightIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-down-right-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowLeftIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.78 12.53a.75.75 0 0 1-1.06 0L2.47 8.28a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L4.81 7h7.44a.75.75 0 0 1 0 1.5H4.81l2.97 2.97a.75.75 0 0 1 0 1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.78 19.03a.75.75 0 0 1-1.06 0l-6.25-6.25a.75.75 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L5.81 11.5h14.44a.75.75 0 0 1 0 1.5H5.81l4.97 4.97a.75.75 0 0 1 0 1.06Z"]
    }
};
class ArrowLeftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowLeftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowLeftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowLeftIconComponent, isStandalone: true, selector: "svg[arrow-left-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowLeftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-left-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowRightIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.22 2.97a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l2.97-2.97H3.75a.75.75 0 0 1 0-1.5h7.44L8.22 4.03a.75.75 0 0 1 0-1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M13.22 19.03a.75.75 0 0 1 0-1.06L18.19 13H3.75a.75.75 0 0 1 0-1.5h14.44l-4.97-4.97a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z"]
    }
};
class ArrowRightIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowRightIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowRightIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowRightIconComponent, isStandalone: true, selector: "svg[arrow-right-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowRightIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-right-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowSwitchIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.22 14.78a.75.75 0 0 0 1.06-1.06L4.56 12h8.69a.75.75 0 0 0 0-1.5H4.56l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3Zm5.56-6.5a.75.75 0 1 1-1.06-1.06l1.72-1.72H2.75a.75.75 0 0 1 0-1.5h8.69L9.72 2.28a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.72 21.78a.75.75 0 0 0 1.06-1.06L5.56 17.5h14.69a.75.75 0 0 0 0-1.5H5.56l3.22-3.22a.75.75 0 1 0-1.06-1.06l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5Zm8.56-9.5a.75.75 0 1 1-1.06-1.06L18.44 8H3.75a.75.75 0 0 1 0-1.5h14.69l-3.22-3.22a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5Z"]
    }
};
class ArrowSwitchIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowSwitchIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowSwitchIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowSwitchIconComponent, isStandalone: true, selector: "svg[arrow-switch-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowSwitchIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-switch-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowUpIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.47 7.78a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0l4.25 4.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L9 4.81v7.44a.75.75 0 0 1-1.5 0V4.81L4.53 7.78a.75.75 0 0 1-1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M18.655 10.405a.75.75 0 0 1-1.06 0l-4.97-4.97v14.44a.75.75 0 0 1-1.5 0V5.435l-4.97 4.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l6.25-6.25a.75.75 0 0 1 1.06 0l6.25 6.25a.75.75 0 0 1 0 1.06Z"]
    }
};
class ArrowUpIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowUpIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowUpIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowUpIconComponent, isStandalone: true, selector: "svg[arrow-up-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowUpIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-up-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowUpLeftIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.96 4.75A.75.75 0 0 1 4.71 4h6.01a.75.75 0 0 1 0 1.5h-4.2l5.26 5.26a.75.75 0 0 1-1.06 1.061l-5.26-5.26v4.2a.75.75 0 0 1-1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.75 15.5a.75.75 0 0 1-.75-.75v-9A.75.75 0 0 1 5.75 5h9a.75.75 0 0 1 0 1.5H7.56l10.22 10.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L6.5 7.56v7.19a.75.75 0 0 1-.75.75Z"]
    }
};
class ArrowUpLeftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowUpLeftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowUpLeftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowUpLeftIconComponent, isStandalone: true, selector: "svg[arrow-up-left-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowUpLeftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-up-left-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const arrowUpRightIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.53 4.75A.75.75 0 0 1 5.28 4h6.01a.75.75 0 0 1 .75.75v6.01a.75.75 0 0 1-1.5 0v-4.2l-5.26 5.261a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L9.48 5.5h-4.2a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M18.25 15.5a.75.75 0 0 1-.75-.75V7.56L7.28 17.78a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L16.44 6.5H9.25a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75Z"]
    }
};
class ArrowUpRightIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = arrowUpRightIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowUpRightIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ArrowUpRightIconComponent, isStandalone: true, selector: "svg[arrow-up-right-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ArrowUpRightIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[arrow-up-right-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const beakerIconData = {
    "16": {
        "width": 16,
        "paths": ["M5 5.782V2.5h-.25a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5H11v3.282l3.666 5.76C15.619 13.04 14.543 15 12.767 15H3.233c-1.776 0-2.852-1.96-1.899-3.458Zm-2.4 6.565a.75.75 0 0 0 .633 1.153h9.534a.75.75 0 0 0 .633-1.153L12.225 10.5h-8.45ZM9.5 2.5h-3V6c0 .143-.04.283-.117.403L4.73 9h6.54L9.617 6.403A.746.746 0 0 1 9.5 6Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8 8.807V3.5h-.563a.75.75 0 0 1 0-1.5h9.125a.75.75 0 0 1 0 1.5H16v5.307l5.125 9.301c.964 1.75-.302 3.892-2.299 3.892H5.174c-1.998 0-3.263-2.142-2.3-3.892ZM4.189 18.832a1.123 1.123 0 0 0 .985 1.668h13.652a1.123 1.123 0 0 0 .985-1.668L17.7 15H6.3ZM14.5 3.5h-5V9a.75.75 0 0 1-.093.362L7.127 13.5h9.746l-2.28-4.138A.75.75 0 0 1 14.5 9Z"]
    }
};
class BeakerIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = beakerIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BeakerIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BeakerIconComponent, isStandalone: true, selector: "svg[beaker-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BeakerIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[beaker-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bellIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16a2 2 0 0 0 1.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 0 0 8 16ZM3 5a5 5 0 0 1 10 0v2.947c0 .05.015.098.042.139l1.703 2.555A1.519 1.519 0 0 1 13.482 13H2.518a1.516 1.516 0 0 1-1.263-2.36l1.703-2.554A.255.255 0 0 0 3 7.947Zm5-3.5A3.5 3.5 0 0 0 4.5 5v2.947c0 .346-.102.683-.294.97l-1.703 2.556a.017.017 0 0 0-.003.01l.001.006c0 .002.002.004.004.006l.006.004.007.001h10.964l.007-.001.006-.004.004-.006.001-.007a.017.017 0 0 0-.003-.01l-1.703-2.554a1.745 1.745 0 0 1-.294-.97V5A3.5 3.5 0 0 0 8 1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 1c3.681 0 7 2.565 7 6v4.539c0 .642.189 1.269.545 1.803l2.2 3.298A1.517 1.517 0 0 1 20.482 19H15.5a3.5 3.5 0 1 1-7 0H3.519a1.518 1.518 0 0 1-1.265-2.359l2.2-3.299A3.25 3.25 0 0 0 5 11.539V7c0-3.435 3.318-6 7-6ZM6.5 7v4.539a4.75 4.75 0 0 1-.797 2.635l-2.2 3.298-.003.01.001.007.004.006.006.004.007.001h16.964l.007-.001.006-.004.004-.006.001-.006a.017.017 0 0 0-.003-.01l-2.199-3.299a4.753 4.753 0 0 1-.798-2.635V7c0-2.364-2.383-4.5-5.5-4.5S6.5 4.636 6.5 7ZM14 19h-4a2 2 0 1 0 4 0Z"]
    }
};
class BellIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bellIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BellIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BellIconComponent, isStandalone: true, selector: "svg[bell-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BellIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bell-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bellFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16c.9 0 1.7-.6 1.9-1.5.1-.3-.1-.5-.4-.5h-3c-.3 0-.5.2-.4.5.2.9 1 1.5 1.9 1.5ZM3 5c0-2.8 2.2-5 5-5s5 2.2 5 5v3l1.7 2.6c.2.2.3.5.3.8 0 .8-.7 1.5-1.5 1.5h-11c-.8.1-1.5-.6-1.5-1.4 0-.3.1-.6.3-.8L3 8.1V5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M6 8a6 6 0 1 1 12 0v2.917c0 .703.228 1.387.65 1.95L20.7 15.6a1.5 1.5 0 0 1-1.2 2.4h-15a1.5 1.5 0 0 1-1.2-2.4l2.05-2.733a3.25 3.25 0 0 0 .65-1.95Zm6 13.5A3.502 3.502 0 0 1 8.645 19h6.71A3.502 3.502 0 0 1 12 21.5Z"]
    }
};
class BellFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bellFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BellFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BellFillIconComponent, isStandalone: true, selector: "svg[bell-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BellFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bell-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bellSlashIconData = {
    "16": {
        "width": 16,
        "paths": ["m4.182 4.31.016.011 10.104 7.316.013.01 1.375.996a.75.75 0 1 1-.88 1.214L13.626 13H2.518a1.516 1.516 0 0 1-1.263-2.36l1.703-2.554A.255.255 0 0 0 3 7.947V5.305L.31 3.357a.75.75 0 1 1 .88-1.214Zm7.373 7.19L4.5 6.391v1.556c0 .346-.102.683-.294.97l-1.703 2.556a.017.017 0 0 0-.003.01c0 .005.002.009.005.012l.006.004.007.001ZM8 1.5c-.997 0-1.895.416-2.534 1.086A.75.75 0 1 1 4.38 1.55 5 5 0 0 1 13 5v2.373a.75.75 0 0 1-1.5 0V5A3.5 3.5 0 0 0 8 1.5ZM8 16a2 2 0 0 1-1.985-1.75c-.017-.137.097-.25.235-.25h3.5c.138 0 .252.113.235.25A2 2 0 0 1 8 16Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.22 1.22a.75.75 0 0 1 1.06 0l20.5 20.5a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L17.94 19H15.5a3.5 3.5 0 1 1-7 0H3.518a1.516 1.516 0 0 1-1.263-2.36l2.2-3.298A3.249 3.249 0 0 0 5 11.539V7c0-.294.025-.583.073-.866L1.22 2.28a.75.75 0 0 1 0-1.06ZM6.5 7.56h-.001v3.979a4.75 4.75 0 0 1-.797 2.635l-2.2 3.298-.003.01.001.007.004.006.006.004.007.001H16.44ZM10 19a2 2 0 1 0 4 0Zm2-16.5c-1.463 0-2.8.485-3.788 1.257l-.04.032a.75.75 0 1 1-.935-1.173l.05-.04C8.548 1.59 10.212 1 12 1c3.681 0 7 2.565 7 6v4.539c0 .642.19 1.269.546 1.803l1.328 1.992a.75.75 0 1 1-1.248.832l-1.328-1.992a4.75 4.75 0 0 1-.798-2.635V7c0-2.364-2.383-4.5-5.5-4.5Z"]
    }
};
class BellSlashIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bellSlashIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BellSlashIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BellSlashIconComponent, isStandalone: true, selector: "svg[bell-slash-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BellSlashIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bell-slash-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const blockedIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.467.22a.749.749 0 0 1 .53-.22h6.006c.199 0 .389.079.53.22l4.247 4.247c.141.14.22.331.22.53v6.006a.749.749 0 0 1-.22.53l-4.247 4.247a.749.749 0 0 1-.53.22H4.997a.749.749 0 0 1-.53-.22L.22 11.533a.749.749 0 0 1-.22-.53V4.997c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.308v5.384L5.308 14.5h5.384l3.808-3.808V5.308L10.692 1.5ZM4 7.75A.75.75 0 0 1 4.75 7h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 4 7.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.638 2.22a.749.749 0 0 1 .53-.22h7.664c.199 0 .389.079.53.22l5.418 5.418c.141.14.22.332.22.53v7.664a.749.749 0 0 1-.22.53l-5.418 5.418a.749.749 0 0 1-.53.22H8.168a.749.749 0 0 1-.53-.22l-5.42-5.418a.752.752 0 0 1-.219-.53V8.168c0-.199.079-.389.22-.53l5.418-5.42ZM8.48 3.5 3.5 8.48v7.04l4.98 4.98h7.04l4.98-4.98V8.48L15.52 3.5ZM7 11.75a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z"]
    }
};
class BlockedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = blockedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BlockedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BlockedIconComponent, isStandalone: true, selector: "svg[blocked-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BlockedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[blocked-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const boldIconData = {
    "16": {
        "width": 16,
        "paths": ["M4 2h4.5a3.501 3.501 0 0 1 2.852 5.53A3.499 3.499 0 0 1 9.5 14H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm1 7v3h4.5a1.5 1.5 0 0 0 0-3Zm3.5-2a1.5 1.5 0 0 0 0-3H5v3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M6 4.75c0-.69.56-1.25 1.25-1.25h5a4.752 4.752 0 0 1 3.888 7.479A5 5 0 0 1 14 20.5H7.25c-.69 0-1.25-.56-1.25-1.25ZM8.5 13v5H14a2.5 2.5 0 1 0 0-5Zm0-2.5h3.751A2.25 2.25 0 0 0 12.25 6H8.5Z"]
    }
};
class BoldIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = boldIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BoldIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BoldIconComponent, isStandalone: true, selector: "svg[bold-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BoldIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bold-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bookIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75A.75.75 0 0 1 .75 1h4.253c1.227 0 2.317.59 3 1.501A3.743 3.743 0 0 1 11.006 1h4.245a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75h-4.507a2.25 2.25 0 0 0-1.591.659l-.622.621a.75.75 0 0 1-1.06 0l-.622-.621A2.25 2.25 0 0 0 5.258 13H.75a.75.75 0 0 1-.75-.75Zm7.251 10.324.004-5.073-.002-2.253A2.25 2.25 0 0 0 5.003 2.5H1.5v9h3.757a3.75 3.75 0 0 1 1.994.574ZM8.755 4.75l-.004 7.322a3.752 3.752 0 0 1 1.992-.572H14.5v-9h-3.495a2.25 2.25 0 0 0-2.25 2.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M0 3.75A.75.75 0 0 1 .75 3h7.497c1.566 0 2.945.8 3.751 2.014A4.495 4.495 0 0 1 15.75 3h7.5a.75.75 0 0 1 .75.75v15.063a.752.752 0 0 1-.755.75l-7.682-.052a3 3 0 0 0-2.142.878l-.89.891a.75.75 0 0 1-1.061 0l-.902-.901a2.996 2.996 0 0 0-2.121-.879H.75a.75.75 0 0 1-.75-.75Zm12.75 15.232a4.503 4.503 0 0 1 2.823-.971l6.927.047V4.5h-6.75a3 3 0 0 0-3 3ZM11.247 7.497a3 3 0 0 0-3-2.997H1.5V18h6.947c1.018 0 2.006.346 2.803.98Z"]
    }
};
class BookIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bookIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BookIconComponent, isStandalone: true, selector: "svg[book-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[book-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bookmarkIconData = {
    "16": {
        "width": 16,
        "paths": ["M3 2.75C3 1.784 3.784 1 4.75 1h6.5c.966 0 1.75.784 1.75 1.75v11.5a.75.75 0 0 1-1.227.579L8 11.722l-3.773 3.107A.751.751 0 0 1 3 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.91l3.023-2.489a.75.75 0 0 1 .954 0l3.023 2.49V2.75a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5 3.75C5 2.784 5.784 2 6.75 2h10.5c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 0 1-1.218.586L12 17.21l-5.781 4.625A.75.75 0 0 1 5 21.25Zm1.75-.25a.25.25 0 0 0-.25.25v15.94l5.031-4.026a.749.749 0 0 1 .938 0L17.5 19.69V3.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class BookmarkIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bookmarkIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookmarkIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BookmarkIconComponent, isStandalone: true, selector: "svg[bookmark-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookmarkIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bookmark-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bookmarkFillIconData = {
    "24": {
        "width": 24,
        "paths": ["M6.69 2h10.56c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 0 1-1.218.585L12 17.21l-5.781 4.626A.75.75 0 0 1 5 21.253L4.94 3.756A1.748 1.748 0 0 1 6.69 2Z"]
    }
};
class BookmarkFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bookmarkFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookmarkFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BookmarkFillIconComponent, isStandalone: true, selector: "svg[bookmark-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookmarkFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bookmark-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bookmarkSlashIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.19 1.143 4.182 3.31l.014.01 8.486 6.145.014.01 2.994 2.168a.75.75 0 1 1-.88 1.214L13 11.547v2.703a.75.75 0 0 1-1.206.596L8 11.944l-3.794 2.902A.75.75 0 0 1 3 14.25V4.305L.31 2.357a.75.75 0 1 1 .88-1.214ZM4.5 5.39v7.341l3.044-2.328a.75.75 0 0 1 .912 0l3.044 2.328V10.46ZM5.865 1h5.385c.966 0 1.75.784 1.75 1.75v3.624a.75.75 0 0 1-1.5 0V2.75a.25.25 0 0 0-.25-.25H5.865a.75.75 0 0 1 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.565 2.018v-.001l21.75 15.75a.75.75 0 1 1-.88 1.215L19 16.495v4.764a.748.748 0 0 1-1.219.584L12 17.21l-5.781 4.634A.75.75 0 0 1 5 21.259V6.357L.685 3.232a.75.75 0 0 1 .88-1.214ZM17.5 15.408l-11-7.965v12.254l5.031-4.032a.749.749 0 0 1 .938 0l5.031 4.032ZM7.25 2a.75.75 0 0 0 0 1.5h10a.25.25 0 0 1 .25.25v6.5a.75.75 0 0 0 1.5 0v-6.5A1.75 1.75 0 0 0 17.25 2h-10Z"]
    }
};
class BookmarkSlashIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bookmarkSlashIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookmarkSlashIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BookmarkSlashIconComponent, isStandalone: true, selector: "svg[bookmark-slash-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookmarkSlashIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bookmark-slash-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bookmarkSlashFillIconData = {
    "24": {
        "width": 24,
        "paths": ["m3.232 2.175 18.5 15.5a.75.75 0 1 1-.964 1.15L19 17.343v3.907a.75.75 0 0 1-1.218.585L12 17.21l-5.781 4.626A.75.75 0 0 1 5 21.253L4.947 5.569 2.268 3.325a.75.75 0 1 1 .964-1.15ZM7.421 2h9.829c.966 0 1.75.784 1.75 1.75v8.073a.75.75 0 0 1-1.232.575L6.94 3.325A.75.75 0 0 1 7.421 2Z"]
    }
};
class BookmarkSlashFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bookmarkSlashFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookmarkSlashFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BookmarkSlashFillIconComponent, isStandalone: true, selector: "svg[bookmark-slash-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BookmarkSlashFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bookmark-slash-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const briefcaseIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.75 0h2.5C10.216 0 11 .784 11 1.75V3h3.25c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-8.5C0 3.784.784 3 1.75 3H5V1.75C5 .784 5.784 0 6.75 0ZM3.5 9.5a3.49 3.49 0 0 1-2-.627v4.377c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V8.873a3.49 3.49 0 0 1-2 .627Zm-1.75-5a.25.25 0 0 0-.25.25V6a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V4.75a.25.25 0 0 0-.25-.25H1.75ZM9.5 3V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.5 1.75C7.5.784 8.284 0 9.25 0h5.5c.966 0 1.75.784 1.75 1.75V4h4.75c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 21.25 22H2.75A1.75 1.75 0 0 1 1 20.25V5.75C1 4.784 1.784 4 2.75 4H7.5Zm-5 10.24v8.26c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25v-8.26A4.235 4.235 0 0 1 18.75 13H5.25a4.235 4.235 0 0 1-2.75-1.01Zm19-3.24v-3a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v3a2.75 2.75 0 0 0 2.75 2.75h13.5a2.75 2.75 0 0 0 2.75-2.75Zm-6.5-7a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25V4h6Z"]
    }
};
class BriefcaseIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = briefcaseIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BriefcaseIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BriefcaseIconComponent, isStandalone: true, selector: "svg[briefcase-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BriefcaseIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[briefcase-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const broadcastIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.75 8.582v5.668a.75.75 0 0 1-1.5 0V8.582a1.75 1.75 0 1 1 1.5 0Zm3.983-7.125a.75.75 0 0 1 1.06.026A7.976 7.976 0 0 1 16 7c0 2.139-.84 4.083-2.207 5.517a.75.75 0 1 1-1.086-1.034A6.474 6.474 0 0 0 14.5 7a6.474 6.474 0 0 0-1.793-4.483.75.75 0 0 1 .026-1.06Zm-9.466 0c.3.286.312.76.026 1.06A6.474 6.474 0 0 0 1.5 7a6.47 6.47 0 0 0 1.793 4.483.75.75 0 0 1-1.086 1.034A7.973 7.973 0 0 1 0 7c0-2.139.84-4.083 2.207-5.517a.75.75 0 0 1 1.06-.026Zm8.556 2.321A4.988 4.988 0 0 1 13 7a4.988 4.988 0 0 1-1.177 3.222.75.75 0 1 1-1.146-.967A3.487 3.487 0 0 0 11.5 7c0-.86-.309-1.645-.823-2.255a.75.75 0 0 1 1.146-.967Zm-6.492.958A3.48 3.48 0 0 0 4.5 7a3.48 3.48 0 0 0 .823 2.255.75.75 0 0 1-1.146.967A4.981 4.981 0 0 1 3 7a4.982 4.982 0 0 1 1.188-3.236.75.75 0 1 1 1.143.972Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M20.485 2.515a.75.75 0 0 0-1.06 1.06A10.465 10.465 0 0 1 22.5 11c0 2.9-1.174 5.523-3.075 7.424a.75.75 0 0 0 1.06 1.061A11.965 11.965 0 0 0 24 11c0-3.314-1.344-6.315-3.515-8.485Zm-15.91 1.06a.75.75 0 0 0-1.06-1.06A11.965 11.965 0 0 0 0 11c0 3.313 1.344 6.314 3.515 8.485a.75.75 0 0 0 1.06-1.06A10.465 10.465 0 0 1 1.5 11c0-2.9 1.174-5.524 3.075-7.425ZM8.11 7.11a.75.75 0 0 0-1.06-1.06A6.98 6.98 0 0 0 5 11a6.98 6.98 0 0 0 2.05 4.95.75.75 0 0 0 1.06-1.061 5.48 5.48 0 0 1-1.61-3.89 5.48 5.48 0 0 1 1.61-3.888Zm8.84-1.06a.75.75 0 1 0-1.06 1.06A5.48 5.48 0 0 1 17.5 11a5.48 5.48 0 0 1-1.61 3.889.75.75 0 1 0 1.06 1.06A6.98 6.98 0 0 0 19 11a6.98 6.98 0 0 0-2.05-4.949ZM14 11a2 2 0 0 1-1.25 1.855v8.395a.75.75 0 0 1-1.5 0v-8.395A2 2 0 1 1 14 11Z"]
    }
};
class BroadcastIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = broadcastIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BroadcastIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BroadcastIconComponent, isStandalone: true, selector: "svg[broadcast-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BroadcastIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[broadcast-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const browserIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25ZM14.5 6h-13v7.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Zm-6-3.5v2h6V2.75a.25.25 0 0 0-.25-.25ZM5 2.5v2h2v-2Zm-3.25 0a.25.25 0 0 0-.25.25V4.5h2v-2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M0 3.75C0 2.784.784 2 1.75 2h20.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 22.25 22H1.75A1.75 1.75 0 0 1 0 20.25ZM22.5 7h-21v13.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25Zm-10-3.5v2h10V3.75a.25.25 0 0 0-.25-.25ZM7 3.5v2h4v-2Zm-5.25 0a.25.25 0 0 0-.25.25V5.5h4v-2Z"]
    }
};
class BrowserIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = browserIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BrowserIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BrowserIconComponent, isStandalone: true, selector: "svg[browser-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BrowserIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[browser-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const bugIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.72.22a.75.75 0 0 1 1.06 0l1 .999a3.488 3.488 0 0 1 2.441 0l.999-1a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.775.776c.616.63.995 1.493.995 2.444v.327c0 .1-.009.197-.025.292.408.14.764.392 1.029.722l1.968-.787a.75.75 0 0 1 .556 1.392L13 7.258V9h2.25a.75.75 0 0 1 0 1.5H13v.5c0 .409-.049.806-.141 1.186l2.17.868a.75.75 0 0 1-.557 1.392l-2.184-.873A4.997 4.997 0 0 1 8 16a4.997 4.997 0 0 1-4.288-2.427l-2.183.873a.75.75 0 0 1-.558-1.392l2.17-.868A5.036 5.036 0 0 1 3 11v-.5H.75a.75.75 0 0 1 0-1.5H3V7.258L.971 6.446a.75.75 0 0 1 .558-1.392l1.967.787c.265-.33.62-.583 1.03-.722a1.677 1.677 0 0 1-.026-.292V4.5c0-.951.38-1.814.995-2.444L4.72 1.28a.75.75 0 0 1 0-1.06Zm.53 6.28a.75.75 0 0 0-.75.75V11a3.5 3.5 0 1 0 7 0V7.25a.75.75 0 0 0-.75-.75ZM6.173 5h3.654A.172.172 0 0 0 10 4.827V4.5a2 2 0 1 0-4 0v.327c0 .096.077.173.173.173Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.72.22a.75.75 0 0 1 1.06 0l1.204 1.203A4.98 4.98 0 0 1 12 1c.717 0 1.4.151 2.016.423L15.22.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-.971.972A4.991 4.991 0 0 1 17 6v1.104a2.755 2.755 0 0 1 1.917 1.974l1.998-.999a.75.75 0 0 1 .67 1.342L19 10.714V13.5l3.25.003a.75.75 0 0 1 0 1.5L19 15.001V16c0 .568-.068 1.134-.204 1.686l.04.018 2.75 1.375a.75.75 0 1 1-.671 1.342l-2.638-1.319A6.998 6.998 0 0 1 12 23a6.998 6.998 0 0 1-6.197-3.742l-2.758 1.181a.752.752 0 0 1-1.064-.776.752.752 0 0 1 .474-.602l2.795-1.199A6.976 6.976 0 0 1 5 16v-.996H1.75a.75.75 0 0 1 0-1.5H5v-2.79L2.415 9.42a.75.75 0 0 1 .67-1.342l1.998.999A2.756 2.756 0 0 1 7 7.104V6a4.99 4.99 0 0 1 1.69-3.748l-.97-.972a.75.75 0 0 1 0-1.06ZM6.5 9.75V16a5.5 5.5 0 1 0 11 0V9.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25ZM8.5 7h7V6a3.5 3.5 0 1 0-7 0Z"]
    }
};
class BugIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = bugIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BugIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: BugIconComponent, isStandalone: true, selector: "svg[bug-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: BugIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[bug-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const cacheIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.5 5.724V8c0 .248.238.7 1.169 1.159.874.43 2.144.745 3.62.822a.75.75 0 1 1-.078 1.498c-1.622-.085-3.102-.432-4.204-.975a5.565 5.565 0 0 1-.507-.28V12.5c0 .133.058.318.282.551.227.237.591.483 1.101.707 1.015.447 2.47.742 4.117.742.406 0 .802-.018 1.183-.052a.751.751 0 1 1 .134 1.494C8.89 15.98 8.45 16 8 16c-1.805 0-3.475-.32-4.721-.869-.623-.274-1.173-.619-1.579-1.041-.408-.425-.7-.964-.7-1.59v-9c0-.626.292-1.165.7-1.591.406-.42.956-.766 1.579-1.04C4.525.32 6.195 0 8 0c1.806 0 3.476.32 4.721.869.623.274 1.173.619 1.579 1.041.408.425.7.964.7 1.59 0 .626-.292 1.165-.7 1.591-.406.42-.956.766-1.578 1.04C11.475 6.68 9.805 7 8 7c-1.805 0-3.475-.32-4.721-.869a6.15 6.15 0 0 1-.779-.407Zm0-2.224c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 5.205 6.353 5.5 8 5.5c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55 0-.133-.058-.318-.282-.551-.227-.237-.591-.483-1.101-.707C11.102 1.795 9.647 1.5 8 1.5c-1.646 0-3.101.295-4.118.742-.508.224-.873.471-1.1.708-.224.232-.282.417-.282.55Z", "M14.49 7.582a.375.375 0 0 0-.66-.313l-3.625 4.625a.375.375 0 0 0 .295.606h2.127l-.619 2.922a.375.375 0 0 0 .666.304l3.125-4.125A.375.375 0 0 0 15.5 11h-1.778l.769-3.418Z"]
    }
};
class CacheIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = cacheIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CacheIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CacheIconComponent, isStandalone: true, selector: "svg[cache-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CacheIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[cache-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const calendarIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.75 0a.75.75 0 0 1 .75.75V2h5V.75a.75.75 0 0 1 1.5 0V2h1.25c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25V3.75C1 2.784 1.784 2 2.75 2H4V.75A.75.75 0 0 1 4.75 0ZM2.5 7.5v6.75c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V7.5Zm10.75-4H2.75a.25.25 0 0 0-.25.25V6h11V3.75a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M6.75 0a.75.75 0 0 1 .75.75V3h9V.75a.75.75 0 0 1 1.5 0V3h2.75c.966 0 1.75.784 1.75 1.75v16a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75v-16C1.5 3.784 2.284 3 3.25 3H6V.75A.75.75 0 0 1 6.75 0ZM21 9.5H3v11.25c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25Zm-17.75-5a.25.25 0 0 0-.25.25V8h18V4.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class CalendarIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = calendarIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CalendarIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CalendarIconComponent, isStandalone: true, selector: "svg[calendar-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CalendarIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[calendar-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const checkIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M21.03 5.72a.75.75 0 0 1 0 1.06l-11.5 11.5a.747.747 0 0 1-1.072-.012l-5.5-5.75a.75.75 0 1 1 1.084-1.036l4.97 5.195L19.97 5.72a.75.75 0 0 1 1.06 0Z"]
    }
};
class CheckIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = checkIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CheckIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CheckIconComponent, isStandalone: true, selector: "svg[check-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CheckIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[check-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const checkCircleIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm1.5 0a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm10.28-1.72-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.47 1.47 3.97-3.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class CheckCircleIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = checkCircleIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CheckCircleIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CheckCircleIconComponent, isStandalone: true, selector: "svg[check-circle-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CheckCircleIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[check-circle-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const checkCircleFillIconData = {
    "12": {
        "width": 12,
        "paths": ["M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm-.705 8.737L9.63 4.403 8.392 3.166 5.295 6.263l-1.7-1.702L2.356 5.8l2.938 2.938Z"]
    },
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm3.78-9.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018L6.75 9.19 5.28 7.72a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l2 2a.75.75 0 0 0 1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"]
    }
};
class CheckCircleFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = checkCircleFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CheckCircleFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CheckCircleFillIconComponent, isStandalone: true, selector: "svg[check-circle-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CheckCircleFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[check-circle-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const checkboxIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.5 2.75v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25Zm9.28 3.53-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.47 1.47 3.97-3.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z", "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25Z"]
    }
};
class CheckboxIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = checkboxIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CheckboxIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CheckboxIconComponent, isStandalone: true, selector: "svg[checkbox-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CheckboxIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[checkbox-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const checklistIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.5 1.75v11.5c0 .138.112.25.25.25h3.17a.75.75 0 0 1 0 1.5H2.75A1.75 1.75 0 0 1 1 13.25V1.75C1 .784 1.784 0 2.75 0h8.5C12.216 0 13 .784 13 1.75v7.736a.75.75 0 0 1-1.5 0V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25Zm13.274 9.537v-.001l-4.557 4.45a.75.75 0 0 1-1.055-.008l-1.943-1.95a.75.75 0 0 1 1.062-1.058l1.419 1.425 4.026-3.932a.75.75 0 1 1 1.048 1.074ZM4.75 4h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM4 7.75A.75.75 0 0 1 4.75 7h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 4 7.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.5 3.75a.25.25 0 0 1 .25-.25h13.5a.25.25 0 0 1 .25.25v10a.75.75 0 0 0 1.5 0v-10A1.75 1.75 0 0 0 17.25 2H3.75A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h7a.75.75 0 0 0 0-1.5h-7a.25.25 0 0 1-.25-.25V3.75Z", "M6.25 7a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Zm-.75 4.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm16.28 4.53a.75.75 0 1 0-1.06-1.06l-4.97 4.97-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5Z"]
    }
};
class ChecklistIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = checklistIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChecklistIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ChecklistIconComponent, isStandalone: true, selector: "svg[checklist-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChecklistIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[checklist-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const chevronDownIconData = {
    "12": {
        "width": 12,
        "paths": ["M6 8.825c-.2 0-.4-.1-.5-.2l-3.3-3.3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l2.7 2.7 2.7-2.7c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-3.2 3.2c-.2.2-.4.3-.6.3Z"]
    },
    "16": {
        "width": 16,
        "paths": ["M12.78 5.22a.749.749 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.06 0L3.22 6.28a.749.749 0 1 1 1.06-1.06L8 8.939l3.72-3.719a.749.749 0 0 1 1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.22 8.22a.749.749 0 0 0 0 1.06l6.25 6.25a.749.749 0 0 0 1.06 0l6.25-6.25a.749.749 0 1 0-1.06-1.06L12 13.939 6.28 8.22a.749.749 0 0 0-1.06 0Z"]
    }
};
class ChevronDownIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = chevronDownIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChevronDownIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ChevronDownIconComponent, isStandalone: true, selector: "svg[chevron-down-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChevronDownIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[chevron-down-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const chevronLeftIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.78 12.78a.75.75 0 0 1-1.06 0L4.47 8.53a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L6.06 8l3.72 3.72a.75.75 0 0 1 0 1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15.28 5.22a.75.75 0 0 1 0 1.06L9.56 12l5.72 5.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-6.25-6.25a.75.75 0 0 1 0-1.06l6.25-6.25a.75.75 0 0 1 1.06 0Z"]
    }
};
class ChevronLeftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = chevronLeftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChevronLeftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ChevronLeftIconComponent, isStandalone: true, selector: "svg[chevron-left-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChevronLeftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[chevron-left-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const chevronRightIconData = {
    "12": {
        "width": 12,
        "paths": ["M4.7 10c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1L6.9 6 4.2 3.3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l3.3 3.2c.3.3.3.8 0 1.1L5.3 9.7c-.2.2-.4.3-.6.3Z"]
    },
    "16": {
        "width": 16,
        "paths": ["M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.72 18.78a.75.75 0 0 1 0-1.06L14.44 12 8.72 6.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z"]
    }
};
class ChevronRightIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = chevronRightIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChevronRightIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ChevronRightIconComponent, isStandalone: true, selector: "svg[chevron-right-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChevronRightIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[chevron-right-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const chevronUpIconData = {
    "12": {
        "width": 12,
        "paths": ["M6 4c-.2 0-.4.1-.5.2L2.2 7.5c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0L6 5.9l2.7 2.7c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1L6.6 4.3C6.4 4.1 6.2 4 6 4Z"]
    },
    "16": {
        "width": 16,
        "paths": ["M3.22 10.53a.749.749 0 0 1 0-1.06l4.25-4.25a.749.749 0 0 1 1.06 0l4.25 4.25a.749.749 0 1 1-1.06 1.06L8 6.811 4.28 10.53a.749.749 0 0 1-1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M18.78 15.78a.749.749 0 0 1-1.06 0L12 10.061 6.28 15.78a.749.749 0 1 1-1.06-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 0 1 0 1.06Z"]
    }
};
class ChevronUpIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = chevronUpIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChevronUpIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ChevronUpIconComponent, isStandalone: true, selector: "svg[chevron-up-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ChevronUpIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[chevron-up-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const circleIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z"]
    }
};
class CircleIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = circleIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CircleIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CircleIconComponent, isStandalone: true, selector: "svg[circle-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CircleIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[circle-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const circleSlashIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM3.965 13.096a6.5 6.5 0 0 0 9.131-9.131ZM1.5 8a6.474 6.474 0 0 0 1.404 4.035l9.131-9.131A6.499 6.499 0 0 0 1.5 8Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM5.834 19.227A9.464 9.464 0 0 0 12 21.5a9.5 9.5 0 0 0 9.5-9.5 9.464 9.464 0 0 0-2.273-6.166ZM2.5 12a9.464 9.464 0 0 0 2.273 6.166L18.166 4.773A9.463 9.463 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class CircleSlashIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = circleSlashIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CircleSlashIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CircleSlashIconComponent, isStandalone: true, selector: "svg[circle-slash-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CircleSlashIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[circle-slash-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const clockIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm7-3.25v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5a.75.75 0 0 1 1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.5 7.25a.75.75 0 0 0-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 0 0 .744-1.302L12.5 12.315V7.25Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class ClockIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = clockIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ClockIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ClockIconComponent, isStandalone: true, selector: "svg[clock-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ClockIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[clock-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const clockFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8.575-3.25a.825.825 0 1 0-1.65 0v3.5c0 .337.205.64.519.766l2.5 1a.825.825 0 0 0 .612-1.532l-1.981-.793Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11.575-4.75a.825.825 0 1 0-1.65 0v5.5c0 .296.159.57.416.716l3.5 2a.825.825 0 0 0 .818-1.432l-3.084-1.763Z"]
    }
};
class ClockFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = clockFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ClockFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ClockFillIconComponent, isStandalone: true, selector: "svg[clock-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ClockFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[clock-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const cloudIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 7.25A5.225 5.225 0 0 1 7.25 2a5.222 5.222 0 0 1 4.767 3.029A4.472 4.472 0 0 1 16 9.5c0 2.505-1.995 4.5-4.5 4.5h-8A3.474 3.474 0 0 1 0 10.5c0-1.41.809-2.614 2.001-3.17Zm1.54.482a.75.75 0 0 1-.556.832c-.86.22-1.484.987-1.484 1.936 0 1.124.876 2 2 2h8c1.676 0 3-1.324 3-3s-1.324-3-3-3a.75.75 0 0 1-.709-.504A3.72 3.72 0 0 0 7.25 3.5C5.16 3.5 3.5 5.16 3.5 7.25c.002.146.014.292.035.436l.004.036.001.008Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.103 10.107c0-4.244 3.445-7.607 7.733-7.607 3.19 0 5.912 1.858 7.099 4.563l.01.022.001.006C21.348 7.345 24 10.095 24 13.536 24 17.148 21.076 20 17.431 20H5.017C2.23 20 0 17.83 0 15.06a4.899 4.899 0 0 1 3.112-4.581 7.696 7.696 0 0 1-.009-.372ZM10.836 4c-3.485 0-6.233 2.717-6.233 6.107 0 .284.022.602.052.756a.75.75 0 0 1-.552.869c-1.52.385-2.603 1.712-2.603 3.328 0 1.917 1.532 3.44 3.517 3.44h12.414c2.843 0 5.069-2.206 5.069-4.964 0-2.759-2.226-4.965-5.069-4.965a.75.75 0 0 1-.696-.47l-.179-.446C15.606 5.5 13.424 4 10.836 4Z"]
    }
};
class CloudIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = cloudIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CloudIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CloudIconComponent, isStandalone: true, selector: "svg[cloud-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CloudIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[cloud-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const cloudOfflineIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.25 2c-.69 0-1.351.13-1.957.371a.75.75 0 1 0 .554 1.394c.43-.17.903-.265 1.403-.265a3.72 3.72 0 0 1 3.541 2.496.75.75 0 0 0 .709.504c1.676 0 3 1.324 3 3a3 3 0 0 1-.681 1.92.75.75 0 0 0 1.156.955A4.496 4.496 0 0 0 16 9.5a4.472 4.472 0 0 0-3.983-4.471A5.222 5.222 0 0 0 7.25 2ZM.72 1.72a.75.75 0 0 1 1.06 0l2.311 2.31c.03.025.056.052.08.08l8.531 8.532.035.034 2.043 2.044a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-1.8-1.799a4.54 4.54 0 0 1-.42.019h-8A3.474 3.474 0 0 1 0 10.5c0-1.41.809-2.614 2.001-3.17a5.218 5.218 0 0 1 .646-2.622L.72 2.78a.75.75 0 0 1 0-1.06ZM3.5 7.25c.004.161.018.322.041.481a.75.75 0 0 1-.557.833c-.86.22-1.484.986-1.484 1.936 0 1.124.876 2 2 2h6.94L3.771 5.832A3.788 3.788 0 0 0 3.5 7.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m2.78 2.22 19.5 19.5a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2.845-2.845a6.932 6.932 0 0 1-.944.065H5.017C2.229 20 0 17.831 0 15.059a4.899 4.899 0 0 1 3.111-4.58A7.52 7.52 0 0 1 4.36 5.922L1.72 3.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018ZM16.94 18.5 5.448 7.01a6.026 6.026 0 0 0-.794 3.853.75.75 0 0 1-.552.869c-1.52.385-2.603 1.712-2.603 3.328 0 1.917 1.532 3.44 3.517 3.44Zm-6.104-16a7.865 7.865 0 0 0-3.638.88.75.75 0 1 0 .692 1.331A6.365 6.365 0 0 1 10.836 4c2.588 0 4.77 1.5 5.72 3.655l.179.445a.75.75 0 0 0 .696.471c2.843 0 5.069 2.206 5.069 4.965a4.9 4.9 0 0 1-1.684 3.716.75.75 0 0 0 .986 1.13A6.396 6.396 0 0 0 24 13.536c0-3.44-2.652-6.191-6.054-6.445l-.002-.006a.634.634 0 0 0-.01-.022C16.749 4.358 14.026 2.5 10.837 2.5Z"]
    }
};
class CloudOfflineIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = cloudOfflineIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CloudOfflineIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CloudOfflineIconComponent, isStandalone: true, selector: "svg[cloud-offline-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CloudOfflineIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[cloud-offline-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const codeIconData = {
    "16": {
        "width": 16,
        "paths": ["m11.28 3.22 4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L13.94 8l-3.72-3.72a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Zm-6.56 0a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L2.06 8l3.72 3.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L.47 8.53a.75.75 0 0 1 0-1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15.22 4.97a.75.75 0 0 1 1.06 0l6.5 6.5a.75.75 0 0 1 0 1.06l-6.5 6.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L21.19 12l-5.97-5.97a.75.75 0 0 1 0-1.06Zm-6.44 0a.75.75 0 0 1 0 1.06L2.81 12l5.97 5.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-6.5-6.5a.75.75 0 0 1 0-1.06l6.5-6.5a.75.75 0 0 1 1.06 0Z"]
    }
};
class CodeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = codeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CodeIconComponent, isStandalone: true, selector: "svg[code-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[code-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const codeOfConductIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.048 2.241c.964-.709 2.079-1.238 3.325-1.241a4.616 4.616 0 0 1 3.282 1.355c.41.408.757.86.996 1.428.238.568.348 1.206.347 1.968 0 2.193-1.505 4.254-3.081 5.862-1.496 1.526-3.213 2.796-4.249 3.563l-.22.163a.749.749 0 0 1-.895 0l-.221-.163c-1.036-.767-2.753-2.037-4.249-3.563C1.51 10.008.007 7.952.002 5.762a4.614 4.614 0 0 1 1.353-3.407C3.123.585 6.223.537 8.048 2.24Zm-1.153.983c-1.25-1.033-3.321-.967-4.48.191a3.115 3.115 0 0 0-.913 2.335c0 1.556 1.109 3.24 2.652 4.813C5.463 11.898 6.96 13.032 8 13.805c.353-.262.758-.565 1.191-.905l-1.326-1.223a.75.75 0 0 1 1.018-1.102l1.48 1.366c.328-.281.659-.577.984-.887L9.99 9.802a.75.75 0 1 1 1.019-1.103l1.384 1.28c.295-.329.566-.661.81-.995L12.92 8.7l-1.167-1.168c-.674-.671-1.78-.664-2.474.03-.268.269-.538.537-.802.797-.893.882-2.319.843-3.185-.032-.346-.35-.693-.697-1.043-1.047a.75.75 0 0 1-.04-1.016c.162-.191.336-.401.52-.623.62-.748 1.356-1.637 2.166-2.417Zm7.112 4.442c.313-.65.491-1.293.491-1.916v-.001c0-.614-.088-1.045-.23-1.385-.143-.339-.357-.633-.673-.949a3.111 3.111 0 0 0-2.218-.915c-1.092.003-2.165.627-3.226 1.602-.823.755-1.554 1.637-2.228 2.45l-.127.154.562.566a.755.755 0 0 0 1.066.02l.794-.79c1.258-1.258 3.312-1.31 4.594-.032.396.394.792.791 1.173 1.173Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2.828 4.328C5.26 1.896 9.5 1.881 11.935 4.317c.024.024.046.05.067.076 1.391-1.078 2.993-1.886 4.777-1.89a6.22 6.22 0 0 1 4.424 1.825c.559.56 1.023 1.165 1.34 1.922.318.756.47 1.617.468 2.663 0 2.972-2.047 5.808-4.269 8.074-2.098 2.14-4.507 3.924-5.974 5.009l-.311.23a.752.752 0 0 1-.897 0l-.312-.23c-1.466-1.085-3.875-2.869-5.973-5.009-2.22-2.263-4.264-5.095-4.27-8.063a6.216 6.216 0 0 1 1.823-4.596Zm8.033 1.042c-1.846-1.834-5.124-1.823-6.969.022a4.712 4.712 0 0 0-1.382 3.52c0 2.332 1.65 4.79 3.839 7.022 1.947 1.986 4.184 3.66 5.66 4.752a78.214 78.214 0 0 0 2.159-1.645l-2.14-1.974a.752.752 0 0 1 1.02-1.106l2.295 2.118c.616-.52 1.242-1.08 1.85-1.672l-2.16-1.992a.753.753 0 0 1 1.021-1.106l2.188 2.02a18.963 18.963 0 0 0 1.528-1.877l-.585-.586-1.651-1.652c-1.078-1.074-2.837-1.055-3.935.043-.379.38-.76.758-1.132 1.126-1.14 1.124-2.96 1.077-4.07-.043-.489-.495-.98-.988-1.475-1.482a.752.752 0 0 1-.04-1.019c.234-.276.483-.576.745-.893.928-1.12 2.023-2.442 3.234-3.576Zm9.725 6.77c.579-1.08.92-2.167.92-3.228.002-.899-.128-1.552-.35-2.08-.22-.526-.551-.974-1.017-1.44a4.71 4.71 0 0 0-3.356-1.384c-1.66.004-3.25.951-4.77 2.346-1.18 1.084-2.233 2.353-3.188 3.506l-.351.423c.331.332.663.664.993.998a1.375 1.375 0 0 0 1.943.03c.37-.365.748-.74 1.125-1.118 1.662-1.663 4.373-1.726 6.06-.045.56.558 1.12 1.12 1.658 1.658Z"]
    }
};
class CodeOfConductIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = codeOfConductIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodeOfConductIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CodeOfConductIconComponent, isStandalone: true, selector: "svg[code-of-conduct-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodeOfConductIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[code-of-conduct-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const codeReviewIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 13H8.061l-2.574 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25v-8.5C0 1.784.784 1 1.75 1ZM1.5 2.75v8.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Zm5.28 1.72a.75.75 0 0 1 0 1.06L5.31 7l1.47 1.47a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 0Zm2.44 0a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.69 7 9.22 5.53a.75.75 0 0 1 0-1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.3 6.74a.75.75 0 0 1-.04 1.06l-2.908 2.7 2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm3.44 1.06a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7Z", "M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.749.749 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25Z"]
    }
};
class CodeReviewIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = codeReviewIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodeReviewIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CodeReviewIconComponent, isStandalone: true, selector: "svg[code-review-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodeReviewIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[code-review-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const codeSquareIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Zm7.47 3.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L10.69 8 9.22 6.53a.75.75 0 0 1 0-1.06ZM6.78 6.53 5.31 8l1.47 1.47a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2-2a.75.75 0 0 1 0-1.06l2-2a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.3 8.24a.75.75 0 0 1-.04 1.06L7.352 12l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm3.44 1.06a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7Z", "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class CodeSquareIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = codeSquareIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodeSquareIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CodeSquareIconComponent, isStandalone: true, selector: "svg[code-square-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodeSquareIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[code-square-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const codescanIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.47 4.97a.75.75 0 0 0 0 1.06L9.94 7.5 8.47 8.97a.75.75 0 1 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06l-2-2a.75.75 0 0 0-1.06 0ZM6.53 6.03a.75.75 0 0 0-1.06-1.06l-2 2a.75.75 0 0 0 0 1.06l2 2a.75.75 0 1 0 1.06-1.06L5.06 7.5l1.47-1.47Z", "M12.246 13.307a7.501 7.501 0 1 1 1.06-1.06l2.474 2.473a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM1.5 7.5a6.002 6.002 0 0 0 3.608 5.504 6.002 6.002 0 0 0 6.486-1.117.748.748 0 0 1 .292-.293A6 6 0 1 0 1.5 7.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.97 6.97a.75.75 0 0 0 0 1.06l2.47 2.47-2.47 2.47a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0ZM9.03 8.03a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06L6.56 10.5l2.47-2.47Z", "M10.5 0C16.299 0 21 4.701 21 10.5a10.457 10.457 0 0 1-2.564 6.875l4.344 4.345a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0Zm-9 10.5a9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9Z"]
    }
};
class CodescanIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = codescanIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodescanIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CodescanIconComponent, isStandalone: true, selector: "svg[codescan-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodescanIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[codescan-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const codescanCheckmarkIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.28 6.28a.75.75 0 1 0-1.06-1.06L6.25 8.19l-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3.5-3.5Z", "M7.5 15a7.5 7.5 0 1 1 5.807-2.754l2.473 2.474a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2.474-2.473A7.472 7.472 0 0 1 7.5 15Zm0-13.5a6 6 0 1 0 4.094 10.386.748.748 0 0 1 .293-.292 6.002 6.002 0 0 0 1.117-6.486A6.002 6.002 0 0 0 7.5 1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15.03 8.28a.75.75 0 0 0-1.06-1.06l-5.22 5.22-2.22-2.22a.75.75 0 1 0-1.06 1.06l2.75 2.75a.75.75 0 0 0 1.06 0l5.75-5.75Z", "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-4.345-4.344A10.457 10.457 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"]
    }
};
class CodescanCheckmarkIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = codescanCheckmarkIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodescanCheckmarkIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CodescanCheckmarkIconComponent, isStandalone: true, selector: "svg[codescan-checkmark-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodescanCheckmarkIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[codescan-checkmark-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const codespacesIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 11.25c0-.966.784-1.75 1.75-1.75h12.5c.966 0 1.75.784 1.75 1.75v3A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm2-9.5C2 .784 2.784 0 3.75 0h8.5C13.216 0 14 .784 14 1.75v5a1.75 1.75 0 0 1-1.75 1.75h-8.5A1.75 1.75 0 0 1 2 6.75Zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25Zm-2 9.5a.25.25 0 0 0-.25.25v3c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-3a.25.25 0 0 0-.25-.25Z", "M7 12.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm-4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.5 3.75C3.5 2.784 4.284 2 5.25 2h13.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 18.75 13H5.25a1.75 1.75 0 0 1-1.75-1.75Zm-2 12c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v4a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75ZM5.25 3.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h13.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Zm-2 12a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25Z", "M10 17.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"]
    }
};
class CodespacesIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = codespacesIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodespacesIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CodespacesIconComponent, isStandalone: true, selector: "svg[codespaces-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CodespacesIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[codespaces-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const columnsIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.75 0h2.5C6.216 0 7 .784 7 1.75v12.5A1.75 1.75 0 0 1 5.25 16h-2.5A1.75 1.75 0 0 1 1 14.25V1.75C1 .784 1.784 0 2.75 0Zm8 0h2.5C14.216 0 15 .784 15 1.75v12.5A1.75 1.75 0 0 1 13.25 16h-2.5A1.75 1.75 0 0 1 9 14.25V1.75C9 .784 9.784 0 10.75 0ZM2.5 1.75v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Zm8 0v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.75 2h5.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 9.25 22h-5.5A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2Zm11 0h5.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22h-5.5A1.75 1.75 0 0 1 13 20.25V3.75c0-.966.784-1.75 1.75-1.75ZM3.5 3.75v16.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25Zm11 0v16.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25Z"]
    }
};
class ColumnsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = columnsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ColumnsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ColumnsIconComponent, isStandalone: true, selector: "svg[columns-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ColumnsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[columns-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const commandPaletteIconData = {
    "16": {
        "width": 16,
        "paths": ["m6.354 8.04-4.773 4.773a.75.75 0 1 0 1.061 1.06L7.945 8.57a.75.75 0 0 0 0-1.06L2.642 2.206a.75.75 0 0 0-1.06 1.061L6.353 8.04ZM8.75 11.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.045 18.894 9.94 12 3.045 5.106a.75.75 0 0 1 1.06-1.061l7.425 7.425a.75.75 0 0 1 0 1.06l-7.424 7.425a.75.75 0 0 1-1.061-1.06Zm8.205.606a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5h-9.5Z"]
    }
};
class CommandPaletteIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = commandPaletteIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CommandPaletteIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CommandPaletteIconComponent, isStandalone: true, selector: "svg[command-palette-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CommandPaletteIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[command-palette-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const commentIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 13.25 12H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 13.543V12H2.75A1.75 1.75 0 0 1 1 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.749.749 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25Z"]
    }
};
class CommentIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = commentIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CommentIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CommentIconComponent, isStandalone: true, selector: "svg[comment-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CommentIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[comment-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const commentDiscussionIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 1h8.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.458 1.458 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25v-5.5C0 1.784.784 1 1.75 1ZM1.5 2.75v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25Zm13 2a.25.25 0 0 0-.25-.25h-.5a.75.75 0 0 1 0-1.5h.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.458 1.458 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l2.22 2.22v-2.19a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.458 1.458 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25v-9.5C0 1.784.784 1 1.75 1ZM1.5 2.75v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z", "M22.5 8.75a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5a.75.75 0 0 1 .53.22l2.72 2.72v-2.19a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5Z"]
    }
};
class CommentDiscussionIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = commentDiscussionIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CommentDiscussionIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CommentDiscussionIconComponent, isStandalone: true, selector: "svg[comment-discussion-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CommentDiscussionIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[comment-discussion-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const commitIconData = {
    "24": {
        "width": 24,
        "paths": ["M0 11.75A.75.75 0 0 1 .75 11h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Zm17.5 0a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z", "M12 17.75a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"]
    }
};
class CommitIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = commitIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CommitIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CommitIconComponent, isStandalone: true, selector: "svg[commit-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CommitIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[commit-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const containerIconData = {
    "16": {
        "width": 16,
        "paths": ["m10.41.24 4.711 2.774c.544.316.878.897.879 1.526v5.01a1.77 1.77 0 0 1-.88 1.53l-7.753 4.521-.002.001a1.769 1.769 0 0 1-1.774 0H5.59L.873 12.85A1.761 1.761 0 0 1 0 11.327V6.292c0-.304.078-.598.22-.855l.004-.005.01-.019c.15-.262.369-.486.64-.643L8.641.239a1.752 1.752 0 0 1 1.765 0l.002.001ZM9.397 1.534l-7.17 4.182 4.116 2.388a.27.27 0 0 0 .269 0l7.152-4.148-4.115-2.422a.252.252 0 0 0-.252 0Zm-7.768 10.02 4.1 2.393V9.474a1.807 1.807 0 0 1-.138-.072L1.5 7.029v4.298c0 .095.05.181.129.227Zm8.6.642 1.521-.887v-4.45l-1.521.882ZM7.365 9.402h.001c-.044.026-.09.049-.136.071v4.472l1.5-.875V8.61Zm5.885 1.032 1.115-.65h.002a.267.267 0 0 0 .133-.232V5.264l-1.25.725Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M13.152.682a2.251 2.251 0 0 1 2.269 0l.007.004 6.957 4.276a2.277 2.277 0 0 1 1.126 1.964v7.516c0 .81-.432 1.56-1.133 1.968l-.002.001-11.964 7.037-.004.003c-.706.41-1.578.41-2.284 0l-.026-.015-6.503-4.502a2.268 2.268 0 0 1-1.096-1.943V9.438c0-.392.1-.77.284-1.1l.003-.006.014-.026c.197-.342.48-.627.82-.827h.002L13.152.681Zm.757 1.295h-.001L2.648 8.616l6.248 4.247a.775.775 0 0 0 .758-.01h.001l11.633-6.804-6.629-4.074a.75.75 0 0 0-.75.003ZM8.517 14.33a2.286 2.286 0 0 1-.393-.18l-.023-.014-6.102-4.147v7.003c0 .275.145.528.379.664l.025.014 6.114 4.232V14.33ZM18 9.709l-3.25 1.9v7.548L18 17.245Zm-7.59 4.438-.002.002a2.296 2.296 0 0 1-.391.18v7.612l3.233-1.902v-7.552Zm9.09-5.316v7.532l2.124-1.25a.776.776 0 0 0 .387-.671V7.363Z"]
    }
};
class ContainerIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = containerIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ContainerIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ContainerIconComponent, isStandalone: true, selector: "svg[container-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ContainerIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[container-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const copilotIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.998 15.035c-4.562 0-7.873-2.914-7.998-3.749V9.338c.085-.628.677-1.686 1.588-2.065.013-.07.024-.143.036-.218.029-.183.06-.384.126-.612-.201-.508-.254-1.084-.254-1.656 0-.87.128-1.769.693-2.484.579-.733 1.494-1.124 2.724-1.261 1.206-.134 2.262.034 2.944.765.05.053.096.108.139.165.044-.057.094-.112.143-.165.682-.731 1.738-.899 2.944-.765 1.23.137 2.145.528 2.724 1.261.566.715.693 1.614.693 2.484 0 .572-.053 1.148-.254 1.656.066.228.098.429.126.612.012.076.024.148.037.218.924.385 1.522 1.471 1.591 2.095v1.872c0 .766-3.351 3.795-8.002 3.795Zm0-1.485c2.28 0 4.584-1.11 5.002-1.433V7.862l-.023-.116c-.49.21-1.075.291-1.727.291-1.146 0-2.059-.327-2.71-.991A3.222 3.222 0 0 1 8 6.303a3.24 3.24 0 0 1-.544.743c-.65.664-1.563.991-2.71.991-.652 0-1.236-.081-1.727-.291l-.023.116v4.255c.419.323 2.722 1.433 5.002 1.433ZM6.762 2.83c-.193-.206-.637-.413-1.682-.297-1.019.113-1.479.404-1.713.7-.247.312-.369.789-.369 1.554 0 .793.129 1.171.308 1.371.162.181.519.379 1.442.379.853 0 1.339-.235 1.638-.54.315-.322.527-.827.617-1.553.117-.935-.037-1.395-.241-1.614Zm4.155-.297c-1.044-.116-1.488.091-1.681.297-.204.219-.359.679-.242 1.614.091.726.303 1.231.618 1.553.299.305.784.54 1.638.54.922 0 1.28-.198 1.442-.379.179-.2.308-.578.308-1.371 0-.765-.123-1.242-.37-1.554-.233-.296-.693-.587-1.713-.7Z", "M6.25 9.037a.75.75 0 0 1 .75.75v1.501a.75.75 0 0 1-1.5 0V9.787a.75.75 0 0 1 .75-.75Zm4.25.75v1.501a.75.75 0 0 1-1.5 0V9.787a.75.75 0 0 1 1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M23.922 16.992c-.861 1.495-5.859 5.023-11.922 5.023-6.063 0-11.061-3.528-11.922-5.023A.641.641 0 0 1 0 16.736v-2.869a.841.841 0 0 1 .053-.22c.372-.935 1.347-2.292 2.605-2.656.167-.429.414-1.055.644-1.517a10.195 10.195 0 0 1-.052-1.086c0-1.331.282-2.499 1.132-3.368.397-.406.89-.717 1.474-.952 1.399-1.136 3.392-2.093 6.122-2.093 2.731 0 4.767.957 6.166 2.093.584.235 1.077.546 1.474.952.85.869 1.132 2.037 1.132 3.368 0 .368-.014.733-.052 1.086.23.462.477 1.088.644 1.517 1.258.364 2.233 1.721 2.605 2.656a.832.832 0 0 1 .053.22v2.869a.641.641 0 0 1-.078.256ZM12.172 11h-.344a4.323 4.323 0 0 1-.355.508C10.703 12.455 9.555 13 7.965 13c-1.725 0-2.989-.359-3.782-1.259a2.005 2.005 0 0 1-.085-.104L4 11.741v6.585c1.435.779 4.514 2.179 8 2.179 3.486 0 6.565-1.4 8-2.179v-6.585l-.098-.104s-.033.045-.085.104c-.793.9-2.057 1.259-3.782 1.259-1.59 0-2.738-.545-3.508-1.492a4.323 4.323 0 0 1-.355-.508h-.016.016Zm.641-2.935c.136 1.057.403 1.913.878 2.497.442.544 1.134.938 2.344.938 1.573 0 2.292-.337 2.657-.751.384-.435.558-1.15.558-2.361 0-1.14-.243-1.847-.705-2.319-.477-.488-1.319-.862-2.824-1.025-1.487-.161-2.192.138-2.533.529-.269.307-.437.808-.438 1.578v.021c0 .265.021.562.063.893Zm-1.626 0c.042-.331.063-.628.063-.894v-.02c-.001-.77-.169-1.271-.438-1.578-.341-.391-1.046-.69-2.533-.529-1.505.163-2.347.537-2.824 1.025-.462.472-.705 1.179-.705 2.319 0 1.211.175 1.926.558 2.361.365.414 1.084.751 2.657.751 1.21 0 1.902-.394 2.344-.938.475-.584.742-1.44.878-2.497Z", "M14.5 14.25a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1Zm-5 0a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1Z"]
    },
    "48": {
        "width": 48,
        "paths": ["M47.801 34.003c-1.72 2.988-11.706 10.037-23.82 10.037S1.881 36.991.161 34.003a1.309 1.309 0 0 1-.161-.57v-5.615c.012-.17.047-.338.11-.498.744-1.867 2.692-4.58 5.206-5.308.333-.855.826-2.106 1.287-3.029a20.112 20.112 0 0 1-.104-2.171c0-2.659.563-4.992 2.262-6.729.793-.811 1.777-1.433 2.945-1.901C14.502 5.911 18.483 4 23.938 4c5.455 0 9.523 1.911 12.319 4.182 1.167.468 2.151 1.09 2.944 1.901 1.699 1.737 2.263 4.07 2.263 6.729 0 .736-.027 1.465-.105 2.171.461.923.954 2.174 1.288 3.029 2.513.728 4.461 3.441 5.205 5.308.081.205.115.424.115.645v5.318c0 .252-.04.502-.166.72ZM24.325 22.031h-.688a8.52 8.52 0 0 1-.709 1.016c-1.537 1.892-3.833 2.98-7.008 2.98-3.447 0-5.972-.717-7.557-2.514a4.408 4.408 0 0 1-.171-.21l-.195.21v13.155c2.867 1.558 9.02 4.353 15.984 4.353s13.117-2.795 15.984-4.353V23.513l-.195-.21s-.066.091-.171.21c-1.584 1.797-4.11 2.514-7.557 2.514-3.175 0-5.47-1.088-7.008-2.98a8.637 8.637 0 0 1-.709-1.016h-.033.033Zm-1.969-5.864a14.31 14.31 0 0 0 .127-1.785v-.042c-.003-1.537-.339-2.538-.876-3.152-.681-.78-2.09-1.378-5.06-1.057-3.008.326-4.69 1.073-5.643 2.048-.923.944-1.408 2.356-1.408 4.633 0 2.42.348 3.849 1.115 4.719.729.827 2.165 1.499 5.309 1.499 2.417 0 3.799-.786 4.683-1.873.948-1.168 1.482-2.878 1.753-4.99Zm3.25 0c.271 2.112.805 3.822 1.754 4.99.883 1.087 2.265 1.873 4.682 1.873 3.145 0 4.58-.672 5.309-1.499.767-.87 1.116-2.299 1.116-4.719 0-2.277-.485-3.689-1.408-4.633-.954-.975-2.635-1.722-5.644-2.048-2.969-.321-4.378.277-5.06 1.057-.537.614-.873 1.615-.876 3.152v.042c.002.53.042 1.123.127 1.785Z", "M28.998 28.516c1.104 0 1.999.895 1.999 1.999v3.998a2 2 0 1 1-3.998 0v-3.998c0-1.104.895-1.999 1.999-1.999Zm-9.996 0c1.104 0 1.999.895 1.999 1.999v3.998a2 2 0 1 1-3.998 0v-3.998c0-1.104.895-1.999 1.999-1.999Z"]
    },
    "96": {
        "width": 96,
        "paths": ["M95.667 67.954C92.225 73.933 72.24 88.04 47.997 88.04 23.754 88.04 3.769 73.933.328 67.954c-.216-.375-.307-.796-.328-1.226V55.661c.019-.371.089-.736.226-1.081 1.489-3.738 5.386-9.166 10.417-10.623.667-1.712 1.655-4.215 2.576-6.062-.154-1.414-.208-2.872-.208-4.345 0-5.322 1.128-9.99 4.527-13.466 1.587-1.623 3.557-2.869 5.893-3.805 5.595-4.545 13.563-8.369 24.48-8.369s19.057 3.824 24.652 8.369c2.337.936 4.306 2.182 5.894 3.805 3.399 3.476 4.527 8.144 4.527 13.466 0 1.473-.054 2.931-.208 4.345.921 1.847 1.909 4.35 2.576 6.062 5.03 1.457 8.928 6.885 10.417 10.623.163.41.231.848.231 1.289v10.644c0 .504-.081 1.004-.333 1.441ZM48.686 43.993l-.3.001-1.077-.001c-.423.709-.894 1.39-1.418 2.035-3.078 3.787-7.672 5.964-14.026 5.964-6.897 0-11.952-1.435-15.123-5.032a7.886 7.886 0 0 1-.342-.419l-.39.419v26.326c5.737 3.118 18.05 8.713 31.987 8.713 13.938 0 26.251-5.595 31.988-8.713V46.96l-.39-.419s-.132.181-.342.419c-3.171 3.597-8.226 5.032-15.123 5.032-6.354 0-10.949-2.177-14.026-5.964a17.178 17.178 0 0 1-1.418-2.034h-.066l.066-.001Zm-3.94-11.733c.17-1.326.251-2.513.253-3.573v-.084c-.005-3.077-.678-5.079-1.752-6.308-1.365-1.562-4.184-2.758-10.127-2.115-6.021.652-9.386 2.146-11.294 4.098-1.847 1.889-2.818 4.715-2.818 9.272 0 4.842.698 7.703 2.232 9.443 1.459 1.655 4.332 3.001 10.625 3.001 4.837 0 7.603-1.573 9.371-3.749 1.899-2.336 2.967-5.759 3.51-9.985Zm6.503 0c.543 4.226 1.611 7.649 3.51 9.985 1.768 2.176 4.533 3.749 9.371 3.749 6.292 0 9.165-1.346 10.624-3.001 1.535-1.74 2.232-4.601 2.232-9.443 0-4.557-.97-7.383-2.817-9.272-1.908-1.952-5.274-3.446-11.294-4.098-5.943-.643-8.763.553-10.127 2.115-1.074 1.229-1.747 3.231-1.752 6.308v.084c.002 1.06.083 2.247.253 3.573Zm-2.563 11.734h.066l-.066-.001v.001Z", "M38.5 55.75a3.5 3.5 0 0 1 3.5 3.5v8.5a3.5 3.5 0 1 1-7 0v-8.5a3.5 3.5 0 0 1 3.5-3.5Zm19 0a3.5 3.5 0 0 1 3.5 3.5v8.5a3.5 3.5 0 1 1-7 0v-8.5a3.5 3.5 0 0 1 3.5-3.5Z"]
    }
};
class CopilotIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = copilotIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CopilotIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CopilotIconComponent, isStandalone: true, selector: "svg[copilot-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CopilotIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[copilot-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const copilotErrorIconData = {
    "16": {
        "width": 16,
        "paths": ["M16 11.24c0 .112-.072.274-.21.467L13 9.688V7.862l-.023-.116c-.49.21-1.075.291-1.727.291-.198 0-.388-.009-.571-.029L6.833 5.226a4.01 4.01 0 0 0 .17-.782c.117-.935-.037-1.395-.241-1.614-.193-.206-.637-.413-1.682-.297-.683.076-1.115.231-1.395.415l-1.257-.91c.579-.564 1.413-.877 2.485-.996 1.206-.134 2.262.034 2.944.765.05.053.096.108.139.165.044-.057.094-.112.143-.165.682-.731 1.738-.899 2.944-.765 1.23.137 2.145.528 2.724 1.261.566.715.693 1.614.693 2.484 0 .572-.053 1.148-.254 1.656.066.228.098.429.126.612.012.076.024.148.037.218.924.385 1.522 1.471 1.591 2.095Zm-5.083-8.707c-1.044-.116-1.488.091-1.681.297-.204.219-.359.679-.242 1.614.091.726.303 1.231.618 1.553.299.305.784.54 1.638.54.922 0 1.28-.198 1.442-.379.179-.2.308-.578.308-1.371 0-.765-.123-1.242-.37-1.554-.233-.296-.693-.587-1.713-.7Zm2.511 11.074c-1.393.776-3.272 1.428-5.43 1.428-4.562 0-7.873-2.914-7.998-3.749V9.338c.085-.628.677-1.686 1.588-2.065.013-.07.024-.143.036-.218.029-.183.06-.384.126-.612-.18-.455-.241-.963-.252-1.475L.31 4.107A.747.747 0 0 1 0 3.509V3.49a.748.748 0 0 1 .625-.73c.156-.026.306.047.435.139l14.667 10.578a.592.592 0 0 1 .227.264.752.752 0 0 1 .046.249v.022a.75.75 0 0 1-1.19.596Zm-1.367-.991L5.635 7.964a5.128 5.128 0 0 1-.889.073c-.652 0-1.236-.081-1.727-.291l-.023.116v4.255c.419.323 2.722 1.433 5.002 1.433 1.539 0 3.089-.505 4.063-.934Z"]
    }
};
class CopilotErrorIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = copilotErrorIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CopilotErrorIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CopilotErrorIconComponent, isStandalone: true, selector: "svg[copilot-error-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CopilotErrorIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[copilot-error-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const copilotWarningIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.498 14.811a4.53 4.53 0 0 1-1.161-1.337 4.476 4.476 0 0 1-.587-2.224 4.496 4.496 0 0 1 4.5-4.5 4.5 4.5 0 0 1 4.5 4.5 4.5 4.5 0 0 1-7.252 3.561ZM10.5 8.75V11a.75.75 0 0 0 1.5 0V8.75a.75.75 0 1 0-1.5 0Zm.75 5.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", "m14.354 6.114-.05-.029a5.949 5.949 0 0 0-1.351-.589c.03-.19.047-.422.047-.709 0-.765-.123-1.242-.37-1.554-.233-.296-.693-.587-1.713-.7-1.044-.116-1.488.091-1.681.297-.204.219-.359.679-.242 1.614.058.462.165.834.316 1.127A6.025 6.025 0 0 0 6.369 7.76c-.472.185-1.015.277-1.623.277-.652 0-1.236-.081-1.727-.291l-.023.116v4.255c.265.205 1.285.725 2.577 1.079a5.937 5.937 0 0 0 .939 1.736C2.733 14.407.111 12.027 0 11.286V9.338c.085-.628.677-1.686 1.588-2.065.013-.07.024-.143.036-.218.029-.183.06-.384.126-.612-.201-.508-.254-1.084-.254-1.656 0-.87.128-1.769.693-2.484.579-.733 1.494-1.124 2.724-1.261 1.206-.134 2.262.034 2.944.765.05.053.096.108.139.165.044-.057.094-.112.143-.165.682-.731 1.738-.899 2.944-.765 1.23.137 2.145.528 2.724 1.261.566.715.693 1.614.693 2.484 0 .452-.033.906-.146 1.327ZM6.762 2.83c-.193-.206-.637-.413-1.682-.297-1.019.113-1.479.404-1.713.7-.247.312-.369.789-.369 1.554 0 .793.129 1.171.308 1.371.162.181.519.379 1.442.379.853 0 1.339-.235 1.638-.54.315-.322.527-.827.617-1.553.117-.935-.037-1.395-.241-1.614Z"]
    }
};
class CopilotWarningIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = copilotWarningIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CopilotWarningIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CopilotWarningIconComponent, isStandalone: true, selector: "svg[copilot-warning-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CopilotWarningIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[copilot-warning-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const copyIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z", "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.024 3.75c0-.966.784-1.75 1.75-1.75H20.25c.966 0 1.75.784 1.75 1.75v11.498a1.75 1.75 0 0 1-1.75 1.75H8.774a1.75 1.75 0 0 1-1.75-1.75Zm1.75-.25a.25.25 0 0 0-.25.25v11.498c0 .139.112.25.25.25H20.25a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z", "M1.995 10.749a1.75 1.75 0 0 1 1.75-1.751H5.25a.75.75 0 1 1 0 1.5H3.745a.25.25 0 0 0-.25.25L3.5 20.25c0 .138.111.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1.51a.75.75 0 1 1 1.5 0v1.51A1.75 1.75 0 0 1 13.25 22h-9.5A1.75 1.75 0 0 1 2 20.25l-.005-9.501Z"]
    }
};
class CopyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = copyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CopyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CopyIconComponent, isStandalone: true, selector: "svg[copy-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CopyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[copy-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const cpuIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.5.75V2h3V.75a.75.75 0 0 1 1.5 0V2h1.25c.966 0 1.75.784 1.75 1.75V5h1.25a.75.75 0 0 1 0 1.5H14v3h1.25a.75.75 0 0 1 0 1.5H14v1.25A1.75 1.75 0 0 1 12.25 14H11v1.25a.75.75 0 0 1-1.5 0V14h-3v1.25a.75.75 0 0 1-1.5 0V14H3.75A1.75 1.75 0 0 1 2 12.25V11H.75a.75.75 0 0 1 0-1.5H2v-3H.75a.75.75 0 0 1 0-1.5H2V3.75C2 2.784 2.784 2 3.75 2H5V.75a.75.75 0 0 1 1.5 0Zm5.75 11.75a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25ZM5.75 5h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 5.75 5Zm.75 4.5h3v-3h-3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.75 8h6.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1-.75-.75v-6.5A.75.75 0 0 1 8.75 8Zm.75 6.5h5v-5h-5Z", "M15.25 1a.75.75 0 0 1 .75.75V4h2.25c.966 0 1.75.784 1.75 1.75V8h2.25a.75.75 0 0 1 0 1.5H20v5h2.25a.75.75 0 0 1 0 1.5H20v2.25A1.75 1.75 0 0 1 18.25 20H16v2.25a.75.75 0 0 1-1.5 0V20h-5v2.25a.75.75 0 0 1-1.5 0V20H5.75A1.75 1.75 0 0 1 4 18.25V16H1.75a.75.75 0 0 1 0-1.5H4v-5H1.75a.75.75 0 0 1 0-1.5H4V5.75C4 4.784 4.784 4 5.75 4H8V1.75a.75.75 0 0 1 1.5 0V4h5V1.75a.75.75 0 0 1 .75-.75Zm3 17.5a.25.25 0 0 0 .25-.25V5.75a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25Z"]
    }
};
class CpuIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = cpuIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CpuIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CpuIconComponent, isStandalone: true, selector: "svg[cpu-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CpuIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[cpu-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const creditCardIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.75 9a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z", "M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25ZM14.5 6.5h-13v5.75c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Zm0-2.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25V5h13Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15.25 14a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z", "M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25V4.75C0 3.784.784 3 1.75 3Zm-.25 7v9.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V10Zm0-5.25V8.5h21V4.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"]
    }
};
class CreditCardIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = creditCardIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CreditCardIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CreditCardIconComponent, isStandalone: true, selector: "svg[credit-card-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CreditCardIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[credit-card-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const crossReferenceIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.75 3.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 13H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 14.543V13H2.75A1.75 1.75 0 0 1 1 11.25v-7.5C1 2.784 1.784 2 2.75 2h5.5a.75.75 0 0 1 0 1.5ZM16 1.25v4.146a.25.25 0 0 1-.427.177L14.03 4.03l-3.75 3.75a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l3.75-3.75-1.543-1.543A.25.25 0 0 1 11.604 1h4.146a.25.25 0 0 1 .25.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16.5 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V4.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L20.94 3h-3.69a.75.75 0 0 1-.75-.75Z", "M3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.75.75 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25v-6a.75.75 0 0 1 1.5 0v6a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.457 1.457 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75V4.25c0-.966.784-1.75 1.75-1.75h11a.75.75 0 0 1 0 1.5h-11Z"]
    }
};
class CrossReferenceIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = crossReferenceIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CrossReferenceIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: CrossReferenceIconComponent, isStandalone: true, selector: "svg[cross-reference-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: CrossReferenceIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[cross-reference-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const dashIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 7.75A.75.75 0 0 1 2.75 7h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 2 7.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.5 12.75a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H5.25a.75.75 0 0 1-.75-.75Z"]
    }
};
class DashIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = dashIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DashIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DashIconComponent, isStandalone: true, selector: "svg[dash-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DashIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[dash-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const databaseIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 3.5c0-.626.292-1.165.7-1.59.406-.422.956-.767 1.579-1.041C4.525.32 6.195 0 8 0c1.805 0 3.475.32 4.722.869.622.274 1.172.62 1.578 1.04.408.426.7.965.7 1.591v9c0 .626-.292 1.165-.7 1.59-.406.422-.956.767-1.579 1.041C11.476 15.68 9.806 16 8 16c-1.805 0-3.475-.32-4.721-.869-.623-.274-1.173-.62-1.579-1.04-.408-.426-.7-.965-.7-1.591Zm1.5 0c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 5.205 6.353 5.5 8 5.5c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55 0-.133-.058-.318-.282-.551-.227-.237-.591-.483-1.101-.707C11.102 1.795 9.647 1.5 8 1.5c-1.646 0-3.101.295-4.118.742-.508.224-.873.471-1.1.708-.224.232-.282.417-.282.55Zm0 4.5c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 9.705 6.353 10 8 10c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55V5.724c-.241.15-.503.286-.778.407C11.475 6.68 9.805 7 8 7c-1.805 0-3.475-.32-4.721-.869a6.15 6.15 0 0 1-.779-.407Zm0 2.225V12.5c0 .133.058.318.282.55.227.237.592.484 1.1.708 1.016.447 2.471.742 4.118.742 1.647 0 3.102-.295 4.117-.742.51-.224.874-.47 1.101-.707.224-.233.282-.418.282-.551v-2.275c-.241.15-.503.285-.778.406-1.247.549-2.917.869-4.722.869-1.805 0-3.475-.32-4.721-.869a6.327 6.327 0 0 1-.779-.406Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 1.25c2.487 0 4.773.402 6.466 1.079.844.337 1.577.758 2.112 1.264.536.507.922 1.151.922 1.907v12.987l-.026.013h.026c0 .756-.386 1.4-.922 1.907-.535.506-1.268.927-2.112 1.264-1.693.677-3.979 1.079-6.466 1.079s-4.774-.402-6.466-1.079c-.844-.337-1.577-.758-2.112-1.264C2.886 19.9 2.5 19.256 2.5 18.5h.026l-.026-.013V5.5c0-.756.386-1.4.922-1.907.535-.506 1.268-.927 2.112-1.264C7.226 1.652 9.513 1.25 12 1.25ZM4 14.371v4.116l-.013.013H4c0 .211.103.487.453.817.351.332.898.666 1.638.962 1.475.589 3.564.971 5.909.971 2.345 0 4.434-.381 5.909-.971.739-.296 1.288-.63 1.638-.962.349-.33.453-.607.453-.817h.013L20 18.487v-4.116a7.85 7.85 0 0 1-1.534.8c-1.693.677-3.979 1.079-6.466 1.079s-4.774-.402-6.466-1.079a7.843 7.843 0 0 1-1.534-.8ZM20 12V7.871a7.85 7.85 0 0 1-1.534.8C16.773 9.348 14.487 9.75 12 9.75s-4.774-.402-6.466-1.079A7.85 7.85 0 0 1 4 7.871V12c0 .21.104.487.453.817.35.332.899.666 1.638.961 1.475.59 3.564.972 5.909.972 2.345 0 4.434-.382 5.909-.972.74-.295 1.287-.629 1.638-.96.35-.33.453-.607.453-.818ZM4 5.5c0 .211.103.487.453.817.351.332.898.666 1.638.962 1.475.589 3.564.971 5.909.971 2.345 0 4.434-.381 5.909-.971.739-.296 1.288-.63 1.638-.962.349-.33.453-.607.453-.817 0-.211-.103-.487-.453-.817-.351-.332-.898-.666-1.638-.962-1.475-.589-3.564-.971-5.909-.971-2.345 0-4.434.381-5.909.971-.739.296-1.288.63-1.638.962C4.104 5.013 4 5.29 4 5.5Z"]
    }
};
class DatabaseIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = databaseIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DatabaseIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DatabaseIconComponent, isStandalone: true, selector: "svg[database-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DatabaseIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[database-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const dependabotIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.75 7.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Zm5.25.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z", "M6.25 0h2A.75.75 0 0 1 9 .75V3.5h3.25a2.25 2.25 0 0 1 2.25 2.25V8h.75a.75.75 0 0 1 0 1.5h-.75v2.75a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25V9.5H.75a.75.75 0 0 1 0-1.5h.75V5.75A2.25 2.25 0 0 1 3.75 3.5H7.5v-2H6.25a.75.75 0 0 1 0-1.5ZM3 5.75v6.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-6.5a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0-.75.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.75 11a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Zm7.25.75a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0v-3.5Z", "M9.813 1h2.437a.75.75 0 0 1 .75.75V5h6.75A2.25 2.25 0 0 1 22 7.25v5.25h1.25a.75.75 0 0 1 0 1.5H22v5.75A2.25 2.25 0 0 1 19.75 22H4.25A2.25 2.25 0 0 1 2 19.75V14H.75a.75.75 0 0 1 0-1.5H2V7.25A2.25 2.25 0 0 1 4.25 5h7.25V2.5H9.813A.75.75 0 0 1 9.812 1ZM3.5 7.25v12.5c0 .414.336.75.75.75h15.5a.75.75 0 0 0 .75-.75V7.25a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75Z"]
    }
};
class DependabotIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = dependabotIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DependabotIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DependabotIconComponent, isStandalone: true, selector: "svg[dependabot-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DependabotIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[dependabot-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const desktopDownloadIconData = {
    "16": {
        "width": 16,
        "paths": ["m4.927 5.427 2.896 2.896a.25.25 0 0 0 .354 0l2.896-2.896A.25.25 0 0 0 10.896 5H8.75V.75a.75.75 0 1 0-1.5 0V5H5.104a.25.25 0 0 0-.177.427Z", "M1.573 2.573a.25.25 0 0 0-.073.177v7.5a.25.25 0 0 0 .25.25h12.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-3a.75.75 0 1 1 0-1.5h3A1.75 1.75 0 0 1 16 2.75v7.5A1.75 1.75 0 0 1 14.25 12h-3.727c.099 1.041.52 1.872 1.292 2.757A.75.75 0 0 1 11.25 16h-6.5a.75.75 0 0 1-.565-1.243c.772-.885 1.192-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5A1.75 1.75 0 0 1 1.75 1h3a.75.75 0 0 1 0 1.5h-3a.25.25 0 0 0-.177.073ZM6.982 12a5.72 5.72 0 0 1-.765 2.5h3.566a5.72 5.72 0 0 1-.765-2.5H6.982Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.25 9.331V.75a.75.75 0 0 1 1.5 0v8.58l1.949-2.11A.75.75 0 1 1 15.8 8.237l-3.25 3.52a.75.75 0 0 1-1.102 0l-3.25-3.52A.75.75 0 1 1 9.3 7.22l1.949 2.111Z", "M2.5 3.75v11.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.75.75 0 0 1 0-1.5h5.5c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 21.25 17h-6.204c.171 1.375.805 2.652 1.769 3.757A.752.752 0 0 1 16.25 22h-8.5a.75.75 0 0 1-.566-1.243c.965-1.105 1.599-2.382 1.77-3.757H2.75A1.75 1.75 0 0 1 1 15.25V3.75C1 2.784 1.784 2 2.75 2h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25ZM10.463 17c-.126 1.266-.564 2.445-1.223 3.5h5.52c-.66-1.055-1.098-2.234-1.223-3.5Z"]
    }
};
class DesktopDownloadIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = desktopDownloadIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DesktopDownloadIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DesktopDownloadIconComponent, isStandalone: true, selector: "svg[desktop-download-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DesktopDownloadIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[desktop-download-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const deviceCameraIconData = {
    "16": {
        "width": 16,
        "paths": ["M15 3c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1 0-.55.45-1 1-1h4c.55 0 1 .45 1 1Zm-4.5 9c1.94 0 3.5-1.56 3.5-3.5S12.44 5 10.5 5 7 6.56 7 8.5 8.56 12 10.5 12ZM13 8.5c0 1.38-1.13 2.5-2.5 2.5S8 9.87 8 8.5 9.13 6 10.5 6 13 7.13 13 8.5ZM6 5V4H2v1Z"]
    }
};
class DeviceCameraIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = deviceCameraIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DeviceCameraIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DeviceCameraIconComponent, isStandalone: true, selector: "svg[device-camera-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DeviceCameraIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[device-camera-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const deviceCameraVideoIconData = {
    "16": {
        "width": 16,
        "paths": ["M16 3.75v8.5a.75.75 0 0 1-1.136.643L11 10.575v.675A1.75 1.75 0 0 1 9.25 13h-7.5A1.75 1.75 0 0 1 0 11.25v-6.5C0 3.784.784 3 1.75 3h7.5c.966 0 1.75.784 1.75 1.75v.675l3.864-2.318A.75.75 0 0 1 16 3.75Zm-6.5 1a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-6.5ZM11 8.825l3.5 2.1v-5.85l-3.5 2.1Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M24 5.25v13a.75.75 0 0 1-1.136.643L16.5 15.075v2.175A1.75 1.75 0 0 1 14.75 19h-13A1.75 1.75 0 0 1 0 17.25v-11C0 5.284.784 4.5 1.75 4.5h13c.966 0 1.75.784 1.75 1.75v2.175l6.364-3.818A.75.75 0 0 1 24 5.25Zm-9 1a.25.25 0 0 0-.25-.25h-13a.25.25 0 0 0-.25.25v11c0 .138.112.25.25.25h13a.25.25 0 0 0 .25-.25v-11Zm1.5 7.075 6 3.6V6.575l-6 3.6Z"]
    }
};
class DeviceCameraVideoIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = deviceCameraVideoIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DeviceCameraVideoIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DeviceCameraVideoIconComponent, isStandalone: true, selector: "svg[device-camera-video-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DeviceCameraVideoIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[device-camera-video-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const deviceDesktopIconData = {
    "16": {
        "width": 16,
        "paths": ["M14.25 1c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 14.25 12h-3.727c.099 1.041.52 1.872 1.292 2.757A.752.752 0 0 1 11.25 16h-6.5a.75.75 0 0 1-.565-1.243c.772-.885 1.192-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5C0 1.784.784 1 1.75 1ZM1.75 2.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25ZM9.018 12H6.982a5.72 5.72 0 0 1-.765 2.5h3.566a5.72 5.72 0 0 1-.765-2.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.954 17H2.75A1.75 1.75 0 0 1 1 15.25V3.75C1 2.784 1.784 2 2.75 2h18.5c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 21.25 17h-6.204c.171 1.375.805 2.652 1.769 3.757A.752.752 0 0 1 16.25 22h-8.5a.75.75 0 0 1-.565-1.243c.964-1.105 1.598-2.382 1.769-3.757ZM21.5 3.75a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25ZM13.537 17h-3.074c-.126 1.266-.564 2.445-1.223 3.5h5.52c-.659-1.055-1.098-2.234-1.223-3.5Z"]
    }
};
class DeviceDesktopIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = deviceDesktopIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DeviceDesktopIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DeviceDesktopIconComponent, isStandalone: true, selector: "svg[device-desktop-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DeviceDesktopIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[device-desktop-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const deviceMobileIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.75 0h8.5C13.216 0 14 .784 14 1.75v12.5A1.75 1.75 0 0 1 12.25 16h-8.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.784 0 3.75 0ZM3.5 1.75v12.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.25 5.25A.75.75 0 0 1 11 4.5h2A.75.75 0 0 1 13 6h-2a.75.75 0 0 1-.75-.75ZM12 19.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", "M4 2.75C4 1.784 4.784 1 5.75 1h12.5c.966 0 1.75.784 1.75 1.75v18.5A1.75 1.75 0 0 1 18.25 23H5.75A1.75 1.75 0 0 1 4 21.25Zm1.75-.25a.25.25 0 0 0-.25.25v18.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class DeviceMobileIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = deviceMobileIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DeviceMobileIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DeviceMobileIconComponent, isStandalone: true, selector: "svg[device-mobile-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DeviceMobileIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[device-mobile-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const devicesIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75V5a.75.75 0 0 1-1.5 0V2.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25H7A.75.75 0 0 1 7 12h-.268a5.712 5.712 0 0 1-.765 2.5H7A.75.75 0 0 1 7 16H4.5a.75.75 0 0 1-.565-1.243c.772-.885 1.193-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5Z", "M10.75 7h3.5c.967 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 16h-3.5A1.75 1.75 0 0 1 9 14.25v-5.5C9 7.784 9.783 7 10.75 7Zm-.25 1.75v5.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-3.5a.25.25 0 0 0-.25.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1 3.75C1 2.784 1.784 2 2.75 2h18.5c.966 0 1.75.784 1.75 1.75v4a.75.75 0 0 1-1.5 0v-4a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h9a.75.75 0 0 1 0 1.5h-1.287c-.126 1.266-.564 2.445-1.223 3.5h2.51a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.565-1.243c.964-1.105 1.598-2.382 1.769-3.757H2.75A1.75 1.75 0 0 1 1 15.25V3.75Z", "M14 11.75c0-.967.783-1.75 1.75-1.75h5.5c.966 0 1.75.783 1.75 1.75v8.5A1.75 1.75 0 0 1 21.25 22h-5.5A1.75 1.75 0 0 1 14 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25Z"]
    }
};
class DevicesIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = devicesIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DevicesIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DevicesIconComponent, isStandalone: true, selector: "svg[devices-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DevicesIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[devices-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const diamondIconData = {
    "16": {
        "width": 16,
        "paths": ["M.527 9.237a1.75 1.75 0 0 1 0-2.474L6.777.512a1.75 1.75 0 0 1 2.475 0l6.251 6.25a1.75 1.75 0 0 1 0 2.475l-6.25 6.251a1.75 1.75 0 0 1-2.475 0L.527 9.238Zm1.06-1.414a.25.25 0 0 0 0 .354l6.251 6.25a.25.25 0 0 0 .354 0l6.25-6.25a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.354 0l-6.25 6.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.527 13.237a1.75 1.75 0 0 1 0-2.474l9.272-9.273a1.75 1.75 0 0 1 2.475 0l9.272 9.273a1.75 1.75 0 0 1 0 2.474l-9.272 9.272a1.75 1.75 0 0 1-2.475 0Zm1.06-1.414a.25.25 0 0 0 0 .354l9.273 9.272a.25.25 0 0 0 .353 0l9.272-9.272a.25.25 0 0 0 0-.354l-9.272-9.272a.25.25 0 0 0-.353 0Z"]
    }
};
class DiamondIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = diamondIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiamondIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiamondIconComponent, isStandalone: true, selector: "svg[diamond-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiamondIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[diamond-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const diffIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.75 1.75V5H12a.75.75 0 0 1 0 1.5H8.75v3.25a.75.75 0 0 1-1.5 0V6.5H4A.75.75 0 0 1 4 5h3.25V1.75a.75.75 0 0 1 1.5 0ZM4 13h8a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 4 13Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.25 3.5a.75.75 0 0 1 .75.75V8.5h4.25a.75.75 0 0 1 0 1.5H13v4.25a.75.75 0 0 1-1.5 0V10H7.25a.75.75 0 0 1 0-1.5h4.25V4.25a.75.75 0 0 1 .75-.75ZM6.562 19.25a.75.75 0 0 1 .75-.75h9.938a.75.75 0 0 1 0 1.5H7.312a.75.75 0 0 1-.75-.75Z"]
    }
};
class DiffIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = diffIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiffIconComponent, isStandalone: true, selector: "svg[diff-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[diff-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const diffAddedIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1Zm10.5 1.5H2.75a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM8 4a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 8 4Z"]
    }
};
class DiffAddedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = diffAddedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffAddedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiffAddedIconComponent, isStandalone: true, selector: "svg[diff-added-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffAddedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[diff-added-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const diffIgnoredIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm8.53 3.28-5.5 5.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l5.5-5.5a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"]
    }
};
class DiffIgnoredIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = diffIgnoredIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffIgnoredIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiffIgnoredIconComponent, isStandalone: true, selector: "svg[diff-ignored-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffIgnoredIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[diff-ignored-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const diffModifiedIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z"]
    }
};
class DiffModifiedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = diffModifiedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffModifiedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiffModifiedIconComponent, isStandalone: true, selector: "svg[diff-modified-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffModifiedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[diff-modified-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const diffRemovedIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm8.5 6.25h-6.5a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5Z"]
    }
};
class DiffRemovedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = diffRemovedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffRemovedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiffRemovedIconComponent, isStandalone: true, selector: "svg[diff-removed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffRemovedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[diff-removed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const diffRenamedIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm9.03 6.03-3.25 3.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.97-1.97H4.75a.75.75 0 0 1 0-1.5h4.69L7.47 5.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l3.25 3.25a.75.75 0 0 1 0 1.06Z"]
    }
};
class DiffRenamedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = diffRenamedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffRenamedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiffRenamedIconComponent, isStandalone: true, selector: "svg[diff-renamed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiffRenamedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[diff-renamed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const discussionClosedIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm-5.47.28-3 3a.747.747 0 0 1-1.06 0l-1.5-1.5a.749.749 0 1 1 1.06-1.06l.97.969L7.72 3.72a.749.749 0 1 1 1.06 1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm-9.72-3.22-5 5a.747.747 0 0 1-1.06 0l-2.5-2.5a.749.749 0 1 1 1.06-1.06L7 8.689l4.47-4.469a.749.749 0 1 1 1.06 1.06Z"]
    }
};
class DiscussionClosedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = discussionClosedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiscussionClosedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiscussionClosedIconComponent, isStandalone: true, selector: "svg[discussion-closed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiscussionClosedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[discussion-closed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const discussionDuplicateIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm-6.282.03L5.03 7.468a.749.749 0 1 1-1.06-1.061L6.907 3.47a.75.75 0 0 1 1.061 1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25ZM11.28 5.53l-5 5a.749.749 0 1 1-1.06-1.06l5-5a.749.749 0 1 1 1.06 1.06Z"]
    }
};
class DiscussionDuplicateIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = discussionDuplicateIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiscussionDuplicateIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiscussionDuplicateIconComponent, isStandalone: true, selector: "svg[discussion-duplicate-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiscussionDuplicateIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[discussion-duplicate-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const discussionOutdatedIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM6.5 4v1.492l.466.187.036.015.812.375a.75.75 0 1 1-.628 1.362l-.795-.367-.92-.368A.75.75 0 0 1 5 6V4a.75.75 0 0 1 1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25ZM8.5 4.75v3.14l1.15.488a.608.608 0 0 1 .037.017l1.393.681a.75.75 0 0 1-.66 1.348l-1.374-.673-1.589-.674A.751.751 0 0 1 7 8.386V4.75a.75.75 0 0 1 1.5 0Z"]
    }
};
class DiscussionOutdatedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = discussionOutdatedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiscussionOutdatedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DiscussionOutdatedIconComponent, isStandalone: true, selector: "svg[discussion-outdated-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DiscussionOutdatedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[discussion-outdated-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const dotIconData = {
    "16": {
        "width": 16,
        "paths": ["M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"]
    }
};
class DotIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = dotIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DotIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DotIconComponent, isStandalone: true, selector: "svg[dot-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DotIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[dot-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const dotFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"]
    }
};
class DotFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = dotFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DotFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DotFillIconComponent, isStandalone: true, selector: "svg[dot-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DotFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[dot-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const downloadIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z", "M7.25 7.689V2a.75.75 0 0 1 1.5 0v5.689l1.97-1.969a.749.749 0 1 1 1.06 1.06l-3.25 3.25a.749.749 0 0 1-1.06 0L4.22 6.78a.749.749 0 1 1 1.06-1.06l1.97 1.969Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.75 17.25a.75.75 0 0 1 .75.75v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25V18a.75.75 0 0 1 .75-.75Z", "M5.22 9.97a.749.749 0 0 1 1.06 0l4.97 4.969V2.75a.75.75 0 0 1 1.5 0v12.189l4.97-4.969a.749.749 0 1 1 1.06 1.06l-6.25 6.25a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06Z"]
    }
};
class DownloadIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = downloadIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DownloadIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DownloadIconComponent, isStandalone: true, selector: "svg[download-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DownloadIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[download-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const duplicateIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.5 3a.75.75 0 0 1 .75.75v1h1a.75.75 0 0 1 0 1.5h-1v1a.75.75 0 0 1-1.5 0v-1h-1a.75.75 0 0 1 0-1.5h1v-1A.75.75 0 0 1 10.5 3Z", "M6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25v-7.5C5 .784 5.784 0 6.75 0ZM6.5 1.75v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25Z", "M1.75 5A1.75 1.75 0 0 0 0 6.75v7.5C0 15.216.784 16 1.75 16h7.5A1.75 1.75 0 0 0 11 14.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.25.25 0 0 1-.25.25h-7.5a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25h1.5a.75.75 0 0 0 0-1.5h-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M14.513 6a.75.75 0 0 1 .75.75v2h1.987a.75.75 0 0 1 0 1.5h-1.987v2a.75.75 0 1 1-1.5 0v-2H11.75a.75.75 0 0 1 0-1.5h2.013v-2a.75.75 0 0 1 .75-.75Z", "M7.024 3.75c0-.966.784-1.75 1.75-1.75H20.25c.966 0 1.75.784 1.75 1.75v11.498a1.75 1.75 0 0 1-1.75 1.75H8.774a1.75 1.75 0 0 1-1.75-1.75Zm1.75-.25a.25.25 0 0 0-.25.25v11.498c0 .139.112.25.25.25H20.25a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z", "M1.995 10.749a1.75 1.75 0 0 1 1.75-1.751H5.25a.75.75 0 1 1 0 1.5H3.745a.25.25 0 0 0-.25.25L3.5 20.25c0 .138.111.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1.51a.75.75 0 1 1 1.5 0v1.51A1.75 1.75 0 0 1 13.25 22h-9.5A1.75 1.75 0 0 1 2 20.25l-.005-9.501Z"]
    }
};
class DuplicateIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = duplicateIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DuplicateIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: DuplicateIconComponent, isStandalone: true, selector: "svg[duplicate-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: DuplicateIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[duplicate-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const ellipsisIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 5.75C0 4.784.784 4 1.75 4h12.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 14.25 12H1.75A1.75 1.75 0 0 1 0 10.25ZM12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM4 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"]
    }
};
class EllipsisIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = ellipsisIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: EllipsisIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: EllipsisIconComponent, isStandalone: true, selector: "svg[ellipsis-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: EllipsisIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[ellipsis-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const eyeIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 2c1.981 0 3.671.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.62 1.62 0 0 1 0 1.798c-.45.678-1.367 1.932-2.637 3.023C11.67 13.008 9.981 14 8 14c-1.981 0-3.671-.992-4.933-2.078C1.797 10.83.88 9.576.43 8.898a1.62 1.62 0 0 1 0-1.798c.45-.677 1.367-1.931 2.637-3.022C4.33 2.992 6.019 2 8 2ZM1.679 7.932a.12.12 0 0 0 0 .136c.411.622 1.241 1.75 2.366 2.717C5.176 11.758 6.527 12.5 8 12.5c1.473 0 2.825-.742 3.955-1.715 1.124-.967 1.954-2.096 2.366-2.717a.12.12 0 0 0 0-.136c-.412-.621-1.242-1.75-2.366-2.717C10.824 4.242 9.473 3.5 8 3.5c-1.473 0-2.825.742-3.955 1.715-1.124.967-1.954 2.096-2.366 2.717ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z", "M12 3.5c3.432 0 6.124 1.534 8.054 3.241 1.926 1.703 3.132 3.61 3.616 4.46a1.6 1.6 0 0 1 0 1.598c-.484.85-1.69 2.757-3.616 4.461-1.929 1.706-4.622 3.24-8.054 3.24-3.432 0-6.124-1.534-8.054-3.24C2.02 15.558.814 13.65.33 12.8a1.6 1.6 0 0 1 0-1.598c.484-.85 1.69-2.757 3.616-4.462C5.875 5.034 8.568 3.5 12 3.5ZM1.633 11.945a.115.115 0 0 0-.017.055c.001.02.006.039.017.056.441.774 1.551 2.527 3.307 4.08C6.691 17.685 9.045 19 12 19c2.955 0 5.31-1.315 7.06-2.864 1.756-1.553 2.866-3.306 3.307-4.08a.111.111 0 0 0 .017-.056.111.111 0 0 0-.017-.056c-.441-.773-1.551-2.527-3.307-4.08C17.309 6.315 14.955 5 12 5 9.045 5 6.69 6.314 4.94 7.865c-1.756 1.552-2.866 3.306-3.307 4.08Z"]
    }
};
class EyeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = eyeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: EyeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: EyeIconComponent, isStandalone: true, selector: "svg[eye-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: EyeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[eye-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const eyeClosedIconData = {
    "16": {
        "width": 16,
        "paths": ["M.143 2.31a.75.75 0 0 1 1.047-.167l14.5 10.5a.75.75 0 1 1-.88 1.214l-2.248-1.628C11.346 13.19 9.792 14 8 14c-1.981 0-3.67-.992-4.933-2.078C1.797 10.832.88 9.577.43 8.9a1.619 1.619 0 0 1 0-1.797c.353-.533.995-1.42 1.868-2.305L.31 3.357A.75.75 0 0 1 .143 2.31Zm1.536 5.622A.12.12 0 0 0 1.657 8c0 .021.006.045.022.068.412.621 1.242 1.75 2.366 2.717C5.175 11.758 6.527 12.5 8 12.5c1.195 0 2.31-.488 3.29-1.191L9.063 9.695A2 2 0 0 1 6.058 7.52L3.529 5.688a14.207 14.207 0 0 0-1.85 2.244ZM8 3.5c-.516 0-1.017.09-1.499.251a.75.75 0 1 1-.473-1.423A6.207 6.207 0 0 1 8 2c1.981 0 3.67.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.62 1.62 0 0 1 0 1.798c-.11.166-.248.365-.41.587a.75.75 0 1 1-1.21-.887c.148-.201.272-.382.371-.53a.119.119 0 0 0 0-.137c-.412-.621-1.242-1.75-2.366-2.717C10.825 4.242 9.473 3.5 8 3.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.052 5.837A9.715 9.715 0 0 1 12 5c2.955 0 5.309 1.315 7.06 2.864 1.756 1.553 2.866 3.307 3.307 4.08a.11.11 0 0 1 .016.055.122.122 0 0 1-.017.06 16.766 16.766 0 0 1-1.53 2.218.75.75 0 1 0 1.163.946 18.253 18.253 0 0 0 1.67-2.42 1.607 1.607 0 0 0 .001-1.602c-.485-.85-1.69-2.757-3.616-4.46C18.124 5.034 15.432 3.5 12 3.5c-1.695 0-3.215.374-4.552.963a.75.75 0 0 0 .604 1.373Zm11.114 12.15C17.328 19.38 14.933 20.5 12 20.5c-3.432 0-6.125-1.534-8.054-3.24C2.02 15.556.814 13.648.33 12.798a1.606 1.606 0 0 1 .001-1.6A18.283 18.283 0 0 1 3.648 7.01L1.317 5.362a.75.75 0 1 1 .866-1.224l20.5 14.5a.75.75 0 1 1-.866 1.224ZM4.902 7.898c-1.73 1.541-2.828 3.273-3.268 4.044a.112.112 0 0 0-.017.059c0 .015.003.034.016.055.441.774 1.551 2.527 3.307 4.08C6.69 17.685 9.045 19 12 19c2.334 0 4.29-.82 5.874-1.927l-3.516-2.487a3.5 3.5 0 0 1-5.583-3.949L4.902 7.899Z"]
    }
};
class EyeClosedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = eyeClosedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: EyeClosedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: EyeClosedIconComponent, isStandalone: true, selector: "svg[eye-closed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: EyeClosedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[eye-closed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedDiscussionIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM4 5v5a1 1 0 0 0 1 1h1v1.5a.5.5 0 0 0 .854.354L8.707 11H11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1Z"]
    }
};
class FeedDiscussionIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedDiscussionIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedDiscussionIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedDiscussionIconComponent, isStandalone: true, selector: "svg[feed-discussion-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedDiscussionIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-discussion-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedForkedIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM6 6.928a1.75 1.75 0 1 0-1 0V7.5A1.5 1.5 0 0 0 6.5 9h1v1.072a1.75 1.75 0 1 0 1 0V9h1A1.5 1.5 0 0 0 11 7.5v-.572a1.75 1.75 0 1 0-1 0V7.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5Z"]
    }
};
class FeedForkedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedForkedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedForkedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedForkedIconComponent, isStandalone: true, selector: "svg[feed-forked-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedForkedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-forked-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedHeartIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm2.33-11.5c-1.22 0-1.83.5-2.323 1.136C7.513 5 6.903 4.5 5.682 4.5c-1.028 0-2.169.784-2.169 2.5 0 1.499 1.493 3.433 3.246 4.517.52.321.89.479 1.248.484.357-.005.728-.163 1.247-.484C11.007 10.433 12.5 8.5 12.5 7c0-1.716-1.14-2.5-2.17-2.5Z"]
    }
};
class FeedHeartIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedHeartIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedHeartIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedHeartIconComponent, isStandalone: true, selector: "svg[feed-heart-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedHeartIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-heart-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedIssueClosedIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm3.457 6.957a.999.999 0 1 0-1.414-1.414L7.25 8.336 5.957 7.043a.999.999 0 1 0-1.414 1.414l2 2a.999.999 0 0 0 1.414 0Z"]
    }
};
class FeedIssueClosedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedIssueClosedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedIssueClosedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedIssueClosedIconComponent, isStandalone: true, selector: "svg[feed-issue-closed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedIssueClosedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-issue-closed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedIssueDraftIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM3.802 7.334a.75.75 0 0 0-1.482-.233 5.8 5.8 0 0 0 0 1.798.749.749 0 1 0 1.482-.233 4.296 4.296 0 0 1 0-1.332ZM8 2.25a5.8 5.8 0 0 0-.899.07.749.749 0 1 0 .233 1.482 4.296 4.296 0 0 1 1.332 0 .75.75 0 0 0 .233-1.482A5.8 5.8 0 0 0 8 2.25Zm-.666 9.948a.75.75 0 0 0-.233 1.482 5.8 5.8 0 0 0 1.798 0 .749.749 0 1 0-.233-1.482 4.296 4.296 0 0 1-1.332 0Zm6.346-5.097a.749.749 0 1 0-1.482.233 4.296 4.296 0 0 1 0 1.332.75.75 0 0 0 1.482.233 5.8 5.8 0 0 0 0-1.798Zm-8.178-2.54a.75.75 0 0 0-.882-1.213A5.77 5.77 0 0 0 3.348 4.62a.749.749 0 1 0 1.213.882c.263-.361.58-.678.941-.941Zm-.941 5.937a.75.75 0 0 0-1.213.882 5.77 5.77 0 0 0 1.272 1.272.749.749 0 1 0 .882-1.213 4.285 4.285 0 0 1-.941-.941Zm6.819-7.15a.749.749 0 1 0-.882 1.213c.36.263.679.58.941.941a.75.75 0 0 0 1.213-.882 5.77 5.77 0 0 0-1.272-1.272Zm1.272 8.032a.749.749 0 1 0-1.213-.882c-.262.36-.581.679-.941.941a.75.75 0 0 0 .882 1.213 5.77 5.77 0 0 0 1.272-1.272Z"]
    }
};
class FeedIssueDraftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedIssueDraftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedIssueDraftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedIssueDraftIconComponent, isStandalone: true, selector: "svg[feed-issue-draft-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedIssueDraftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-issue-draft-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedIssueOpenIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.75 8a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0ZM9.5 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 8Z", "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-5.75a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 1 0 0-11.5Z"]
    }
};
class FeedIssueOpenIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedIssueOpenIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedIssueOpenIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedIssueOpenIconComponent, isStandalone: true, selector: "svg[feed-issue-open-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedIssueOpenIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-issue-open-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedIssueReopenIconData = {
    "16": {
        "width": 17,
        "paths": ["M.5 8a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm3.427-4.323a.25.25 0 0 0-.427.177V6c0 .138.112.25.25.25h2.146a.25.25 0 0 0 .177-.427l-.524-.524a4.003 4.003 0 0 1 6.862 1.858.75.75 0 0 0 1.467-.314 5.502 5.502 0 0 0-9.39-2.605Zm9.573 8.469V10a.25.25 0 0 0-.25-.25h-2.146a.25.25 0 0 0-.177.427l.524.524a4.002 4.002 0 0 1-6.862-1.858.75.75 0 0 0-1.467.314 5.502 5.502 0 0 0 9.39 2.605l.561.561a.25.25 0 0 0 .427-.177ZM10 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 10 8Z"]
    }
};
class FeedIssueReopenIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedIssueReopenIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedIssueReopenIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedIssueReopenIconComponent, isStandalone: true, selector: "svg[feed-issue-reopen-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedIssueReopenIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-issue-reopen-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedMergedIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.25-11.25A1.75 1.75 0 1 0 6 6.428v3.144a1.75 1.75 0 1 0 1 0V8.236A2.99 2.99 0 0 0 9 9h.571a1.75 1.75 0 1 0 0-1H9a2 2 0 0 1-1.957-1.586A1.75 1.75 0 0 0 8.25 4.75Z"]
    }
};
class FeedMergedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedMergedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedMergedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedMergedIconComponent, isStandalone: true, selector: "svg[feed-merged-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedMergedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-merged-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedPersonIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.847-8.145a2.502 2.502 0 1 0-1.694 0C5.471 8.261 4 9.775 4 11c0 .395.145.995 1 .995h6c.855 0 1-.6 1-.995 0-1.224-1.47-2.74-3.153-3.145Z"]
    }
};
class FeedPersonIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedPersonIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPersonIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedPersonIconComponent, isStandalone: true, selector: "svg[feed-person-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPersonIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-person-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedPlusIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm1.062 4.312a1 1 0 1 0-2 0v2.75h-2.75a1 1 0 0 0 0 2h2.75v2.75a1 1 0 1 0 2 0v-2.75h2.75a1 1 0 1 0 0-2h-2.75Z"]
    }
};
class FeedPlusIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedPlusIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPlusIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedPlusIconComponent, isStandalone: true, selector: "svg[feed-plus-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPlusIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-plus-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedPublicIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm4.5.25v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H7v-1.5a1.5 1.5 0 0 1 2.443-1.167.75.75 0 0 0 .943-1.166A3 3 0 0 0 5.5 5.75v1.5a1 1 0 0 0-1 1Z"]
    }
};
class FeedPublicIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedPublicIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPublicIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedPublicIconComponent, isStandalone: true, selector: "svg[feed-public-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPublicIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-public-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedPullRequestClosedIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM5.5 12.25A1.75 1.75 0 0 0 6 8.822V6.928A1.752 1.752 0 0 0 5.5 3.5 1.75 1.75 0 0 0 5 6.928v1.894a1.752 1.752 0 0 0 .5 3.428Zm5-5a.5.5 0 0 0-.5.5v1.072a1.752 1.752 0 0 0 .5 3.428 1.75 1.75 0 0 0 .5-3.428V7.75a.5.5 0 0 0-.5-.5Zm1.255-2.763a.5.5 0 0 0-.707-.707l-.53.531-.531-.531a.5.5 0 0 0-.707.707l.531.531-.531.53a.5.5 0 0 0 .707.707l.531-.53.53.53a.5.5 0 0 0 .707-.707l-.53-.53Z"]
    }
};
class FeedPullRequestClosedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedPullRequestClosedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPullRequestClosedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedPullRequestClosedIconComponent, isStandalone: true, selector: "svg[feed-pull-request-closed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPullRequestClosedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-pull-request-closed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedPullRequestDraftIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm7.25 2.5c0-.793-.527-1.462-1.25-1.678V6.928A1.752 1.752 0 0 0 5.5 3.5 1.75 1.75 0 0 0 5 6.928v1.894a1.752 1.752 0 0 0 .5 3.428 1.75 1.75 0 0 0 1.75-1.75Zm3.25 1.75a1.75 1.75 0 1 0 .001-3.499 1.75 1.75 0 0 0-.001 3.499Zm0-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.75-3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"]
    }
};
class FeedPullRequestDraftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedPullRequestDraftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPullRequestDraftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedPullRequestDraftIconComponent, isStandalone: true, selector: "svg[feed-pull-request-draft-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPullRequestDraftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-pull-request-draft-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedPullRequestOpenIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm6.75 2.5c0-.793-.527-1.462-1.25-1.678V6.928A1.752 1.752 0 0 0 5 3.5a1.75 1.75 0 0 0-.5 3.428v1.894A1.752 1.752 0 0 0 5 12.25a1.75 1.75 0 0 0 1.75-1.75Zm3.25-5h.25a.5.5 0 0 1 .5.5v2.822a1.752 1.752 0 0 0 .5 3.428 1.75 1.75 0 0 0 .5-3.428V6a1.5 1.5 0 0 0-1.5-1.5H10V3.129a.25.25 0 0 0-.427-.177L7.702 4.823a.25.25 0 0 0 0 .354l1.871 1.871A.25.25 0 0 0 10 6.871Z"]
    }
};
class FeedPullRequestOpenIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedPullRequestOpenIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPullRequestOpenIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedPullRequestOpenIconComponent, isStandalone: true, selector: "svg[feed-pull-request-open-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedPullRequestOpenIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-pull-request-open-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedRepoIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM5.5 4A1.5 1.5 0 0 0 4 5.5v5c0 .828.5 1.5 1 1.5v-1a1 1 0 0 1 1-1h5v1h-1v1h1.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Zm.5 7.25v2.514a.25.25 0 0 0 .426.178l.898-.888a.25.25 0 0 1 .352 0l.898.888A.25.25 0 0 0 9 13.764V11H6.25a.25.25 0 0 0-.25.25Z"]
    }
};
class FeedRepoIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedRepoIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedRepoIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedRepoIconComponent, isStandalone: true, selector: "svg[feed-repo-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedRepoIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-repo-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedRocketIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm3.031-12a4.38 4.38 0 0 0-3.097 1.283l-.23.229c-.156.157-.308.32-.452.49H5.65a.876.876 0 0 0-.746.417l-.856 1.388a.377.377 0 0 0 .21.556l1.552.477 1.35 1.35.478 1.553a.374.374 0 0 0 .555.21l1.389-.855a.876.876 0 0 0 .416-.746V8.747c.17-.144.333-.295.49-.452l.23-.23A4.379 4.379 0 0 0 12 4.969v-.093A.876.876 0 0 0 11.124 4Zm-5.107 7.144h-.001a.809.809 0 0 0-1.33-.881c-.395.394-.564 1.258-.62 1.62a.12.12 0 0 0 .035.108.12.12 0 0 0 .108.035c.362-.056 1.226-.225 1.62-.619a.803.803 0 0 0 .188-.263Z"]
    }
};
class FeedRocketIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedRocketIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedRocketIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedRocketIconComponent, isStandalone: true, selector: "svg[feed-rocket-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedRocketIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-rocket-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedStarIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.252-12.932a.476.476 0 0 0-.682.195l-1.2 2.432-2.684.39a.477.477 0 0 0-.266.816l1.944 1.892-.46 2.674a.479.479 0 0 0 .694.504L8 10.709l2.4 1.261a.478.478 0 0 0 .694-.504l-.458-2.673L12.578 6.9a.479.479 0 0 0-.265-.815l-2.685-.39-1.2-2.432a.473.473 0 0 0-.176-.195Z"]
    }
};
class FeedStarIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedStarIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedStarIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedStarIconComponent, isStandalone: true, selector: "svg[feed-star-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedStarIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-star-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedTagIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.22 6.5a.72.72 0 1 1-1.44 0 .72.72 0 0 1 1.44 0Z", "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM4 5v3.38c.001.397.159.778.44 1.059l3.211 3.213a1.202 1.202 0 0 0 1.698 0l3.303-3.303a1.202 1.202 0 0 0 0-1.698L9.439 4.44A1.5 1.5 0 0 0 8.379 4H5a1 1 0 0 0-1 1Z"]
    }
};
class FeedTagIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedTagIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedTagIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedTagIconComponent, isStandalone: true, selector: "svg[feed-tag-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedTagIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-tag-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const feedTrophyIconData = {
    "16": {
        "width": 16,
        "paths": ["M11 5h1v1.146a1 1 0 0 1-.629.928L11 7.223V5ZM5 7.223l-.371-.149A1 1 0 0 1 4 6.146V5h1v2.223Z", "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM3 5v1.146a2 2 0 0 0 1.257 1.858l.865.346a3.005 3.005 0 0 0 2.294 2.093C7.22 11.404 6.658 12 5.502 12H5.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1c-1.158 0-1.72-.595-1.916-1.557a3.005 3.005 0 0 0 2.294-2.094l.865-.346A2 2 0 0 0 13 6.146V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z"]
    }
};
class FeedTrophyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = feedTrophyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedTrophyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FeedTrophyIconComponent, isStandalone: true, selector: "svg[feed-trophy-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FeedTrophyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[feed-trophy-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 9 4.25V1.5Zm6.75.062V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm2-.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4Zm10 0v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"]
    }
};
class FileIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileIconComponent, isStandalone: true, selector: "svg[file-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileAddedIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Zm4.48 3.758a.75.75 0 0 1 .755.745l.01 1.497h1.497a.75.75 0 0 1 0 1.5H9v1.507a.75.75 0 0 1-1.5 0V9.005l-1.502.01a.75.75 0 0 1-.01-1.5l1.507-.01-.01-1.492a.75.75 0 0 1 .745-.755Z"]
    }
};
class FileAddedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileAddedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileAddedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileAddedIconComponent, isStandalone: true, selector: "svg[file-added-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileAddedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-added-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileBadgeIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.75 1.5a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 1 13.25V1.75C1 .784 1.784 0 2.75 0h8a1.75 1.75 0 0 1 1.508.862.75.75 0 1 1-1.289.768.25.25 0 0 0-.219-.13h-8Z", "M8 7a3.999 3.999 0 0 1 7.605-1.733 4 4 0 0 1-1.115 4.863l.995 4.973a.75.75 0 0 1-.991.852l-2.409-.876a.248.248 0 0 0-.17 0l-2.409.876a.75.75 0 0 1-.991-.852l.994-4.973A3.994 3.994 0 0 1 8 7Zm4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 6.5c-.373 0-.745-.051-1.104-.154l-.649 3.243 1.155-.42c.386-.14.81-.14 1.196 0l1.155.42-.649-3.243A4.004 4.004 0 0 1 12 11Z"]
    }
};
class FileBadgeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileBadgeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileBadgeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileBadgeIconComponent, isStandalone: true, selector: "svg[file-badge-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileBadgeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-badge-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileBinaryIconData = {
    "16": {
        "width": 16,
        "paths": ["M4 1.75C4 .784 4.784 0 5.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 14.25 15h-9a.75.75 0 0 1 0-1.5h9a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 10 4.25V1.5H5.75a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0Zm-4 6C0 6.784.784 6 1.75 6h1.5C4.216 6 5 6.784 5 7.75v2.5A1.75 1.75 0 0 1 3.25 12h-1.5A1.75 1.75 0 0 1 0 10.25ZM6.75 6h1.5a.75.75 0 0 1 .75.75v3.75h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-3h-.75a.75.75 0 0 1 0-1.5Zm-5 1.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm9.75-5.938V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm12-.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z", "M0 13.75C0 12.784.784 12 1.75 12h3c.966 0 1.75.784 1.75 1.75v4a1.75 1.75 0 0 1-1.75 1.75h-3A1.75 1.75 0 0 1 0 17.75Zm1.75-.25a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25ZM9 12a.75.75 0 0 0 0 1.5h1.5V18H9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5H12v-5.25a.75.75 0 0 0-.75-.75H9Z"]
    }
};
class FileBinaryIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileBinaryIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileBinaryIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileBinaryIconComponent, isStandalone: true, selector: "svg[file-binary-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileBinaryIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-binary-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileCodeIconData = {
    "16": {
        "width": 16,
        "paths": ["M4 1.75C4 .784 4.784 0 5.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 14.25 15h-9a.75.75 0 0 1 0-1.5h9a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 10 4.25V1.5H5.75a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0Zm1.72 4.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.47-1.47-1.47-1.47a.75.75 0 0 1 0-1.06ZM3.28 7.78 1.81 9.25l1.47 1.47a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-2-2a.75.75 0 0 1 0-1.06l2-2a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Zm8.22-6.218V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm12-.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z", "M4.53 12.24a.75.75 0 0 1-.039 1.06l-2.639 2.45 2.64 2.45a.75.75 0 1 1-1.022 1.1l-3.23-3a.75.75 0 0 1 0-1.1l3.23-3a.75.75 0 0 1 1.06.04Zm3.979 1.06a.75.75 0 1 1 1.02-1.1l3.231 3a.75.75 0 0 1 0 1.1l-3.23 3a.75.75 0 1 1-1.021-1.1l2.639-2.45-2.64-2.45Z"]
    }
};
class FileCodeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileCodeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileCodeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileCodeIconComponent, isStandalone: true, selector: "svg[file-code-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileCodeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-code-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileDiffIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 1.75C1 .784 1.784 0 2.75 0h7.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073ZM8 3.25a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0V7h-1.5a.75.75 0 0 1 0-1.5h1.5V4A.75.75 0 0 1 8 3.25Zm-3 8a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.5 6.75a.75.75 0 0 0-1.5 0V9H8.75a.75.75 0 0 0 0 1.5H11v2.25a.75.75 0 0 0 1.5 0V10.5h2.25a.75.75 0 0 0 0-1.5H12.5V6.75ZM8.75 16a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z", "M5 1h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2Zm-.5 2v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V7.018a.5.5 0 0 0-.146-.354l-4.018-4.018a.5.5 0 0 0-.354-.146H5a.5.5 0 0 0-.5.5Z"]
    }
};
class FileDiffIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileDiffIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDiffIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileDiffIconComponent, isStandalone: true, selector: "svg[file-diff-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDiffIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-diff-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileDirectoryIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.784.784 1 1.75 1H5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H7.5c-.55 0-1.07-.26-1.4-.7l-.9-1.2a.25.25 0 0 0-.2-.1Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 4.75C2 3.784 2.784 3 3.75 3h4.971c.58 0 1.12.286 1.447.765l1.404 2.063c.046.069.124.11.207.11h8.471c.966 0 1.75.783 1.75 1.75V19.25A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V7.687a.25.25 0 0 0-.25-.25h-8.471a1.75 1.75 0 0 1-1.447-.765L8.928 4.61a.252.252 0 0 0-.208-.11Z"]
    }
};
class FileDirectoryIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileDirectoryIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDirectoryIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileDirectoryIconComponent, isStandalone: true, selector: "svg[file-directory-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDirectoryIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-directory-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileDirectoryFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 1A1.75 1.75 0 0 0 0 2.75v10.5C0 14.216.784 15 1.75 15h12.5A1.75 1.75 0 0 0 16 13.25v-8.5A1.75 1.75 0 0 0 14.25 3H7.5a.25.25 0 0 1-.2-.1l-.9-1.2C6.07 1.26 5.55 1 5 1H1.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 4.75C2 3.784 2.784 3 3.75 3h4.971c.58 0 1.12.286 1.447.765l1.404 2.063c.046.069.124.11.207.11h8.471c.966 0 1.75.783 1.75 1.75V19.25A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Z"]
    }
};
class FileDirectoryFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileDirectoryFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDirectoryFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileDirectoryFillIconComponent, isStandalone: true, selector: "svg[file-directory-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDirectoryFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-directory-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileDirectoryOpenFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M.513 1.513A1.75 1.75 0 0 1 1.75 1h3.5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1H13a1 1 0 0 1 1 1v.5H2.75a.75.75 0 0 0 0 1.5h11.978a1 1 0 0 1 .994 1.117L15 13.25A1.75 1.75 0 0 1 13.25 15H1.75A1.75 1.75 0 0 1 0 13.25V2.75c0-.464.184-.91.513-1.237Z"]
    }
};
class FileDirectoryOpenFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileDirectoryOpenFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDirectoryOpenFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileDirectoryOpenFillIconComponent, isStandalone: true, selector: "svg[file-directory-open-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDirectoryOpenFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-directory-open-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileDirectorySymlinkIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.784.784 1 1.75 1H5a1.75 1.75 0 0 1 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H5.375a.75.75 0 0 1 0-1.5h8.875a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H7.5a1.75 1.75 0 0 1-1.4-.7l-.9-1.2a.25.25 0 0 0-.2-.1H1.75a.25.25 0 0 0-.25.25v3a.75.75 0 0 1-1.5 0v-3Z", "M1.5 12.237a2.25 2.25 0 0 1 2.262-2.249L4 9.989v1.938c0 .218.26.331.42.183l2.883-2.677a.25.25 0 0 0 0-.366L4.42 6.39a.25.25 0 0 0-.42.183v1.916l-.229-.001A3.75 3.75 0 0 0 0 12.237v1.013a.75.75 0 0 0 1.5 0v-1.013Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 4.75C2 3.784 2.784 3 3.75 3h4.971a1.75 1.75 0 0 1 1.447.765l1.404 2.063a.25.25 0 0 0 .207.11h8.471c.966 0 1.75.783 1.75 1.75V19.25A1.75 1.75 0 0 1 20.25 21H4.75a.75.75 0 0 1 0-1.5h15.5a.25.25 0 0 0 .25-.25V7.688a.25.25 0 0 0-.25-.25h-8.471a1.751 1.751 0 0 1-1.447-.766L8.928 4.609a.252.252 0 0 0-.207-.109H3.75a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0v-3.5Z", "m9.308 12.5-2.104-2.236a.75.75 0 1 1 1.092-1.028l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.75.75 0 1 1-1.092-1.028L9.308 14H4.09a2.59 2.59 0 0 0-2.59 2.59v3.16a.75.75 0 0 1-1.5 0v-3.16a4.09 4.09 0 0 1 4.09-4.09h5.218Z"]
    }
};
class FileDirectorySymlinkIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileDirectorySymlinkIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDirectorySymlinkIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileDirectorySymlinkIconComponent, isStandalone: true, selector: "svg[file-directory-symlink-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileDirectorySymlinkIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-directory-symlink-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileMediaIconData = {
    "24": {
        "width": 24,
        "paths": ["M21.75 21.5H2.25A1.75 1.75 0 0 1 .5 19.75V4.25c0-.966.784-1.75 1.75-1.75h19.5c.966 0 1.75.784 1.75 1.75v15.5a1.75 1.75 0 0 1-1.75 1.75ZM2.25 4a.25.25 0 0 0-.25.25v15.5c0 .138.112.25.25.25h3.178L14 10.977a1.749 1.749 0 0 1 2.506-.032L22 16.44V4.25a.25.25 0 0 0-.25-.25ZM22 19.75v-1.19l-6.555-6.554a.248.248 0 0 0-.18-.073.247.247 0 0 0-.178.077L7.497 20H21.75a.25.25 0 0 0 .25-.25ZM10.5 9.25a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Zm-1.5 0a1.75 1.75 0 1 0-3.501.001A1.75 1.75 0 0 0 9 9.25Z"]
    }
};
class FileMediaIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileMediaIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileMediaIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileMediaIconComponent, isStandalone: true, selector: "svg[file-media-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileMediaIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-media-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileMovedIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073H3.75a.25.25 0 0 0-.25.25v6.5a.75.75 0 0 1-1.5 0v-6.5Z", "m5.427 15.573 3.146-3.146a.25.25 0 0 0 0-.354L5.427 8.927A.25.25 0 0 0 5 9.104V11.5H.75a.75.75 0 0 0 0 1.5H5v2.396c0 .223.27.335.427.177Z"]
    }
};
class FileMovedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileMovedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileMovedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileMovedIconComponent, isStandalone: true, selector: "svg[file-moved-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileMovedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-moved-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileRemovedIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Zm4.5 6h2.242a.75.75 0 0 1 0 1.5h-2.24l-2.254.015a.75.75 0 0 1-.01-1.5Z"]
    }
};
class FileRemovedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileRemovedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileRemovedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileRemovedIconComponent, isStandalone: true, selector: "svg[file-removed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileRemovedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-removed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileSubmoduleIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.784.784 1 1.75 1H5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm9.42 9.36 2.883-2.677a.25.25 0 0 0 0-.366L9.42 6.39a.249.249 0 0 0-.42.183V8.5H4.75a.75.75 0 0 0 0 1.5H9v1.927c0 .218.26.331.42.183Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 4.75C2 3.784 2.784 3 3.75 3h4.965a1.75 1.75 0 0 1 1.456.78l1.406 2.109a.25.25 0 0 0 .208.111h8.465c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Zm12.78 4.97a.749.749 0 0 0-1.275.326.749.749 0 0 0 .215.734l1.72 1.72H6.75a.75.75 0 0 0 0 1.5h8.69l-1.72 1.72a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215l3-3a.75.75 0 0 0 0-1.06Z"]
    }
};
class FileSubmoduleIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileSubmoduleIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileSubmoduleIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileSubmoduleIconComponent, isStandalone: true, selector: "svg[file-submodule-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileSubmoduleIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-submodule-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileSymlinkFileIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.784 0 3.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 12.25 15h-7a.75.75 0 0 1 0-1.5h7a.25.25 0 0 0 .25-.25V6H9.75A1.75 1.75 0 0 1 8 4.25V1.5H3.75a.25.25 0 0 0-.25.25V4.5a.75.75 0 0 1-1.5 0Zm-.5 10.487v1.013a.75.75 0 0 1-1.5 0v-1.012a3.748 3.748 0 0 1 3.77-3.749L4 8.49V6.573a.25.25 0 0 1 .42-.183l2.883 2.678a.25.25 0 0 1 0 .366L4.42 12.111a.25.25 0 0 1-.42-.183V9.99l-.238-.003a2.25 2.25 0 0 0-2.262 2.25Zm8-10.675V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm6.308 11.5-2.104-2.236a.751.751 0 0 1 .369-1.255.749.749 0 0 1 .723.227l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.749.749 0 0 1-1.275-.293.751.751 0 0 1 .183-.735L9.308 16H4.09a2.59 2.59 0 0 0-2.59 2.59v3.16a.75.75 0 0 1-1.5 0v-3.16a4.09 4.09 0 0 1 4.09-4.09ZM15 2.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"]
    }
};
class FileSymlinkFileIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileSymlinkFileIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileSymlinkFileIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileSymlinkFileIconComponent, isStandalone: true, selector: "svg[file-symlink-file-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileSymlinkFileIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-symlink-file-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fileZipIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.5 1.75v11.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 2 13.25V1.75C2 .784 2.784 0 3.75 0h5.586c.464 0 .909.185 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 12.25 15h-.5a.75.75 0 0 1 0-1.5h.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177L9.513 1.573a.25.25 0 0 0-.177-.073H7.25a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5h-3a.25.25 0 0 0-.25.25Zm3.75 8.75h.5c.966 0 1.75.784 1.75 1.75v3a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-3c0-.966.784-1.75 1.75-1.75ZM6 5.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 5.25Zm.75 2.25h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM8 6.75A.75.75 0 0 1 8.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 8 6.75ZM8.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM8 9.75A.75.75 0 0 1 8.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 8 9.75Zm-1 2.5v2.25h1v-2.25a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5 2.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h1.75a.75.75 0 0 1 0 1.5H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2h-2.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V7.018a.5.5 0 0 0-.146-.354l-4.018-4.018a.5.5 0 0 0-.354-.146H5Z", "M11.5 15.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm.75-3.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm-.75-2.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM12.25 6a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm-.75-2.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM9.75 13.5a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM9 11.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm.75-3.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM9 5.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 9 5.25ZM11 17h1a2 2 0 0 1 2 2v4.25a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V19a2 2 0 0 1 2-2Zm-.5 2v3.5h2V19a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Z"]
    }
};
class FileZipIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fileZipIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileZipIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FileZipIconComponent, isStandalone: true, selector: "svg[file-zip-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FileZipIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[file-zip-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const filterIconData = {
    "16": {
        "width": 16,
        "paths": ["M.75 3h14.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2.75 6a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75ZM6 11.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75Zm4 4.938a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"]
    }
};
class FilterIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = filterIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FilterIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FilterIconComponent, isStandalone: true, selector: "svg[filter-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FilterIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[filter-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const filterRemoveIconData = {
    "16": {
        "width": 16,
        "paths": ["M14.384 4.57a.752.752 0 0 0 1.061 0 .752.752 0 0 0 0-1.061l-.884-.884.883-.884A.75.75 0 0 0 14.384.68l-.884.884-.884-.884a.75.75 0 0 0-1.06 1.061l.883.884-.883.884a.75.75 0 0 0 1.06 1.061l.884-.884.884.884ZM.75 3a.75.75 0 0 0 0 1.5H9A.75.75 0 0 0 9 3H.75ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M21.587 9.273a.75.75 0 1 0 1.061-1.061l-1.591-1.591 1.591-1.591a.749.749 0 1 0-1.061-1.06l-1.591 1.591-1.591-1.591a.749.749 0 1 0-1.06 1.06l1.591 1.591-1.591 1.591a.75.75 0 0 0 1.06 1.061l1.591-1.591 1.591 1.591ZM1.75 6a.75.75 0 0 0 0 1.5H14.5a.75.75 0 0 0 0-1.5H1.75ZM5 11.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75Zm4 4.938a.75.75 0 0 1 .75-.75h2.5a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"]
    }
};
class FilterRemoveIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = filterRemoveIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FilterRemoveIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FilterRemoveIconComponent, isStandalone: true, selector: "svg[filter-remove-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FilterRemoveIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[filter-remove-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const fiscalHostIconData = {
    "16": {
        "width": 16,
        "paths": ["M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", "M4 9.25h-.75a.75.75 0 0 1 0-1.5H4v-1.5h-.75a.75.75 0 0 1 0-1.5H4V3.5a1 1 0 0 1 1-1h7.5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1ZM5.5 4v.793a.75.75 0 0 1 0 1.414v1.586a.75.75 0 0 1 0 1.414V10H12V4Z", "M12.75 14.25V14h-9.5v.25a.75.75 0 0 1-1.5 0V14A1.75 1.75 0 0 1 0 12.25V1.75C0 .784.784 0 1.75 0h12.5C15.217 0 16 .784 16 1.75v10.5A1.75 1.75 0 0 1 14.25 14v.25a.75.75 0 0 1-1.5 0ZM1.75 1.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class FiscalHostIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = fiscalHostIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FiscalHostIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FiscalHostIconComponent, isStandalone: true, selector: "svg[fiscal-host-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FiscalHostIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[fiscal-host-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const flameIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.533.753V.752c.217 2.385 1.463 3.626 2.653 4.81C13.37 6.74 14.498 7.863 14.498 10c0 3.5-3 6-6.5 6S1.5 13.512 1.5 10c0-1.298.536-2.56 1.425-3.286.376-.308.862 0 1.035.454C4.46 8.487 5.581 8.419 6 8c.282-.282.341-.811-.003-1.5C4.34 3.187 7.035.75 8.77.146c.39-.137.726.194.763.607ZM7.998 14.5c2.832 0 5-1.98 5-4.5 0-1.463-.68-2.19-1.879-3.383l-.036-.037c-1.013-1.008-2.3-2.29-2.834-4.434-.322.256-.63.579-.864.953-.432.696-.621 1.58-.046 2.73.473.947.67 2.284-.278 3.232-.61.61-1.545.84-2.403.633a2.79 2.79 0 0 1-1.436-.874A3.198 3.198 0 0 0 3 10c0 2.53 2.164 4.5 4.998 4.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M14.265 1.627c0 3.545 1.869 5.327 3.479 7.021 1.54 1.62 3.006 3.163 3.006 6.102 0 4.812-3.753 8.25-8.565 8.25-4.813 0-8.935-3.421-8.935-8.25 0-2.039.962-4.011 2.509-4.899.305-.175.672.007.803.334C7.563 12.684 8.797 12.64 9.437 12c.388-.387.47-1.116-.004-2.062-2.405-4.812 1.863-8.279 4.2-8.854.336-.082.615.198.632.543ZM12.185 21.5c4.059 0 7.065-2.84 7.065-6.75 0-2.337-1.093-3.489-2.678-5.158l-.021-.023c-1.44-1.517-3.139-3.351-3.649-6.557a6.148 6.148 0 0 0-1.911 1.76c-.787 1.144-1.147 2.633-.216 4.495.603 1.205.777 2.74-.277 3.794-.657.657-1.762 1.1-2.956.586-.752-.324-1.353-.955-1.838-1.79-.567.706-.954 1.74-.954 2.893 0 3.847 3.288 6.75 7.435 6.75Z"]
    }
};
class FlameIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = flameIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FlameIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FlameIconComponent, isStandalone: true, selector: "svg[flame-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FlameIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[flame-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const foldIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.896 2H8.75V.75a.75.75 0 0 0-1.5 0V2H5.104a.25.25 0 0 0-.177.427l2.896 2.896a.25.25 0 0 0 .354 0l2.896-2.896A.25.25 0 0 0 10.896 2ZM8.75 15.25a.75.75 0 0 1-1.5 0V14H5.104a.25.25 0 0 1-.177-.427l2.896-2.896a.25.25 0 0 1 .354 0l2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25Zm-6.5-6.5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 15c.199 0 .389.079.53.22l3.25 3.25a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 16.81l-2.72 2.72a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25A.749.749 0 0 1 12 15Z", "M12.53 8.78a.75.75 0 0 1-1.06 0L8.22 5.53a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L12 7.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734ZM12 15.75a.75.75 0 0 1 .75.75v5.75a.75.75 0 0 1-1.5 0V16.5a.75.75 0 0 1 .75-.75Z", "M12 8.5a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"]
    }
};
class FoldIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = foldIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FoldIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FoldIconComponent, isStandalone: true, selector: "svg[fold-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FoldIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[fold-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const foldDownIconData = {
    "16": {
        "width": 16,
        "paths": ["m8.177 14.323 2.896-2.896a.25.25 0 0 0-.177-.427H8.75V7.764a.75.75 0 1 0-1.5 0V11H5.104a.25.25 0 0 0-.177.427l2.896 2.896a.25.25 0 0 0 .354 0ZM2.25 5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 4.25a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5a.75.75 0 0 1 .75.75ZM8.25 5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 4.25a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5a.75.75 0 0 1 .75.75Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 19a.749.749 0 0 1-.53-.22l-3.25-3.25a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215L12 17.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-3.25 3.25A.749.749 0 0 1 12 19Z", "M12 18a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 18ZM2.75 6a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 2.75 6Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6.75 6Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"]
    }
};
class FoldDownIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = foldDownIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FoldDownIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FoldDownIconComponent, isStandalone: true, selector: "svg[fold-down-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FoldDownIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[fold-down-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const foldUpIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.823 1.677 4.927 4.573A.25.25 0 0 0 5.104 5H7.25v3.236a.75.75 0 1 0 1.5 0V5h2.146a.25.25 0 0 0 .177-.427L8.177 1.677a.25.25 0 0 0-.354 0ZM13.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm-3.75.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM7.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM4 11.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM1.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.47 5.22a.75.75 0 0 1 1.06 0l3.25 3.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L12 6.81 9.28 9.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Z", "M12 5.5a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0v-8A.75.75 0 0 1 12 5.5ZM2.75 18a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"]
    }
};
class FoldUpIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = foldUpIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FoldUpIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: FoldUpIconComponent, isStandalone: true, selector: "svg[fold-up-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: FoldUpIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[fold-up-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gearIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8.2 8.2 0 0 1 .701.031C9.444.095 9.99.645 10.16 1.29l.288 1.107c.018.066.079.158.212.224.231.114.454.243.668.386.123.082.233.09.299.071l1.103-.303c.644-.176 1.392.021 1.82.63.27.385.506.792.704 1.218.315.675.111 1.422-.364 1.891l-.814.806c-.049.048-.098.147-.088.294.016.257.016.515 0 .772-.01.147.038.246.088.294l.814.806c.475.469.679 1.216.364 1.891a7.977 7.977 0 0 1-.704 1.217c-.428.61-1.176.807-1.82.63l-1.102-.302c-.067-.019-.177-.011-.3.071a5.909 5.909 0 0 1-.668.386c-.133.066-.194.158-.211.224l-.29 1.106c-.168.646-.715 1.196-1.458 1.26a8.006 8.006 0 0 1-1.402 0c-.743-.064-1.289-.614-1.458-1.26l-.289-1.106c-.018-.066-.079-.158-.212-.224a5.738 5.738 0 0 1-.668-.386c-.123-.082-.233-.09-.299-.071l-1.103.303c-.644.176-1.392-.021-1.82-.63a8.12 8.12 0 0 1-.704-1.218c-.315-.675-.111-1.422.363-1.891l.815-.806c.05-.048.098-.147.088-.294a6.214 6.214 0 0 1 0-.772c.01-.147-.038-.246-.088-.294l-.815-.806C.635 6.045.431 5.298.746 4.623a7.92 7.92 0 0 1 .704-1.217c.428-.61 1.176-.807 1.82-.63l1.102.302c.067.019.177.011.3-.071.214-.143.437-.272.668-.386.133-.066.194-.158.211-.224l.29-1.106C6.009.645 6.556.095 7.299.03 7.53.01 7.764 0 8 0Zm-.571 1.525c-.036.003-.108.036-.137.146l-.289 1.105c-.147.561-.549.967-.998 1.189-.173.086-.34.183-.5.29-.417.278-.97.423-1.529.27l-1.103-.303c-.109-.03-.175.016-.195.045-.22.312-.412.644-.573.99-.014.031-.021.11.059.19l.815.806c.411.406.562.957.53 1.456a4.709 4.709 0 0 0 0 .582c.032.499-.119 1.05-.53 1.456l-.815.806c-.081.08-.073.159-.059.19.162.346.353.677.573.989.02.03.085.076.195.046l1.102-.303c.56-.153 1.113-.008 1.53.27.161.107.328.204.501.29.447.222.85.629.997 1.189l.289 1.105c.029.109.101.143.137.146a6.6 6.6 0 0 0 1.142 0c.036-.003.108-.036.137-.146l.289-1.105c.147-.561.549-.967.998-1.189.173-.086.34-.183.5-.29.417-.278.97-.423 1.529-.27l1.103.303c.109.029.175-.016.195-.045.22-.313.411-.644.573-.99.014-.031.021-.11-.059-.19l-.815-.806c-.411-.406-.562-.957-.53-1.456a4.709 4.709 0 0 0 0-.582c-.032-.499.119-1.05.53-1.456l.815-.806c.081-.08.073-.159.059-.19a6.464 6.464 0 0 0-.573-.989c-.02-.03-.085-.076-.195-.046l-1.102.303c-.56.153-1.113.008-1.53-.27a4.44 4.44 0 0 0-.501-.29c-.447-.222-.85-.629-.997-1.189l-.289-1.105c-.029-.11-.101-.143-.137-.146a6.6 6.6 0 0 0-1.142 0ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9.5 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 8Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z", "M12 1c.266 0 .532.009.797.028.763.055 1.345.617 1.512 1.304l.352 1.45c.019.078.09.171.225.221.247.089.49.19.728.302.13.061.246.044.315.002l1.275-.776c.603-.368 1.411-.353 1.99.147.402.349.78.726 1.128 1.129.501.578.515 1.386.147 1.99l-.776 1.274c-.042.069-.058.185.002.315.112.238.213.481.303.728.048.135.142.205.22.225l1.45.352c.687.167 1.249.749 1.303 1.512.038.531.038 1.063 0 1.594-.054.763-.616 1.345-1.303 1.512l-1.45.352c-.078.019-.171.09-.221.225-.089.248-.19.491-.302.728-.061.13-.044.246-.002.315l.776 1.275c.368.603.353 1.411-.147 1.99-.349.402-.726.78-1.129 1.128-.578.501-1.386.515-1.99.147l-1.274-.776c-.069-.042-.185-.058-.314.002a8.606 8.606 0 0 1-.729.303c-.135.048-.205.142-.225.22l-.352 1.45c-.167.687-.749 1.249-1.512 1.303-.531.038-1.063.038-1.594 0-.763-.054-1.345-.616-1.512-1.303l-.352-1.45c-.019-.078-.09-.171-.225-.221a8.138 8.138 0 0 1-.728-.302c-.13-.061-.246-.044-.315-.002l-1.275.776c-.603.368-1.411.353-1.99-.147-.402-.349-.78-.726-1.128-1.129-.501-.578-.515-1.386-.147-1.99l.776-1.274c.042-.069.058-.185-.002-.314a8.606 8.606 0 0 1-.303-.729c-.048-.135-.142-.205-.22-.225l-1.45-.352c-.687-.167-1.249-.749-1.304-1.512a11.158 11.158 0 0 1 0-1.594c.055-.763.617-1.345 1.304-1.512l1.45-.352c.078-.019.171-.09.221-.225.089-.248.19-.491.302-.728.061-.13.044-.246.002-.315l-.776-1.275c-.368-.603-.353-1.411.147-1.99.349-.402.726-.78 1.129-1.128.578-.501 1.386-.515 1.99-.147l1.274.776c.069.042.185.058.315-.002.238-.112.481-.213.728-.303.135-.048.205-.142.225-.22l.352-1.45c.167-.687.749-1.249 1.512-1.304C11.466 1.01 11.732 1 12 1Zm-.69 1.525c-.055.004-.135.05-.161.161l-.353 1.45a1.832 1.832 0 0 1-1.172 1.277 7.147 7.147 0 0 0-.6.249 1.833 1.833 0 0 1-1.734-.074l-1.274-.776c-.098-.06-.186-.036-.228 0a9.774 9.774 0 0 0-.976.976c-.036.042-.06.131 0 .228l.776 1.274c.314.529.342 1.18.074 1.734a7.147 7.147 0 0 0-.249.6 1.831 1.831 0 0 1-1.278 1.173l-1.45.351c-.11.027-.156.107-.16.162a9.63 9.63 0 0 0 0 1.38c.004.055.05.135.161.161l1.45.353a1.832 1.832 0 0 1 1.277 1.172c.074.204.157.404.249.6.268.553.24 1.204-.074 1.733l-.776 1.275c-.06.098-.036.186 0 .228.301.348.628.675.976.976.042.036.131.06.228 0l1.274-.776a1.83 1.83 0 0 1 1.734-.075c.196.093.396.176.6.25a1.831 1.831 0 0 1 1.173 1.278l.351 1.45c.027.11.107.156.162.16a9.63 9.63 0 0 0 1.38 0c.055-.004.135-.05.161-.161l.353-1.45a1.834 1.834 0 0 1 1.172-1.278 6.82 6.82 0 0 0 .6-.248 1.831 1.831 0 0 1 1.733.074l1.275.776c.098.06.186.036.228 0 .348-.301.675-.628.976-.976.036-.042.06-.131 0-.228l-.776-1.275a1.834 1.834 0 0 1-.075-1.733c.093-.196.176-.396.25-.6a1.831 1.831 0 0 1 1.278-1.173l1.45-.351c.11-.027.156-.107.16-.162a9.63 9.63 0 0 0 0-1.38c-.004-.055-.05-.135-.161-.161l-1.45-.353c-.626-.152-1.08-.625-1.278-1.172a6.576 6.576 0 0 0-.248-.6 1.833 1.833 0 0 1 .074-1.734l.776-1.274c.06-.098.036-.186 0-.228a9.774 9.774 0 0 0-.976-.976c-.042-.036-.131-.06-.228 0l-1.275.776a1.831 1.831 0 0 1-1.733.074 6.88 6.88 0 0 0-.6-.249 1.835 1.835 0 0 1-1.173-1.278l-.351-1.45c-.027-.11-.107-.156-.162-.16a9.63 9.63 0 0 0-1.38 0Z"]
    }
};
class GearIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gearIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GearIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GearIconComponent, isStandalone: true, selector: "svg[gear-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GearIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[gear-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const giftIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 2.75A2.75 2.75 0 0 1 4.75 0c.983 0 1.873.42 2.57 1.232.268.318.497.668.68 1.042.183-.375.411-.725.68-1.044C9.376.42 10.266 0 11.25 0a2.75 2.75 0 0 1 2.45 4h.55c.966 0 1.75.784 1.75 1.75v2c0 .698-.409 1.301-1 1.582v4.918A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25V9.332C.409 9.05 0 8.448 0 7.75v-2C0 4.784.784 4 1.75 4h.55c-.192-.375-.3-.8-.3-1.25ZM7.25 9.5H2.5v4.75c0 .138.112.25.25.25h4.5Zm1.5 0v5h4.5a.25.25 0 0 0 .25-.25V9.5Zm0-4V8h5.5a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25Zm-7 0a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h5.5V5.5h-5.5Zm3-4a1.25 1.25 0 0 0 0 2.5h2.309c-.233-.818-.542-1.401-.878-1.793-.43-.502-.915-.707-1.431-.707ZM8.941 4h2.309a1.25 1.25 0 0 0 0-2.5c-.516 0-1 .205-1.43.707-.337.392-.646.975-.879 1.793Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.75 3.75A3.75 3.75 0 0 1 7.5 0c1.455 0 3.436.901 4.5 3.11C13.064.901 15.044 0 16.5 0a3.75 3.75 0 0 1 3 6h1.75c.966 0 1.75.784 1.75 1.75v2.5c0 .698-.409 1.301-1 1.582v8.418A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-8.418c-.591-.282-1-.884-1-1.582v-2.5C1 6.784 1.784 6 2.75 6H4.5a3.733 3.733 0 0 1-.75-2.25ZM20.5 12h-7.75v8.5h7.5a.25.25 0 0 0 .25-.25Zm-9.25 8.5V12H3.5v8.25c0 .138.112.25.25.25Zm10-10a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-8.5v3Zm-18.5 0h8.5v-3h-8.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25Zm16-6.75A2.25 2.25 0 0 0 16.5 1.5c-1.15 0-3.433 1.007-3.72 4.5h3.72a2.25 2.25 0 0 0 2.25-2.25ZM11.22 6c-.287-3.493-2.57-4.5-3.72-4.5a2.25 2.25 0 1 0 0 4.5Z"]
    }
};
class GiftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = giftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GiftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GiftIconComponent, isStandalone: true, selector: "svg[gift-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GiftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[gift-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gitBranchIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.5 3.25a2.25 2.25 0 1 1 3 2.122V6A2.5 2.5 0 0 1 10 8.5H6a1 1 0 0 0-1 1v1.128a2.251 2.251 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.5 0v1.836A2.493 2.493 0 0 1 6 7h4a1 1 0 0 0 1-1v-.628A2.25 2.25 0 0 1 9.5 3.25Zm-6 0a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm8.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15 4.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM2.5 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5Zm0 14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 21Zm12.5-14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 6.5Z", "M5.75 16.75A.75.75 0 0 1 5 16V8a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-.75.75Z", "M17.5 8.75v-1H19v1a3.75 3.75 0 0 1-3.75 3.75h-7a1.75 1.75 0 0 0-1.75 1.75H5A3.25 3.25 0 0 1 8.25 11h7a2.25 2.25 0 0 0 2.25-2.25Z"]
    }
};
class GitBranchIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gitBranchIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitBranchIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GitBranchIconComponent, isStandalone: true, selector: "svg[git-branch-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitBranchIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[git-branch-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gitCommitIconData = {
    "16": {
        "width": 16,
        "paths": ["M11.93 8.5a4.002 4.002 0 0 1-7.86 0H.75a.75.75 0 0 1 0-1.5h3.32a4.002 4.002 0 0 1 7.86 0h3.32a.75.75 0 0 1 0 1.5Zm-1.43-.75a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16.944 11h4.306a.75.75 0 0 1 0 1.5h-4.306a5.001 5.001 0 0 1-9.888 0H2.75a.75.75 0 0 1 0-1.5h4.306a5.001 5.001 0 0 1 9.888 0Zm-1.444.75a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0Z"]
    }
};
class GitCommitIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gitCommitIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitCommitIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GitCommitIconComponent, isStandalone: true, selector: "svg[git-commit-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitCommitIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[git-commit-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gitCompareIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM6 12v-1.646a.25.25 0 0 1 .427-.177l2.396 2.396a.25.25 0 0 1 0 .354l-2.396 2.396A.25.25 0 0 1 6 15.146V13.5H5A2.5 2.5 0 0 1 2.5 11V5.372a2.25 2.25 0 1 1 1.5 0V11a1 1 0 0 0 1 1ZM4 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM12.75 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16.5 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm3.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z", "M13.905 1.72a.75.75 0 0 1 0 1.06L12.685 4h4.065a3.75 3.75 0 0 1 3.75 3.75v8.75a.75.75 0 0 1-1.5 0V7.75a2.25 2.25 0 0 0-2.25-2.25h-4.064l1.22 1.22a.75.75 0 0 1-1.061 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM7.5 4.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0ZM4.25 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 4.25 6.5Z", "M10.095 22.28a.75.75 0 0 1 0-1.06l1.22-1.22H7.25a3.75 3.75 0 0 1-3.75-3.75V7.5a.75.75 0 0 1 1.5 0v8.75a2.25 2.25 0 0 0 2.25 2.25h4.064l-1.22-1.22a.748.748 0 0 1 .332-1.265.75.75 0 0 1 .729.205l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0Z"]
    }
};
class GitCompareIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gitCompareIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitCompareIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GitCompareIconComponent, isStandalone: true, selector: "svg[git-compare-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitCompareIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[git-compare-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gitMergeIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.45 5.154A4.25 4.25 0 0 0 9.25 7.5h1.378a2.251 2.251 0 1 1 0 1.5H9.25A5.734 5.734 0 0 1 5 7.123v3.505a2.25 2.25 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.95-.218ZM4.25 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.5-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5 3.25a.75.75 0 1 0 0 .005V3.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15 13.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-12.5 6a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5Zm0 14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 21Zm12.5-6a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 15Z", "M6.5 7.25c0 2.9 2.35 5.25 5.25 5.25h4.5V14h-4.5A6.75 6.75 0 0 1 5 7.25Z", "M5.75 16.75A.75.75 0 0 1 5 16V8a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-.75.75Z"]
    }
};
class GitMergeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gitMergeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitMergeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GitMergeIconComponent, isStandalone: true, selector: "svg[git-merge-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitMergeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[git-merge-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gitMergeQueueIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.75 4.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM3 7.75a.75.75 0 0 1 1.5 0v2.878a2.251 2.251 0 1 1-1.5 0Zm.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm5-7.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm5.75 2.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-1.5 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.75 6.5a1.75 1.75 0 1 1 .001-3.501A1.75 1.75 0 0 1 5.75 6.5ZM9.5 8.75a1.75 1.75 0 1 1 3.501.001A1.75 1.75 0 0 1 9.5 8.75ZM5.75 22.5a3.25 3.25 0 0 1-.745-6.414A.81.81 0 0 1 5 16v-5a.75.75 0 0 1 1.5 0v5a.81.81 0 0 1-.005.086A3.252 3.252 0 0 1 5.75 22.5ZM4 19.25a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 4 19.25Zm11-6.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm3.25 1.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"]
    }
};
class GitMergeQueueIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gitMergeQueueIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitMergeQueueIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GitMergeQueueIconComponent, isStandalone: true, selector: "svg[git-merge-queue-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitMergeQueueIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[git-merge-queue-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gitPullRequestIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-14.5 0a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM4.75 3a1.75 1.75 0 1 0 .001 3.501A1.75 1.75 0 0 0 4.75 3Zm0 14.5a1.75 1.75 0 1 0 .001 3.501A1.75 1.75 0 0 0 4.75 17.5Zm14.5 0a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z", "M13.405 1.72a.75.75 0 0 1 0 1.06L12.185 4h4.065A3.75 3.75 0 0 1 20 7.75v8.75a.75.75 0 0 1-1.5 0V7.75a2.25 2.25 0 0 0-2.25-2.25h-4.064l1.22 1.22a.75.75 0 0 1-1.061 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM4.75 7.25A.75.75 0 0 1 5.5 8v8A.75.75 0 0 1 4 16V8a.75.75 0 0 1 .75-.75Z"]
    }
};
class GitPullRequestIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gitPullRequestIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitPullRequestIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GitPullRequestIconComponent, isStandalone: true, selector: "svg[git-pull-request-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitPullRequestIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[git-pull-request-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gitPullRequestClosedIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 5.5a.75.75 0 0 1 .75.75v3.378a2.251 2.251 0 1 1-1.5 0V7.25a.75.75 0 0 1 .75-.75Zm-2.03-5.273a.75.75 0 0 1 1.06 0l.97.97.97-.97a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.97.97.97.97a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-.97-.97-.97.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l.97-.97-.97-.97a.75.75 0 0 1 0-1.06ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M22.266 2.711a.75.75 0 1 0-1.061-1.06l-1.983 1.983-1.984-1.983a.75.75 0 1 0-1.06 1.06l1.983 1.983-1.983 1.984a.75.75 0 0 0 1.06 1.06l1.984-1.983 1.983 1.983a.75.75 0 0 0 1.06-1.06l-1.983-1.984 1.984-1.983ZM4.75 1.5a3.25 3.25 0 0 1 .745 6.414A.827.827 0 0 1 5.5 8v8a.827.827 0 0 1-.005.086A3.25 3.25 0 0 1 4.75 22.5a3.25 3.25 0 0 1-.745-6.414A.827.827 0 0 1 4 16V8c0-.029.002-.057.005-.086A3.25 3.25 0 0 1 4.75 1.5ZM16 19.25a3.252 3.252 0 0 1 2.5-3.163V9.625a.75.75 0 0 1 1.5 0v6.462a3.252 3.252 0 0 1-.75 6.413A3.25 3.25 0 0 1 16 19.25ZM3 4.75a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 4.75Zm0 14.5a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 19.25Zm16.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z"]
    }
};
class GitPullRequestClosedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gitPullRequestClosedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitPullRequestClosedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GitPullRequestClosedIconComponent, isStandalone: true, selector: "svg[git-pull-request-closed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitPullRequestClosedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[git-pull-request-closed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const gitPullRequestDraftIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 14a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM14 7.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm0-4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.75 1.5a3.25 3.25 0 0 1 .745 6.414A.827.827 0 0 1 5.5 8v8a.827.827 0 0 1-.005.086A3.25 3.25 0 0 1 4.75 22.5a3.25 3.25 0 0 1-.745-6.414A.827.827 0 0 1 4 16V8c0-.029.002-.057.005-.086A3.25 3.25 0 0 1 4.75 1.5ZM16 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM3 4.75a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 4.75Zm0 14.5a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 19.25Zm16.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Zm0-11.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM21 11.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"]
    }
};
class GitPullRequestDraftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = gitPullRequestDraftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitPullRequestDraftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GitPullRequestDraftIconComponent, isStandalone: true, selector: "svg[git-pull-request-draft-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GitPullRequestDraftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[git-pull-request-draft-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const globeIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM5.78 8.75a9.64 9.64 0 0 0 1.363 4.177c.255.426.542.832.857 1.215.245-.296.551-.705.857-1.215A9.64 9.64 0 0 0 10.22 8.75Zm4.44-1.5a9.64 9.64 0 0 0-1.363-4.177c-.307-.51-.612-.919-.857-1.215a9.927 9.927 0 0 0-.857 1.215A9.64 9.64 0 0 0 5.78 7.25Zm-5.944 1.5H1.543a6.507 6.507 0 0 0 4.666 5.5c-.123-.181-.24-.365-.352-.552-.715-1.192-1.437-2.874-1.581-4.948Zm-2.733-1.5h2.733c.144-2.074.866-3.756 1.58-4.948.12-.197.237-.381.353-.552a6.507 6.507 0 0 0-4.666 5.5Zm10.181 1.5c-.144 2.074-.866 3.756-1.58 4.948-.12.197-.237.381-.353.552a6.507 6.507 0 0 0 4.666-5.5Zm2.733-1.5a6.507 6.507 0 0 0-4.666-5.5c.123.181.24.365.353.552.714 1.192 1.436 2.874 1.58 4.948Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm3.241 10.5v-.001c-.1-2.708-.992-4.904-1.89-6.452a13.919 13.919 0 0 0-1.304-1.88L12 3.11l-.047.059c-.354.425-.828 1.06-1.304 1.88-.898 1.547-1.79 3.743-1.89 6.451Zm-12.728 0h4.745c.1-3.037 1.1-5.49 2.093-7.204.39-.672.78-1.233 1.119-1.673C6.11 3.329 2.746 7 2.513 11.5Zm18.974 0C21.254 7 17.89 3.329 13.53 2.623c.339.44.729 1.001 1.119 1.673.993 1.714 1.993 4.167 2.093 7.204ZM8.787 13c.182 2.478 1.02 4.5 1.862 5.953.382.661.818 1.29 1.304 1.88l.047.057.047-.059c.354-.425.828-1.06 1.304-1.88.842-1.451 1.679-3.471 1.862-5.951Zm-1.504 0H2.552a9.505 9.505 0 0 0 7.918 8.377 15.773 15.773 0 0 1-1.119-1.673C8.413 18.085 7.47 15.807 7.283 13Zm9.434 0c-.186 2.807-1.13 5.085-2.068 6.704-.39.672-.78 1.233-1.118 1.673A9.506 9.506 0 0 0 21.447 13Z"]
    }
};
class GlobeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = globeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GlobeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GlobeIconComponent, isStandalone: true, selector: "svg[globe-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GlobeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[globe-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const goalIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.637 2.363h-.001l1.676.335c.09.018.164.084.19.173a.25.25 0 0 1-.062.249l-1.373 1.374a.876.876 0 0 1-.619.256H12.31L9.45 7.611A1.5 1.5 0 1 1 6.5 8a1.501 1.501 0 0 1 1.889-1.449l2.861-2.862V2.552c0-.232.092-.455.256-.619L12.88.559a.25.25 0 0 1 .249-.062c.089.026.155.1.173.19Z", "M2 8a6 6 0 1 0 11.769-1.656.751.751 0 1 1 1.442-.413 7.502 7.502 0 0 1-12.513 7.371A7.501 7.501 0 0 1 10.069.789a.75.75 0 0 1-.413 1.442A6.001 6.001 0 0 0 2 8Z", "M5 8a3.002 3.002 0 0 0 4.699 2.476 3 3 0 0 0 1.28-2.827.748.748 0 0 1 1.045-.782.75.75 0 0 1 .445.61A4.5 4.5 0 1 1 8.516 3.53a.75.75 0 1 1-.17 1.49A3 3 0 0 0 5 8Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M20.172 6.75h-1.861l-4.566 4.564a1.874 1.874 0 1 1-1.06-1.06l4.565-4.565V3.828a.94.94 0 0 1 .275-.664l1.73-1.73a.249.249 0 0 1 .25-.063c.089.026.155.1.173.191l.46 2.301 2.3.46c.09.018.164.084.19.173a.25.25 0 0 1-.062.249l-1.731 1.73a.937.937 0 0 1-.663.275Z", "M2.625 12A9.375 9.375 0 0 0 12 21.375 9.375 9.375 0 0 0 21.375 12c0-.898-.126-1.766-.361-2.587A.75.75 0 0 1 22.455 9c.274.954.42 1.96.42 3 0 6.006-4.869 10.875-10.875 10.875S1.125 18.006 1.125 12 5.994 1.125 12 1.125c1.015-.001 2.024.14 3 .419a.75.75 0 1 1-.413 1.442A9.39 9.39 0 0 0 12 2.625 9.375 9.375 0 0 0 2.625 12Z", "M7.125 12a4.874 4.874 0 1 0 9.717-.569.748.748 0 0 1 1.047-.798c.251.112.42.351.442.625a6.373 6.373 0 0 1-10.836 5.253 6.376 6.376 0 0 1 5.236-10.844.75.75 0 1 1-.17 1.49A4.876 4.876 0 0 0 7.125 12Z"]
    }
};
class GoalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = goalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GoalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GoalIconComponent, isStandalone: true, selector: "svg[goal-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GoalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[goal-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const grabberIconData = {
    "16": {
        "width": 16,
        "paths": ["M10 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-4 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    }
};
class GrabberIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = grabberIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GrabberIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GrabberIconComponent, isStandalone: true, selector: "svg[grabber-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GrabberIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[grabber-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const graphIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 1.75V13.5h13.75a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75V1.75a.75.75 0 0 1 1.5 0Zm14.28 2.53-5.25 5.25a.75.75 0 0 1-1.06 0L7 7.06 4.28 9.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25a.75.75 0 0 1 1.06 0L10 7.94l4.72-4.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2.5 2.75a.75.75 0 0 0-1.5 0v18.5c0 .414.336.75.75.75H20a.75.75 0 0 0 0-1.5H2.5V2.75Z", "M22.28 7.78a.75.75 0 0 0-1.06-1.06l-5.72 5.72-3.72-3.72a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 1 0 1.06 1.06l5.47-5.47 3.72 3.72a.75.75 0 0 0 1.06 0l6.25-6.25Z"]
    }
};
class GraphIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = graphIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GraphIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: GraphIconComponent, isStandalone: true, selector: "svg[graph-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: GraphIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[graph-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const hashIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.368 1.01a.75.75 0 0 1 .623.859L6.57 4.5h3.98l.46-2.868a.75.75 0 0 1 1.48.237L12.07 4.5h2.18a.75.75 0 0 1 0 1.5h-2.42l-.64 4h2.56a.75.75 0 0 1 0 1.5h-2.8l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H5.45l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H1.75a.75.75 0 0 1 0-1.5h2.42l.64-4H2.25a.75.75 0 0 1 0-1.5h2.8l.46-2.868a.75.75 0 0 1 .858-.622ZM9.67 10l.64-4H6.33l-.64 4Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.618 1.76a.75.75 0 0 1 .623.859L9.46 7.5h6.48l.82-5.118a.75.75 0 0 1 1.48.237L17.46 7.5h3.79a.75.75 0 0 1 0 1.5h-4.03l-.96 6h3.99a.75.75 0 0 1 0 1.5h-4.23l-.78 4.869a.75.75 0 0 1-1.48-.237l.74-4.632H8.02l-.78 4.869a.75.75 0 0 1-1.48-.237L6.5 16.5H2.745a.75.75 0 0 1 0-1.5H6.74l.96-6H3.75a.75.75 0 0 1 0-1.5h4.19l.82-5.118a.75.75 0 0 1 .858-.622ZM14.741 15l.96-6H9.22l-.96 6Z"]
    }
};
class HashIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = hashIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HashIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HashIconComponent, isStandalone: true, selector: "svg[hash-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HashIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[hash-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const headingIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.75 2a.75.75 0 0 1 .75.75V7h7V2.75a.75.75 0 0 1 1.5 0v10.5a.75.75 0 0 1-1.5 0V8.5h-7v4.75a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 3.75 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M6.25 4a.75.75 0 0 1 .75.75V11h10V4.75a.75.75 0 0 1 1.5 0v14.5a.75.75 0 0 1-1.5 0V12.5H7v6.75a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 6.25 4Z"]
    }
};
class HeadingIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = headingIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HeadingIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HeadingIconComponent, isStandalone: true, selector: "svg[heading-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HeadingIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[heading-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const heartIconData = {
    "16": {
        "width": 16,
        "paths": ["m8 14.25.345.666a.75.75 0 0 1-.69 0l-.008-.004-.018-.01a7.152 7.152 0 0 1-.31-.17 22.055 22.055 0 0 1-3.434-2.414C2.045 10.731 0 8.35 0 5.5 0 2.836 2.086 1 4.25 1 5.797 1 7.153 1.802 8 3.02 8.847 1.802 10.203 1 11.75 1 13.914 1 16 2.836 16 5.5c0 2.85-2.045 5.231-3.885 6.818a22.066 22.066 0 0 1-3.744 2.584l-.018.01-.006.003h-.002ZM4.25 2.5c-1.336 0-2.75 1.164-2.75 3 0 2.15 1.58 4.144 3.365 5.682A20.58 20.58 0 0 0 8 13.393a20.58 20.58 0 0 0 3.135-2.211C12.92 9.644 14.5 7.65 14.5 5.5c0-1.836-1.414-3-2.75-3-1.373 0-2.609.986-3.029 2.456a.749.749 0 0 1-1.442 0C6.859 3.486 5.623 2.5 4.25 2.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m12 20.703.343.667a.748.748 0 0 1-.686 0l-.003-.002-.007-.003-.025-.013a31.138 31.138 0 0 1-5.233-3.576C3.8 15.573 1 12.332 1 8.514v-.001C1 5.053 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262a31.148 31.148 0 0 1-5.233 3.576l-.025.013-.007.003-.002.001ZM6.736 4C4.657 4 2.5 5.88 2.5 8.514c0 3.107 2.324 5.96 4.861 8.12a29.655 29.655 0 0 0 4.566 3.175l.073.041.073-.04c.271-.153.661-.38 1.13-.674.94-.588 2.19-1.441 3.436-2.502 2.537-2.16 4.861-5.013 4.861-8.12C21.5 5.88 19.343 4 17.264 4c-2.106 0-3.801 1.389-4.553 3.643a.751.751 0 0 1-1.422 0C10.537 5.389 8.841 4 6.736 4Z"]
    }
};
class HeartIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = heartIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HeartIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HeartIconComponent, isStandalone: true, selector: "svg[heart-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HeartIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[heart-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const heartFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.655 14.916v-.001h-.002l-.006-.003-.018-.01a22.066 22.066 0 0 1-3.744-2.584C2.045 10.731 0 8.35 0 5.5 0 2.836 2.086 1 4.25 1 5.797 1 7.153 1.802 8 3.02 8.847 1.802 10.203 1 11.75 1 13.914 1 16 2.836 16 5.5c0 2.85-2.044 5.231-3.886 6.818a22.094 22.094 0 0 1-3.433 2.414 7.152 7.152 0 0 1-.31.17l-.018.01-.008.004a.75.75 0 0 1-.69 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"]
    }
};
class HeartFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = heartFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HeartFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HeartFillIconComponent, isStandalone: true, selector: "svg[heart-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HeartFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[heart-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const historyIconData = {
    "16": {
        "width": 16,
        "paths": ["m.427 1.927 1.215 1.215a8.002 8.002 0 1 1-1.6 5.685.75.75 0 1 1 1.493-.154 6.5 6.5 0 1 0 1.18-4.458l1.358 1.358A.25.25 0 0 1 3.896 6H.25A.25.25 0 0 1 0 5.75V2.104a.25.25 0 0 1 .427-.177ZM7.75 4a.75.75 0 0 1 .75.75v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5A.75.75 0 0 1 7.75 4Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.998 2.5A9.503 9.503 0 0 0 3.378 8H5.75a.75.75 0 0 1 0 1.5H2a1 1 0 0 1-1-1V4.75a.75.75 0 0 1 1.5 0v1.697A10.997 10.997 0 0 1 11.998 1C18.074 1 23 5.925 23 12s-4.926 11-11.002 11C6.014 23 1.146 18.223 1 12.275a.75.75 0 0 1 1.5-.037 9.5 9.5 0 0 0 9.498 9.262c5.248 0 9.502-4.253 9.502-9.5s-4.254-9.5-9.502-9.5Z", "M12.5 7.25a.75.75 0 0 0-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 0 0 .744-1.302L12.5 12.315V7.25Z"]
    }
};
class HistoryIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = historyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HistoryIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HistoryIconComponent, isStandalone: true, selector: "svg[history-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HistoryIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[history-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const homeIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.906.664a1.749 1.749 0 0 1 2.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019A1.75 1.75 0 0 1 13.25 15h-3.5a.75.75 0 0 1-.75-.75V9H7v5.25a.75.75 0 0 1-.75.75h-3.5A1.75 1.75 0 0 1 1 13.25V6.23c0-.531.242-1.034.657-1.366l5.25-4.2Zm1.25 1.171a.25.25 0 0 0-.312 0l-5.25 4.2a.25.25 0 0 0-.094.196v7.019c0 .138.112.25.25.25H5.5V8.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v5.25h2.75a.25.25 0 0 0 .25-.25V6.23a.25.25 0 0 0-.094-.195Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.03 2.59a1.501 1.501 0 0 1 1.94 0l7.5 6.363a1.5 1.5 0 0 1 .53 1.144V19.5a1.5 1.5 0 0 1-1.5 1.5h-5.75a.75.75 0 0 1-.75-.75V14h-2v6.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-9.403c0-.44.194-.859.53-1.144ZM12 3.734l-7.5 6.363V19.5h5v-6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v6.25h5v-9.403Z"]
    }
};
class HomeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = homeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HomeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HomeIconComponent, isStandalone: true, selector: "svg[home-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HomeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[home-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const homeFillIconData = {
    "24": {
        "width": 24,
        "paths": ["M12.97 2.59a1.5 1.5 0 0 0-1.94 0l-7.5 6.363A1.5 1.5 0 0 0 3 10.097V19.5A1.5 1.5 0 0 0 4.5 21h4.75a.75.75 0 0 0 .75-.75V14h4v6.25c0 .414.336.75.75.75h4.75a1.5 1.5 0 0 0 1.5-1.5v-9.403a1.5 1.5 0 0 0-.53-1.144l-7.5-6.363Z"]
    }
};
class HomeFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = homeFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HomeFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HomeFillIconComponent, isStandalone: true, selector: "svg[home-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HomeFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[home-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const horizontalRuleIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 7.75A.75.75 0 0 1 .75 7h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 7.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 12.75a.75.75 0 0 1 .75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"]
    }
};
class HorizontalRuleIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = horizontalRuleIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HorizontalRuleIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HorizontalRuleIconComponent, isStandalone: true, selector: "svg[horizontal-rule-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HorizontalRuleIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[horizontal-rule-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const hourglassIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.75 1h10.5a.75.75 0 0 1 0 1.5h-.75v1.25a4.75 4.75 0 0 1-1.9 3.8l-.333.25a.25.25 0 0 0 0 .4l.333.25a4.75 4.75 0 0 1 1.9 3.8v1.25h.75a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h.75v-1.25a4.75 4.75 0 0 1 1.9-3.8l.333-.25a.25.25 0 0 0 0-.4L5.4 7.55a4.75 4.75 0 0 1-1.9-3.8V2.5h-.75a.75.75 0 0 1 0-1.5ZM11 2.5H5v1.25c0 1.023.482 1.986 1.3 2.6l.333.25c.934.7.934 2.1 0 2.8l-.333.25a3.251 3.251 0 0 0-1.3 2.6v1.25h6v-1.25a3.251 3.251 0 0 0-1.3-2.6l-.333-.25a1.748 1.748 0 0 1 0-2.8l.333-.25a3.251 3.251 0 0 0 1.3-2.6Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.75 2h14.5a.75.75 0 0 1 0 1.5h-.75v2.982a4.75 4.75 0 0 1-2.215 4.017l-2.044 1.29a.25.25 0 0 0 0 .422l2.044 1.29a4.75 4.75 0 0 1 2.215 4.017V20.5h.75a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h.75v-2.982a4.75 4.75 0 0 1 2.215-4.017l2.044-1.29a.25.25 0 0 0 0-.422l-2.044-1.29A4.75 4.75 0 0 1 5.5 6.482V3.5h-.75a.75.75 0 0 1 0-1.5ZM17 3.5H7v2.982A3.25 3.25 0 0 0 8.516 9.23l2.044 1.29a1.75 1.75 0 0 1 0 2.96l-2.044 1.29A3.25 3.25 0 0 0 7 17.518V20.5h10v-2.982a3.25 3.25 0 0 0-1.516-2.748l-2.044-1.29a1.75 1.75 0 0 1 0-2.96l2.044-1.29A3.25 3.25 0 0 0 17 6.482Z"]
    }
};
class HourglassIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = hourglassIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HourglassIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HourglassIconComponent, isStandalone: true, selector: "svg[hourglass-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HourglassIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[hourglass-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const hubotIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 0 1 16 0v5.25a.75.75 0 0 1-1.5 0V8a6.5 6.5 0 1 0-13 0v5.25a.75.75 0 0 1-1.5 0Zm3-1.25C3 5.784 3.784 5 4.75 5h6.5c.966 0 1.75.784 1.75 1.75v1.5A1.75 1.75 0 0 1 11.25 10h-6.5A1.75 1.75 0 0 1 3 8.25Zm1.47-.53a.75.75 0 0 0 0 1.06l1.5 1.5a.75.75 0 0 0 1.06 0L8 7.81l.97.97a.75.75 0 0 0 1.06 0l1.5-1.5a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215l-.97.97-.97-.97a.75.75 0 0 0-1.06 0l-.97.97-.97-.97a.75.75 0 0 0-1.06 0Zm1.03 6.03a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M0 13C0 6.373 5.373 1 12 1s12 5.373 12 12v8.657a.75.75 0 0 1-1.5 0V13c0-5.799-4.701-10.5-10.5-10.5S1.5 7.201 1.5 13v8.657a.75.75 0 0 1-1.5 0V13Z", "M8 19.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM5.25 9.5h13.5c.966 0 1.75.784 1.75 1.75v3.5a1.75 1.75 0 0 1-1.75 1.75H5.25a1.75 1.75 0 0 1-1.75-1.75v-3.5c0-.966.784-1.75 1.75-1.75Zm.22 1.47a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0L12 12.56l2.47 2.47a.75.75 0 0 0 1.06 0l3-3a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L15 13.44l-2.47-2.47a.75.75 0 0 0-1.06 0L9 13.44l-2.47-2.47a.75.75 0 0 0-1.06 0Z"]
    }
};
class HubotIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = hubotIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HubotIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: HubotIconComponent, isStandalone: true, selector: "svg[hubot-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: HubotIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[hubot-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const idBadgeIconData = {
    "16": {
        "width": 16,
        "paths": ["M3 7.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3Zm10 .25a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 .75.75ZM10.25 11a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5h2.5Z", "M7.25 0h1.5c.966 0 1.75.784 1.75 1.75V3h3.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-8.5C0 3.784.784 3 1.75 3H5.5V1.75C5.5.784 6.284 0 7.25 0Zm3.232 4.5A1.75 1.75 0 0 1 8.75 6h-1.5a1.75 1.75 0 0 1-1.732-1.5H1.75a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM7 1.75v2.5c0 .138.112.25.25.25h1.5A.25.25 0 0 0 9 4.25v-2.5a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25Z"]
    }
};
class IdBadgeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = idBadgeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IdBadgeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: IdBadgeIconComponent, isStandalone: true, selector: "svg[id-badge-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IdBadgeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[id-badge-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const imageIconData = {
    "16": {
        "width": 16,
        "paths": ["M16 13.25A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25V2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75ZM1.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h.94l.03-.03 6.077-6.078a1.75 1.75 0 0 1 2.412-.06L14.5 10.31V2.75a.25.25 0 0 0-.25-.25Zm12.5 11a.25.25 0 0 0 .25-.25v-.917l-4.298-3.889a.25.25 0 0 0-.344.009L4.81 13.5ZM7 6a2 2 0 1 1-3.999.001A2 2 0 0 1 7 6ZM5.5 6a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.75 3h14.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 19.25 21H4.75A1.75 1.75 0 0 1 3 19.25V4.75C3 3.784 3.784 3 4.75 3Zm14.5 1.5H4.75a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h.19l9.823-9.823a1.75 1.75 0 0 1 2.475 0l2.262 2.262V4.75a.25.25 0 0 0-.25-.25Zm.25 9.56-3.323-3.323a.25.25 0 0 0-.354 0L7.061 19.5H19.25a.25.25 0 0 0 .25-.25ZM8.5 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"]
    }
};
class ImageIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = imageIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ImageIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ImageIconComponent, isStandalone: true, selector: "svg[image-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ImageIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[image-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const inboxIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.8 2.06A1.75 1.75 0 0 1 4.41 1h7.18c.7 0 1.333.417 1.61 1.06l2.74 6.395c.04.093.06.194.06.295v4.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-4.5c0-.101.02-.202.06-.295Zm1.61.44a.25.25 0 0 0-.23.152L1.887 8H4.75a.75.75 0 0 1 .6.3L6.625 10h2.75l1.275-1.7a.75.75 0 0 1 .6-.3h2.863L11.82 2.652a.25.25 0 0 0-.23-.152Zm10.09 7h-2.875l-1.275 1.7a.75.75 0 0 1-.6.3h-3.5a.75.75 0 0 1-.6-.3L4.375 9.5H1.5v3.75c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.801 3.57A1.75 1.75 0 0 1 6.414 2.5h11.174c.702 0 1.337.42 1.611 1.067l3.741 8.828c.04.092.06.192.06.293v7.562A1.75 1.75 0 0 1 21.25 22H2.75A1.75 1.75 0 0 1 1 20.25v-7.5c0-.1.02-.199.059-.291L4.8 3.571ZM6.414 4a.25.25 0 0 0-.23.153L2.88 12H8a.75.75 0 0 1 .648.372L10.18 15h3.638l1.533-2.628a.75.75 0 0 1 .64-.372l5.13-.051-3.304-7.797a.25.25 0 0 0-.23-.152ZM21.5 13.445l-5.067.05-1.535 2.633a.75.75 0 0 1-.648.372h-4.5a.75.75 0 0 1-.648-.372L7.57 13.5H2.5v6.75c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25Z"]
    }
};
class InboxIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = inboxIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: InboxIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: InboxIconComponent, isStandalone: true, selector: "svg[inbox-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: InboxIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[inbox-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const infinityIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 6.984c.59-.533 1.204-1.066 1.825-1.493.797-.548 1.7-.991 2.675-.991C14.414 4.5 16 6.086 16 8s-1.586 3.5-3.5 3.5c-.975 0-1.878-.444-2.675-.991-.621-.427-1.235-.96-1.825-1.493-.59.533-1.204 1.066-1.825 1.493-.797.547-1.7.991-2.675.991C1.586 11.5 0 9.914 0 8s1.586-3.5 3.5-3.5c.975 0 1.878.443 2.675.991.621.427 1.235.96 1.825 1.493ZM9.114 8c.536.483 1.052.922 1.56 1.273.704.483 1.3.727 1.826.727 1.086 0 2-.914 2-2 0-1.086-.914-2-2-2-.525 0-1.122.244-1.825.727-.51.35-1.025.79-1.561 1.273ZM3.5 6c-1.086 0-2 .914-2 2 0 1.086.914 2 2 2 .525 0 1.122-.244 1.825-.727.51-.35 1.025-.79 1.561-1.273-.536-.483-1.052-.922-1.56-1.273C4.621 6.244 4.025 6 3.5 6Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 11.16c.887-.933 1.813-1.865 2.78-2.6C15.952 7.668 17.267 7 18.75 7 21.657 7 24 9.615 24 12.25s-2.343 5.25-5.25 5.25c-1.483 0-2.798-.668-3.97-1.56-.967-.735-1.893-1.667-2.78-2.6-.887.933-1.813 1.865-2.78 2.6-1.172.892-2.487 1.56-3.97 1.56C2.343 17.5 0 14.885 0 12.25S2.343 7 5.25 7c1.483 0 2.798.667 3.97 1.56.967.735 1.893 1.667 2.78 2.6ZM5.25 8.5c-2.032 0-3.75 1.895-3.75 3.75S3.218 16 5.25 16c1.017 0 2.014-.457 3.062-1.253.89-.678 1.758-1.554 2.655-2.497-.897-.943-1.765-1.82-2.655-2.497C7.264 8.957 6.267 8.5 5.25 8.5Zm7.783 3.75c.897.943 1.765 1.82 2.655 2.497C16.736 15.543 17.733 16 18.75 16c2.032 0 3.75-1.895 3.75-3.75S20.782 8.5 18.75 8.5c-1.017 0-2.014.457-3.062 1.253-.89.678-1.758 1.554-2.655 2.497Z"]
    }
};
class InfinityIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = infinityIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: InfinityIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: InfinityIconComponent, isStandalone: true, selector: "svg[infinity-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: InfinityIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[infinity-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const infoIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.5 7.75A.75.75 0 0 1 7.25 7h1a.75.75 0 0 1 .75.75v2.75h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25v-2h-.25a.75.75 0 0 1-.75-.75ZM8 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M13 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3 3.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.25h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75V12h-.75a.75.75 0 0 1-.75-.75Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class InfoIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = infoIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: InfoIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: InfoIconComponent, isStandalone: true, selector: "svg[info-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: InfoIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[info-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const issueClosedIconData = {
    "16": {
        "width": 16,
        "paths": ["M11.28 6.78a.75.75 0 0 0-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l3.5-3.5Z", "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class IssueClosedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = issueClosedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueClosedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: IssueClosedIconComponent, isStandalone: true, selector: "svg[issue-closed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueClosedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[issue-closed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const issueDraftIconData = {
    "16": {
        "width": 16,
        "paths": ["M14.307 11.655a.75.75 0 0 1 .165 1.048 8.05 8.05 0 0 1-1.769 1.77.75.75 0 0 1-.883-1.214 6.552 6.552 0 0 0 1.44-1.439.75.75 0 0 1 1.047-.165Zm-2.652-9.962a.75.75 0 0 1 1.048-.165 8.05 8.05 0 0 1 1.77 1.769.75.75 0 0 1-1.214.883 6.552 6.552 0 0 0-1.439-1.44.75.75 0 0 1-.165-1.047ZM6.749.097a8.074 8.074 0 0 1 2.502 0 .75.75 0 1 1-.233 1.482 6.558 6.558 0 0 0-2.036 0A.751.751 0 0 1 6.749.097ZM.955 6.125a.75.75 0 0 1 .624.857 6.558 6.558 0 0 0 0 2.036.75.75 0 1 1-1.482.233 8.074 8.074 0 0 1 0-2.502.75.75 0 0 1 .858-.624Zm14.09 0a.75.75 0 0 1 .858.624c.13.829.13 1.673 0 2.502a.75.75 0 1 1-1.482-.233 6.558 6.558 0 0 0 0-2.036.75.75 0 0 1 .624-.857Zm-8.92 8.92a.75.75 0 0 1 .857-.624 6.558 6.558 0 0 0 2.036 0 .75.75 0 1 1 .233 1.482c-.829.13-1.673.13-2.502 0a.75.75 0 0 1-.624-.858Zm-4.432-3.39a.75.75 0 0 1 1.048.165 6.552 6.552 0 0 0 1.439 1.44.751.751 0 0 1-.883 1.212 8.05 8.05 0 0 1-1.77-1.769.75.75 0 0 1 .166-1.048Zm2.652-9.962A.75.75 0 0 1 4.18 2.74a6.556 6.556 0 0 0-1.44 1.44.751.751 0 0 1-1.212-.883 8.05 8.05 0 0 1 1.769-1.77.75.75 0 0 1 1.048.166Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M17.32 3.205a.75.75 0 0 1 1.046-.177 11.056 11.056 0 0 1 2.605 2.606.75.75 0 1 1-1.222.869 9.554 9.554 0 0 0-2.252-2.252.75.75 0 0 1-.177-1.046Zm3.475 14.115a.75.75 0 0 1 .176 1.046 11.07 11.07 0 0 1-2.605 2.605.75.75 0 1 1-.869-1.222 9.554 9.554 0 0 0 2.252-2.252.75.75 0 0 1 1.046-.177ZM2.018 9.543a.75.75 0 0 1 .615.864 9.571 9.571 0 0 0 0 3.186.75.75 0 1 1-1.48.25 11.07 11.07 0 0 1 0-3.686.75.75 0 0 1 .865-.614Zm7.525 12.439a.75.75 0 0 1 .864-.615 9.571 9.571 0 0 0 3.186 0 .75.75 0 1 1 .25 1.48 11.07 11.07 0 0 1-3.686 0 .75.75 0 0 1-.614-.865ZM6.68 3.205a.75.75 0 0 1-.177 1.046A9.558 9.558 0 0 0 4.25 6.503a.75.75 0 1 1-1.223-.87 11.056 11.056 0 0 1 2.606-2.605.75.75 0 0 1 1.046.177ZM3.205 17.32a.75.75 0 0 1 1.046.177 9.554 9.554 0 0 0 2.252 2.252.75.75 0 1 1-.87 1.223 11.056 11.056 0 0 1-2.605-2.606.75.75 0 0 1 .177-1.046Zm6.952-16.166a11.07 11.07 0 0 1 3.686 0 .75.75 0 0 1-.25 1.479 9.571 9.571 0 0 0-3.186 0 .75.75 0 1 1-.25-1.48Zm11.825 8.389a.75.75 0 0 1 .864.614 11.07 11.07 0 0 1 0 3.686.75.75 0 0 1-1.479-.25 9.571 9.571 0 0 0 0-3.186.75.75 0 0 1 .615-.864Z"]
    }
};
class IssueDraftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = issueDraftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueDraftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: IssueDraftIconComponent, isStandalone: true, selector: "svg[issue-draft-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueDraftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[issue-draft-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const issueOpenedIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Zm9.5 2a2 2 0 1 1-.001-3.999A2 2 0 0 1 12 14Z"]
    }
};
class IssueOpenedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = issueOpenedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueOpenedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: IssueOpenedIconComponent, isStandalone: true, selector: "svg[issue-opened-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueOpenedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[issue-opened-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const issueReopenedIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.029 2.217a6.5 6.5 0 0 1 9.437 5.11.75.75 0 1 0 1.492-.154 8 8 0 0 0-14.315-4.03L.427 1.927A.25.25 0 0 0 0 2.104V5.75A.25.25 0 0 0 .25 6h3.646a.25.25 0 0 0 .177-.427L2.715 4.215a6.491 6.491 0 0 1 2.314-1.998ZM1.262 8.169a.75.75 0 0 0-1.22.658 8.001 8.001 0 0 0 14.315 4.03l1.216 1.216a.25.25 0 0 0 .427-.177V10.25a.25.25 0 0 0-.25-.25h-3.646a.25.25 0 0 0-.177.427l1.358 1.358a6.501 6.501 0 0 1-11.751-3.11.75.75 0 0 0-.272-.506Z", "M9.06 9.06a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.38 8A9.502 9.502 0 0 1 12 2.5a9.502 9.502 0 0 1 9.215 7.182.75.75 0 1 0 1.456-.364C21.473 4.539 17.15 1 12 1a10.995 10.995 0 0 0-9.5 5.452V4.75a.75.75 0 0 0-1.5 0V8.5a1 1 0 0 0 1 1h3.75a.75.75 0 0 0 0-1.5H3.38Zm-.595 6.318a.75.75 0 0 0-1.455.364C2.527 19.461 6.85 23 12 23c4.052 0 7.592-2.191 9.5-5.451v1.701a.75.75 0 0 0 1.5 0V15.5a1 1 0 0 0-1-1h-3.75a.75.75 0 0 0 0 1.5h2.37A9.502 9.502 0 0 1 12 21.5c-4.446 0-8.181-3.055-9.215-7.182Z", "M13.414 13.414a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828Z"]
    }
};
class IssueReopenedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = issueReopenedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueReopenedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: IssueReopenedIconComponent, isStandalone: true, selector: "svg[issue-reopened-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueReopenedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[issue-reopened-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const issueTrackedByIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 8a6.5 6.5 0 0 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z", "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm3.573 5.823-2.896-2.896a.25.25 0 0 1 0-.354l2.896-2.896a.25.25 0 0 1 .427.177V11.5h3.25a.75.75 0 0 1 0 1.5H12v2.146a.25.25 0 0 1-.427.177Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 2.5a9.5 9.5 0 1 0 0 19 .75.75 0 0 1 0 1.5C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11a.75.75 0 0 1-1.5 0A9.5 9.5 0 0 0 12 2.5Z", "m13.759 17.48 3.728 3.314a.308.308 0 0 0 .513-.23V18h4.25a.75.75 0 0 0 0-1.5H18v-2.564a.308.308 0 0 0-.513-.23L13.76 17.02a.308.308 0 0 0 0 .46ZM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"]
    }
};
class IssueTrackedByIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = issueTrackedByIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueTrackedByIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: IssueTrackedByIconComponent, isStandalone: true, selector: "svg[issue-tracked-by-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueTrackedByIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[issue-tracked-by-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const issueTracksIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 8a6.5 6.5 0 0 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z", "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 1.75a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Zm2.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2.5 12a9.5 9.5 0 1 1 19 0 .75.75 0 0 0 1.5 0c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11a.75.75 0 0 0 0-1.5A9.5 9.5 0 0 1 2.5 12Z", "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2.5 2.75a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm3.75 2.75a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Z"]
    }
};
class IssueTracksIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = issueTracksIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueTracksIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: IssueTracksIconComponent, isStandalone: true, selector: "svg[issue-tracks-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IssueTracksIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[issue-tracks-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const italicIconData = {
    "16": {
        "width": 16,
        "paths": ["M6 2.75A.75.75 0 0 1 6.75 2h6.5a.75.75 0 0 1 0 1.5h-2.505l-3.858 9H9.25a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.505l3.858-9H6.75A.75.75 0 0 1 6 2.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10 4.75a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-3.514l-5.828 13h3.342a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h3.514l5.828-13H10.75a.75.75 0 0 1-.75-.75Z"]
    }
};
class ItalicIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = italicIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ItalicIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ItalicIconComponent, isStandalone: true, selector: "svg[italic-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ItalicIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[italic-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const iterationsIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.5 7.25a4.75 4.75 0 0 1 9.5 0 .75.75 0 0 0 1.5 0 6.25 6.25 0 1 0-6.25 6.25H12v2.146c0 .223.27.335.427.177l2.896-2.896a.25.25 0 0 0 0-.354l-2.896-2.896a.25.25 0 0 0-.427.177V12H7.25A4.75 4.75 0 0 1 2.5 7.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2.5 10.5a8 8 0 1 1 16 0 .75.75 0 0 0 1.5 0 9.5 9.5 0 1 0-9.5 9.5h10.94l-2.72 2.72a.75.75 0 1 0 1.06 1.06l3.735-3.735c.44-.439.44-1.151 0-1.59L19.78 14.72a.75.75 0 0 0-1.06 1.06l2.72 2.72H10.5a8 8 0 0 1-8-8Z"]
    }
};
class IterationsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = iterationsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IterationsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: IterationsIconComponent, isStandalone: true, selector: "svg[iterations-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: IterationsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[iterations-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const kebabHorizontalIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM1.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M20 14a2 2 0 1 1-.001-3.999A2 2 0 0 1 20 14ZM6 12a2 2 0 1 1-3.999.001A2 2 0 0 1 6 12Zm8 0a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12Z"]
    }
};
class KebabHorizontalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = kebabHorizontalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: KebabHorizontalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: KebabHorizontalIconComponent, isStandalone: true, selector: "svg[kebab-horizontal-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: KebabHorizontalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[kebab-horizontal-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const keyIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.5 0a5.499 5.499 0 1 1-1.288 10.848l-.932.932a.749.749 0 0 1-.53.22H7v.75a.749.749 0 0 1-.22.53l-.5.5a.749.749 0 0 1-.53.22H5v.75a.749.749 0 0 1-.22.53l-.5.5a.749.749 0 0 1-.53.22h-2A1.75 1.75 0 0 1 0 14.25v-2c0-.199.079-.389.22-.53l4.932-4.932A5.5 5.5 0 0 1 10.5 0Zm-4 5.5c-.001.431.069.86.205 1.269a.75.75 0 0 1-.181.768L1.5 12.56v1.69c0 .138.112.25.25.25h1.69l.06-.06v-1.19a.75.75 0 0 1 .75-.75h1.19l.06-.06v-1.19a.75.75 0 0 1 .75-.75h1.19l1.023-1.025a.75.75 0 0 1 .768-.18A4 4 0 1 0 6.5 5.5ZM11 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16.75 8.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z", "M15.75 0a8.25 8.25 0 1 1-2.541 16.101l-1.636 1.636a1.744 1.744 0 0 1-1.237.513H9.25a.25.25 0 0 0-.25.25v1.448a.876.876 0 0 1-.256.619l-.214.213a.75.75 0 0 1-.545.22H5.25a.25.25 0 0 0-.25.25v1A1.75 1.75 0 0 1 3.25 24h-1.5A1.75 1.75 0 0 1 0 22.25v-2.836c0-.464.185-.908.513-1.236l7.386-7.388A8.249 8.249 0 0 1 15.75 0ZM9 8.25a6.733 6.733 0 0 0 .463 2.462.75.75 0 0 1-.168.804l-7.722 7.721a.25.25 0 0 0-.073.177v2.836c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-1c0-.966.784-1.75 1.75-1.75H7.5v-1c0-.966.784-1.75 1.75-1.75h1.086a.25.25 0 0 0 .177-.073l1.971-1.972a.75.75 0 0 1 .804-.168A6.75 6.75 0 1 0 9 8.25Z"]
    }
};
class KeyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = keyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: KeyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: KeyIconComponent, isStandalone: true, selector: "svg[key-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: KeyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[key-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const keyAsteriskIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75A2.75 2.75 0 0 1 2.75 0h10.5A2.75 2.75 0 0 1 16 2.75v10.5A2.75 2.75 0 0 1 13.25 16H2.75A2.75 2.75 0 0 1 0 13.25ZM2.75 1.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25Z", "M8 4a.75.75 0 0 1 .75.75V6.7l1.69-.975a.75.75 0 0 1 .75 1.3L9.5 8l1.69.976a.75.75 0 0 1-.75 1.298L8.75 9.3v1.951a.75.75 0 0 1-1.5 0V9.299l-1.69.976a.75.75 0 0 1-.75-1.3L6.5 8l-1.69-.975a.75.75 0 0 1 .75-1.3l1.69.976V4.75A.75.75 0 0 1 8 4Z"]
    }
};
class KeyAsteriskIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = keyAsteriskIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: KeyAsteriskIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: KeyAsteriskIconComponent, isStandalone: true, selector: "svg[key-asterisk-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: KeyAsteriskIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[key-asterisk-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const lawIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.75.75V2h.985c.304 0 .603.08.867.231l1.29.736c.038.022.08.033.124.033h2.234a.75.75 0 0 1 0 1.5h-.427l2.111 4.692a.75.75 0 0 1-.154.838l-.53-.53.529.531-.001.002-.002.002-.006.006-.006.005-.01.01-.045.04c-.21.176-.441.327-.686.45C14.556 10.78 13.88 11 13 11a4.498 4.498 0 0 1-2.023-.454 3.544 3.544 0 0 1-.686-.45l-.045-.04-.016-.015-.006-.006-.004-.004v-.001a.75.75 0 0 1-.154-.838L12.178 4.5h-.162c-.305 0-.604-.079-.868-.231l-1.29-.736a.245.245 0 0 0-.124-.033H8.75V13h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5V3.5h-.984a.245.245 0 0 0-.124.033l-1.289.737c-.265.15-.564.23-.869.23h-.162l2.112 4.692a.75.75 0 0 1-.154.838l-.53-.53.529.531-.001.002-.002.002-.006.006-.016.015-.045.04c-.21.176-.441.327-.686.45C4.556 10.78 3.88 11 3 11a4.498 4.498 0 0 1-2.023-.454 3.544 3.544 0 0 1-.686-.45l-.045-.04-.016-.015-.006-.006-.004-.004v-.001a.75.75 0 0 1-.154-.838L2.178 4.5H1.75a.75.75 0 0 1 0-1.5h2.234a.249.249 0 0 0 .125-.033l1.288-.737c.265-.15.564-.23.869-.23h.984V.75a.75.75 0 0 1 1.5 0Zm2.945 8.477c.285.135.718.273 1.305.273s1.02-.138 1.305-.273L13 6.327Zm-10 0c.285.135.718.273 1.305.273s1.02-.138 1.305-.273L3 6.327Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.75 2.75V4.5h1.975c.351 0 .694.106.984.303l1.697 1.154c.041.028.09.043.14.043h4.102a.75.75 0 0 1 0 1.5H20.07l3.366 7.68a.749.749 0 0 1-.23.896c-.1.074-.203.143-.31.206a6.296 6.296 0 0 1-.79.399 7.349 7.349 0 0 1-2.856.569 7.343 7.343 0 0 1-2.855-.568 6.205 6.205 0 0 1-.79-.4 3.205 3.205 0 0 1-.307-.202l-.005-.004a.749.749 0 0 1-.23-.896l3.368-7.68h-.886c-.351 0-.694-.106-.984-.303l-1.697-1.154a.246.246 0 0 0-.14-.043H12.75v14.5h4.487a.75.75 0 0 1 0 1.5H6.763a.75.75 0 0 1 0-1.5h4.487V6H9.275a.249.249 0 0 0-.14.043L7.439 7.197c-.29.197-.633.303-.984.303h-.886l3.368 7.68a.75.75 0 0 1-.209.878c-.08.065-.16.126-.31.223a6.077 6.077 0 0 1-.792.433 6.924 6.924 0 0 1-2.876.62 6.913 6.913 0 0 1-2.876-.62 6.077 6.077 0 0 1-.792-.433 3.483 3.483 0 0 1-.309-.221.762.762 0 0 1-.21-.88L3.93 7.5H2.353a.75.75 0 0 1 0-1.5h4.102c.05 0 .099-.015.141-.043l1.695-1.154c.29-.198.634-.303.985-.303h1.974V2.75a.75.75 0 0 1 1.5 0ZM2.193 15.198a5.414 5.414 0 0 0 2.557.635 5.414 5.414 0 0 0 2.557-.635L4.75 9.368Zm14.51-.024c.082.04.174.083.275.126.53.223 1.305.45 2.272.45a5.847 5.847 0 0 0 2.547-.576L19.25 9.367Z"]
    }
};
class LawIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = lawIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LawIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LawIconComponent, isStandalone: true, selector: "svg[law-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LawIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[law-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const lightBulbIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 1.5c-2.363 0-4 1.69-4 3.75 0 .984.424 1.625.984 2.304l.214.253c.223.264.47.556.673.848.284.411.537.896.621 1.49a.75.75 0 0 1-1.484.211c-.04-.282-.163-.547-.37-.847a8.456 8.456 0 0 0-.542-.68c-.084-.1-.173-.205-.268-.32C3.201 7.75 2.5 6.766 2.5 5.25 2.5 2.31 4.863 0 8 0s5.5 2.31 5.5 5.25c0 1.516-.701 2.5-1.328 3.259-.095.115-.184.22-.268.319-.207.245-.383.453-.541.681-.208.3-.33.565-.37.847a.751.751 0 0 1-1.485-.212c.084-.593.337-1.078.621-1.489.203-.292.45-.584.673-.848.075-.088.147-.173.213-.253.561-.679.985-1.32.985-2.304 0-2.06-1.637-3.75-4-3.75ZM5.75 12h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 15.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 2.5c-3.81 0-6.5 2.743-6.5 6.119 0 1.536.632 2.572 1.425 3.56.172.215.347.422.527.635l.096.112c.21.25.427.508.63.774.404.531.783 1.128.995 1.834a.75.75 0 0 1-1.436.432c-.138-.46-.397-.89-.753-1.357a18.111 18.111 0 0 0-.582-.714l-.092-.11c-.18-.212-.37-.436-.555-.667C4.87 12.016 4 10.651 4 8.618 4 4.363 7.415 1 12 1s8 3.362 8 7.619c0 2.032-.87 3.397-1.755 4.5-.185.23-.375.454-.555.667l-.092.109c-.21.248-.405.481-.582.714-.356.467-.615.898-.753 1.357a.751.751 0 0 1-1.437-.432c.213-.706.592-1.303.997-1.834.202-.266.419-.524.63-.774l.095-.112c.18-.213.355-.42.527-.634.793-.99 1.425-2.025 1.425-3.561C18.5 5.243 15.81 2.5 12 2.5ZM8.75 18h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5Zm.75 3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"]
    }
};
class LightBulbIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = lightBulbIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LightBulbIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LightBulbIconComponent, isStandalone: true, selector: "svg[light-bulb-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LightBulbIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[light-bulb-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const linkIconData = {
    "16": {
        "width": 16,
        "paths": ["m7.775 3.275 1.25-1.25a3.5 3.5 0 1 1 4.95 4.95l-2.5 2.5a3.5 3.5 0 0 1-4.95 0 .751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018 1.998 1.998 0 0 0 2.83 0l2.5-2.5a2.002 2.002 0 0 0-2.83-2.83l-1.25 1.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Zm-4.69 9.64a1.998 1.998 0 0 0 2.83 0l1.25-1.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.25 1.25a3.5 3.5 0 1 1-4.95-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018 1.998 1.998 0 0 0-2.83 0l-2.5 2.5a1.998 1.998 0 0 0 0 2.83Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M14.78 3.653a3.936 3.936 0 1 1 5.567 5.567l-3.627 3.627a3.936 3.936 0 0 1-5.88-.353.75.75 0 0 0-1.18.928 5.436 5.436 0 0 0 8.12.486l3.628-3.628a5.436 5.436 0 1 0-7.688-7.688l-3 3a.75.75 0 0 0 1.06 1.061l3-3Z", "M7.28 11.153a3.936 3.936 0 0 1 5.88.353.75.75 0 0 0 1.18-.928 5.436 5.436 0 0 0-8.12-.486L2.592 13.72a5.436 5.436 0 1 0 7.688 7.688l3-3a.75.75 0 1 0-1.06-1.06l-3 3a3.936 3.936 0 0 1-5.567-5.568l3.627-3.627Z"]
    }
};
class LinkIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = linkIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LinkIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LinkIconComponent, isStandalone: true, selector: "svg[link-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LinkIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[link-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const linkExternalIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.75 2h3.5a.75.75 0 0 1 0 1.5h-3.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 1.5 0v3.5A1.75 1.75 0 0 1 12.25 14h-8.5A1.75 1.75 0 0 1 2 12.25v-8.5C2 2.784 2.784 2 3.75 2Zm6.854-1h4.146a.25.25 0 0 1 .25.25v4.146a.25.25 0 0 1-.427.177L13.03 4.03 9.28 7.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.75-3.75-1.543-1.543A.25.25 0 0 1 10.604 1Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15.5 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V4.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L19.94 3h-3.69a.75.75 0 0 1-.75-.75Z", "M2.5 4.25c0-.966.784-1.75 1.75-1.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.25.25 0 0 0-.25.25v15.5c0 .138.112.25.25.25h15.5a.25.25 0 0 0 .25-.25v-8.5a.75.75 0 0 1 1.5 0v8.5a1.75 1.75 0 0 1-1.75 1.75H4.25a1.75 1.75 0 0 1-1.75-1.75V4.25Z"]
    }
};
class LinkExternalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = linkExternalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LinkExternalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LinkExternalIconComponent, isStandalone: true, selector: "svg[link-external-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LinkExternalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[link-external-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const listOrderedIconData = {
    "16": {
        "width": 16,
        "paths": ["M5 3.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 3.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 8.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75ZM.924 10.32a.5.5 0 0 1-.851-.525l.001-.001.001-.002.002-.004.007-.011c.097-.144.215-.273.348-.384.228-.19.588-.392 1.068-.392.468 0 .858.181 1.126.484.259.294.377.673.377 1.038 0 .987-.686 1.495-1.156 1.845l-.047.035c-.303.225-.522.4-.654.597h1.357a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5c0-1.005.692-1.52 1.167-1.875l.035-.025c.531-.396.8-.625.8-1.078a.57.57 0 0 0-.128-.376C1.806 10.068 1.695 10 1.5 10a.658.658 0 0 0-.429.163.835.835 0 0 0-.144.153ZM2.003 2.5V6h.503a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1h.503V3.308l-.28.14a.5.5 0 0 1-.446-.895l1.003-.5a.5.5 0 0 1 .723.447Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.604 3.089A.75.75 0 0 1 4 3.75V8.5h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 1 1 0-1.5h.75V5.151l-.334.223a.75.75 0 0 1-.832-1.248l1.5-1a.75.75 0 0 1 .77-.037ZM8.75 5.5a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75ZM5.5 15.75c0-.704-.271-1.286-.72-1.686a2.302 2.302 0 0 0-1.53-.564c-.535 0-1.094.178-1.53.565-.449.399-.72.982-.72 1.685a.75.75 0 0 0 1.5 0c0-.296.104-.464.217-.564A.805.805 0 0 1 3.25 15c.215 0 .406.072.533.185.113.101.217.268.217.565 0 .332-.069.48-.21.657-.092.113-.216.24-.403.419l-.147.14c-.152.144-.33.313-.52.504l-1.5 1.5a.75.75 0 0 0-.22.53v.25c0 .414.336.75.75.75H5A.75.75 0 0 0 5 19H3.31l.47-.47c.176-.176.333-.324.48-.465l.165-.156a5.98 5.98 0 0 0 .536-.566c.358-.447.539-.925.539-1.593Z"]
    }
};
class ListOrderedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = listOrderedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ListOrderedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ListOrderedIconComponent, isStandalone: true, selector: "svg[list-ordered-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ListOrderedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[list-ordered-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const listUnorderedIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.75 2.5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM2 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.75 5.5h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    }
};
class ListUnorderedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = listUnorderedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ListUnorderedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ListUnorderedIconComponent, isStandalone: true, selector: "svg[list-unordered-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ListUnorderedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[list-unordered-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const locationIconData = {
    "16": {
        "width": 16,
        "paths": ["m12.596 11.596-3.535 3.536a1.5 1.5 0 0 1-2.122 0l-3.535-3.536a6.5 6.5 0 1 1 9.192-9.193 6.5 6.5 0 0 1 0 9.193Zm-1.06-8.132v-.001a5 5 0 1 0-7.072 7.072L8 14.07l3.536-3.534a5 5 0 0 0 0-7.072ZM8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 9Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", "M19.071 3.429h.001c3.905 3.905 3.905 10.237 0 14.142l-5.403 5.403a2.36 2.36 0 0 1-3.336 0l-5.375-5.375-.028-.028c-3.905-3.905-3.905-10.237 0-14.142 3.904-3.905 10.236-3.905 14.141 0ZM5.99 4.489v.001a8.5 8.5 0 0 0 0 12.02l.023.024.002.002 5.378 5.378a.859.859 0 0 0 1.214 0l5.403-5.404a8.5 8.5 0 0 0-.043-11.977A8.5 8.5 0 0 0 5.99 4.489Z"]
    }
};
class LocationIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = locationIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LocationIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LocationIconComponent, isStandalone: true, selector: "svg[location-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LocationIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[location-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const lockIconData = {
    "16": {
        "width": 16,
        "paths": ["M4 4a4 4 0 0 1 8 0v2h.25c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-5.5C2 6.784 2.784 6 3.75 6H4Zm8.25 3.5h-8.5a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM10.5 6V4a2.5 2.5 0 1 0-5 0v2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M6 9V7.25C6 3.845 8.503 1 12 1s6 2.845 6 6.25V9h.5a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 19.5v-8A2.5 2.5 0 0 1 5.5 9Zm-1.5 2.5v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1Zm3-4.25V9h9V7.25c0-2.67-1.922-4.75-4.5-4.75-2.578 0-4.5 2.08-4.5 4.75Z"]
    }
};
class LockIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = lockIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LockIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LockIconComponent, isStandalone: true, selector: "svg[lock-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LockIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[lock-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const logIconData = {
    "16": {
        "width": 16,
        "paths": ["M5 8.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 5 8.25ZM4 10.5A.75.75 0 0 0 4 12h4a.75.75 0 0 0 0-1.5H4Z", "M13-.005c1.654 0 3 1.328 3 3 0 .982-.338 1.933-.783 2.818-.443.879-1.028 1.758-1.582 2.588l-.011.017c-.568.853-1.104 1.659-1.501 2.446-.398.789-.623 1.494-.623 2.136a1.5 1.5 0 1 0 2.333-1.248.75.75 0 0 1 .834-1.246A3 3 0 0 1 13 16H3a3 3 0 0 1-3-3c0-1.582.891-3.135 1.777-4.506.209-.322.418-.637.623-.946.473-.709.923-1.386 1.287-2.048H2.51c-.576 0-1.381-.133-1.907-.783A2.68 2.68 0 0 1 0 2.995a3 3 0 0 1 3-3Zm0 1.5a1.5 1.5 0 0 0-1.5 1.5c0 .476.223.834.667 1.132A.75.75 0 0 1 11.75 5.5H5.368c-.467 1.003-1.141 2.015-1.773 2.963-.192.289-.381.571-.558.845C2.13 10.711 1.5 11.916 1.5 13A1.5 1.5 0 0 0 3 14.5h7.401A2.989 2.989 0 0 1 10 13c0-.979.338-1.928.784-2.812.441-.874 1.023-1.748 1.575-2.576l.017-.026c.568-.853 1.103-1.658 1.501-2.448.398-.79.623-1.497.623-2.143 0-.838-.669-1.5-1.5-1.5Zm-10 0a1.5 1.5 0 0 0-1.5 1.5c0 .321.1.569.27.778.097.12.325.227.74.227h7.674A2.737 2.737 0 0 1 10 2.995c0-.546.146-1.059.401-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.197 10a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm-2.382 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm-1.581 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z", "M4.125 0h15.75a4.11 4.11 0 0 1 2.92 1.205A4.11 4.11 0 0 1 24 4.125c0 1.384-.476 2.794-1.128 4.16-.652 1.365-1.515 2.757-2.352 4.104l-.008.013c-.849 1.368-1.669 2.691-2.28 3.97-.614 1.283-.982 2.45-.982 3.503a2.625 2.625 0 1 0 4.083-2.183.75.75 0 1 1 .834-1.247A4.126 4.126 0 0 1 19.875 24H4.5a4.125 4.125 0 0 1-4.125-4.125c0-2.234 1.258-4.656 2.59-6.902.348-.586.702-1.162 1.05-1.728.8-1.304 1.567-2.553 2.144-3.738H3.39c-.823 0-1.886-.193-2.567-1.035A3.647 3.647 0 0 1 0 4.125 4.125 4.125 0 0 1 4.125 0ZM15.75 19.875c0-1.38.476-2.786 1.128-4.15.649-1.358 1.509-2.743 2.343-4.086l.017-.028c.849-1.367 1.669-2.692 2.28-3.972.614-1.285.982-2.457.982-3.514A2.615 2.615 0 0 0 19.875 1.5a2.625 2.625 0 0 0-2.625 2.625c0 .865.421 1.509 1.167 2.009A.75.75 0 0 1 18 7.507H7.812c-.65 1.483-1.624 3.069-2.577 4.619-.334.544-.666 1.083-.98 1.612-1.355 2.287-2.38 4.371-2.38 6.137A2.625 2.625 0 0 0 4.5 22.5h12.193a4.108 4.108 0 0 1-.943-2.625ZM1.5 4.125c-.01.511.163 1.008.487 1.403.254.313.74.479 1.402.479h12.86a3.648 3.648 0 0 1-.499-1.882 4.11 4.11 0 0 1 .943-2.625H4.125A2.625 2.625 0 0 0 1.5 4.125Z"]
    }
};
class LogIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = logIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LogIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LogIconComponent, isStandalone: true, selector: "svg[log-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LogIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[log-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const logoGistIconData = {
    "16": {
        "width": 25,
        "paths": ["M4.7 8.73v-1h3.52v5.69c-.78.37-1.95.64-3.59.64C1.11 14.06 0 11.37 0 8.03 0 4.69 1.13 2 4.63 2c1.62 0 2.64.33 3.28.66v1.05c-1.22-.5-2-.73-3.28-.73-2.57 0-3.48 2.21-3.48 5.06 0 2.85.91 5.05 3.47 5.05.89 0 1.98-.07 2.53-.34V8.73Zm10.98.69h.03c2.22.2 2.75.95 2.75 2.23 0 1.21-.76 2.41-3.14 2.41-.75 0-1.83-.19-2.33-.39v-.94c.47.17 1.22.36 2.33.36 1.62 0 2.06-.69 2.06-1.42 0-.71-.22-1.21-1.77-1.34-2.26-.2-2.73-1-2.73-2.08 0-1.11.72-2.31 2.92-2.31.73 0 1.56.09 2.25.39v.94c-.61-.2-1.22-.36-2.27-.36-1.55 0-1.88.57-1.88 1.34 0 .69.28 1.04 1.78 1.17Zm8.58-3.33v.85h-2.42v4.87c0 .95.53 1.34 1.5 1.34.2 0 .42 0 .61-.03v.89c-.17.03-.5.05-.69.05-1.31 0-2.5-.6-2.5-2.13v-5H19.2v-.48l1.56-.44V3.9l1.08-.31v2.5h2.42Zm-13.17-.03v6.41c0 .54.19.7.67.7v.89c-1.14 0-1.72-.47-1.72-1.72V6.06h1.05Zm.25-2.33c0 .44-.34.78-.78.78a.76.76 0 0 1-.77-.78c0-.44.32-.78.77-.78s.78.34.78.78Z"]
    }
};
class LogoGistIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = logoGistIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LogoGistIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LogoGistIconComponent, isStandalone: true, selector: "svg[logo-gist-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LogoGistIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[logo-gist-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const logoGithubIconData = {
    "16": {
        "width": 45,
        "paths": ["M8.81 7.35v5.74c0 .04-.01.11-.06.13 0 0-1.25.89-3.31.89-2.49 0-5.44-.78-5.44-5.92S2.58 1.99 5.1 2c2.18 0 3.06.49 3.2.58.04.05.06.09.06.14L7.94 4.5c0 .09-.09.2-.2.17-.36-.11-.9-.33-2.17-.33-1.47 0-3.05.42-3.05 3.73s1.5 3.7 2.58 3.7c.92 0 1.25-.11 1.25-.11v-2.3H4.88c-.11 0-.19-.08-.19-.17V7.35c0-.09.08-.17.19-.17h3.74c.11 0 .19.08.19.17Zm35.85 2.33c0 3.43-1.11 4.41-3.05 4.41-1.64 0-2.52-.83-2.52-.83s-.04.46-.09.52c-.03.06-.08.08-.14.08h-1.48c-.1 0-.19-.08-.19-.17l.02-11.11c0-.09.08-.17.17-.17h2.13c.09 0 .17.08.17.17v3.77s.82-.53 2.02-.53l-.01-.02c1.2 0 2.97.45 2.97 3.88ZM27.68 2.43c.09 0 .17.08.17.17v11.11c0 .09-.08.17-.17.17h-2.13c-.09 0-.17-.08-.17-.17l.02-4.75h-3.31v4.75c0 .09-.08.17-.17.17h-2.13c-.08 0-.17-.08-.17-.17V2.6c0-.09.08-.17.17-.17h2.13c.09 0 .17.08.17.17v4.09h3.31V2.6c0-.09.08-.17.17-.17Zm8.26 3.64c.11 0 .19.08.19.17l-.02 7.47c0 .09-.06.17-.17.17H34.6c-.07 0-.14-.04-.16-.09-.03-.06-.08-.45-.08-.45s-1.13.77-2.52.77c-1.69 0-2.92-.55-2.92-2.75V6.25c0-.09.08-.17.17-.17h2.14c.09 0 .17.08.17.17V11c0 .75.22 1.09.97 1.09s1.3-.39 1.3-.39V6.26c0-.11.06-.19.17-.19Zm-17.406 5.971h.005a.177.177 0 0 1 .141.179v1.5c0 .07-.03.14-.09.16-.1.05-.74.22-1.27.22-1.16 0-2.86-.25-2.86-2.69V8.13h-1.11c-.09 0-.17-.08-.17-.19V6.58c0-.08.05-.15.13-.17.07-.01 1.16-.28 1.16-.28V3.96c0-.08.05-.13.14-.13h2.16c.09 0 .14.05.14.13v2.11h1.59c.08 0 .16.08.16.17v1.7c0 .11-.07.19-.16.19h-1.59v3.131c0 .47.27.83 1.05.83.247 0 .481-.049.574-.05ZM12.24 6.06c.09 0 .17.08.17.17v7.37c0 .18-.05.27-.25.27h-1.92c-.17 0-.3-.07-.3-.27V6.26c0-.11.08-.2.17-.2Zm29.99 3.78c0-1.81-.73-2.05-1.5-1.97-.6.04-1.08.34-1.08.34v3.52s.49.34 1.22.36c1.03.03 1.36-.34 1.36-2.25ZM11.19 2.68c.75 0 1.36.61 1.36 1.38 0 .77-.61 1.38-1.36 1.38-.77 0-1.38-.61-1.38-1.38 0-.77.61-1.38 1.38-1.38Zm7.34 9.35v.001l.01.01h-.001l-.005-.001v.001c-.009-.001-.015-.011-.024-.011Z"]
    }
};
class LogoGithubIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = logoGithubIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LogoGithubIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: LogoGithubIconComponent, isStandalone: true, selector: "svg[logo-github-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: LogoGithubIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[logo-github-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const mailIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25v-8.5C0 2.784.784 2 1.75 2ZM1.5 12.251c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V5.809L8.38 9.397a.75.75 0 0 1-.76 0L1.5 5.809v6.442Zm13-8.181v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 7.88Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 18.75v-14C0 3.784.784 3 1.75 3ZM1.5 7.412V18.75c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V7.412l-9.52 6.433c-.592.4-1.368.4-1.96 0Zm0-2.662v.852l10.36 7a.25.25 0 0 0 .28 0l10.36-7V4.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"]
    }
};
class MailIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = mailIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MailIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MailIconComponent, isStandalone: true, selector: "svg[mail-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MailIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[mail-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const markGithubIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z"]
    }
};
class MarkGithubIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = markGithubIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MarkGithubIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MarkGithubIconComponent, isStandalone: true, selector: "svg[mark-github-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MarkGithubIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[mark-github-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const markdownIconData = {
    "16": {
        "width": 16,
        "paths": ["M14.85 3c.63 0 1.15.52 1.14 1.15v7.7c0 .63-.51 1.15-1.15 1.15H1.15C.52 13 0 12.48 0 11.84V4.15C0 3.52.52 3 1.15 3ZM9 11V5H7L5.5 7 4 5H2v6h2V8l1.5 1.92L7 8v3Zm2.99.5L14.5 8H13V5h-2v3H9.5Z"]
    }
};
class MarkdownIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = markdownIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MarkdownIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MarkdownIconComponent, isStandalone: true, selector: "svg[markdown-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MarkdownIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[markdown-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const megaphoneIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.25 9a.75.75 0 0 1 .75.75c0 2.142.456 3.828.733 4.653a.122.122 0 0 0 .05.064.212.212 0 0 0 .117.033h1.31c.085 0 .18-.042.258-.152a.45.45 0 0 0 .075-.366A16.743 16.743 0 0 1 6 9.75a.75.75 0 0 1 1.5 0c0 1.588.25 2.926.494 3.85.293 1.113-.504 2.4-1.783 2.4H4.9c-.686 0-1.35-.41-1.589-1.12A16.4 16.4 0 0 1 2.5 9.75.75.75 0 0 1 3.25 9Z", "M0 6a4 4 0 0 1 4-4h2.75a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75H4a4 4 0 0 1-4-4Zm4-2.5a2.5 2.5 0 1 0 0 5h2v-5Z", "M15.59.082A.75.75 0 0 1 16 .75v10.5a.75.75 0 0 1-1.189.608l-.002-.001h.001l-.014-.01a5.775 5.775 0 0 0-.422-.25 10.63 10.63 0 0 0-1.469-.64C11.576 10.484 9.536 10 6.75 10a.75.75 0 0 1 0-1.5c2.964 0 5.174.516 6.658 1.043.423.151.787.302 1.092.443V2.014c-.305.14-.669.292-1.092.443C11.924 2.984 9.713 3.5 6.75 3.5a.75.75 0 0 1 0-1.5c2.786 0 4.826-.484 6.155-.957.665-.236 1.154-.47 1.47-.64.144-.077.284-.161.421-.25l.014-.01a.75.75 0 0 1 .78-.061Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M22 1.75v14.5a.75.75 0 0 1-.399.662c-.384.204-.783-.035-1.139-.248l-.003-.002c-.09-.054-.177-.107-.261-.15a15.53 15.53 0 0 0-2-.849c-1.738-.607-4.321-1.223-7.703-1.251a.833.833 0 0 1 .005.088c0 2.279.494 4.279.906 5.547.368 1.131-.438 2.453-1.732 2.453H7.661c-.696 0-1.36-.42-1.6-1.129C5.684 20.255 5 17.811 5 14.75v-.457A5.5 5.5 0 0 1 6.5 3.5h3.75c3.505 0 6.175-.61 7.955-1.21a15.88 15.88 0 0 0 2.002-.82 9.21 9.21 0 0 0 .49-.262c.048-.028.095-.055.142-.085A.751.751 0 0 1 22 1.75ZM10.5 12.912c3.564.029 6.313.678 8.193 1.335.737.258 1.34.517 1.807.74V2.993c-.467.216-1.073.467-1.815.718-1.878.634-4.624 1.26-8.185 1.288ZM6.5 5a4 4 0 0 0 0 8H9V5Zm0 9.75c0 2.847.638 5.123.982 6.141.018.051.074.109.179.109h2.013c.087 0 .179-.043.249-.147a.396.396 0 0 0 .057-.343C9.537 19.148 9 16.986 9 14.5H6.5Z"]
    }
};
class MegaphoneIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = megaphoneIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MegaphoneIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MegaphoneIconComponent, isStandalone: true, selector: "svg[megaphone-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MegaphoneIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[megaphone-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const mentionIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.75 2.37a6.501 6.501 0 0 0 6.5 11.26.75.75 0 0 1 .75 1.298A7.999 7.999 0 0 1 .989 4.148 8 8 0 0 1 16 7.75v1.5a2.75 2.75 0 0 1-5.072 1.475 3.999 3.999 0 0 1-6.65-4.19A4 4 0 0 1 12 8v1.25a1.25 1.25 0 0 0 2.5 0V7.867a6.5 6.5 0 0 0-9.75-5.496ZM10.5 8a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M20.226 7.25c-2.623-4.542-8.432-6.098-12.974-3.475-4.543 2.622-6.099 8.431-3.477 12.974 2.623 4.542 8.431 6.099 12.974 3.477a.75.75 0 0 1 .75 1.299c-5.26 3.037-11.987 1.235-15.024-4.026C-.562 12.24 1.24 5.512 6.501 2.475 11.76-.562 18.488 1.24 21.525 6.501a10.959 10.959 0 0 1 1.455 4.826c.013.056.02.113.02.173v2.25a3.5 3.5 0 0 1-6.623 1.581 5.5 5.5 0 1 1 1.112-3.682.802.802 0 0 1 .011.129v1.972a2 2 0 1 0 4 0v-1.766a9.456 9.456 0 0 0-1.274-4.733ZM16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z"]
    }
};
class MentionIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = mentionIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MentionIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MentionIconComponent, isStandalone: true, selector: "svg[mention-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MentionIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[mention-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const meterIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 1.5a6.5 6.5 0 1 0 6.016 4.035.75.75 0 0 1 1.388-.57 8 8 0 1 1-4.37-4.37.75.75 0 1 1-.569 1.389A6.473 6.473 0 0 0 8 1.5Zm6.28.22a.75.75 0 0 1 0 1.06l-4.063 4.064a2.5 2.5 0 1 1-1.06-1.06L13.22 1.72a.75.75 0 0 1 1.06 0ZM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"]
    }
};
class MeterIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = meterIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MeterIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MeterIconComponent, isStandalone: true, selector: "svg[meter-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MeterIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[meter-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const milestoneIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.75 0a.75.75 0 0 1 .75.75V3h3.634c.414 0 .814.147 1.13.414l2.07 1.75a1.75 1.75 0 0 1 0 2.672l-2.07 1.75a1.75 1.75 0 0 1-1.13.414H8.5v5.25a.75.75 0 0 1-1.5 0V10H2.75A1.75 1.75 0 0 1 1 8.25v-3.5C1 3.784 1.784 3 2.75 3H7V.75A.75.75 0 0 1 7.75 0Zm4.384 8.5a.25.25 0 0 0 .161-.06l2.07-1.75a.248.248 0 0 0 0-.38l-2.07-1.75a.25.25 0 0 0-.161-.06H2.75a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h9.384Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.75 1a.75.75 0 0 1 .75.75V4h6.532c.42 0 .826.15 1.143.425l3.187 2.75a1.75 1.75 0 0 1 0 2.65l-3.187 2.75a1.75 1.75 0 0 1-1.143.425H12.5v9.25a.75.75 0 0 1-1.5 0V13H3.75A1.75 1.75 0 0 1 2 11.25v-5.5C2 4.783 2.784 4 3.75 4H11V1.75a.75.75 0 0 1 .75-.75Zm7.282 4.5H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h15.282c.06 0 .118-.021.163-.06l3.188-2.75a.248.248 0 0 0 0-.38l-3.188-2.75a.249.249 0 0 0-.163-.06Z"]
    }
};
class MilestoneIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = milestoneIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MilestoneIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MilestoneIconComponent, isStandalone: true, selector: "svg[milestone-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MilestoneIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[milestone-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const mirrorIconData = {
    "16": {
        "width": 16,
        "paths": ["M15.547 3.061A.75.75 0 0 1 16 3.75v8.5a.751.751 0 0 1-1.265.545l-4.5-4.25a.75.75 0 0 1 0-1.09l4.5-4.25a.75.75 0 0 1 .812-.144ZM0 12.25v-8.5a.751.751 0 0 1 1.265-.545l4.5 4.25a.75.75 0 0 1 0 1.09l-4.5 4.25A.75.75 0 0 1 0 12.25Zm1.5-6.76v5.02L4.158 8ZM11.842 8l2.658 2.51V5.49ZM8 4a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 4Zm.75-2.25v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 1.5 0Zm0 6v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 1.5 0ZM8 10a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 10Zm0 3a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 13Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M21.553 6.064A.75.75 0 0 1 22 6.75v10.5a.75.75 0 0 1-1.256.554l-5.75-5.25a.748.748 0 0 1 0-1.108l5.75-5.25a.75.75 0 0 1 .809-.132ZM2.447 17.936A.75.75 0 0 1 2 17.25V6.75a.75.75 0 0 1 1.256-.554l5.75 5.25a.748.748 0 0 1 0 1.108l-5.75 5.25a.75.75 0 0 1-.809.132ZM7.387 12 3.5 8.45v7.1L7.388 12Zm9.226 0 3.887 3.55v-7.1L16.612 12ZM12 2.75a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 4a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 8a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 4a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0-8a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Z"]
    }
};
class MirrorIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = mirrorIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MirrorIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MirrorIconComponent, isStandalone: true, selector: "svg[mirror-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MirrorIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[mirror-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const moonIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.598 1.591a.749.749 0 0 1 .785-.175 7.001 7.001 0 1 1-8.967 8.967.75.75 0 0 1 .961-.96 5.5 5.5 0 0 0 7.046-7.046.75.75 0 0 1 .175-.786Zm1.616 1.945a7 7 0 0 1-7.678 7.678 5.499 5.499 0 1 0 7.678-7.678Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M14.768 3.96v.001l-.002-.005a9.08 9.08 0 0 0-.218-.779c-.13-.394.21-.8.602-.67.29.096.575.205.855.328l.01.005A10.002 10.002 0 0 1 12 22a10.002 10.002 0 0 1-9.162-5.985l-.004-.01a9.722 9.722 0 0 1-.329-.855c-.13-.392.277-.732.67-.602.257.084.517.157.78.218l.004.002A9 9 0 0 0 14.999 6a9.09 9.09 0 0 0-.231-2.04ZM16.5 6c0 5.799-4.701 10.5-10.5 10.5-.426 0-.847-.026-1.26-.075A8.5 8.5 0 1 0 16.425 4.74c.05.413.075.833.075 1.259Z"]
    }
};
class MoonIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = moonIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoonIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MoonIconComponent, isStandalone: true, selector: "svg[moon-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoonIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[moon-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const mortarBoardIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.693 1.066a.747.747 0 0 1 .614 0l7.25 3.25a.75.75 0 0 1 0 1.368L13 6.831v2.794c0 1.024-.81 1.749-1.66 2.173-.893.447-2.075.702-3.34.702-.278 0-.55-.012-.816-.036a.75.75 0 0 1 .133-1.494c.22.02.45.03.683.03 1.082 0 2.025-.221 2.67-.543.69-.345.83-.682.83-.832V7.503L8.307 8.934a.747.747 0 0 1-.614 0L4 7.28v1.663c.296.105.575.275.812.512.438.438.688 1.059.688 1.796v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3c0-.737.25-1.358.688-1.796.237-.237.516-.407.812-.512V6.606L.443 5.684a.75.75 0 0 1 0-1.368ZM2.583 5 8 7.428 13.416 5 8 2.572ZM2.5 11.25v2.25H4v-2.25c0-.388-.125-.611-.25-.735a.697.697 0 0 0-.5-.203.707.707 0 0 0-.5.203c-.125.124-.25.347-.25.735Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.292 2.06v-.001l11.25 4.75a.749.749 0 0 1 0 1.382L19 10.108V15a.75.75 0 0 1-.11.391h-.001a2.84 2.84 0 0 1-.392.482c-.249.256-.625.58-1.163.896-1.08.638-2.776 1.23-5.334 1.23-.673 0-1.286-.041-1.846-.113a.75.75 0 0 1 .192-1.487c.492.063 1.042.1 1.654.1 2.317 0 3.746-.533 4.572-1.021.31-.178.596-.397.849-.65l.079-.085V10.74l-5.208 2.2a.75.75 0 0 1-.584 0L5.75 10.424v3.17c.502.129.96.391 1.327.758.579.578.923 1.41.923 2.428v4.5a.761.761 0 0 1-.345.634 2.157 2.157 0 0 1-.21.117 3.923 3.923 0 0 1-.52.213A6.121 6.121 0 0 1 5 22.532a6.092 6.092 0 0 1-1.925-.288 4.065 4.065 0 0 1-.52-.213 1.816 1.816 0 0 1-.22-.124.757.757 0 0 1-.335-.624v-4.5c0-1.02.344-1.85.923-2.43a2.904 2.904 0 0 1 1.327-.757V9.793L.458 8.19a.75.75 0 0 1 0-1.38l11.25-4.75a.75.75 0 0 1 .584 0ZM12 11.436 21.322 7.5 12 3.564 2.678 7.5ZM5 15c-.377 0-.745.141-1.017.413-.265.265-.483.7-.483 1.368v4.022c.299.105.797.228 1.5.228s1.201-.123 1.5-.228V16.78c0-.669-.218-1.103-.483-1.368A1.433 1.433 0 0 0 5 15Z"]
    }
};
class MortarBoardIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = mortarBoardIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MortarBoardIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MortarBoardIconComponent, isStandalone: true, selector: "svg[mortar-board-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MortarBoardIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[mortar-board-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const moveToBottomIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.47 10.78a.749.749 0 0 0 1.06 0l3.75-3.75a.749.749 0 1 0-1.06-1.06L8.75 8.439V1.75a.75.75 0 0 0-1.5 0v6.689L4.78 5.97a.749.749 0 1 0-1.06 1.06l3.75 3.75ZM3.75 13a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4 21.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1-.75-.75ZM5.22 9.97a.749.749 0 0 1 1.06 0l4.97 4.969V2.75a.75.75 0 0 1 1.5 0v12.189l4.97-4.969a.749.749 0 1 1 1.06 1.06l-6.25 6.25a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06Z"]
    }
};
class MoveToBottomIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = moveToBottomIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoveToBottomIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MoveToBottomIconComponent, isStandalone: true, selector: "svg[move-to-bottom-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoveToBottomIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[move-to-bottom-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const moveToEndIconData = {
    "16": {
        "width": 16,
        "paths": ["m10.78 8.53-3.75 3.75a.749.749 0 1 1-1.06-1.06l2.469-2.47H1.75a.75.75 0 0 1 0-1.5h6.689L5.97 4.78a.749.749 0 1 1 1.06-1.06l3.75 3.75a.749.749 0 0 1 0 1.06ZM13 12.25v-8.5a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.22 5.22a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 0 1 0 1.06l-6.25 6.25a.749.749 0 1 1-1.06-1.06l4.969-4.97H1.75a.75.75 0 0 1 0-1.5h14.439L11.22 6.28a.749.749 0 0 1 0-1.06Zm10.03-1.47a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z"]
    }
};
class MoveToEndIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = moveToEndIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoveToEndIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MoveToEndIconComponent, isStandalone: true, selector: "svg[move-to-end-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoveToEndIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[move-to-end-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const moveToStartIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.22 7.47a.749.749 0 0 0 0 1.06l3.75 3.75a.749.749 0 1 0 1.06-1.06L7.561 8.75h6.689a.75.75 0 0 0 0-1.5H7.561l2.469-2.47a.749.749 0 1 0-1.06-1.06L5.22 7.47ZM3 3.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.78 18.78a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 1 1 1.06 1.06l-4.969 4.97H22.25a.75.75 0 0 1 0 1.5H7.811l4.969 4.97a.749.749 0 0 1 0 1.06ZM2.75 3.75a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z"]
    }
};
class MoveToStartIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = moveToStartIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoveToStartIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MoveToStartIconComponent, isStandalone: true, selector: "svg[move-to-start-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoveToStartIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[move-to-start-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const moveToTopIconData = {
    "16": {
        "width": 16,
        "paths": ["M3 2.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 2.25Zm5.53 2.97 3.75 3.75a.749.749 0 1 1-1.06 1.06L8.75 7.561v6.689a.75.75 0 0 1-1.5 0V7.561L4.78 10.03a.749.749 0 1 1-1.06-1.06l3.75-3.75a.749.749 0 0 1 1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.75 3.5a.75.75 0 0 1 0-1.5h14.5a.75.75 0 0 1 0 1.5H4.75Zm.47 9.47a.749.749 0 1 0 1.06 1.06l4.97-4.969V21.25a.75.75 0 0 0 1.5 0V9.061l4.97 4.969a.749.749 0 1 0 1.06-1.06l-6.25-6.25a.749.749 0 0 0-1.06 0l-6.25 6.25Z"]
    }
};
class MoveToTopIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = moveToTopIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoveToTopIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MoveToTopIconComponent, isStandalone: true, selector: "svg[move-to-top-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MoveToTopIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[move-to-top-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const multiSelectIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.75 7.5h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5Zm0 5h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5Zm-4-10h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5ZM2 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10.314-3.082L11.07 2.417A.25.25 0 0 1 11.256 2h4.488a.25.25 0 0 1 .186.417l-2.244 2.5a.25.25 0 0 1-.372 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.75 11.5h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm-5-12h10a.75.75 0 0 1 0 1.5h-10a.75.75 0 0 1 0-1.5ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM19.309 7.918l-2.245-2.501A.25.25 0 0 1 17.25 5h4.49a.25.25 0 0 1 .185.417l-2.244 2.5a.25.25 0 0 1-.372 0Z"]
    }
};
class MultiSelectIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = multiSelectIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MultiSelectIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MultiSelectIconComponent, isStandalone: true, selector: "svg[multi-select-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MultiSelectIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[multi-select-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const muteIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 2.75v10.5a.751.751 0 0 1-1.238.57L3.473 11H1.75A1.75 1.75 0 0 1 0 9.25v-2.5C0 5.784.784 5 1.75 5h1.722l3.29-2.82A.75.75 0 0 1 8 2.75Zm3.28 2.47L13 6.94l1.72-1.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L14.06 8l1.72 1.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L13 9.06l-1.72 1.72a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L11.94 8l-1.72-1.72a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Zm-7.042 1.1a.752.752 0 0 1-.488.18h-2a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2c.179 0 .352.064.488.18L6.5 11.62V4.38Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 3.75v16.5a.75.75 0 0 1-1.255.555L5.46 16H2.75A1.75 1.75 0 0 1 1 14.25v-4.5C1 8.784 1.784 8 2.75 8h2.71l5.285-4.805A.75.75 0 0 1 12 3.75ZM6.255 9.305a.748.748 0 0 1-.505.195h-3a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h3c.187 0 .367.069.505.195l4.245 3.86V5.445ZM16.28 8.22a.75.75 0 1 0-1.06 1.06L17.94 12l-2.72 2.72a.75.75 0 1 0 1.06 1.06L19 13.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L20.06 12l2.72-2.72a.75.75 0 0 0-1.06-1.06L19 10.94l-2.72-2.72Z"]
    }
};
class MuteIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = muteIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MuteIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: MuteIconComponent, isStandalone: true, selector: "svg[mute-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: MuteIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[mute-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const noEntryIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.25 7.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Z", "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Zm15.75.75H5.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5Z"]
    }
};
class NoEntryIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = noEntryIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NoEntryIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: NoEntryIconComponent, isStandalone: true, selector: "svg[no-entry-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NoEntryIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[no-entry-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const noEntryFillIconData = {
    "12": {
        "width": 12,
        "paths": ["M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm3 5H3v2h6Z"]
    }
};
class NoEntryFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = noEntryFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NoEntryFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: NoEntryFillIconComponent, isStandalone: true, selector: "svg[no-entry-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NoEntryFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[no-entry-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const northStarIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.5.75a.75.75 0 0 0-1.5 0v5.19L4.391 3.33a.75.75 0 1 0-1.06 1.061L5.939 7H.75a.75.75 0 0 0 0 1.5h5.19l-2.61 2.609a.75.75 0 1 0 1.061 1.06L7 9.561v5.189a.75.75 0 0 0 1.5 0V9.56l2.609 2.61a.75.75 0 1 0 1.06-1.061L9.561 8.5h5.189a.75.75 0 0 0 0-1.5H9.56l2.61-2.609a.75.75 0 0 0-1.061-1.06L8.5 5.939V.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.5 1.25a.75.75 0 0 0-1.5 0v8.69L6.447 5.385a.75.75 0 1 0-1.061 1.06L9.94 11H1.25a.75.75 0 0 0 0 1.5h8.69l-4.554 4.553a.75.75 0 0 0 1.06 1.061L11 13.561v8.689a.75.75 0 0 0 1.5 0v-8.69l4.553 4.554a.75.75 0 0 0 1.061-1.06L13.561 12.5h8.689a.75.75 0 0 0 0-1.5h-8.69l4.554-4.553a.75.75 0 1 0-1.06-1.061L12.5 9.939V1.25Z"]
    }
};
class NorthStarIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = northStarIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NorthStarIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: NorthStarIconComponent, isStandalone: true, selector: "svg[north-star-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NorthStarIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[north-star-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const noteIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM3.5 6.25a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm.75 2.25h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z", "M5 8.75A.75.75 0 0 1 5.75 8h11.5a.75.75 0 0 1 0 1.5H5.75A.75.75 0 0 1 5 8.75Zm0 4a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z"]
    }
};
class NoteIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = noteIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NoteIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: NoteIconComponent, isStandalone: true, selector: "svg[note-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NoteIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[note-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const numberIconData = {
    "16": {
        "width": 16,
        "paths": ["M9 4.75A.75.75 0 0 1 9.75 4h4a.75.75 0 0 1 .53 1.28l-1.89 1.892c.312.076.604.18.867.319.742.391 1.244 1.063 1.244 2.005 0 .653-.231 1.208-.629 1.627-.386.408-.894.653-1.408.777-1.01.243-2.225.063-3.124-.527a.751.751 0 0 1 .822-1.254c.534.35 1.32.474 1.951.322.306-.073.53-.201.67-.349.129-.136.218-.32.218-.596 0-.308-.123-.509-.444-.678-.373-.197-.98-.318-1.806-.318a.75.75 0 0 1-.53-1.28l1.72-1.72H9.75A.75.75 0 0 1 9 4.75Zm-3.587 5.763c-.35-.05-.77.113-.983.572a.75.75 0 1 1-1.36-.632c.508-1.094 1.589-1.565 2.558-1.425 1 .145 1.872.945 1.872 2.222 0 1.433-1.088 2.192-1.79 2.681-.308.216-.571.397-.772.573H7a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75c0-.69.3-1.211.67-1.61.348-.372.8-.676 1.15-.92.8-.56 1.18-.904 1.18-1.474 0-.473-.267-.69-.587-.737ZM5.604.089A.75.75 0 0 1 6 .75v4.77h.711a.75.75 0 0 1 0 1.5H3.759a.75.75 0 0 1 0-1.5H4.5V2.15l-.334.223a.75.75 0 0 1-.832-1.248l1.5-1a.75.75 0 0 1 .77-.037Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M13.003 7.754a.75.75 0 0 1 .75-.75h5.232a.75.75 0 0 1 .53 1.28l-2.776 2.777c.55.097 1.057.253 1.492.483.905.477 1.504 1.284 1.504 2.418 0 .966-.471 1.75-1.172 2.27-.687.511-1.587.77-2.521.77-1.367 0-2.274-.528-2.667-.756a.75.75 0 0 1 .755-1.297c.331.193.953.553 1.912.553.673 0 1.243-.188 1.627-.473.37-.275.566-.635.566-1.067 0-.5-.219-.836-.703-1.091-.538-.284-1.375-.443-2.471-.443a.75.75 0 0 1-.53-1.28l2.643-2.644h-3.421a.75.75 0 0 1-.75-.75ZM7.88 15.215a1.4 1.4 0 0 0-1.446.83.75.75 0 0 1-1.37-.61 2.899 2.899 0 0 1 2.986-1.71c.589.06 1.139.323 1.557.743.434.446.685 1.058.685 1.778 0 1.641-1.254 2.437-2.12 2.986-.538.341-1.18.694-1.495 1.273H9.75a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75c0-1.799 1.337-2.63 2.243-3.21 1.032-.659 1.55-1.031 1.55-1.8 0-.355-.116-.584-.26-.732a1.071 1.071 0 0 0-.652-.298Zm.234-13.121a.75.75 0 0 1 .386.656V9h1.252a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5H7V4.103l-.853.533a.749.749 0 1 1-.795-1.272l2-1.25a.749.749 0 0 1 .762-.02Z"]
    }
};
class NumberIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = numberIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NumberIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: NumberIconComponent, isStandalone: true, selector: "svg[number-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NumberIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[number-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opArrowInIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.47 13.78a.749.749 0 0 1 0-1.06l2.969-2.97H6A4.75 4.75 0 0 1 1.25 5V2.5a.75.75 0 0 1 1.5 0V5A3.25 3.25 0 0 0 6 8.25h6.439L9.47 5.28a.749.749 0 1 1 1.06-1.06l4.25 4.25a.749.749 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.06 0Z"]
    }
};
class OpArrowInIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opArrowInIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpArrowInIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpArrowInIconComponent, isStandalone: true, selector: "svg[op-arrow-in-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpArrowInIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-arrow-in-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opAttachmentaddIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.832 12.991c.478.585 1.341.62 1.915-.025l5.628-6.317a.381.381 0 0 0 0-.535c-.146-.164-.331-.164-.477 0l-4.655 5.225a.651.651 0 0 1-.488.219.655.655 0 0 1-.486-.228.826.826 0 0 1-.203-.545.828.828 0 0 1 .195-.548l4.655-5.226c.159-.183.348-.329.558-.429a1.55 1.55 0 0 1 1.325 0c.21.1.4.246.558.429.164.178.293.391.382.626.089.236.134.489.134.744 0 .256-.045.509-.134.744a1.924 1.924 0 0 1-.382.627L5.73 14.069c-1.089 1.223-2.86 1.263-3.912-.011-1.078-1.224-1.11-3.201.021-4.378L8.43 2.281c1.521-1.708 3.907-1.708 5.429 0 1.521 1.708 1.521 4.387 0 6.095a.66.66 0 0 1-.489.219.66.66 0 0 1-.485-.229.83.83 0 0 1-.204-.545.839.839 0 0 1 .195-.548 2.94 2.94 0 0 0 0-3.889c-.979-1.1-2.484-1.1-3.464 0l-6.601 7.409-.021.024c-.521.536-.553 1.504.021 2.149l.021.025Z", "M12.25 9.5a.75.75 0 0 1 .75.75v1.25h1.25a.75.75 0 0 1 0 1.5H13v1.25a.75.75 0 0 1-1.5 0V13h-1.25a.75.75 0 0 1 0-1.5h1.25v-1.25a.75.75 0 0 1 .75-.75Z"]
    }
};
class OpAttachmentaddIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opAttachmentaddIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpAttachmentaddIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpAttachmentaddIconComponent, isStandalone: true, selector: "svg[op-attachmentadd-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpAttachmentaddIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-attachmentadd-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opBacklogsIconData = {
    "16": {
        "width": 16,
        "paths": ["M12.084 6.306a.652.652 0 0 0 .943 0 .704.704 0 0 0 0-.973l-.862-.89h1.279c.123 0 .223.102.223.229v7.344c0 .127-.1.23-.223.23h-1.777a.678.678 0 0 0-.667.688c0 .381.299.689.667.689h1.777c.86 0 1.556-.719 1.556-1.607V4.672c0-.887-.696-1.606-1.556-1.606h-1.279l.862-.891a.704.704 0 0 0 0-.973.652.652 0 0 0-.943 0l-2 2.065a.706.706 0 0 0 0 .974l2 2.065Zm-4.64-4.388c.86 0 1.556.719 1.556 1.607v.459c0 .887-.696 1.606-1.556 1.606H2.556C1.696 5.59 1 4.871 1 3.984v-.459c0-.888.696-1.607 1.556-1.607Zm.223 1.607c0-.127-.1-.23-.223-.23H2.556a.227.227 0 0 0-.223.23v.459c0 .126.1.229.223.229h4.888a.226.226 0 0 0 .223-.229Z", "M11.667 8.115v.459c0 .887-.697 1.606-1.556 1.606H4.333c-.859 0-1.555-.719-1.555-1.606v-.459c0-.888.696-1.607 1.555-1.607h5.778c.859 0 1.556.719 1.556 1.607Zm-1.556-.23H4.333a.227.227 0 0 0-.222.23v.459c0 .127.1.229.222.229h5.778a.225.225 0 0 0 .222-.229v-.459a.226.226 0 0 0-.222-.23Zm-.222 5.049v.459c0 .888-.697 1.607-1.556 1.607H2.556C1.696 15 1 14.281 1 13.393v-.459c0-.887.696-1.606 1.556-1.606h5.777c.859 0 1.556.719 1.556 1.606Zm-1.556-.229H2.556a.226.226 0 0 0-.223.229v.459c0 .127.1.23.223.23h5.777a.227.227 0 0 0 .223-.23v-.459c0-.126-.1-.229-.223-.229Z"]
    }
};
class OpBacklogsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opBacklogsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBacklogsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpBacklogsIconComponent, isStandalone: true, selector: "svg[op-backlogs-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBacklogsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-backlogs-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opBaselineIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 .5a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 1 .5Zm0 10a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 1 10.5Zm1-2.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8 6a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z", "M10.28 5.47c.141.14.22.331.22.53v1.992l1.028.812a.747.747 0 0 1 .397.966.75.75 0 0 1-.954.426l-1.5-1A.753.753 0 0 1 9 8.5V6c0-.199.079-.39.22-.53a.747.747 0 0 1 1.06 0Z"]
    }
};
class OpBaselineIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opBaselineIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBaselineIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpBaselineIconComponent, isStandalone: true, selector: "svg[op-baseline-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBaselineIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-baseline-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opBcfIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.966 3.788a8.806 8.806 0 0 1 1.562 3.14c.384 1.453.334 2.617.217 3.381.165-.033.303-.067.411-.096.31-.083.576-.234.792-.449.198-.199.347-.443.456-.71a26.774 26.774 0 0 0-.538-2.496 25.863 25.863 0 0 0-.785-2.481c-.13-.342-.271-.681-.421-1-.272-.575-.575-1.082-.898-1.405l-.088-.086a5.752 5.752 0 0 0-.625-.519l-.016-.011a5.73 5.73 0 0 0-7.36.617 5.731 5.731 0 0 0-.648 7.318c.02-.093.042-.186.067-.279.192-.715.775-1.588 1.435-2.406.194-1.05.893-2.053 1.309-2.47.454-.454 1.459-1.151 2.504-1.329a2.51 2.51 0 0 1 1.064.03c.337.088.658.261.946.549a8.104 8.104 0 0 1 .616.702Z", "M10.326 10.718a8.804 8.804 0 0 1-3.5-.217c-1.45-.394-2.433-1.019-3.036-1.503a6.497 6.497 0 0 0-.123.404c-.083.31-.085.616-.006.91.072.272.209.522.386.75.93.356 1.875.631 2.43.782.564.154 1.538.399 2.541.561.361.059.725.106 1.077.135.634.053 1.224.044 1.665-.074l.12-.034c.263-.077.517-.171.761-.282l.076-.034a5.733 5.733 0 0 0 3.088-6.657 5.73 5.73 0 0 0-6.013-4.22c.07.064.139.13.207.197.524.524.988 1.465 1.366 2.446.813.693 1.332 1.8 1.484 2.369.167.62.268 1.839-.1 2.833-.126.34-.307.653-.558.907a2.06 2.06 0 0 1-.949.544 8.137 8.137 0 0 1-.916.183Z", "M5.582 5.507a8.783 8.783 0 0 0-2.178 3.6 5.24 5.24 0 0 0-.059.208 2.061 2.061 0 0 0-.004 1.094c.095.345.276.657.507.936.676.816 1.783 1.338 2.403 1.504.569.152 1.787.256 2.793-.101 1.039.163 2.086.231 2.801.04.093-.025.185-.052.275-.081a5.73 5.73 0 0 1-6.661 3.097 5.73 5.73 0 0 1-4.221-6.001l.007-.072.001-.012a5.87 5.87 0 0 1 .168-.921c.118-.441.405-.956.768-1.48.2-.289.424-.581.655-.864a25.826 25.826 0 0 1 1.756-1.921A26.887 26.887 0 0 1 6.486 2.82c.285-.039.571-.032.842.04.294.079.558.234.785.461.079.079.178.182.289.309-.721.28-1.753.819-2.82 1.877Z"]
    }
};
class OpBcfIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opBcfIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBcfIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpBcfIconComponent, isStandalone: true, selector: "svg[op-bcf-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBcfIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-bcf-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opBoardsIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 1.724c0-.4.324-.724.724-.724h2.897a.724.724 0 1 1 0 1.448H1.724A.724.724 0 0 1 1 1.724Zm4.828 0c0-.4.324-.724.724-.724h2.896a.724.724 0 1 1 0 1.448H6.552a.724.724 0 0 1-.724-.724Zm4.827 0c0-.4.324-.724.724-.724h2.897a.724.724 0 1 1 0 1.448h-2.897a.724.724 0 0 1-.724-.724ZM1 4.621c0-.933.756-1.69 1.69-1.69h.965c.933 0 1.69.757 1.69 1.69v8.689A1.69 1.69 0 0 1 3.655 15H2.69A1.69 1.69 0 0 1 1 13.31Zm1.69-.242a.242.242 0 0 0-.242.242v8.689c0 .134.108.242.242.242h.965a.242.242 0 0 0 .242-.242V4.621a.242.242 0 0 0-.242-.242Zm3.138.242c0-.933.756-1.69 1.689-1.69h.966a1.69 1.69 0 0 1 1.689 1.69v2.896a1.69 1.69 0 0 1-1.689 1.69h-.966a1.69 1.69 0 0 1-1.689-1.69Zm1.689-.242a.241.241 0 0 0-.241.242v2.896c0 .134.108.242.241.242h.966a.241.241 0 0 0 .241-.242V4.621a.241.241 0 0 0-.241-.242Zm3.138.242c0-.933.757-1.69 1.69-1.69h.965c.933 0 1.69.757 1.69 1.69v5.827a1.69 1.69 0 0 1-1.69 1.69h-.965a1.69 1.69 0 0 1-1.69-1.69Zm1.69-.242a.241.241 0 0 0-.241.242v5.827c0 .134.108.242.241.242h.965a.242.242 0 0 0 .242-.242V4.621a.242.242 0 0 0-.242-.242Z"]
    }
};
class OpBoardsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opBoardsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBoardsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpBoardsIconComponent, isStandalone: true, selector: "svg[op-boards-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBoardsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-boards-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opBookEditIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.778C0 1.348.336 1 .75 1h4.253c1.227 0 2.317.611 3.001 1.557C8.688 1.611 9.778 1 11.005 1h4.245c.414 0 .75.348.75.778V8c0 .43-.336.778-.75.778A.764.764 0 0 1 14.5 8V2.556h-3.495c-1.243 0-2.25 1.044-2.25 2.333l-.004 7.594c.105-.068.213-.131.323-.188.454-.234.926.163.926.689 0 .354-.225.658-.509.855-.121.084-.235.18-.339.289l-.622.644a.73.73 0 0 1-1.06 0l-.622-.644a2.209 2.209 0 0 0-1.591-.684H.75a.764.764 0 0 1-.75-.777Zm7.255 5.445-.002-2.336c-.001-1.288-1.008-2.331-2.25-2.331H1.5v9.333h3.757a3.65 3.65 0 0 1 1.994.595Z", "M14.41 9.504a.665.665 0 0 1 .966 0l.424.44a.727.727 0 0 1 0 1.002l-3.362 3.486a.68.68 0 0 1-.295.18l-1.27.376a.283.283 0 0 1-.287-.077.312.312 0 0 1-.075-.298l.363-1.316a.717.717 0 0 1 .174-.307Zm.552.429a.096.096 0 0 0-.138 0l-.493.512.562.582.493-.511a.104.104 0 0 0 0-.143Z"]
    }
};
class OpBookEditIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opBookEditIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBookEditIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpBookEditIconComponent, isStandalone: true, selector: "svg[op-book-edit-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBookEditIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-book-edit-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opBudgetIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.636 1.308c1.424-.411 3.156-.411 4.58 0 .715.207 1.344.514 1.811.919.467.404.825.958.825 1.625s-.358 1.221-.825 1.625c-.467.404-1.096.712-1.811.918-1.424.412-3.156.412-4.58 0a5.679 5.679 0 0 1-1.08-.427v1.341c0 .042.003.097.123.207.143.133.393.284.799.466a.776.776 0 1 1-.635 1.419 8.387 8.387 0 0 1-.287-.134v1.498c0 .042.003.098.123.208.143.133.393.284.799.465a.778.778 0 0 1-.635 1.42c-.443-.198-.885-.432-1.22-.742-.36-.333-.623-.779-.623-1.351V3.852c0-.667.358-1.221.825-1.625.467-.405 1.096-.712 1.811-.919Zm-.793 2.993c.249.216.656.436 1.225.6 1.142.33 2.574.33 3.716 0 .569-.164.976-.384 1.225-.6.25-.216.287-.375.287-.449 0-.074-.037-.233-.287-.449-.249-.216-.656-.436-1.225-.6-1.142-.33-2.574-.33-3.716 0-.569.164-.976.384-1.225.6-.25.216-.287.375-.287.449 0 .074.037.233.287.449Z", "M6.793 7.22c.88-.44 2.041-.689 3.281-.689 1.24 0 2.401.249 3.281.689C14.189 7.637 15 8.357 15 9.383v2.765c0 1.026-.812 1.745-1.645 2.162-.88.44-2.041.69-3.281.69-1.24 0-2.401-.25-3.281-.69-.833-.417-1.645-1.136-1.645-2.162V9.376c.004-1.022.813-1.74 1.645-2.156Zm6.651 2.161c-.001-.121-.12-.437-.784-.769-.622-.311-1.535-.526-2.586-.526s-1.964.215-2.585.526c-.668.334-.785.651-.785.771 0 .119.117.437.785.771.621.31 1.534.525 2.585.525s1.964-.215 2.586-.525c.663-.332.783-.648.784-.769v-.004Zm0 2.767v-.649l-.089.046c-.88.44-2.041.69-3.281.69-1.24 0-2.401-.25-3.281-.69l-.089-.046v.649c0 .119.117.437.785.771.621.311 1.534.525 2.585.525s1.964-.214 2.585-.525c.669-.334.785-.652.785-.771Z"]
    }
};
class OpBudgetIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opBudgetIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBudgetIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpBudgetIconComponent, isStandalone: true, selector: "svg[op-budget-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpBudgetIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-budget-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opCalendarAlertIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.75 2a.75.75 0 0 1 .75.75V4h3V2.75a.75.75 0 0 1 1.5 0V4h1.25c.967 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 10.25 16h-8.5A1.75 1.75 0 0 1 0 14.25v-8.5C0 4.784.784 4 1.75 4H3V2.75A.75.75 0 0 1 3.75 2ZM1.5 9.5v4.75c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25V9.5Zm8.75-4h-8.5a.25.25 0 0 0-.25.25V8h9V5.75a.25.25 0 0 0-.25-.25Zm5.5-4.75v2.5a.75.75 0 0 1-1.5 0V.75a.75.75 0 0 1 1.5 0ZM16 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    }
};
class OpCalendarAlertIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opCalendarAlertIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCalendarAlertIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpCalendarAlertIconComponent, isStandalone: true, selector: "svg[op-calendar-alert-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCalendarAlertIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-calendar-alert-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opCartIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.173 13.689c0-.722.593-1.312 1.33-1.312.737 0 1.329.59 1.329 1.312A1.32 1.32 0 0 1 5.503 15c-.737 0-1.33-.59-1.33-1.311Zm7.053 0a1.32 1.32 0 0 1 1.329-1.312c.737 0 1.329.59 1.329 1.312A1.32 1.32 0 0 1 12.555 15a1.32 1.32 0 0 1-1.329-1.311ZM1 1.677C1 1.303 1.308 1 1.688 1H2.97c.325 0 .606.224.674.536l.57 2.633h9.179c1.027 0 1.79.935 1.569 1.922l-.811 3.61a1.948 1.948 0 0 1-.688 1.097c-.349.278-.784.43-1.234.431H5.965a1.988 1.988 0 0 1-1.258-.42 1.94 1.94 0 0 1-.704-1.118L2.99 5.018a.56.56 0 0 1-.012-.059l-.564-2.604h-.726A.683.683 0 0 1 1 1.677Zm3.508 3.847.841 3.884a.592.592 0 0 0 .594.466h6.284a.6.6 0 0 0 .579-.463l.811-3.612a.227.227 0 0 0-.224-.275Z"]
    }
};
class OpCartIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opCartIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCartIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpCartIconComponent, isStandalone: true, selector: "svg[op-cart-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCartIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-cart-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opColumnsLeftIconData = {
    "16": {
        "width": 16,
        "paths": ["M12.25 16h-2.5A1.75 1.75 0 0 1 8 14.25V1.75C8 .784 8.783 0 9.75 0h2.5C13.217 0 14 .784 14 1.75v12.5A1.75 1.75 0 0 1 12.25 16Zm.25-1.75V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25ZM5.1 5.134 2.154 7.678a.414.414 0 0 0 0 .644L5.1 10.866c.332.287.9.084.9-.322V5.456c0-.405-.568-.609-.9-.322Z"]
    }
};
class OpColumnsLeftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opColumnsLeftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpColumnsLeftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpColumnsLeftIconComponent, isStandalone: true, selector: "svg[op-columns-left-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpColumnsLeftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-columns-left-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opColumnsRightIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.25 16h-2.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.783 0 3.75 0h2.5C7.216 0 8 .784 8 1.75v12.5A1.75 1.75 0 0 1 6.25 16Zm.25-1.75V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25Zm4.4-3.384 2.946-2.544a.413.413 0 0 0 0-.644L10.9 5.134c-.332-.287-.9-.083-.9.322v5.088c0 .405.568.609.9.322Z"]
    }
};
class OpColumnsRightIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opColumnsRightIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpColumnsRightIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpColumnsRightIconComponent, isStandalone: true, selector: "svg[op-columns-right-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpColumnsRightIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-columns-right-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opCopyToProjectIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z", "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.217 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z", "M12 3.25a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-1.5 0v-4ZM8.25 2.5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75Zm1.5.75a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Z"]
    }
};
class OpCopyToProjectIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opCopyToProjectIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCopyToProjectIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpCopyToProjectIconComponent, isStandalone: true, selector: "svg[op-copy-to-project-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCopyToProjectIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-copy-to-project-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opCostReportsIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 1.75V13.5h13.75a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75V1.75a.75.75 0 0 1 1.5 0Z", "M3 6.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 3 6.25Zm3-1a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 6 5.25Zm3 1a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 9 6.25Zm3-4a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Zm3 2a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75Z"]
    }
};
class OpCostReportsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opCostReportsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCostReportsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpCostReportsIconComponent, isStandalone: true, selector: "svg[op-cost-reports-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCostReportsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-cost-reports-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opCursorRectangleSelectIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.454 12.908a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.151a1 1 0 0 1 1-1h.151Zm-4.303 0a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.151a1 1 0 0 1 1-1h.151Zm12.908-8.605a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.151a1 1 0 0 1 1-1h.151Zm0-4.303a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h.151ZM9.756 0a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h.151ZM5.454 0a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h.151ZM1.151 0a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h.151Zm0 8.605a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.151a1 1 0 0 1 1-1h.151Zm0-4.302a1 1 0 0 1 1 1v.151a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.151a1 1 0 0 1 1-1h.151Zm5.59 2.438a.523.523 0 0 1 .569-.113l8.366 3.445a.523.523 0 0 1 .007.964L12.6 12.358a.462.462 0 0 0-.242.242l-1.322 3.083a.521.521 0 0 1-.963-.007L6.628 7.31a.523.523 0 0 1 .113-.569Zm1.331 1.331 2.494 6.055.831-1.939c.152-.355.435-.639.791-.791l1.939-.831Z"]
    }
};
class OpCursorRectangleSelectIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opCursorRectangleSelectIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCursorRectangleSelectIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpCursorRectangleSelectIconComponent, isStandalone: true, selector: "svg[op-cursor-rectangle-select-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCursorRectangleSelectIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-cursor-rectangle-select-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opCursorSelectIconData = {
    "16": {
        "width": 16,
        "paths": ["M.26.26a.89.89 0 0 1 .967-.193L15.45 5.923a.89.89 0 0 1 .011 1.639L10.22 9.808a.79.79 0 0 0-.412.412l-2.246 5.241a.888.888 0 0 1-1.639-.011L.067 1.227A.89.89 0 0 1 .26.26Zm2.263 2.263 4.238 10.293L8.174 9.52A2.567 2.567 0 0 1 9.52 8.174l3.296-1.413Z"]
    }
};
class OpCursorSelectIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opCursorSelectIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCursorSelectIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpCursorSelectIconComponent, isStandalone: true, selector: "svg[op-cursor-select-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCursorSelectIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-cursor-select-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opCustomFieldsIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.889 14.333v.834a.78.78 0 0 1-.256.594.888.888 0 0 1-.627.239H8q-.378 0-.634-.24a.782.782 0 0 1-.255-.593v-3.334a.78.78 0 0 1 .256-.594A.886.886 0 0 1 8 11q.378 0 .634.24c.17.16.255.358.255.593v.834h6.222c.252 0 .463.08.634.24a.78.78 0 0 1 .255.588v.005a.78.78 0 0 1-.256.594.886.886 0 0 1-.633.239Zm-8 0a.892.892 0 0 1-.634-.24.776.776 0 0 1-.255-.59V13.5a.78.78 0 0 1 .256-.594.886.886 0 0 1 .633-.239h3.555a.89.89 0 0 1 .634.24c.171.16.256.357.255.593a.78.78 0 0 1-.256.594.883.883 0 0 1-.633.239ZM1 0h14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Zm.5 1.5v6h13v-6Z", "M3.701 5.895C3.303 5.895 3 5.637 3 5.26c0-.381.293-.602.816-.633l.528-.031v-.139c0-.195-.137-.309-.352-.309-.174 0-.279.057-.406.221a.29.29 0 0 1-.227.106c-.138 0-.238-.09-.238-.219a.31.31 0 0 1 .029-.129c.098-.25.434-.404.868-.404.537 0 .886.277.886.699v1.193c0 .19-.115.287-.277.287-.154 0-.262-.086-.273-.254v-.107h-.012c-.117.223-.379.354-.641.354Zm.188-.413c.25 0 .455-.162.455-.388v-.153l-.442.028c-.213.015-.334.111-.334.26 0 .156.129.253.321.253Zm1.697.42c-.164 0-.279-.097-.279-.289V3.299c0-.195.119-.299.285-.299.168 0 .285.104.285.299v.832h.012a.684.684 0 0 1 .647-.397c.529 0 .851.405.851 1.08 0 .674-.32 1.081-.849 1.081-.307 0-.539-.149-.657-.393H5.87v.111c0 .19-.118.289-.284.289Zm.756-.466c.283 0 .461-.239.461-.622 0-.38-.178-.623-.461-.623-.277 0-.467.248-.467.623 0 .379.19.622.467.622Zm2.317.47c-.631 0-1.031-.414-1.031-1.092 0-.669.398-1.091 1.027-1.091.42 0 .77.203.883.5.02.048.031.099.031.14 0 .141-.109.223-.244.223-.113 0-.181-.045-.24-.148-.104-.184-.231-.268-.412-.268-.289 0-.467.238-.467.642 0 .413.178.647.463.647.199 0 .322-.098.41-.246.076-.119.139-.168.26-.168.133 0 .24.088.24.228a.369.369 0 0 1-.037.149c-.125.285-.482.484-.883.484Z"]
    }
};
class OpCustomFieldsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opCustomFieldsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCustomFieldsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpCustomFieldsIconComponent, isStandalone: true, selector: "svg[op-custom-fields-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpCustomFieldsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-custom-fields-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opEnterpriseAddonsIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM6.343 7.14c-.109 0-.186.114-.152.226L7.84 12.88c.048.16.258.16.306 0l1.649-5.514c.034-.112-.043-.226-.152-.226Zm-3.182 0c-.133 0-.208.163-.128.277l3.684 5.224c.108.153.332.031.281-.153L5.569 7.264a.161.161 0 0 0-.153-.124Zm7.383 0a.162.162 0 0 0-.154.124l-1.429 5.224c-.05.184.174.306.281.153l3.684-5.224c.081-.114.005-.277-.127-.277ZM6.96 4a.162.162 0 0 0-.152.119l-.616 2.016c-.034.112.043.227.153.227h3.291c.111 0 .188-.118.151-.231l-.661-2.016A.162.162 0 0 0 8.975 4ZM4.345 4a.157.157 0 0 0-.138.086L3.112 6.102c-.062.115.015.26.138.26h2.171a.161.161 0 0 0 .151-.117l.639-2.016C6.246 4.117 6.169 4 6.059 4Zm5.664 0c-.11 0-.188.118-.151.23l.662 2.017a.16.16 0 0 0 .151.115h2.169c.124 0 .201-.146.137-.262L11.86 4.084A.16.16 0 0 0 11.722 4Z"]
    }
};
class OpEnterpriseAddonsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opEnterpriseAddonsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpEnterpriseAddonsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpEnterpriseAddonsIconComponent, isStandalone: true, selector: "svg[op-enterprise-addons-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpEnterpriseAddonsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-enterprise-addons-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opEraseIconData = {
    "16": {
        "width": 16,
        "paths": ["M.516 8.751 9.232.489c.163-.155.357-.278.571-.362a1.846 1.846 0 0 1 1.348 0c.214.084.408.207.572.362l3.735 3.541c.331.313.516.738.516 1.18 0 .443-.185.867-.516 1.18l-8.377 7.941h8.039c.233 0 .457.088.622.244a.815.815 0 0 1 .258.59.815.815 0 0 1-.258.591.907.907 0 0 1-.622.244H1.032a.908.908 0 0 1-.623-.244.815.815 0 0 1-.258-.591c0-.221.093-.433.258-.59a.908.908 0 0 1 .623-.244h2.881l-3.397-3.22A1.622 1.622 0 0 1 0 9.931c0-.442.185-.867.516-1.18Zm5.054-2.43 3.736 3.541 4.907-4.652-3.736-3.541Zm-1.245 1.18-2.564 2.43 3.736 3.54 2.563-2.429Z"]
    }
};
class OpEraseIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opEraseIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpEraseIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpEraseIconComponent, isStandalone: true, selector: "svg[op-erase-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpEraseIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-erase-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileAtomIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z", "M4.996 6.419a.64.64 0 0 1 .682-.598c4.454 0 6.315 3.147 6.315 6.314a.64.64 0 1 1-1.28.084c0-3.251-1.902-5.118-5.119-5.118a.642.642 0 0 1-.598-.682Zm.716 1.988c2.281 0 3.695 1.274 3.695 3.694a.642.642 0 0 1-1.274.152c0-1.574-.995-2.572-2.573-2.572a.641.641 0 1 1 .152-1.274Zm-.713 3.555a.856.856 0 1 1 1.711 0 .856.856 0 0 1-1.711 0Z"]
    }
};
class OpFileAtomIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileAtomIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileAtomIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileAtomIconComponent, isStandalone: true, selector: "svg[op-file-atom-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileAtomIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-atom-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileBcfIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.661 13.5c-.798 0-1.283-.563-1.283-1.5 0-.935.494-1.5 1.268-1.5.504 0 .894.241 1.078.659a.517.517 0 0 1 .056.228c0 .159-.099.261-.248.261-.127 0-.207-.06-.268-.201-.123-.295-.343-.444-.612-.444-.425 0-.699.384-.699.995 0 .619.27 1.001.701 1.001.283 0 .496-.138.617-.43.058-.137.129-.191.248-.191.159 0 .263.109.263.27a.54.54 0 0 1-.043.203c-.168.402-.569.649-1.078.649Zm-3.379-.048c-.178 0-.282-.117-.282-.318v-2.268c0-.199.104-.316.282-.316h.889c.506 0 .823.28.823.724 0 .318-.22.583-.506.629v.017a.68.68 0 0 1 .634.701c0 .511-.356.831-.93.831Zm.281-.453h.485c.325 0 .5-.148.5-.426 0-.271-.181-.416-.513-.416h-.472Zm0-1.242h.405c.3 0 .472-.143.472-.388 0-.234-.151-.366-.414-.366h-.463Zm4.641 1.417c0 .199.105.316.282.316s.281-.117.281-.316v-.864h.886c.147 0 .241-.091.241-.242 0-.148-.095-.239-.241-.239h-.886v-.776h.978c.152 0 .255-.095.255-.251 0-.157-.101-.252-.255-.252h-1.259c-.177 0-.282.117-.282.316v2.308Z", "M3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.783 0 3.75 0ZM3.5 1.75v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073H3.75a.25.25 0 0 0-.25.25Z"]
    }
};
class OpFileBcfIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileBcfIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileBcfIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileBcfIconComponent, isStandalone: true, selector: "svg[op-file-bcf-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileBcfIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-bcf-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileCheckIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 1.5a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h3a.75.75 0 0 1 0 1.5h-3A1.75 1.75 0 0 1 0 13.25V1.75C0 .784.784 0 1.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v2.043a.75.75 0 0 1-1.5 0V4.664a.25.25 0 0 0-.073-.177L8.513 1.573a.25.25 0 0 0-.177-.073H1.75Z", "M13.498 9.439a.75.75 0 0 1 .063 1.059l-4.529 5.095L6.97 13.53a.749.749 0 1 1 1.06-1.06l.938.937 3.471-3.905a.75.75 0 0 1 1.059-.063Z"]
    }
};
class OpFileCheckIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileCheckIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileCheckIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileCheckIconComponent, isStandalone: true, selector: "svg[op-file-check-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileCheckIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-check-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileCommentIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 1.75a.25.25 0 0 1 .25-.25h6.586a.25.25 0 0 1 .177.073l2.914 2.914a.25.25 0 0 1 .073.177v1.043a.75.75 0 0 0 1.5 0V4.664c0-.464-.184-.909-.513-1.237L9.573.513A1.746 1.746 0 0 0 8.336 0H1.75A1.75 1.75 0 0 0 0 1.75v11.5C0 14.216.784 15 1.75 15h3a.75.75 0 0 0 0-1.5h-3a.25.25 0 0 1-.25-.25V1.75Z", "M7.75 8h5.5c.966 0 1.75.784 1.75 1.75v2.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 13.25 14h-1.19l-1.573 1.573a1.46 1.46 0 0 1-1.588.316A1.458 1.458 0 0 1 8 14.543V14h-.25c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 6 12.25v-2.5C6 8.784 6.784 8 7.75 8Zm-.177 1.573a.25.25 0 0 0-.073.177v2.5c0 .138.112.25.25.25h1c.199 0 .39.079.53.22.141.14.22.331.22.53v1.19l1.72-1.72a.749.749 0 0 1 .53-.22h1.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.177.073Z"]
    }
};
class OpFileCommentIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileCommentIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileCommentIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileCommentIconComponent, isStandalone: true, selector: "svg[op-file-comment-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileCommentIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-comment-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileCsvIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z", "M6.196 13.5C5.452 13.5 5 12.937 5 12c0-.935.461-1.5 1.182-1.5.469 0 .832.241 1.004.659a.556.556 0 0 1 .053.228c0 .159-.093.261-.232.261-.118 0-.192-.06-.25-.201-.115-.295-.32-.444-.57-.444-.396 0-.652.384-.652.995 0 .619.252 1.001.654 1.001.264 0 .462-.138.575-.43.054-.137.12-.191.231-.191.148 0 .245.109.245.27a.577.577 0 0 1-.04.203c-.156.402-.53.649-1.004.649Zm2.355 0c-.518 0-.85-.239-.95-.557a.503.503 0 0 1-.028-.163c0-.161.095-.267.231-.267.108 0 .179.048.242.177.081.221.278.321.517.321.282 0 .473-.156.473-.37 0-.191-.118-.299-.433-.374l-.266-.06c-.5-.115-.745-.392-.745-.824 0-.531.4-.883.958-.883.458 0 .804.223.915.601.013.04.02.083.02.135 0 .145-.091.243-.225.243-.118 0-.191-.054-.25-.179-.083-.219-.245-.309-.46-.309-.259 0-.432.14-.432.354 0 .179.12.289.418.357l.264.063c.532.122.761.37.761.81 0 .567-.384.925-1.01.925Zm2.319-.01c-.205 0-.327-.105-.403-.352l-.699-2.169a.591.591 0 0 1-.026-.171c0-.171.112-.288.277-.288.14 0 .224.074.267.239l.588 2.077h.012l.586-2.083c.043-.163.121-.233.259-.233.159 0 .269.115.269.28a.538.538 0 0 1-.026.162l-.702 2.188c-.077.245-.198.35-.402.35Z"]
    }
};
class OpFileCsvIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileCsvIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileCsvIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileCsvIconComponent, isStandalone: true, selector: "svg[op-file-csv-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileCsvIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-csv-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileDocIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z", "M5 7.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 7.25ZM5.75 9a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Zm0 2.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"]
    }
};
class OpFileDocIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileDocIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileDocIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileDocIconComponent, isStandalone: true, selector: "svg[op-file-doc-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileDocIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-doc-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileDownloadIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 1.5a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h3a.75.75 0 0 1 0 1.5h-3A1.75 1.75 0 0 1 0 13.25V1.75C0 .784.784 0 1.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v2.043a.75.75 0 0 1-1.5 0V4.664a.25.25 0 0 0-.073-.177L8.513 1.573a.25.25 0 0 0-.177-.073H1.75Z", "M10.4 9.6v2.151l-.776-.775a.595.595 0 0 0-.653-.13.595.595 0 0 0-.371.554.605.605 0 0 0 .176.424l1.8 1.8a.595.595 0 0 0 .653.13.595.595 0 0 0 .195-.13l1.8-1.8a.602.602 0 0 0 0-.848.602.602 0 0 0-.848 0l-.776.775V9.6A.597.597 0 0 0 11 9a.597.597 0 0 0-.6.6Z", "M7.41 15.59c.263.262.619.41.99.41h5.2a1.404 1.404 0 0 0 1.4-1.4v-.4a.597.597 0 0 0-.6-.6.597.597 0 0 0-.6.6v.4a.197.197 0 0 1-.059.141.197.197 0 0 1-.141.059H8.4a.2.2 0 0 1-.2-.2v-.4a.597.597 0 0 0-.6-.6.597.597 0 0 0-.6.6v.4c0 .371.147.727.41.99Z"]
    }
};
class OpFileDownloadIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileDownloadIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileDownloadIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileDownloadIconComponent, isStandalone: true, selector: "svg[op-file-download-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileDownloadIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-download-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileEditIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 1.5a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4A1.75 1.75 0 0 1 0 13.25V1.75C0 .784.784 0 1.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v2.043a.75.75 0 0 1-1.5 0V4.664a.25.25 0 0 0-.073-.177L8.513 1.573a.25.25 0 0 0-.177-.073H1.75Zm11.226 7.755a.87.87 0 0 1 1.23 0l.539.539a.87.87 0 0 1 0 1.23l-4.278 4.279a.882.882 0 0 1-.376.221l-1.616.462a.373.373 0 0 1-.461-.461l.462-1.616a.882.882 0 0 1 .221-.376Zm.703.527a.124.124 0 0 0-.176 0l-.628.627.716.716.627-.628a.124.124 0 0 0 0-.176Z"]
    }
};
class OpFileEditIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileEditIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileEditIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileEditIconComponent, isStandalone: true, selector: "svg[op-file-edit-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileEditIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-edit-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileFormIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z", "M4.25 11.5c0-.967.784-1.75 1.75-1.75h5c.967 0 1.75.783 1.75 1.75v.5A1.75 1.75 0 0 1 11 13.75H6A1.75 1.75 0 0 1 4.25 12Zm0-4.75C4.25 5.784 5.034 5 6 5h5c.967 0 1.75.784 1.75 1.75v.5A1.75 1.75 0 0 1 11 9H6a1.75 1.75 0 0 1-1.75-1.75ZM6 11.25a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25ZM6 6.5a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25v-.5A.25.25 0 0 0 11 6.5Z"]
    }
};
class OpFileFormIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileFormIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileFormIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileFormIconComponent, isStandalone: true, selector: "svg[op-file-form-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileFormIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-form-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFilePresentationIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z", "M4.25 8.5c0-.966.784-1.75 1.75-1.75h5c.967 0 1.75.784 1.75 1.75V12A1.75 1.75 0 0 1 11 13.75H6A1.75 1.75 0 0 1 4.25 12ZM6 8.25a.25.25 0 0 0-.25.25V12c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25V8.5a.25.25 0 0 0-.25-.25Z"]
    }
};
class OpFilePresentationIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFilePresentationIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFilePresentationIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFilePresentationIconComponent, isStandalone: true, selector: "svg[op-file-presentation-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFilePresentationIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-presentation-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileSheetIconData = {
    "16": {
        "width": 16,
        "paths": ["M6 6.75h5c.967 0 1.75.784 1.75 1.75V12A1.75 1.75 0 0 1 11 13.75H6A1.75 1.75 0 0 1 4.25 12V8.5c0-.966.784-1.75 1.75-1.75Zm3.25 5.5H11a.25.25 0 0 0 .25-.25v-1h-2Zm0-2.75h2v-1a.25.25 0 0 0-.25-.25H9.25ZM7.75 11h-2v1c0 .138.112.25.25.25h1.75Zm0-2.75H6a.25.25 0 0 0-.25.25v1h2Z", "M3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.783 0 3.75 0ZM3.5 1.75v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073H3.75a.25.25 0 0 0-.25.25Z"]
    }
};
class OpFileSheetIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileSheetIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileSheetIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileSheetIconComponent, isStandalone: true, selector: "svg[op-file-sheet-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileSheetIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-sheet-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileTextIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z", "M5 7.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 7.25ZM5.75 9a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Zm0 2.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5ZM5 4.75A.75.75 0 0 1 5.75 4h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 4.75Z"]
    }
};
class OpFileTextIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileTextIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileTextIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileTextIconComponent, isStandalone: true, selector: "svg[op-file-text-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileTextIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-text-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opFileXlsDescriptionsIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z", "M5.273 13.49A.266.266 0 0 1 5 13.226c0-.074.023-.138.078-.219l.688-1.009v-.016l-.665-.953a.375.375 0 0 1-.084-.233.28.28 0 0 1 .292-.286c.109 0 .186.05.26.169l.59.917h.015l.61-.937c.067-.105.124-.149.235-.149.15 0 .28.115.28.259a.343.343 0 0 1-.076.218l-.716 1.007v.014l.695.987a.357.357 0 0 1 .076.221.266.266 0 0 1-.277.274c-.105 0-.175-.044-.25-.151l-.615-.903h-.015l-.605.905c-.073.111-.134.149-.243.149Zm2.754-.038c-.181 0-.288-.117-.288-.318v-2.306c0-.201.107-.318.288-.318.182 0 .289.117.289.318v2.121h.977c.157 0 .262.095.262.251 0 .157-.103.252-.262.252H8.027Zm2.863.048c-.569 0-.933-.239-1.044-.557a.48.48 0 0 1-.031-.163c0-.161.105-.267.254-.267.119 0 .197.048.266.177.09.221.305.321.569.321.309 0 .519-.156.519-.37 0-.191-.13-.299-.475-.374l-.292-.06c-.55-.115-.82-.392-.82-.824 0-.531.439-.883 1.053-.883.504 0 .884.223 1.006.601.013.04.021.083.021.135 0 .145-.099.243-.246.243-.13 0-.21-.054-.275-.179-.092-.219-.27-.309-.506-.309-.285 0-.474.14-.474.354 0 .179.132.289.458.357l.291.063c.584.122.836.37.836.81 0 .567-.422.925-1.11.925ZM5 5.75A.75.75 0 0 1 5.75 5h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 5.75Zm.75 1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"]
    }
};
class OpFileXlsDescriptionsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opFileXlsDescriptionsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileXlsDescriptionsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpFileXlsDescriptionsIconComponent, isStandalone: true, selector: "svg[op-file-xls-descriptions-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpFileXlsDescriptionsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-file-xls-descriptions-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opGlossarIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.701 5.172c-.398 0-.701-.258-.701-.635 0-.381.293-.601.816-.633l.528-.031v-.139c0-.195-.137-.308-.352-.308-.174 0-.279.056-.406.22a.287.287 0 0 1-.227.106c-.138 0-.238-.09-.238-.219a.31.31 0 0 1 .029-.129c.098-.25.434-.404.868-.404.537 0 .886.277.886.699v1.194c0 .189-.115.287-.277.287-.154 0-.262-.086-.273-.254v-.108h-.012c-.117.223-.379.354-.641.354Zm.188-.412c.25 0 .455-.162.455-.389v-.152l-.442.027c-.213.016-.334.111-.334.26 0 .156.129.254.321.254Zm1.695-.518c-.154 0-.269-.092-.269-.25s.115-.248.269-.248h.815c.154 0 .269.09.269.248s-.115.25-.269.25h-.815Zm1.427.67c0 .137.095.227.246.227h1.285c.145 0 .23-.08.23-.219s-.085-.219-.23-.219h-.805v-.01l.891-1.166c.066-.084.092-.148.092-.23 0-.154-.104-.25-.272-.25H9.229c-.146 0-.23.08-.23.217 0 .138.086.218.23.218h.827v.012l-.965 1.223c-.059.07-.08.123-.08.197Z", "M2.732.732A2.5 2.5 0 0 1 4.5 0h8.75c.199 0 .39.079.53.22.141.14.22.331.22.53v12.5c0 .199-.079.39-.22.53a.747.747 0 0 1-.53.22h-2.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06.747.747 0 0 1 .53-.22h1.75v-2h-8a.998.998 0 0 0-.982 1.188c.037.193.13.371.268.512a.752.752 0 0 1-.544 1.275.75.75 0 0 1-.528-.225A2.495 2.495 0 0 1 2 11.5v-9A2.5 2.5 0 0 1 2.732.732ZM12.5 9V1.5h-8a.997.997 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9Z", "M5 15.5v-3.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.252.252 0 0 1-.138.224.26.26 0 0 1-.134.025.246.246 0 0 1-.128-.049l-1.45-1.087a.253.253 0 0 0-.3 0L5.4 15.7a.246.246 0 0 1-.128.049.26.26 0 0 1-.134-.025A.252.252 0 0 1 5 15.5Z"]
    }
};
class OpGlossarIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opGlossarIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpGlossarIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpGlossarIconComponent, isStandalone: true, selector: "svg[op-glossar-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpGlossarIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-glossar-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opGridMenuIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 12.4A1.4 1.4 0 0 1 2.4 11h1.2A1.4 1.4 0 0 1 5 12.4v1.2A1.4 1.4 0 0 1 3.6 15H2.4A1.4 1.4 0 0 1 1 13.6Zm1.4-.2a.2.2 0 0 0-.2.2v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2v-1.2a.2.2 0 0 0-.2-.2Zm0-6.2h1.2A1.4 1.4 0 0 1 5 7.4v1.2A1.4 1.4 0 0 1 3.6 10H2.4A1.4 1.4 0 0 1 1 8.6V7.4A1.4 1.4 0 0 1 2.4 6Zm-.2 1.4v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2V7.4a.2.2 0 0 0-.2-.2H2.4a.2.2 0 0 0-.2.2ZM2.4 1h1.2A1.4 1.4 0 0 1 5 2.4v1.2A1.4 1.4 0 0 1 3.6 5H2.4A1.4 1.4 0 0 1 1 3.6V2.4A1.4 1.4 0 0 1 2.4 1Zm-.2 1.4v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2V2.4a.2.2 0 0 0-.2-.2H2.4a.2.2 0 0 0-.2.2ZM7.4 1h1.2A1.4 1.4 0 0 1 10 2.4v1.2A1.4 1.4 0 0 1 8.6 5H7.4A1.4 1.4 0 0 1 6 3.6V2.4A1.4 1.4 0 0 1 7.4 1Zm-.2 1.4v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2V2.4a.2.2 0 0 0-.2-.2H7.4a.2.2 0 0 0-.2.2ZM6 7.4A1.4 1.4 0 0 1 7.4 6h1.2A1.4 1.4 0 0 1 10 7.4v1.2A1.4 1.4 0 0 1 8.6 10H7.4A1.4 1.4 0 0 1 6 8.6Zm1.4-.2a.2.2 0 0 0-.2.2v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2V7.4a.2.2 0 0 0-.2-.2Zm0 3.8h1.2a1.4 1.4 0 0 1 1.4 1.4v1.2A1.4 1.4 0 0 1 8.6 15H7.4A1.4 1.4 0 0 1 6 13.6v-1.2A1.4 1.4 0 0 1 7.4 11Zm-.2 1.4v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2v-1.2a.2.2 0 0 0-.2-.2H7.4a.2.2 0 0 0-.2.2Zm3.8-10A1.4 1.4 0 0 1 12.4 1h1.2A1.4 1.4 0 0 1 15 2.4v1.2A1.4 1.4 0 0 1 13.6 5h-1.2A1.4 1.4 0 0 1 11 3.6Zm1.4-.2a.2.2 0 0 0-.2.2v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2V2.4a.2.2 0 0 0-.2-.2Zm0 3.8h1.2A1.4 1.4 0 0 1 15 7.4v1.2a1.4 1.4 0 0 1-1.4 1.4h-1.2A1.4 1.4 0 0 1 11 8.6V7.4A1.4 1.4 0 0 1 12.4 6Zm-.2 1.4v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2V7.4a.2.2 0 0 0-.2-.2h-1.2a.2.2 0 0 0-.2.2Zm-1.2 5a1.4 1.4 0 0 1 1.4-1.4h1.2a1.4 1.4 0 0 1 1.4 1.4v1.2a1.4 1.4 0 0 1-1.4 1.4h-1.2a1.4 1.4 0 0 1-1.4-1.4Zm1.4-.2a.2.2 0 0 0-.2.2v1.2c0 .11.09.2.2.2h1.2a.2.2 0 0 0 .2-.2v-1.2a.2.2 0 0 0-.2-.2Z"]
    }
};
class OpGridMenuIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opGridMenuIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpGridMenuIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpGridMenuIconComponent, isStandalone: true, selector: "svg[op-grid-menu-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpGridMenuIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-grid-menu-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opGroupIconData = {
    "16": {
        "width": 16,
        "paths": ["m2.001 7.997 2 .003a.668.668 0 0 1 .508 1.095.668.668 0 0 1-.432.234L4 9.333l-1.333-.002v3.335L4 12.667a.67.67 0 0 1 .662.588l.005.078a.663.663 0 0 1-.589.662L4 14H2a.67.67 0 0 1-.662-.589l-.005-.078V8.664a.666.666 0 0 1 .59-.663l.078-.004ZM14 11.333a.666.666 0 0 1 .078 1.329l-.078.005H6a.67.67 0 0 1-.51-1.095.666.666 0 0 1 .432-.234L6 11.333h8Zm0-2a.666.666 0 0 1 .078 1.329l-.078.005H6a.67.67 0 0 1-.51-1.095.666.666 0 0 1 .432-.234L6 9.333h8Zm-10-8a.67.67 0 0 1 .51 1.095.666.666 0 0 1-.432.234L4 2.667H2.667v3.33H4a.67.67 0 0 1 .662.588l.005.078a.663.663 0 0 1-.589.662L4 7.33H2a.67.67 0 0 1-.662-.589l-.005-.078V2a.665.665 0 0 1 .589-.662L2 1.333h2Zm10 3.334a.665.665 0 0 1 .078 1.328L14 6H6a.665.665 0 0 1-.51-1.095.666.666 0 0 1 .432-.234L6 4.667h8Zm0-2a.665.665 0 0 1 .078 1.328L14 4H6a.665.665 0 0 1-.51-1.095.666.666 0 0 1 .432-.234L6 2.667h8Z"]
    }
};
class OpGroupIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opGroupIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpGroupIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpGroupIconComponent, isStandalone: true, selector: "svg[op-group-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpGroupIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-group-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opHierarchyIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.794 1c.439 0 .794.348.794.778v3.111c0 .143.119.259.265.259h1.059c1.023 0 1.853.813 1.853 1.815v2.333h3.441c.438 0 .794.349.794.778 0 .43-.356.778-.794.778H8.765v2.333c0 .143.118.259.264.259h3.177c.438 0 .794.349.794.778 0 .43-.356.778-.794.778H9.029c-1.023 0-1.853-.812-1.853-1.815V6.963a.261.261 0 0 0-.264-.259H5.853C4.83 6.704 4 5.891 4 4.889V1.778c0-.43.356-.778.794-.778Z"]
    }
};
class OpHierarchyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opHierarchyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpHierarchyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpHierarchyIconComponent, isStandalone: true, selector: "svg[op-hierarchy-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpHierarchyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-hierarchy-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opIfcIconData = {
    "16": {
        "width": 16,
        "paths": ["m10.373 2.078 3.411 3.397L9.72 9.512a1.622 1.622 0 0 0 2.552.085 77.475 77.475 0 0 1 2.153-2.175h.001c.291-.286.582-.572.87-.86a1.525 1.525 0 0 0 .517-1.146 1.533 1.533 0 0 0-.517-1.147l-1.654-1.647-.852-.852c-.427-.428-.855-.858-1.285-1.283A1.473 1.473 0 0 0 9.498.318c-.511.482-.997.99-1.455 1.523L9.35 3.137l1.023-1.059Zm-4.689 11.85-3.411-3.397 4.075-4.054c-.705-.827-1.682-.929-2.37-.26a108.57 108.57 0 0 0-3.314 3.34 1.483 1.483 0 0 0 0 2.066 323.626 323.626 0 0 0 3.979 3.963 1.455 1.455 0 0 0 1.95.074 14.21 14.21 0 0 0 1.018-1.021c.14-.15.28-.3.42-.445L6.69 12.858l-1.006 1.07Z", "M9.509 6.313 5.462 2.288 2.051 5.685l1.086 1.019L1.869 7.96A18.86 18.86 0 0 1 .306 6.505a1.416 1.416 0 0 1 .125-1.896A391.7 391.7 0 0 1 4.41.646a1.505 1.505 0 0 1 2.098 0C7.607 1.748 8.704 2.85 9.799 3.952a1.52 1.52 0 0 1 .418 1.249 1.509 1.509 0 0 1-.228.635 1.518 1.518 0 0 1-.48.477Zm1.12 7.428-4.07-4.048c-.2.127-.368.298-.49.501a1.526 1.526 0 0 0-.118 1.357c.087.22.223.417.398.576l3.109 3.097a1.518 1.518 0 0 0 1.761.377c.196-.088.371-.216.513-.377l1.779-1.772.004-.004c.676-.666 1.351-1.333 2.015-2.006a1.444 1.444 0 0 0 .176-1.936c-.473-.5-.972-.974-1.495-1.421L12.96 9.314c.14.128.274.262.408.396.148.149.298.298.456.442.177.158.165.26 0 .424-1.012.996-2.018 1.999-3.024 3.001l-.171.164Z", "m6.252 3.499 3.024 3.007-1.318 1.307-.069-.071c-.149-.154-.318-.329-.5-.495L6.121 5.979a1.549 1.549 0 0 1-.354-1.956 1.56 1.56 0 0 1 .485-.524Zm2.346 5.25-.544-.528-1.268 1.234 3.013 2.995a1.523 1.523 0 0 0 .567-1.712 1.533 1.533 0 0 0-.322-.553 51.468 51.468 0 0 0-1.446-1.436Zm-5.08.984 3.007-2.99 1.302 1.274-.182.193-1.706 1.698a1.559 1.559 0 0 1-1.253.501 1.552 1.552 0 0 1-1.168-.676Zm6.031-.521 2.956-2.939a1.513 1.513 0 0 0-1.792-.56 1.514 1.514 0 0 0-.556.374c-.396.391-.797.792-1.19 1.184l-.572.571c-.034.034-.066.07-.097.107l1.251 1.263Z"]
    }
};
class OpIfcIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opIfcIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpIfcIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpIfcIconComponent, isStandalone: true, selector: "svg[op-ifc-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpIfcIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-ifc-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opInboxInIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.801 2.061A1.75 1.75 0 0 1 4.409 1h1.046a.75.75 0 0 1 0 1.5H4.409c-.1 0-.19.06-.229.152L1.887 8H4.75a.75.75 0 0 1 .6.3L6.625 10h2.75l1.275-1.7a.75.75 0 0 1 .6-.3h2.863L11.82 2.652a.249.249 0 0 0-.229-.152h-1.046a.75.75 0 0 1 0-1.5h1.046c.7 0 1.332.417 1.608 1.061l2.74 6.394c.04.093.061.193.061.295v4.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-4.5c0-.102.021-.202.061-.295ZM11.625 9.5l-1.275 1.7a.75.75 0 0 1-.6.3h-3.5a.75.75 0 0 1-.6-.3L4.375 9.5H1.5v3.75c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V9.5Z", "M8.647 3.5V.75a.75.75 0 0 0-1.5 0V3.5H5a.25.25 0 0 0-.176.427L7.72 6.823a.25.25 0 0 0 .354 0l2.896-2.896a.25.25 0 0 0-.177-.427H8.647Z"]
    }
};
class OpInboxInIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opInboxInIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpInboxInIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpInboxInIconComponent, isStandalone: true, selector: "svg[op-inbox-in-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpInboxInIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-inbox-in-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opIndentIconData = {
    "16": {
        "width": 16,
        "paths": ["M.22 12.22A.747.747 0 0 1 .75 12h14.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H.75a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm6-6A.747.747 0 0 1 6.75 6h8.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-8.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0 3A.747.747 0 0 1 6.75 9h8.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-8.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm-6-6A.747.747 0 0 1 .75 3h14.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H.75a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm2.31 6.353 1.397-1.396a.252.252 0 0 0 0-.354L2.53 6.427a.25.25 0 0 0-.426.177v2.792a.25.25 0 0 0 .426.177Z"]
    }
};
class OpIndentIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opIndentIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpIndentIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpIndentIconComponent, isStandalone: true, selector: "svg[op-indent-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpIndentIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-indent-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opInputDisabledIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.667 8a.666.666 0 1 1-1.332-.002A.666.666 0 0 1 4.667 8Z", "m2.53 1.47 12 12a.749.749 0 1 1-1.06 1.06l-1.138-1.138c-.469.025-1.007.025-1.613.025H5.281c-.898 0-1.647 0-2.242-.08-.628-.085-1.195-.27-1.65-.726-.456-.455-.641-1.022-.726-1.65-.08-.595-.08-1.344-.08-2.242V7.281c0-.898 0-1.647.08-2.242.085-.628.27-1.195.726-1.65.166-.166.347-.296.54-.399l-.459-.46a.749.749 0 1 1 1.06-1.06Zm8.326 10.447-.5-.501a.177.177 0 0 1-.023.001H4.667a.75.75 0 1 1 0-1.5h4.189L6.51 7.571a.663.663 0 0 1-.039.9.666.666 0 1 1-.042-.981L4.51 5.571a.663.663 0 0 1-.039.9.666.666 0 1 1-.042-.981l-1.32-1.32c-.37.063-.542.162-.659.279-.13.13-.238.328-.3.79-.065.483-.067 1.13-.067 2.094v1.334c0 .964.002 1.611.067 2.094.062.462.169.659.299.789.13.13.328.238.79.3.483.065 1.13.067 2.094.067h5.523Zm2.694-.366c.13-.13.238-.328.3-.79.065-.483.067-1.13.067-2.094V7.333c0-.964-.002-1.611-.067-2.094-.062-.462-.169-.659-.299-.789-.13-.13-.328-.238-.79-.3-.483-.065-1.13-.067-2.094-.067H6.235l-1.527-1.5c.205-.005.222-.004.272-.003.041.001.102.003.301.003h5.438c.898 0 1.647 0 2.242.08.628.085 1.195.27 1.65.726.456.455.641 1.022.726 1.65.08.595.08 1.344.08 2.242v1.438c0 .898 0 1.647-.08 2.242-.085.628-.27 1.195-.726 1.65l-1.061-1.06Z", "M10.667 6a.666.666 0 1 1-1.332-.002.666.666 0 0 1 1.332.002Zm2 0a.666.666 0 1 1-1.332-.002.666.666 0 0 1 1.332.002Zm0 2a.666.666 0 1 1-1.332-.002.666.666 0 0 1 1.332.002ZM8.471 6.471a.666.666 0 1 0-.942-.942l.942.942Zm2 2a.666.666 0 1 0-.942-.942l.942.942Z"]
    }
};
class OpInputDisabledIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opInputDisabledIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpInputDisabledIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpInputDisabledIconComponent, isStandalone: true, selector: "svg[op-input-disabled-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpInputDisabledIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-input-disabled-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opInstallationServicesIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 5.013c-.13 0-.259.005-.386.016-.024.003-.073.025-.092.099l-.195.747a1.264 1.264 0 0 1-.674.802c-.117.058-.23.123-.338.196a1.263 1.263 0 0 1-1.032.182l-.745-.204c-.073-.02-.118.011-.132.03-.147.21-.277.434-.386.668-.01.022-.015.075.039.129l.551.544c.277.274.379.646.358.983a3.215 3.215 0 0 0 0 .393c.021.337-.081.609-.358.884H3.277l.621-.621c.033-.033.065-.099.059-.199a4.486 4.486 0 0 1 0-.521c.006-.099-.026-.166-.059-.199l-.55-.543a1.128 1.128 0 0 1-.246-1.278c.135-.289.294-.564.476-.822a1.13 1.13 0 0 1 1.228-.425l.745.205c.045.012.119.007.202-.049.144-.096.295-.183.451-.261.09-.044.131-.106.143-.151l.195-.746a1.13 1.13 0 0 1 .985-.852 5.699 5.699 0 0 1 .946 0c.502.044.871.416.985.852l.195.746c.012.045.053.107.143.151.156.078.307.165.451.261.083.056.157.061.202.049l.745-.205a1.13 1.13 0 0 1 1.228.425c.182.258.341.533.476.822.213.456.075.961-.246 1.278l-.55.543c-.033.033-.065.099-.059.199a4.494 4.494 0 0 1 0 .521c-.006.1.026.166.059.199l.621.621H11.39c-.277-.275-.379-.547-.358-.884a3.182 3.182 0 0 0 0-.393 1.265 1.265 0 0 1 .358-.983l.551-.544c.054-.054.049-.107.039-.129a4.426 4.426 0 0 0-.386-.668c-.014-.019-.059-.05-.132-.03l-.745.204a1.263 1.263 0 0 1-1.032-.182 2.913 2.913 0 0 0-.338-.196 1.263 1.263 0 0 1-.674-.803l-.195-.746c-.019-.074-.068-.096-.092-.099A4.478 4.478 0 0 0 8 5.013Z", "M8 7.376a2.026 2.026 0 0 1 1.714 3.106H6.286A2.026 2.026 0 0 1 8 7.376Zm1.013 2.026a1.013 1.013 0 1 0-2.026 0 1.013 1.013 0 0 0 2.026 0Z", "M16 2.75v7.5A1.75 1.75 0 0 1 14.25 12h-3.727c.099 1.041.52 1.872 1.292 2.757A.75.75 0 0 1 11.25 16h-6.5a.75.75 0 0 1-.565-1.243c.772-.885 1.193-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75Zm-1.5 7.5v-7.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25ZM6.982 12a5.712 5.712 0 0 1-.765 2.5h3.566a5.712 5.712 0 0 1-.765-2.5Z"]
    }
};
class OpInstallationServicesIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opInstallationServicesIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpInstallationServicesIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpInstallationServicesIconComponent, isStandalone: true, selector: "svg[op-installation-services-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpInstallationServicesIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-installation-services-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opKebabVerticalIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.5 14.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 9.5 14.5Zm0-6.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 9.5 8ZM8 0a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8 0Z"]
    }
};
class OpKebabVerticalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opKebabVerticalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpKebabVerticalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpKebabVerticalIconComponent, isStandalone: true, selector: "svg[op-kebab-vertical-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpKebabVerticalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-kebab-vertical-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opLinkAddIconData = {
    "16": {
        "width": 16,
        "paths": ["m7.775 3.275 1.25-1.25a3.503 3.503 0 0 1 4.95 0 3.5 3.5 0 0 1 0 4.95l-2.5 2.5A3.507 3.507 0 0 1 9 10.5a3.496 3.496 0 0 1-2.475-1.025.753.753 0 0 1 .019-1.041.753.753 0 0 1 1.041-.019A1.989 1.989 0 0 0 9 9.002a1.995 1.995 0 0 0 1.415-.587l2.5-2.5a2.005 2.005 0 0 0 .434-2.181 2.015 2.015 0 0 0-1.083-1.083 2.013 2.013 0 0 0-1.532 0 2.015 2.015 0 0 0-.649.434l-1.25 1.25A.747.747 0 0 1 7.574 3.8a.754.754 0 0 1 .201-.525Zm-4.69 9.64a1.989 1.989 0 0 0 1.415.587 1.995 1.995 0 0 0 1.415-.587l1.25-1.25a.754.754 0 0 1 1.042.019.747.747 0 0 1 .018 1.041l-1.25 1.25a3.497 3.497 0 0 1-4.95 0 3.5 3.5 0 0 1 0-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .75.75 0 0 1-1.06 1.06 2.005 2.005 0 0 0-2.181-.434 2.005 2.005 0 0 0-.649.434l-2.5 2.5a2.005 2.005 0 0 0-.434 2.181c.101.243.248.463.434.649ZM12.75 10a.75.75 0 0 1 .75.75V12h1.25a.75.75 0 0 1 0 1.5H13.5v1.25a.75.75 0 0 1-1.5 0V13.5h-1.25a.75.75 0 0 1 0-1.5H12v-1.25a.75.75 0 0 1 .75-.75Z"]
    }
};
class OpLinkAddIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opLinkAddIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLinkAddIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpLinkAddIconComponent, isStandalone: true, selector: "svg[op-link-add-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLinkAddIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-link-add-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opListSelectAllIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.644 2.249c0 .199-.079.39-.22.53L1.799 4.404a.747.747 0 0 1-1.06 0l-.5-.5A.751.751 0 0 1 0 3.356v-.001a.756.756 0 0 1 .565-.726.753.753 0 0 1 .705.185l1.094-1.095a.754.754 0 0 1 1.06 0 .75.75 0 0 1 .22.53ZM5 3.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 3.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 8.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Zm-1.356-1.001c0 .199-.079.39-.22.53l-1.625 1.625a.747.747 0 0 1-1.06 0l-.5-.5A.751.751 0 0 1 0 13.356v-.001a.756.756 0 0 1 .565-.726.753.753 0 0 1 .705.185l1.094-1.095a.754.754 0 0 1 1.06 0 .75.75 0 0 1 .22.53Zm-.22-5.53a.75.75 0 0 1 0 1.06L1.799 9.404a.747.747 0 0 1-1.06 0l-.5-.5A.751.751 0 0 1 0 8.356v-.001a.756.756 0 0 1 .565-.726.753.753 0 0 1 .705.185l1.094-1.095a.754.754 0 0 1 1.06 0Z"]
    }
};
class OpListSelectAllIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opListSelectAllIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpListSelectAllIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpListSelectAllIconComponent, isStandalone: true, selector: "svg[op-list-select-all-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpListSelectAllIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-list-select-all-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opLogoGitlabIconData = {
    "16": {
        "width": 16,
        "paths": ["M.925 6.387 8 15 .252 9.652a.575.575 0 0 1-.222-.289.549.549 0 0 1 0-.358l.895-2.618ZM8 15 5.054 6.387h5.892L8 15Z", "M.925 6.387 2.7 1.2c.091-.267.488-.267.58 0l1.774 5.187H.925Zm14.15 0 .895 2.618c.04.116.04.241 0 .358a.575.575 0 0 1-.222.289L8 15l7.075-8.613Zm0 0h-4.129L12.72 1.2c.092-.267.489-.267.58 0l1.775 5.187Z"]
    }
};
class OpLogoGitlabIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opLogoGitlabIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoGitlabIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpLogoGitlabIconComponent, isStandalone: true, selector: "svg[op-logo-gitlab-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoGitlabIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-logo-gitlab-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opLogoGooglePlusIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.437 12.867c0-.134-.034-.269-.067-.404-.034-.135-.034-.236-.067-.337a1.534 1.534 0 0 0-.169-.336c-.1-.135-.168-.203-.201-.304l-.269-.269c-.101-.135-.202-.202-.269-.27-.067-.033-.168-.134-.303-.235a2.336 2.336 0 0 0-.302-.203c-.034-.067-.168-.134-.303-.235a2.15 2.15 0 0 1-.302-.202c-.101 0-.269-.034-.471-.034-.369 0-.706.034-1.042.067-.302.068-.672.135-1.008.27-.37.101-.672.236-.941.438a1.94 1.94 0 0 0-.673.707c-.168.303-.268.64-.268 1.044 0 .438.134.809.336 1.146.235.37.537.64.907.808.37.202.74.37 1.143.438.403.101.807.168 1.244.168.37 0 .739-.033 1.075-.135.337-.067.639-.202.942-.37.302-.169.537-.404.739-.707.168-.304.269-.64.269-1.045Zm-1.176-8.32c0-.37-.034-.774-.135-1.212-.134-.438-.269-.842-.471-1.247a2.969 2.969 0 0 0-.806-1.01A1.754 1.754 0 0 0 4.706.674c-.605 0-1.042.235-1.378.673-.336.438-.504.977-.504 1.584 0 .303.033.606.134.943.067.337.168.673.336 1.01.135.337.336.64.538.91.202.269.437.471.739.64.303.168.605.235.942.235.605 0 1.075-.168 1.344-.572.269-.371.404-.91.404-1.55ZM6.017 0h4.202L8.908.741H7.63c.437.303.807.707 1.042 1.213.236.539.37 1.078.37 1.617 0 .505-.067.909-.202 1.28-.168.37-.336.673-.537.875l-.639.64a2.17 2.17 0 0 0-.538.573 1.031 1.031 0 0 0-.235.674c0 .168.067.303.168.471.101.169.235.303.403.472.168.135.37.303.572.471.201.135.403.337.605.506.201.202.403.438.571.64.168.235.303.505.403.842.101.303.169.64.169 1.01 0 1.011-.437 1.92-1.345 2.729C7.462 15.596 6.118 16 4.403 16c-.369 0-.773-.034-1.143-.101a7.588 7.588 0 0 1-1.176-.303c-.403-.169-.739-.337-1.042-.573a2.947 2.947 0 0 1-.739-.842A2.366 2.366 0 0 1 0 13.002c0-.404.134-.842.37-1.314.201-.404.504-.741.907-1.044a4.63 4.63 0 0 1 1.412-.707c.504-.135 1.008-.27 1.479-.337.471-.067.941-.101 1.445-.135-.403-.539-.605-1.01-.605-1.414v-.236c.034-.068.034-.135.068-.202 0-.034.033-.101.067-.202.033-.068.033-.135.067-.203-.269.034-.471.068-.672.068a3.542 3.542 0 0 1-2.454-.943c-.672-.64-1.042-1.449-1.042-2.392 0-.876.303-1.684.941-2.392C2.588.842 3.328.371 4.202.168 4.807.034 5.412 0 6.017 0ZM16 2.459v1.213h-2.454v2.459h-1.243V3.672H9.849V2.459h2.454V0h1.243v2.459H16Z"]
    }
};
class OpLogoGooglePlusIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opLogoGooglePlusIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoGooglePlusIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpLogoGooglePlusIconComponent, isStandalone: true, selector: "svg[op-logo-google-plus-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoGooglePlusIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-logo-google-plus-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opLogoNextcloudIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.012 4a3.654 3.654 0 0 0-3.5 2.648 2.376 2.376 0 0 0-2.144-1.374A2.378 2.378 0 0 0 0 7.642a2.379 2.379 0 0 0 2.368 2.368c.945 0 1.766-.566 2.144-1.374a3.655 3.655 0 0 0 3.5 2.648 3.657 3.657 0 0 0 3.492-2.614 2.375 2.375 0 0 0 2.127 1.34A2.38 2.38 0 0 0 16 7.642c0-1.3-1.069-2.368-2.369-2.368-.931 0-1.742.55-2.127 1.34A3.655 3.655 0 0 0 8.012 4Zm0 1.39c1.252 0 2.252 1 2.252 2.252 0 1.252-1 2.252-2.252 2.252a2.24 2.24 0 0 1-2.251-2.252A2.24 2.24 0 0 1 8.012 5.39ZM2.368 6.664c.549 0 .979.429.979.978 0 .548-.43.978-.979.978a.968.968 0 0 1-.978-.978c0-.549.43-.978.978-.978Zm11.263 0c.549 0 .979.429.979.978 0 .548-.43.978-.979.978a.968.968 0 0 1-.978-.978c0-.549.43-.978.978-.978Z"]
    }
};
class OpLogoNextcloudIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opLogoNextcloudIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoNextcloudIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpLogoNextcloudIconComponent, isStandalone: true, selector: "svg[op-logo-nextcloud-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoNextcloudIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-logo-nextcloud-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opLogoOpenprojectIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.124 0h-1.785C9.752 0 8.463 1.224 8.463 2.729v4.33H2.876C1.289 7.059 0 8.282 0 9.788v3.483C0 14.777 1.289 16 2.876 16h1.785c1.587 0 2.876-1.223 2.876-2.729V9.788c0-.313-.066-.596-.165-.878h1.091v3.168c0 .502.43.879.958.879.529 0 .959-.377.959-.879V8.941h2.744C14.711 8.941 16 7.718 16 6.212V2.729C16 1.224 14.711 0 13.124 0ZM5.62 13.271c0 .47-.43.878-.959.878H2.876c-.529 0-.926-.376-.926-.878V9.788c0-.502.397-.878.926-.878h1.785c.529 0 .959.376.959.878v3.483Zm8.43-7.059c0 .502-.397.878-.926.878h-1.785c-.066 0-.132 0-.199-.031-.429-.094-.76-.408-.76-.847V2.729c0-.47.43-.878.959-.878h1.785c.496 0 .926.376.926.878v3.483Z"]
    }
};
class OpLogoOpenprojectIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opLogoOpenprojectIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoOpenprojectIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpLogoOpenprojectIconComponent, isStandalone: true, selector: "svg[op-logo-openproject-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoOpenprojectIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-logo-openproject-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opLogoSlackIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.889 3.362a1.685 1.685 0 0 1-1.681-1.681C4.208.756 4.964 0 5.889 0S7.57.756 7.57 1.681v1.681H5.889Zm-4.208 8.429c.925 0 1.681-.755 1.681-1.68V8.43H1.681C.756 8.43 0 9.186 0 10.111s.756 1.68 1.681 1.68ZM5.889 8.43c-.925 0-1.681.756-1.681 1.681v4.208c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681v-4.208c0-.925-.756-1.681-1.681-1.681ZM7.57 5.889c0-.925-.756-1.681-1.681-1.681H1.681C.756 4.208 0 4.964 0 5.889S.756 7.57 1.681 7.57h4.208c.925 0 1.681-.756 1.681-1.681Zm5.068 0c0-.925.756-1.681 1.681-1.681S16 4.964 16 5.889s-.756 1.681-1.681 1.681h-1.681V5.889ZM10.111 7.57c.925 0 1.68-.756 1.68-1.681V1.681c0-.925-.755-1.681-1.68-1.681C9.186 0 8.43.756 8.43 1.681v4.208c0 .925.756 1.681 1.681 1.681Zm0 5.068c.925 0 1.68.756 1.68 1.681S11.036 16 10.111 16a1.685 1.685 0 0 1-1.681-1.681v-1.681h1.681ZM8.43 10.111c0 .925.756 1.68 1.681 1.68h4.208c.925 0 1.681-.755 1.681-1.68 0-.925-.756-1.681-1.681-1.681h-4.208c-.925 0-1.681.756-1.681 1.681Z"]
    }
};
class OpLogoSlackIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opLogoSlackIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoSlackIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpLogoSlackIconComponent, isStandalone: true, selector: "svg[op-logo-slack-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpLogoSlackIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-logo-slack-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opMailSentIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v5.5a.75.75 0 0 1-1.5 0V4.809L8.379 8.397a.75.75 0 0 1-.758 0L1.5 4.809v6.441c0 .138.112.25.25.25h5.5a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 0 11.25Zm14.5.32v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 6.881Z", "M15.931 11.831a.24.24 0 0 1 .051.26.24.24 0 0 1-.051.078L13.19 14.93a.238.238 0 0 1-.365-.036.233.233 0 0 1-.039-.133v-2.046H9.71a.708.708 0 0 1-.502-.209.718.718 0 0 1 0-1.012.708.708 0 0 1 .502-.209h3.076V9.239a.233.233 0 0 1 .146-.221.238.238 0 0 1 .258.052Z"]
    }
};
class OpMailSentIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opMailSentIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpMailSentIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpMailSentIconComponent, isStandalone: true, selector: "svg[op-mail-sent-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpMailSentIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-mail-sent-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opMarkNextcloudIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.698 8.001a1.68 1.68 0 0 0-1.689-1.688A1.68 1.68 0 0 0 6.32 8.001c0 .939.75 1.689 1.689 1.689.939 0 1.689-.75 1.689-1.689Zm-5.188 0a.726.726 0 0 0-.734-.733.725.725 0 0 0-.733.733c0 .412.322.734.733.734a.726.726 0 0 0 .734-.734Zm8.447 0a.725.725 0 0 0-.734-.733.725.725 0 0 0-.733.733c0 .412.322.734.733.734a.726.726 0 0 0 .734-.734Z", "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM5.384 7.256a1.783 1.783 0 0 0-1.608-1.031C2.801 6.225 2 7.027 2 8.001c0 .975.801 1.777 1.776 1.777.709 0 1.324-.425 1.608-1.031a2.741 2.741 0 0 0 2.625 1.986 2.742 2.742 0 0 0 2.619-1.961 1.782 1.782 0 0 0 1.596 1.006c.974 0 1.776-.802 1.776-1.777 0-.974-.802-1.776-1.776-1.776-.699 0-1.307.413-1.596 1.005a2.742 2.742 0 0 0-2.619-1.96 2.74 2.74 0 0 0-2.625 1.986Z"]
    }
};
class OpMarkNextcloudIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opMarkNextcloudIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpMarkNextcloudIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpMarkNextcloudIconComponent, isStandalone: true, selector: "svg[op-mark-nextcloud-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpMarkNextcloudIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-mark-nextcloud-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opMentionCommentIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 3a3.5 3.5 0 0 1 3.5 3.5c0 .03-.003.059-.008.087a.494.494 0 0 1 .008.087c0 .236-.059.587-.253.895-.21.333-.575.605-1.117.605-.449 0-.778-.188-.997-.442a1.675 1.675 0 1 1-.305-2.687.455.455 0 0 1 .846.238v1.391a.84.84 0 0 0 .112.409c.064.102.155.178.344.178.19 0 .28-.076.345-.178a.84.84 0 0 0 .112-.409c0-.03.003-.059.008-.087a.494.494 0 0 1-.008-.087 2.587 2.587 0 1 0-1.035 2.07.456.456 0 1 1 .549.73A3.5 3.5 0 1 1 8 3Zm0 2.739a.761.761 0 1 0 0 1.523.761.761 0 0 0 0-1.523Z", "M1.75 0h12.5C15.217 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25v-9.5C0 .784.784 0 1.75 0ZM1.5 1.75v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"]
    }
};
class OpMentionCommentIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opMentionCommentIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpMentionCommentIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpMentionCommentIconComponent, isStandalone: true, selector: "svg[op-mention-comment-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpMentionCommentIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-mention-comment-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opMoveIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.916 8.694a.652.652 0 0 0-.943 0 .704.704 0 0 0 0 .973l.862.89H2.556a.226.226 0 0 1-.223-.229V4.607c0-.127.1-.23.223-.23h2.777A.677.677 0 0 0 6 3.689.678.678 0 0 0 5.333 3H2.556C1.696 3 1 3.719 1 4.607v5.721c0 .887.696 1.606 1.556 1.606h1.279l-.862.891a.704.704 0 0 0 0 .973c.26.269.682.269.943 0l2-2.065a.706.706 0 0 0 0-.974l-2-2.065Zm4.64 5.388c-.86 0-1.556-.719-1.556-1.607v-2.459c0-.887.696-1.606 1.556-1.606h4.888c.86 0 1.556.719 1.556 1.606v2.459c0 .888-.696 1.607-1.556 1.607Zm-.223-1.607c0 .127.1.23.223.23h4.888a.227.227 0 0 0 .223-.23v-2.459c0-.126-.1-.229-.223-.229H8.556a.226.226 0 0 0-.223.229ZM7.111 5.066V2.607C7.111 1.719 7.808 1 8.667 1h4.777C14.304 1 15 1.719 15 2.607v2.459c0 .887-.696 1.606-1.556 1.606H8.667c-.859 0-1.556-.719-1.556-1.606Zm1.556.229h4.777a.226.226 0 0 0 .223-.229V2.607c0-.127-.1-.23-.223-.23H8.667a.227.227 0 0 0-.223.23v2.459c0 .126.1.229.223.229Z"]
    }
};
class OpMoveIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opMoveIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpMoveIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpMoveIconComponent, isStandalone: true, selector: "svg[op-move-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpMoveIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-move-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opNoHierarchyIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.818 1c.452 0 .818.348.818.778v3.37h3.546c.452 0 .818.348.818.778 0 .429-.366.778-.818.778H6.636v2.592h3.546c.452 0 .818.349.818.778 0 .43-.366.778-.818.778H6.636v2.333c0 .143.122.259.273.259h3.273c.452 0 .818.349.818.778 0 .43-.366.778-.818.778H6.909C5.855 15 5 14.188 5 13.185V1.778c0-.43.366-.778.818-.778Z"]
    }
};
class OpNoHierarchyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opNoHierarchyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpNoHierarchyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpNoHierarchyIconComponent, isStandalone: true, selector: "svg[op-no-hierarchy-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpNoHierarchyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-no-hierarchy-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opOutdentIconData = {
    "16": {
        "width": 16,
        "paths": ["M.22 12.22A.747.747 0 0 1 .75 12h14.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H.75a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm6-6A.747.747 0 0 1 6.75 6h8.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-8.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0 3A.747.747 0 0 1 6.75 9h8.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-8.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm-6-6A.747.747 0 0 1 .75 3h14.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H.75a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm3.353 3.207L2.177 7.823a.25.25 0 0 0 0 .354l1.396 1.396A.25.25 0 0 0 4 9.396V6.604a.25.25 0 0 0-.427-.177Z"]
    }
};
class OpOutdentIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opOutdentIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpOutdentIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpOutdentIconComponent, isStandalone: true, selector: "svg[op-outdent-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpOutdentIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-outdent-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opPdfIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z", "M5.289 13.5c-.182 0-.289-.119-.289-.322v-2.356c0-.203.107-.322.289-.322h.833c.565 0 .955.404.955 1.014 0 .607-.403 1.013-.984 1.013h-.516v.651c0 .203-.107.322-.288.322Zm.288-1.457h.39c.331 0 .524-.189.524-.527 0-.337-.192-.526-.522-.526h-.392v1.053Zm2.131 1.418c-.182 0-.289-.119-.289-.324v-2.315c0-.203.107-.322.289-.322h.764c.828 0 1.315.529 1.315 1.469 0 .94-.487 1.492-1.315 1.492h-.764Zm.288-.513h.407c.516 0 .795-.337.795-.977 0-.619-.286-.96-.795-.96h-.407v1.937Zm2.452.552c-.181 0-.288-.119-.288-.322v-2.356c0-.203.107-.322.288-.322h1.29c.159 0 .262.096.262.257 0 .16-.105.256-.262.256h-1.001v.792h.908c.149 0 .246.092.246.244 0 .154-.095.247-.246.247h-.908v.882c0 .203-.107.322-.289.322Z"]
    }
};
class OpPdfIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opPdfIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPdfIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpPdfIconComponent, isStandalone: true, selector: "svg[op-pdf-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPdfIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-pdf-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opPdfDescriptionIconData = {
    "16": {
        "width": 16,
        "paths": ["M5 13.151v-2.356c0-.203.106-.322.287-.322h.829c.562 0 .95.404.95 1.013 0 .608-.401 1.014-.979 1.014h-.513v.651c0 .203-.107.322-.287.322-.181 0-.287-.119-.287-.322Zm.962-1.135c.328 0 .52-.189.52-.528 0-.336-.19-.525-.519-.525h-.389v1.053Zm1.463 1.093v-2.314c0-.203.107-.322.287-.322h.76c.823 0 1.308.529 1.308 1.469 0 .94-.485 1.492-1.308 1.492h-.76c-.18 0-.287-.119-.287-.325Zm.979-.188c.513 0 .791-.337.791-.977 0-.62-.285-.96-.791-.96h-.405v1.937Zm2.053.552c-.181 0-.287-.119-.287-.323v-2.355c0-.203.106-.322.287-.322h1.283c.157 0 .26.096.26.256s-.104.257-.26.257h-.996v.792h.902c.149 0 .246.092.246.244 0 .154-.095.246-.246.246h-.902v.882c0 .204-.107.323-.287.323ZM5.75 5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5ZM5 8.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 8.25Z", "M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z"]
    }
};
class OpPdfDescriptionIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opPdfDescriptionIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPdfDescriptionIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpPdfDescriptionIconComponent, isStandalone: true, selector: "svg[op-pdf-description-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPdfDescriptionIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-pdf-description-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opPersonAccountableIconData = {
    "16": {
        "width": 16,
        "paths": ["M16 2.75a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75ZM9 6c0 1.004-.423 1.91-1.101 2.548a5.528 5.528 0 0 1 3.1 4.659.751.751 0 0 1-1.498.086A4.009 4.009 0 0 0 5.5 9.5a4.009 4.009 0 0 0-4.001 3.793A.75.75 0 0 1 0 13.257v-.013l.001-.037a5.528 5.528 0 0 1 3.1-4.659A3.5 3.5 0 1 1 9 6ZM3.5 6a2 2 0 1 0 3.999.001A2 2 0 0 0 3.5 6Zm11.75-2a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5ZM16 6.75a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75Z"]
    }
};
class OpPersonAccountableIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opPersonAccountableIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPersonAccountableIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpPersonAccountableIconComponent, isStandalone: true, selector: "svg[op-person-accountable-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPersonAccountableIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-person-accountable-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opPersonAssignedIconData = {
    "16": {
        "width": 16,
        "paths": ["M15.999 2.749a.75.75 0 0 1-.219.53L13 6a.752.752 0 0 1-1.06 0l-1.72-1.721a.749.749 0 0 1 1.06-1.06l1.19 1.191 2.25-2.191a.752.752 0 0 1 1.06 0c.14.141.219.332.219.53Zm-8.1 5.799a5.528 5.528 0 0 1 3.1 4.659.751.751 0 0 1-1.498.086A4.009 4.009 0 0 0 5.5 9.5a4.009 4.009 0 0 0-4.001 3.793A.75.75 0 0 1 0 13.257v-.013l.001-.037a5.528 5.528 0 0 1 3.1-4.659 3.5 3.5 0 1 1 4.798 0ZM5.5 4a2 2 0 1 0-.001 3.999A2 2 0 0 0 5.5 4Z"]
    }
};
class OpPersonAssignedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opPersonAssignedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPersonAssignedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpPersonAssignedIconComponent, isStandalone: true, selector: "svg[op-person-assigned-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPersonAssignedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-person-assigned-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opPersonMissingIconData = {
    "16": {
        "width": 16,
        "paths": ["M10 7.5c0 1.004-.423 1.91-1.101 2.548a5.528 5.528 0 0 1 3.1 4.659.75.75 0 0 1-1.498.086A4.009 4.009 0 0 0 6.5 11a4.009 4.009 0 0 0-4.001 3.793.751.751 0 0 1-1.498-.086 5.528 5.528 0 0 1 3.1-4.659A3.5 3.5 0 1 1 10 7.5Zm-5.5 0a2 2 0 1 0 3.999.001A2 2 0 0 0 4.5 7.5Zm10.25-5.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM15 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    }
};
class OpPersonMissingIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opPersonMissingIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPersonMissingIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpPersonMissingIconComponent, isStandalone: true, selector: "svg[op-person-missing-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPersonMissingIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-person-missing-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opPersonRemoveIconData = {
    "16": {
        "width": 16,
        "paths": ["M16 2.75a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75ZM9 6c0 1.004-.423 1.91-1.101 2.548a5.528 5.528 0 0 1 3.1 4.659.751.751 0 0 1-1.498.086A4.009 4.009 0 0 0 5.5 9.5a4.009 4.009 0 0 0-4.001 3.793A.75.75 0 0 1 0 13.257v-.013l.001-.037a5.528 5.528 0 0 1 3.1-4.659A3.5 3.5 0 1 1 9 6ZM3.5 6a2 2 0 1 0 3.999.001A2 2 0 0 0 3.5 6Z"]
    }
};
class OpPersonRemoveIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opPersonRemoveIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPersonRemoveIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpPersonRemoveIconComponent, isStandalone: true, selector: "svg[op-person-remove-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPersonRemoveIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-person-remove-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opPhoneIconData = {
    "16": {
        "width": 16,
        "paths": ["M11.297 14.997c-1.01-.037-3.871-.431-6.867-3.428-2.996-2.995-3.39-5.856-3.428-6.866-.056-1.539 1.123-3.035 2.485-3.619a1.034 1.034 0 0 1 1.013.112c1.127.822 1.905 2.068 2.573 3.044a1.052 1.052 0 0 1-.124 1.341l-.951.951c.221.487.67 1.327 1.407 2.063.736.737 1.575 1.186 2.063 1.407l.95-.951a1.056 1.056 0 0 1 1.345-.12c.995.69 2.165 1.456 3.017 2.548a1.022 1.022 0 0 1 .133 1.041c-.587 1.369-2.072 2.534-3.616 2.477Zm-5.875-4.418c2.696 2.695 5.193 2.99 5.927 3.018.886.032 1.79-.692 2.181-1.433-.624-.732-1.436-1.299-2.327-1.915-.088.088-.179.189-.275.295-.473.52-1.04 1.145-1.758.855-.49-.197-1.7-.755-2.757-1.812C5.355 8.53 4.799 7.32 4.6 6.83c-.29-.718.337-1.287.858-1.76.106-.096.207-.188.296-.276-.616-.905-1.174-1.738-1.904-2.331-.752.393-1.48 1.29-1.447 2.188.028.734.323 3.231 3.019 5.928Z"]
    }
};
class OpPhoneIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opPhoneIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPhoneIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpPhoneIconComponent, isStandalone: true, selector: "svg[op-phone-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPhoneIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-phone-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opPrinterIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.6 5C14.928 5 16 6.072 16 7.4v3.8a1 1 0 0 1-1 1h-1.2a1 1 0 0 0-1 1v1.2a1 1 0 0 1-1 1H4.2a1 1 0 0 1-1-1v-1.2a1 1 0 0 0-1-1H1a1 1 0 0 1-1-1V7.4C0 6.072 1.072 5 2.4 5a.8.8 0 0 0 .8-.8V2a1 1 0 0 1 1-1h7.6a1 1 0 0 1 1 1v2.2a.8.8 0 0 0 .8.8ZM5.8 2.6a1 1 0 0 0-1 1V4a1 1 0 0 0 1 1h4.4a1 1 0 0 0 1-1v-.4a1 1 0 0 0-1-1H5.8Zm4.4 11.2a1 1 0 0 0 1-1v-1.2a1 1 0 0 0-1-1H5.8a1 1 0 0 0-1 1v1.2a1 1 0 0 0 1 1h4.4Zm2.6-4a.8.8 0 1 0 1.6 0V7.4c0-.44-.36-.8-.8-.8H2.4c-.44 0-.8.36-.8.8v2.4a.8.8 0 1 0 1.6 0A.8.8 0 0 1 4 9h8a.8.8 0 0 1 .8.8Zm.8-2c0 .44-.36.8-.8.8-.44 0-.8-.36-.8-.8 0-.44.36-.8.8-.8.44 0 .8.36.8.8Z"]
    }
};
class OpPrinterIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opPrinterIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPrinterIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpPrinterIconComponent, isStandalone: true, selector: "svg[op-printer-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpPrinterIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-printer-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opReadAllIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.678 1.248C5.928 1.086 6.211 1 6.5 1c.289 0 .572.086.822.248l4.875 2.758c.497.325.803.92.803 1.563v5.619c0 .481-.171.942-.476 1.281-.305.34-.718.531-1.149.531h-9.75c-.431 0-.844-.191-1.149-.531A1.919 1.919 0 0 1 0 11.188V5.569c0-.643.306-1.238.803-1.563l4.875-2.758Zm.939 1.339a.216.216 0 0 0-.234 0L2 5.023l3.077 2.552a2.368 2.368 0 0 1 1.424-.484c.507 0 1.003.168 1.423.484L11 5.023 6.617 2.587Zm3.737 8.86L7.217 8.921a1.09 1.09 0 0 0-.717-.277c-.26 0-.512.098-.717.277l-3.137 2.526h7.708Zm1.253-5.022L9.112 8.606l2.495 1.964V6.425ZM3.888 8.606 1.393 6.425v4.145l2.495-1.964Z", "M13.47 5.47a.749.749 0 0 1 1.06 0l.207.207c.329.328.513.773.513 1.237V13.5a1.75 1.75 0 0 1-1.75 1.75H3a.75.75 0 0 1 0-1.5h10.5a.25.25 0 0 0 .25-.25V6.914a.25.25 0 0 0-.073-.177l-.207-.207a.749.749 0 0 1 0-1.06Z"]
    }
};
class OpReadAllIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opReadAllIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpReadAllIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpReadAllIconComponent, isStandalone: true, selector: "svg[op-read-all-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpReadAllIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-read-all-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opRelationFollowsIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.122.392a1.75 1.75 0 0 1 1.756 0l5.25 3.045c.54.313.872.89.872 1.514v6.098a1.75 1.75 0 0 1-.872 1.514l-5.376 3.118a1 1 0 0 1-1.502-.865V8.432L3.5 5.677V7.25a.75.75 0 0 1-1.5 0V4.951c0-.624.332-1.201.872-1.514ZM4.245 4.375 9 7.133l4.755-2.758-4.63-2.685a.248.248 0 0 0-.25 0ZM14.5 5.677 9.75 8.432v5.516l4.625-2.683a.249.249 0 0 0 .125-.216Z", "M3.328 14.733 4.501 13.5H1.25a.75.75 0 0 1 0-1.5h3.251l-1.173-1.233a.75.75 0 0 1 1.087-1.034l2.378 2.5a.75.75 0 0 1 0 1.034l-2.378 2.5a.75.75 0 1 1-1.087-1.034Z"]
    }
};
class OpRelationFollowsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opRelationFollowsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpRelationFollowsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpRelationFollowsIconComponent, isStandalone: true, selector: "svg[op-relation-follows-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpRelationFollowsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-relation-follows-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opRelationNewChildIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.973 6.71a.652.652 0 0 1 .943 0l2 2.065c.26.269.26.705 0 .974l-2 2.066a.652.652 0 0 1-.943 0 .706.706 0 0 1 0-.974l.862-.89H1.556C.696 9.951 0 9.232 0 8.344V1.667a.666.666 0 1 1 1.333 0v6.677c0 .127.1.23.223.23h1.279l-.862-.89a.706.706 0 0 1 0-.974Zm8.298-3.517a1.475 1.475 0 0 1 1.458 0l3.542 2.279c.451.258.729.734.729 1.25v4.556c0 .516-.278.993-.729 1.25l-3.542 2.279a1.475 1.475 0 0 1-1.458 0l-3.542-2.279A1.44 1.44 0 0 1 6 11.278V6.722c0-.516.278-.992.729-1.25Zm.833 1.072a.209.209 0 0 0-.208 0L7.875 6.246 11 8.286l3.125-2.04ZM7.25 11.278c0 .074.04.142.104.179l3.021 1.981V9.357L7.25 7.317Zm7.396.179a.207.207 0 0 0 .104-.179V7.317l-3.125 2.04v4.081Z"]
    }
};
class OpRelationNewChildIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opRelationNewChildIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpRelationNewChildIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpRelationNewChildIconComponent, isStandalone: true, selector: "svg[op-relation-new-child-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpRelationNewChildIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-relation-new-child-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opRelationsIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 5.062A4.063 4.063 0 0 1 5.065 1a4.066 4.066 0 0 1 3.997 3.312h1.653a2.208 2.208 0 1 1 0 1.5H9.062a4.06 4.06 0 0 1-.64 1.542l1.226 1.227a2.209 2.209 0 1 1 .937 4.207 2.207 2.207 0 0 1-2-3.144L7.357 8.417c-.454.31-.975.531-1.538.636v1.528a.684.684 0 0 1-.011.128 2.208 2.208 0 1 1-1.486 0 .78.78 0 0 1-.01-.128V9.053A4.063 4.063 0 0 1 1 5.062ZM5.065 2.5a2.56 2.56 0 0 0-2.557 2.562 2.56 2.56 0 0 0 2.557 2.561 2.56 2.56 0 0 0 2.558-2.561A2.56 2.56 0 0 0 5.065 2.5Zm7.727 3.269c.379 0 .7-.309.7-.707a.704.704 0 0 0-.7-.708.703.703 0 0 0-.699.708c0 .398.32.707.699.707Zm-1.508 4.812a.703.703 0 0 0-.699-.708c-.379 0-.7.309-.7.708 0 .398.321.707.7.707a.703.703 0 0 0 .699-.707Zm-6.219 2.915c.379 0 .7-.309.7-.708a.704.704 0 0 0-.7-.707.703.703 0 0 0-.699.707c0 .399.32.708.699.708Z"]
    }
};
class OpRelationsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opRelationsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpRelationsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpRelationsIconComponent, isStandalone: true, selector: "svg[op-relations-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpRelationsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-relations-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opReloadIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.643 3.143A8 8 0 0 1 16 7.96v.08a8 8 0 0 1-15.958.787.75.75 0 0 1 1.492-.154 6.5 6.5 0 1 0 1.181-4.458l1.358 1.358A.25.25 0 0 1 3.896 6H.25A.25.25 0 0 1 0 5.75V2.104a.25.25 0 0 1 .427-.177Z"]
    }
};
class OpReloadIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opReloadIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpReloadIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpReloadIconComponent, isStandalone: true, selector: "svg[op-reload-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpReloadIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-reload-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opResizerBottomRightIconData = {
    "16": {
        "width": 16,
        "paths": ["M14 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    }
};
class OpResizerBottomRightIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opResizerBottomRightIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpResizerBottomRightIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpResizerBottomRightIconComponent, isStandalone: true, selector: "svg[op-resizer-bottom-right-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpResizerBottomRightIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-resizer-bottom-right-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opResizerVerticalLinesIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.5 2.581C7.5 2.26 7.164 2 6.75 2S6 2.26 6 2.581v10.838c0 .321.336.581.75.581s.75-.26.75-.581V2.581Zm3 0c0-.321-.336-.581-.75-.581S9 2.26 9 2.581v10.838c0 .321.336.581.75.581s.75-.26.75-.581V2.581Z"]
    }
};
class OpResizerVerticalLinesIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opResizerVerticalLinesIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpResizerVerticalLinesIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpResizerVerticalLinesIconComponent, isStandalone: true, selector: "svg[op-resizer-vertical-lines-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpResizerVerticalLinesIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-resizer-vertical-lines-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opSaveIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 2.556A1.553 1.553 0 0 1 2.556 1h9.011c.412 0 .808.164 1.1.456l2.105 2.105a.778.778 0 0 1 .228.55v9.333A1.553 1.553 0 0 1 13.444 15H2.556A1.553 1.553 0 0 1 1 13.444V2.556Zm4.667 10.888h4.666V8.778H5.667v4.666Zm6.222 0h1.555V4.433l-1.555-1.555v1.233a1.555 1.555 0 0 1-1.556 1.556H5.667a1.553 1.553 0 0 1-1.556-1.556V2.556H2.556v10.888h1.555V8.778a1.555 1.555 0 0 1 1.556-1.556h4.666a1.553 1.553 0 0 1 1.556 1.556v4.666ZM5.667 2.556v1.555h4.666V2.556H5.667Z"]
    }
};
class OpSaveIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opSaveIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpSaveIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpSaveIconComponent, isStandalone: true, selector: "svg[op-save-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpSaveIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-save-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opScissorsIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.105.2a.889.889 0 0 1 1.25.127L8 6.021 12.644.327a.89.89 0 0 1 1.378 1.124L9.147 7.428l1.561 1.914a3.56 3.56 0 0 1 4.251.588 3.56 3.56 0 0 1 0 5.029 3.56 3.56 0 0 1-5.029 0 3.557 3.557 0 0 1-.51-4.384L8 8.834l-1.42 1.741a3.549 3.549 0 0 1 .26 3.23 3.56 3.56 0 0 1-1.924 1.924 3.549 3.549 0 0 1-2.721 0 3.56 3.56 0 0 1-1.924-1.924 3.55 3.55 0 0 1 .77-3.875 3.56 3.56 0 0 1 4.251-.588l1.561-1.914-4.875-5.977A.889.889 0 0 1 2.105.2Zm1.451 10.467a1.786 1.786 0 0 0-1.258.52 1.78 1.78 0 0 0 .577 2.9 1.786 1.786 0 0 0 1.938-.385 1.79 1.79 0 0 0 .52-1.258 1.785 1.785 0 0 0-.52-1.257 1.77 1.77 0 0 0-1.257-.52Zm8.888 0a1.78 1.78 0 0 0-1.257.52 1.78 1.78 0 0 0 0 2.515 1.78 1.78 0 0 0 2.514 0 1.778 1.778 0 0 0-1.257-3.035Z"]
    }
};
class OpScissorsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opScissorsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpScissorsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpScissorsIconComponent, isStandalone: true, selector: "svg[op-scissors-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpScissorsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-scissors-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opServerKeyIconData = {
    "16": {
        "width": 16,
        "paths": ["M7 3.75A.75.75 0 0 1 7.75 3h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 3.75Zm-4 0A.75.75 0 0 1 3.75 3h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 3.75Z", "M1.75 0h12.5C15.217 0 16 .784 16 1.75v4c0 .372-.116.717-.314 1 .198.283.314.628.314 1V9a.75.75 0 0 1-1.5 0V7.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h7.5a.75.75 0 0 1 0 1.5h-7.5A1.75 1.75 0 0 1 0 11.75v-4c0-.372.116-.717.314-1a1.739 1.739 0 0 1-.314-1v-4C0 .784.784 0 1.75 0ZM1.5 1.75v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z", "M7.75 9h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5Zm-4 0h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Zm8.125 3.062a2.062 2.062 0 1 1 1.58 2.006l-.35.35a.284.284 0 0 1-.199.082h-.281v.281c0 .075-.03.146-.082.199l-.188.188a.284.284 0 0 1-.199.082h-.281v.281c0 .075-.03.146-.082.199l-.188.188a.284.284 0 0 1-.199.082h-.75a.656.656 0 0 1-.656-.656v-.75c0-.075.03-.146.082-.199l1.85-1.85a2.074 2.074 0 0 1-.057-.483ZM15 11.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Z"]
    }
};
class OpServerKeyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opServerKeyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpServerKeyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpServerKeyIconComponent, isStandalone: true, selector: "svg[op-server-key-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpServerKeyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-server-key-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opShortcutsIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Zm.5 1.5v11h11v-11Z", "M4.641 12.045c-.631 0-1.032-.414-1.032-1.092 0-.67.399-1.092 1.028-1.092.42 0 .769.204.883.5.019.049.031.1.031.141 0 .141-.11.223-.244.223-.114 0-.182-.045-.241-.149-.103-.183-.23-.267-.412-.267-.289 0-.466.238-.466.642 0 .412.177.647.462.647.2 0 .323-.098.411-.246.076-.12.138-.168.259-.168.133 0 .241.087.241.228a.349.349 0 0 1-.038.148c-.125.286-.482.485-.882.485Zm1.397-.58v-1.129h-.11c-.135 0-.221-.082-.221-.215s.086-.215.221-.215h.11v-.232c0-.184.107-.297.285-.297.177 0 .285.113.285.297v.232h.201c.135 0 .219.084.219.215s-.084.215-.219.215h-.201v1.002c0 .148.051.211.174.221l.037.003c.14.016.217.075.217.208 0 .168-.164.253-.405.253h-.019c-.381 0-.574-.189-.574-.558Zm1.574.576c-.172 0-.285-.107-.285-.297V10.15c0-.181.111-.287.276-.287.16 0 .269.106.269.287v.137h.012c.054-.26.226-.414.435-.414a.27.27 0 0 1 .178.053c.055.043.082.113.082.211 0 .09-.027.158-.082.205-.055.047-.137.072-.248.074-.26.004-.352.15-.352.399v.929c0 .19-.111.297-.285.297Zm1.491 0c-.166 0-.285-.101-.285-.297V9.438c0-.196.119-.299.285-.299.168 0 .285.103.285.299v2.306c0 .196-.117.297-.285.297Zm1.799-.092c-.16 0-.256-.103-.256-.271v-.559h-.533c-.16 0-.262-.094-.262-.25 0-.154.102-.248.262-.248h.533v-.562c0-.166.098-.272.256-.272s.254.106.254.272v.562h.531c.163 0 .264.094.264.248 0 .156-.103.25-.266.25h-.529v.559c0 .168-.096.271-.254.271Z"]
    }
};
class OpShortcutsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opShortcutsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpShortcutsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpShortcutsIconComponent, isStandalone: true, selector: "svg[op-shortcuts-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpShortcutsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-shortcuts-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opSortByIconData = {
    "16": {
        "width": 16,
        "paths": ["m11.427 2.573 3 3A.251.251 0 0 1 14.25 6H12v6.75a.75.75 0 0 1-1.5 0V6H8.25a.25.25 0 0 1-.177-.427l3-3a.252.252 0 0 1 .354 0ZM4.573 13.427l-3-3A.251.251 0 0 1 1.75 10H4V3.25a.75.75 0 0 1 1.5 0V10h2.25a.25.25 0 0 1 .177.427l-3 3a.252.252 0 0 1-.354 0Z"]
    }
};
class OpSortByIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opSortByIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpSortByIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpSortByIconComponent, isStandalone: true, selector: "svg[op-sort-by-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpSortByIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-sort-by-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opStopwatchStartIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.487 8.903 7 6.639c-.162-.148-.438-.043-.438.167v4.527c0 .21.276.316.438.167l3.487-2.263c.1-.093.1-.242 0-.334Z", "M6.5 0h3a.75.75 0 0 1 0 1.5h-.75v1l-.001.041a6.719 6.719 0 0 1 3.464 1.435l.007-.006.75-.75a.749.749 0 1 1 1.06 1.06l-.75.75-.006.007a6.75 6.75 0 1 1-10.548 0L2.72 5.03l-.75-.75a.749.749 0 1 1 1.06-1.06l.75.75.007.006a6.719 6.719 0 0 1 3.464-1.435L7.25 2.5v-1H6.5a.75.75 0 0 1 0-1.5Zm6.75 9.25a5.25 5.25 0 1 0-10.501.001A5.25 5.25 0 0 0 13.25 9.25Z"]
    }
};
class OpStopwatchStartIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opStopwatchStartIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpStopwatchStartIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpStopwatchStartIconComponent, isStandalone: true, selector: "svg[op-stopwatch-start-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpStopwatchStartIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-stopwatch-start-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opStopwatchStopIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.5 8c0-.604.49-1.094 1.094-1.094h2.812c.604 0 1.094.49 1.094 1.094v2.812c0 .605-.49 1.094-1.094 1.094H6.594A1.094 1.094 0 0 1 5.5 10.812V8Z", "M6.5 0h3a.75.75 0 0 1 0 1.5h-.75v1l-.001.041a6.719 6.719 0 0 1 3.464 1.435l.007-.006.75-.75a.749.749 0 1 1 1.06 1.06l-.75.75-.006.007a6.75 6.75 0 1 1-10.548 0L2.72 5.03l-.75-.75a.749.749 0 1 1 1.06-1.06l.75.75.007.006a6.719 6.719 0 0 1 3.464-1.435L7.25 2.5v-1H6.5a.75.75 0 0 1 0-1.5Zm6.75 9.25a5.25 5.25 0 1 0-10.501.001A5.25 5.25 0 0 0 13.25 9.25Z"]
    }
};
class OpStopwatchStopIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opStopwatchStopIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpStopwatchStopIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpStopwatchStopIconComponent, isStandalone: true, selector: "svg[op-stopwatch-stop-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpStopwatchStopIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-stopwatch-stop-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opTeamPlannerIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.22 2.221A.744.744 0 0 1 2.75 2h12.5a.754.754 0 0 1 0 1.508H2.75a.756.756 0 0 1-.53-1.287Zm-2 6.03a.748.748 0 0 1 .53-.221h3.5a.754.754 0 0 1 0 1.508H.75a.754.754 0 0 1-.53-1.287Zm3.53-3.236a.754.754 0 0 0 0 1.508h2.5a.754.754 0 0 0 0-1.508h-2.5Zm2.913 2.652a2.413 2.413 0 0 1 1.91-1.261 2.392 2.392 0 0 1 2.097.911 2.427 2.427 0 0 1-.24 3.26 3.805 3.805 0 0 1 2.086 2.822.52.52 0 0 1-.429.593.513.513 0 0 1-.59-.431 2.773 2.773 0 0 0-.932-1.665 2.744 2.744 0 0 0-3.567 0 2.768 2.768 0 0 0-.932 1.665.523.523 0 0 1-.591.431.516.516 0 0 1-.428-.594 3.811 3.811 0 0 1 .699-1.667 3.777 3.777 0 0 1 1.387-1.153 2.403 2.403 0 0 1-.758-1.762c0-.401.099-.796.288-1.149Zm1.146.171a1.386 1.386 0 0 0 0 1.955 1.372 1.372 0 0 0 2.347-.977 1.373 1.373 0 0 0-2.347-.978Zm4.389.093a.516.516 0 0 1 .364-.152 2.058 2.058 0 0 1 1.887 1.234 2.09 2.09 0 0 1-.36 2.233 3.47 3.47 0 0 1 1.76 2.082.525.525 0 0 1-.164.553.525.525 0 0 1-.378.117.522.522 0 0 1-.444-.366 2.416 2.416 0 0 0-1.734-1.639.517.517 0 0 1-.395-.505v-.243a.518.518 0 0 1 .286-.464 1.034 1.034 0 0 0 .546-1.165 1.03 1.03 0 0 0-1.004-.8.516.516 0 0 1-.515-.519c0-.137.054-.269.151-.366Z"]
    }
};
class OpTeamPlannerIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opTeamPlannerIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpTeamPlannerIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpTeamPlannerIconComponent, isStandalone: true, selector: "svg[op-team-planner-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpTeamPlannerIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-team-planner-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opTriangleDeltaIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.419 2.935c.675-1.247 2.487-1.247 3.162 0l5.205 8.464c.638 1.177-.227 2.601-1.581 2.601H2.795c-1.354 0-2.219-1.424-1.581-2.601Zm1.807.714a.258.258 0 0 0-.452 0l-5.205 8.464a.253.253 0 0 0 .226.372h10.41a.253.253 0 0 0 .226-.372Z"]
    }
};
class OpTriangleDeltaIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opTriangleDeltaIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpTriangleDeltaIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpTriangleDeltaIconComponent, isStandalone: true, selector: "svg[op-triangle-delta-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpTriangleDeltaIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-triangle-delta-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opViewCardsIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z", "M.817.27c.27-.171.59-.27.933-.27h12.5a1.737 1.737 0 0 1 1.237.513A1.735 1.735 0 0 1 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75a1.756 1.756 0 0 1-1.342-.626A1.754 1.754 0 0 1 0 14.25V1.75A1.738 1.738 0 0 1 .513.513C.605.421.707.339.817.27ZM14.3 1.505a.273.273 0 0 0-.05-.005H1.75a.25.25 0 0 0-.25.25v12.515a.257.257 0 0 0 .117.197.257.257 0 0 0 .121.038H14.25a.25.25 0 0 0 .25-.25V1.75a.243.243 0 0 0-.073-.177.25.25 0 0 0-.127-.068ZM3 5.366a1.003 1.003 0 0 1-.5-.866v-1a.997.997 0 0 1 .5-.866.997.997 0 0 1 .5-.134h3a.995.995 0 0 1 .866.5.997.997 0 0 1 .134.5v1a.995.995 0 0 1-.376.781.995.995 0 0 1-.624.219h-3a.997.997 0 0 1-.5-.134Zm4.281 3.758A.995.995 0 0 1 6.5 9.5h-3a.997.997 0 0 1-.781-.376A.995.995 0 0 1 2.5 8.5v-1a.995.995 0 0 1 .5-.866.997.997 0 0 1 .5-.134h3a.995.995 0 0 1 .781.376.995.995 0 0 1 .219.624v1a.995.995 0 0 1-.219.624ZM13 6.634a1.003 1.003 0 0 1 .5.866v1a1 1 0 0 1-1 1h-3a.998.998 0 0 1-1-1v-1a.995.995 0 0 1 .376-.781A.995.995 0 0 1 9.5 6.5h3c.182 0 .353.049.5.134Zm.281-1.51a1.003 1.003 0 0 1-.781.376h-3a.995.995 0 0 1-.781-.376A.995.995 0 0 1 8.5 4.5v-1a.997.997 0 0 1 .376-.781A.995.995 0 0 1 9.5 2.5h3a.997.997 0 0 1 .866.5.997.997 0 0 1 .134.5v1a.995.995 0 0 1-.219.624Zm-6 5.752a.995.995 0 0 1 .219.624v1a1 1 0 0 1-1 1h-3a.997.997 0 0 1-.866-.5.997.997 0 0 1-.134-.5v-1a.995.995 0 0 1 .5-.866.997.997 0 0 1 .5-.134h3c.316 0 .598.147.781.376Z"]
    }
};
class OpViewCardsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opViewCardsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewCardsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpViewCardsIconComponent, isStandalone: true, selector: "svg[op-view-cards-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewCardsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-view-cards-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opViewFullscreenIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z", "M4.75 4.5a.25.25 0 0 0-.25.25v1.5a.75.75 0 0 1-1.5 0v-1.5C3 3.783 3.783 3 4.75 3h1.5a.75.75 0 0 1 0 1.5ZM9 3.75A.75.75 0 0 1 9.75 3h1.5c.967 0 1.75.783 1.75 1.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.25.25 0 0 0-.25-.25h-1.5A.75.75 0 0 1 9 3.75ZM3.75 9a.75.75 0 0 1 .75.75v1.5c0 .138.112.25.25.25h1.5a.75.75 0 0 1 0 1.5h-1.5A1.75 1.75 0 0 1 3 11.25v-1.5A.75.75 0 0 1 3.75 9Zm8.5 0a.75.75 0 0 1 .75.75v1.5A1.75 1.75 0 0 1 11.25 13h-1.5a.75.75 0 0 1 0-1.5h1.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 .75-.75Z"]
    }
};
class OpViewFullscreenIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opViewFullscreenIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewFullscreenIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpViewFullscreenIconComponent, isStandalone: true, selector: "svg[op-view-fullscreen-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewFullscreenIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-view-fullscreen-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opViewListIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z", "M3.22 12.22a.747.747 0 0 1 .53-.22h8.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-8.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0-6A.747.747 0 0 1 3.75 6h8.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-8.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0 3A.747.747 0 0 1 3.75 9h8.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-8.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0-6A.747.747 0 0 1 3.75 3h8.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-8.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Z"]
    }
};
class OpViewListIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opViewListIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewListIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpViewListIconComponent, isStandalone: true, selector: "svg[op-view-list-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewListIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-view-list-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opViewModalIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z", "M7.26 3.201a1.497 1.497 0 0 1 1.5 0l3.51 1.18a1.498 1.498 0 0 1 .75 1.3v4.362a1.497 1.497 0 0 1-.75 1.299l-3.51 1.18a1.497 1.497 0 0 1-1.5 0l-3.51-1.18a1.494 1.494 0 0 1-.75-1.3v-4.36a1.5 1.5 0 0 1 .75-1.3l3.511-1.18ZM4.501 6.547v3.496l2.76.748V7.296Zm4.26 4.243 2.758-.747V6.549l-2.758.747Zm2.01-5.541L8.01 4.5l-2.76.748 2.761.749Z"]
    }
};
class OpViewModalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opViewModalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewModalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpViewModalIconComponent, isStandalone: true, selector: "svg[op-view-modal-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewModalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-view-modal-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opViewSplitIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25H9.5v-13H1.75a.25.25 0 0 0-.25.25ZM11 14.5h3.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H11Z", "M3.22 12.22a.747.747 0 0 1 .53-.22h3.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-3.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0-6A.747.747 0 0 1 3.75 6h3.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-3.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0 3A.747.747 0 0 1 3.75 9h3.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-3.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0-6A.747.747 0 0 1 3.75 3h3.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-3.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Z"]
    }
};
class OpViewSplitIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opViewSplitIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewSplitIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpViewSplitIconComponent, isStandalone: true, selector: "svg[op-view-split-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewSplitIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-view-split-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opViewSplitModalIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25H9.5v-13H1.75a.25.25 0 0 0-.25.25ZM11 14.5h3.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H11Z", "M4.668 5.201a1.497 1.497 0 0 1 1.5 0l1.602.75a1.498 1.498 0 0 1 .75 1.3v2.042a1.492 1.492 0 0 1-.75 1.299l-1.51.805a1.508 1.508 0 0 1-1.5 0l-1.51-.805a1.498 1.498 0 0 1-.75-1.3v-2.04a1.498 1.498 0 0 1 .75-1.301l1.419-.749Zm-.667 2.915v1.177l.76.373L4.76 8.55Zm2.26 1.549.758-.372V8.118l-.759.432Zm.01-2.846L5.418 6.5l-.668.318.76.433Z"]
    }
};
class OpViewSplitModalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opViewSplitModalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewSplitModalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpViewSplitModalIconComponent, isStandalone: true, selector: "svg[op-view-split-modal-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewSplitModalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-view-split-modal-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opViewTimelineIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z", "M.22 12.22A.747.747 0 0 1 .75 12h10.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H.75a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm4-6A.747.747 0 0 1 4.75 6h10.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H4.75a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm2 3A.747.747 0 0 1 6.75 9h2.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-2.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm-6-6A.747.747 0 0 1 .75 3h5.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H.75a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Z"]
    }
};
class OpViewTimelineIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opViewTimelineIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewTimelineIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpViewTimelineIconComponent, isStandalone: true, selector: "svg[op-view-timeline-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpViewTimelineIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-view-timeline-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opWorkPackagesIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.844.177a1.303 1.303 0 0 1 1.312 0l3.188 2.089c.406.236.656.673.656 1.146v4.176c0 .473-.25.91-.656 1.146l-3.188 2.089a1.304 1.304 0 0 1-1.312 0L9 9.615v2.973c0 .473-.25.91-.656 1.146l-3.188 2.089c-.2.117-.424.176-.648.177h-.016a1.294 1.294 0 0 1-.648-.177L.656 13.734A1.325 1.325 0 0 1 0 12.588V8.412c0-.473.25-.91.656-1.146l3.188-2.089a1.304 1.304 0 0 1 1.312 0L7 6.385V3.412c0-.473.25-.91.656-1.146Zm-6.25 5.982a.19.19 0 0 0-.188 0L1.687 7.975 4.5 9.846l2.813-1.871Zm7-5a.19.19 0 0 0-.188 0L8.687 2.975 11.5 4.846l2.813-1.871ZM1.125 12.588c0 .068.036.13.094.164l2.719 1.816v-3.74L1.125 8.957Zm6.656.164a.19.19 0 0 0 .094-.164V8.957l-2.812 1.871v3.74Zm7-5a.19.19 0 0 0 .094-.164V3.957l-2.813 1.871v3.74Zm-5.789.517 1.946 1.299v-3.74L8.125 3.957v3.165l.219.144c.365.212.604.586.648 1.003Z"]
    }
};
class OpWorkPackagesIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opWorkPackagesIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpWorkPackagesIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpWorkPackagesIconComponent, isStandalone: true, selector: "svg[op-work-packages-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpWorkPackagesIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-work-packages-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opXlsIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.846 12.943c.111.318.475.557 1.044.557.688 0 1.11-.358 1.11-.925 0-.44-.252-.688-.836-.81l-.291-.063c-.326-.068-.458-.178-.458-.357 0-.214.189-.354.474-.354.236 0 .414.09.506.309.065.125.145.179.275.179.147 0 .246-.098.246-.243a.425.425 0 0 0-.021-.135c-.122-.378-.502-.601-1.006-.601-.614 0-1.053.352-1.053.883 0 .432.27.709.82.824l.292.06c.345.075.475.183.475.374 0 .214-.21.37-.519.37-.264 0-.479-.1-.569-.321-.069-.129-.147-.177-.266-.177-.149 0-.254.106-.254.267a.48.48 0 0 0 .031.163Zm-4.573.547A.266.266 0 0 1 5 13.226c0-.074.023-.138.078-.219l.688-1.009v-.016l-.665-.953a.375.375 0 0 1-.084-.233.28.28 0 0 1 .292-.286c.109 0 .186.05.26.169l.59.917h.015l.61-.937c.067-.105.124-.149.235-.149.15 0 .28.115.28.259a.343.343 0 0 1-.076.218l-.716 1.007v.014l.695.987a.357.357 0 0 1 .076.221.266.266 0 0 1-.277.274c-.105 0-.175-.044-.25-.151l-.615-.903h-.015l-.605.905c-.073.111-.134.149-.243.149Zm2.754-.038c-.181 0-.288-.117-.288-.318v-2.306c0-.201.107-.318.288-.318.182 0 .289.117.289.318v2.121h.977c.157 0 .262.095.262.251 0 .157-.103.252-.262.252H8.027Z", "M3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.783 0 3.75 0ZM3.5 1.75v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073H3.75a.25.25 0 0 0-.25.25Z"]
    }
};
class OpXlsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opXlsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpXlsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpXlsIconComponent, isStandalone: true, selector: "svg[op-xls-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpXlsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-xls-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const opXlsRelationsIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.585 4.092a.665.665 0 0 1 .676 0l1.25.796a.683.683 0 0 1 .335.589v.506a.29.29 0 0 1-.288.292.29.29 0 0 1-.289-.292V5.76l-1.057.683V8.15c0 .3-.322.487-.578.337l-1.299-.825A.683.683 0 0 1 6 7.073V5.477c0-.243.128-.467.335-.589Zm.386.505a.097.097 0 0 0-.096 0l-1.012.656 1.06.684 1.06-.684ZM6.577 7.073c0 .034.018.066.048.084l1.01.655V6.443L6.577 5.76Z", "M9.588 8.507a.295.295 0 0 0 .01.413.286.286 0 0 0 .408-.011l.915-.973a.294.294 0 0 0 0-.402l-.915-.974a.287.287 0 0 0-.408-.01.295.295 0 0 0-.01.413l.451.48H8.788a.29.29 0 0 0-.288.292.29.29 0 0 0 .288.292h1.251l-.451.48Zm.258 4.436c.111.318.475.557 1.044.557.688 0 1.11-.358 1.11-.925 0-.44-.252-.688-.836-.81l-.291-.063c-.326-.068-.458-.178-.458-.357 0-.214.189-.354.474-.354.236 0 .414.09.506.309.065.125.145.179.275.179.147 0 .246-.098.246-.243a.425.425 0 0 0-.021-.135c-.122-.378-.502-.601-1.006-.601-.614 0-1.053.352-1.053.883 0 .432.27.709.82.824l.292.06c.345.075.475.183.475.374 0 .214-.21.37-.519.37-.264 0-.479-.1-.569-.321-.069-.129-.147-.177-.266-.177-.149 0-.254.106-.254.267a.48.48 0 0 0 .031.163Zm-4.573.547A.266.266 0 0 1 5 13.226c0-.074.023-.138.078-.219l.688-1.009v-.016l-.665-.953a.375.375 0 0 1-.084-.233.28.28 0 0 1 .292-.286c.109 0 .186.05.26.169l.59.917h.015l.61-.937c.067-.105.124-.149.235-.149.15 0 .28.115.28.259a.343.343 0 0 1-.076.218l-.716 1.007v.014l.695.987a.357.357 0 0 1 .076.221.266.266 0 0 1-.277.274c-.105 0-.175-.044-.25-.151l-.615-.903h-.015l-.605.905c-.073.111-.134.149-.243.149Zm2.754-.038c-.181 0-.288-.117-.288-.318v-2.306c0-.201.107-.318.288-.318.182 0 .289.117.289.318v2.121h.977c.157 0 .262.095.262.251 0 .157-.103.252-.262.252H8.027Z", "M2 1.75C2 .784 2.783 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Z"]
    }
};
class OpXlsRelationsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = opXlsRelationsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpXlsRelationsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OpXlsRelationsIconComponent, isStandalone: true, selector: "svg[op-xls-relations-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OpXlsRelationsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[op-xls-relations-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const organizationIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 16A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0h8.5C11.216 0 12 .784 12 1.75v12.5c0 .085-.006.168-.018.25h2.268a.25.25 0 0 0 .25-.25V8.285a.25.25 0 0 0-.111-.208l-1.055-.703a.749.749 0 1 1 .832-1.248l1.055.703c.487.325.779.871.779 1.456v5.965A1.75 1.75 0 0 1 14.25 16h-3.5a.766.766 0 0 1-.197-.026c-.099.017-.2.026-.303.026h-3a.75.75 0 0 1-.75-.75V14h-1v1.25a.75.75 0 0 1-.75.75Zm-.25-1.75c0 .138.112.25.25.25H4v-1.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.25h2.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM3.75 6h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 3.75A.75.75 0 0 1 3.75 3h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 3.75Zm4 3A.75.75 0 0 1 7.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 7 6.75ZM7.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 9.75A.75.75 0 0 1 3.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 9.75ZM7.75 9h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M6.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM5.5 9.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM6.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 12.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm.75-4.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 5.75A.75.75 0 0 1 9.75 5h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 9 5.75ZM13.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm-.75-2.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM13.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z", "M2 20V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v17c0 .173-.022.34-.063.5H20a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.2-.4l-.5-.375a.75.75 0 0 1 .9-1.2l.5.375c.504.378.8.97.8 1.6v8a2 2 0 0 1-2 2h-3.562a.767.767 0 0 1-.166-.018c-.089.012-.18.018-.272.018h-3.75a.75.75 0 0 1-.75-.75V19h-3v2.25a.75.75 0 0 1-.75.75H4a2 2 0 0 1-2-2Zm2 .5h3v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v17a.5.5 0 0 0 .5.5Z"]
    }
};
class OrganizationIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = organizationIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OrganizationIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: OrganizationIconComponent, isStandalone: true, selector: "svg[organization-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: OrganizationIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[organization-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const packageIconData = {
    "16": {
        "width": 16,
        "paths": ["m8.878.392 5.25 3.045c.54.314.872.89.872 1.514v6.098a1.75 1.75 0 0 1-.872 1.514l-5.25 3.045a1.75 1.75 0 0 1-1.756 0l-5.25-3.045A1.75 1.75 0 0 1 1 11.049V4.951c0-.624.332-1.201.872-1.514L7.122.392a1.75 1.75 0 0 1 1.756 0ZM7.875 1.69l-4.63 2.685L8 7.133l4.755-2.758-4.63-2.685a.248.248 0 0 0-.25 0ZM2.5 5.677v5.372c0 .09.047.171.125.216l4.625 2.683V8.432Zm6.25 8.271 4.625-2.683a.25.25 0 0 0 .125-.216V5.677L8.75 8.432Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.876.64V.639l8.25 4.763c.541.313.875.89.875 1.515v9.525a1.75 1.75 0 0 1-.875 1.516l-8.25 4.762a1.748 1.748 0 0 1-1.75 0l-8.25-4.763a1.75 1.75 0 0 1-.875-1.515V6.917c0-.625.334-1.202.875-1.515L11.126.64a1.748 1.748 0 0 1 1.75 0Zm-1 1.298L4.251 6.34l7.75 4.474 7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0Zm.875 19.123 7.625-4.402a.25.25 0 0 0 .125-.216V7.639l-7.75 4.474ZM3.501 7.64v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z"]
    }
};
class PackageIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = packageIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PackageIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PackageIconComponent, isStandalone: true, selector: "svg[package-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PackageIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[package-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const packageDependenciesIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.122.392a1.75 1.75 0 0 1 1.756 0l5.25 3.045c.54.313.872.89.872 1.514V7.25a.75.75 0 0 1-1.5 0V5.677L7.75 8.432v6.384a1 1 0 0 1-1.502.865L.872 12.563A1.75 1.75 0 0 1 0 11.049V4.951c0-.624.332-1.2.872-1.514ZM7.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685L7 7.133l4.755-2.758ZM1.5 11.049a.25.25 0 0 0 .125.216l4.625 2.683V8.432L1.5 5.677Zm11.672-.282L11.999 12h3.251a.75.75 0 0 1 0 1.5h-3.251l1.173 1.233a.75.75 0 1 1-1.087 1.034l-2.378-2.5a.75.75 0 0 1 0-1.034l2.378-2.5a.75.75 0 0 1 1.087 1.034Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.126.64a1.748 1.748 0 0 1 1.75 0l8.25 4.762c.103.06.199.128.286.206a.75.75 0 0 1 .554.96c.023.113.035.23.035.35v3.332a.75.75 0 0 1-1.5 0V7.64l-7.75 4.474V22.36a.75.75 0 0 1-1.125.65l-8.75-5.052a1.75 1.75 0 0 1-.875-1.515V6.917c0-.119.012-.236.035-.35a.749.749 0 0 1 .554-.96c.088-.078.184-.146.286-.205L9.126.639Zm.875 10.173v.001l7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0L2.251 6.34Zm-8.5-3.175v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z", "m16.617 17.5 2.895-2.702a.75.75 0 0 0-1.024-1.096l-4.285 4a.75.75 0 0 0 0 1.096l4.285 4a.75.75 0 1 0 1.024-1.096L16.617 19h6.633a.75.75 0 0 0 0-1.5h-6.633Z"]
    }
};
class PackageDependenciesIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = packageDependenciesIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PackageDependenciesIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PackageDependenciesIconComponent, isStandalone: true, selector: "svg[package-dependencies-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PackageDependenciesIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[package-dependencies-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const packageDependentsIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.122.392a1.75 1.75 0 0 1 1.756 0l5.25 3.045c.54.313.872.89.872 1.514V7.25a.75.75 0 0 1-1.5 0V5.677L7.75 8.432v6.384a1 1 0 0 1-1.502.865L.872 12.563A1.75 1.75 0 0 1 0 11.049V4.951c0-.624.332-1.2.872-1.514ZM7.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685L7 7.133l4.755-2.758ZM1.5 11.049a.25.25 0 0 0 .125.216l4.625 2.683V8.432L1.5 5.677Zm10.828 3.684 1.173-1.233H10.25a.75.75 0 0 1 0-1.5h3.251l-1.173-1.233a.75.75 0 1 1 1.087-1.034l2.378 2.5a.75.75 0 0 1 0 1.034l-2.378 2.5a.75.75 0 0 1-1.087-1.034Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.126.64a1.748 1.748 0 0 1 1.75 0l8.25 4.762c.103.06.199.128.286.206a.75.75 0 0 1 .554.96c.023.113.035.23.035.35v3.332a.75.75 0 0 1-1.5 0V7.64l-7.75 4.474V22.36a.75.75 0 0 1-1.125.65l-8.75-5.052a1.75 1.75 0 0 1-.875-1.515V6.917c0-.119.012-.236.035-.35a.749.749 0 0 1 .554-.96c.088-.078.184-.146.286-.205L9.126.639Zm.875 10.173v.001l7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0L2.251 6.34Zm-8.5-3.175v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z", "m21.347 17.5-2.894-2.702a.75.75 0 1 1 1.023-1.096l4.286 4a.75.75 0 0 1 0 1.096l-4.286 4a.75.75 0 1 1-1.023-1.096L21.347 19h-6.633a.75.75 0 0 1 0-1.5h6.633Z"]
    }
};
class PackageDependentsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = packageDependentsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PackageDependentsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PackageDependentsIconComponent, isStandalone: true, selector: "svg[package-dependents-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PackageDependentsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[package-dependents-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const paintbrushIconData = {
    "16": {
        "width": 16,
        "paths": ["M11.134 1.535c.7-.509 1.416-.942 2.076-1.155.649-.21 1.463-.267 2.069.34.603.601.568 1.411.368 2.07-.202.668-.624 1.39-1.125 2.096-1.011 1.424-2.496 2.987-3.775 4.249-1.098 1.084-2.132 1.839-3.04 2.3a3.744 3.744 0 0 1-1.055 3.217c-.431.431-1.065.691-1.657.861-.614.177-1.294.287-1.914.357A21.151 21.151 0 0 1 .797 16H.743l.007-.75H.749L.742 16a.75.75 0 0 1-.743-.742l.743-.008-.742.007v-.054a21.25 21.25 0 0 1 .13-2.284c.067-.647.187-1.287.358-1.914.17-.591.43-1.226.86-1.657a3.746 3.746 0 0 1 3.227-1.054c.466-.893 1.225-1.907 2.314-2.982 1.271-1.255 2.833-2.75 4.245-3.777ZM1.62 13.089c-.051.464-.086.929-.104 1.395.466-.018.932-.053 1.396-.104a10.511 10.511 0 0 0 1.668-.309c.526-.151.856-.325 1.011-.48a2.25 2.25 0 1 0-3.182-3.182c-.155.155-.329.485-.48 1.01a10.515 10.515 0 0 0-.309 1.67Zm10.396-10.34c-1.224.89-2.605 2.189-3.822 3.384l1.718 1.718c1.21-1.205 2.51-2.597 3.387-3.833.47-.662.78-1.227.912-1.662.134-.444.032-.551.009-.575h-.001V1.78c-.014-.014-.113-.113-.548.027-.432.14-.995.462-1.655.942Zm-4.832 7.266-.001.001a9.859 9.859 0 0 0 1.63-1.142L7.155 7.216a9.7 9.7 0 0 0-1.161 1.607c.482.302.889.71 1.19 1.192Z"]
    }
};
class PaintbrushIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = paintbrushIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PaintbrushIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PaintbrushIconComponent, isStandalone: true, selector: "svg[paintbrush-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PaintbrushIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[paintbrush-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const paperAirplaneIconData = {
    "16": {
        "width": 16,
        "paths": ["M.989 8 .064 2.68a1.342 1.342 0 0 1 1.85-1.462l13.402 5.744a1.13 1.13 0 0 1 0 2.076L1.913 14.782a1.343 1.343 0 0 1-1.85-1.463L.99 8Zm.603-5.288L2.38 7.25h4.87a.75.75 0 0 1 0 1.5H2.38l-.788 4.538L13.929 8Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.513 1.96a1.374 1.374 0 0 1 1.499-.21l19.335 9.215a1.147 1.147 0 0 1 0 2.07L3.012 22.25a1.374 1.374 0 0 1-1.947-1.46L2.49 12 1.065 3.21a1.375 1.375 0 0 1 .448-1.25Zm2.375 10.79-1.304 8.042L21.031 12 2.584 3.208l1.304 8.042h7.362a.75.75 0 0 1 0 1.5Z"]
    }
};
class PaperAirplaneIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = paperAirplaneIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PaperAirplaneIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PaperAirplaneIconComponent, isStandalone: true, selector: "svg[paper-airplane-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PaperAirplaneIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[paper-airplane-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const paperclipIconData = {
    "16": {
        "width": 16,
        "paths": ["M12.212 3.02a1.753 1.753 0 0 0-2.478.003l-5.83 5.83a3.007 3.007 0 0 0-.88 2.127c0 .795.315 1.551.88 2.116.567.567 1.333.89 2.126.89.79 0 1.548-.321 2.116-.89l5.48-5.48a.75.75 0 0 1 1.061 1.06l-5.48 5.48a4.492 4.492 0 0 1-3.177 1.33c-1.2 0-2.345-.487-3.187-1.33a4.483 4.483 0 0 1-1.32-3.177c0-1.195.475-2.341 1.32-3.186l5.83-5.83a3.25 3.25 0 0 1 5.553 2.297c0 .863-.343 1.691-.953 2.301L7.439 12.39c-.375.377-.884.59-1.416.593a1.998 1.998 0 0 1-1.412-.593 1.992 1.992 0 0 1 0-2.828l5.48-5.48a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-5.48 5.48a.492.492 0 0 0 0 .707.499.499 0 0 0 .352.154.51.51 0 0 0 .356-.154l5.833-5.827a1.755 1.755 0 0 0 0-2.481Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M19.187 3.588a2.75 2.75 0 0 0-3.889 0L5.575 13.31a4.5 4.5 0 0 0 6.364 6.364l8.662-8.662a.75.75 0 0 1 1.061 1.06L13 20.735a6 6 0 0 1-8.485-8.485l9.723-9.723a4.247 4.247 0 0 1 4.124-1.139 4.247 4.247 0 0 1 3.025 3.025 4.247 4.247 0 0 1-1.139 4.124l-9.193 9.193a2.64 2.64 0 0 1-1.858.779 2.626 2.626 0 0 1-1.854-.779c-.196-.196-.338-.47-.43-.726a2.822 2.822 0 0 1-.168-.946c0-.7.284-1.373.775-1.864l8.132-8.131a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-8.131 8.132a1.148 1.148 0 0 0-.336.803c.003.204.053.405.146.587.01.018.018.028.02.032.22.215.501.332.786.332.29 0 .58-.121.798-.34l9.192-9.192a2.75 2.75 0 0 0 0-3.89Z"]
    }
};
class PaperclipIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = paperclipIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PaperclipIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PaperclipIconComponent, isStandalone: true, selector: "svg[paperclip-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PaperclipIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[paperclip-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const passkeyFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.743 4.757a3.757 3.757 0 1 1 5.851 3.119 5.991 5.991 0 0 1 2.15 1.383c.17.17.257.405.258.646.003.598.001 1.197 0 1.795L11 12.778v.721a.5.5 0 0 1-.5.5H1.221a.749.749 0 0 1-.714-.784 6.004 6.004 0 0 1 3.899-5.339 3.754 3.754 0 0 1-1.663-3.119Z", "M15.75 6.875c0 .874-.448 1.643-1.127 2.09a.265.265 0 0 0-.123.22v.59c0 .067-.026.13-.073.177l-.356.356a.125.125 0 0 0 0 .177l.356.356c.047.047.073.11.073.176v.231c0 .067-.026.13-.073.177l-.356.356a.125.125 0 0 0 0 .177l.356.356c.047.047.073.11.073.177v.287a.247.247 0 0 1-.065.168l-.8.88a.52.52 0 0 1-.77 0l-.8-.88a.247.247 0 0 1-.065-.168V9.185a.264.264 0 0 0-.123-.22 2.5 2.5 0 1 1 3.873-2.09ZM14 6.5a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.496 2a5.25 5.25 0 0 0-2.519 9.857A9.006 9.006 0 0 0 .5 20.228a.751.751 0 0 0 .728.772h5.257c3.338.001 6.677.002 10.015 0a.5.5 0 0 0 .5-.5v-4.669a.95.95 0 0 0-.171-.551 9.02 9.02 0 0 0-4.814-3.423A5.25 5.25 0 0 0 9.496 2Z", "M23.625 10.313c0 1.31-.672 2.464-1.691 3.134a.398.398 0 0 0-.184.33v.886a.372.372 0 0 1-.11.265l-.534.534a.188.188 0 0 0 0 .265l.534.534c.071.07.11.166.11.265v.347a.374.374 0 0 1-.11.265l-.534.534a.188.188 0 0 0 0 .265l.534.534a.37.37 0 0 1 .11.265v.431a.379.379 0 0 1-.097.253l-1.2 1.319a.781.781 0 0 1-1.156 0l-1.2-1.319a.379.379 0 0 1-.097-.253v-5.39a.398.398 0 0 0-.184-.33 3.75 3.75 0 1 1 5.809-3.134ZM21 9.75a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0Z"]
    }
};
class PasskeyFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = passkeyFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PasskeyFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PasskeyFillIconComponent, isStandalone: true, selector: "svg[passkey-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PasskeyFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[passkey-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const pasteIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.626 3.533a.249.249 0 0 0-.126.217v9.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-9.5a.249.249 0 0 0-.126-.217.75.75 0 0 1 .752-1.298c.541.313.874.89.874 1.515v9.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-9.5c0-.625.333-1.202.874-1.515a.75.75 0 0 1 .752 1.298ZM5.75 1h4.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 5 4.75v-3A.75.75 0 0 1 5.75 1Zm.75 3h3V2.5h-3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.962 2.513a.75.75 0 0 1-.475.949l-.816.272a.25.25 0 0 0-.171.237V21.25c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25V3.97a.25.25 0 0 0-.17-.236l-.817-.272a.75.75 0 0 1 .474-1.424l.816.273A1.751 1.751 0 0 1 21 3.97v17.28A1.75 1.75 0 0 1 19.25 23H4.75A1.75 1.75 0 0 1 3 21.25V3.97a1.75 1.75 0 0 1 1.197-1.66l.816-.272a.75.75 0 0 1 .949.475Z", "M7 1.75C7 .784 7.784 0 8.75 0h6.5C16.216 0 17 .784 17 1.75v1.5A1.75 1.75 0 0 1 15.25 5h-6.5A1.75 1.75 0 0 1 7 3.25Zm1.75-.25a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25Z"]
    }
};
class PasteIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = pasteIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PasteIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PasteIconComponent, isStandalone: true, selector: "svg[paste-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PasteIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[paste-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const pencilIconData = {
    "16": {
        "width": 16,
        "paths": ["M11.013 1.427a1.75 1.75 0 0 1 2.474 0l1.086 1.086a1.75 1.75 0 0 1 0 2.474l-8.61 8.61c-.21.21-.47.364-.756.445l-3.251.93a.75.75 0 0 1-.927-.928l.929-3.25c.081-.286.235-.547.445-.758l8.61-8.61Zm.176 4.823L9.75 4.81l-6.286 6.287a.253.253 0 0 0-.064.108l-.558 1.953 1.953-.558a.253.253 0 0 0 .108-.064Zm1.238-3.763a.25.25 0 0 0-.354 0L10.811 3.75l1.439 1.44 1.263-1.263a.25.25 0 0 0 0-.354Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M17.263 2.177a1.75 1.75 0 0 1 2.474 0l2.586 2.586a1.75 1.75 0 0 1 0 2.474L19.53 10.03l-.012.013L8.69 20.378a1.753 1.753 0 0 1-.699.409l-5.523 1.68a.748.748 0 0 1-.747-.188.748.748 0 0 1-.188-.747l1.673-5.5a1.75 1.75 0 0 1 .466-.756L14.476 4.963ZM4.708 16.361a.26.26 0 0 0-.067.108l-1.264 4.154 4.177-1.271a.253.253 0 0 0 .1-.059l10.273-9.806-2.94-2.939-10.279 9.813ZM19 8.44l2.263-2.262a.25.25 0 0 0 0-.354l-2.586-2.586a.25.25 0 0 0-.354 0L16.061 5.5Z"]
    }
};
class PencilIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = pencilIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PencilIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PencilIconComponent, isStandalone: true, selector: "svg[pencil-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PencilIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[pencil-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const peopleIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 5.5a3.5 3.5 0 1 1 5.898 2.549 5.508 5.508 0 0 1 3.034 4.084.75.75 0 1 1-1.482.235 4 4 0 0 0-7.9 0 .75.75 0 0 1-1.482-.236A5.507 5.507 0 0 1 3.102 8.05 3.493 3.493 0 0 1 2 5.5ZM11 4a3.001 3.001 0 0 1 2.22 5.018 5.01 5.01 0 0 1 2.56 3.012.749.749 0 0 1-.885.954.752.752 0 0 1-.549-.514 3.507 3.507 0 0 0-2.522-2.372.75.75 0 0 1-.574-.73v-.352a.75.75 0 0 1 .416-.672A1.5 1.5 0 0 0 11 5.5.75.75 0 0 1 11 4Zm-5.5-.5a2 2 0 1 0-.001 3.999A2 2 0 0 0 5.5 3.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.5 8a5.5 5.5 0 1 1 8.596 4.547 9.005 9.005 0 0 1 5.9 8.18.751.751 0 0 1-1.5.045 7.5 7.5 0 0 0-14.993 0 .75.75 0 0 1-1.499-.044 9.005 9.005 0 0 1 5.9-8.181A5.496 5.496 0 0 1 3.5 8ZM9 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm8.29 4c-.148 0-.292.01-.434.03a.75.75 0 1 1-.212-1.484 4.53 4.53 0 0 1 3.38 8.097 6.69 6.69 0 0 1 3.956 6.107.75.75 0 0 1-1.5 0 5.193 5.193 0 0 0-3.696-4.972l-.534-.16v-1.676l.41-.209A3.03 3.03 0 0 0 17.29 8Z"]
    }
};
class PeopleIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = peopleIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PeopleIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PeopleIconComponent, isStandalone: true, selector: "svg[people-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PeopleIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[people-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const personIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.561 8.073a6.005 6.005 0 0 1 3.432 5.142.75.75 0 1 1-1.498.07 4.5 4.5 0 0 0-8.99 0 .75.75 0 0 1-1.498-.07 6.004 6.004 0 0 1 3.431-5.142 3.999 3.999 0 1 1 5.123 0ZM10.5 5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 2.5a5.5 5.5 0 0 1 3.096 10.047 9.005 9.005 0 0 1 5.9 8.181.75.75 0 1 1-1.499.044 7.5 7.5 0 0 0-14.993 0 .75.75 0 0 1-1.5-.045 9.005 9.005 0 0 1 5.9-8.18A5.5 5.5 0 0 1 12 2.5ZM8 8a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z"]
    }
};
class PersonIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = personIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PersonIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PersonIconComponent, isStandalone: true, selector: "svg[person-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PersonIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[person-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const personAddIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.9 8.548h-.001a5.528 5.528 0 0 1 3.1 4.659.75.75 0 1 1-1.498.086A4.01 4.01 0 0 0 5.5 9.5a4.01 4.01 0 0 0-4.001 3.793.75.75 0 1 1-1.498-.085 5.527 5.527 0 0 1 3.1-4.66 3.5 3.5 0 1 1 4.799 0ZM13.25 0a.75.75 0 0 1 .75.75V2h1.25a.75.75 0 0 1 0 1.5H14v1.25a.75.75 0 0 1-1.5 0V3.5h-1.25a.75.75 0 0 1 0-1.5h1.25V.75a.75.75 0 0 1 .75-.75ZM5.5 4a2 2 0 1 0-.001 3.999A2 2 0 0 0 5.5 4Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4 9.5a5 5 0 1 1 7.916 4.062 7.973 7.973 0 0 1 5.018 7.166.75.75 0 1 1-1.499.044 6.469 6.469 0 0 0-12.932 0 .75.75 0 0 1-1.499-.044 7.972 7.972 0 0 1 5.059-7.181A4.994 4.994 0 0 1 4 9.5ZM9 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm10.25-5a.75.75 0 0 1 .75.75V4h2.25a.75.75 0 0 1 0 1.5H20v2.25a.75.75 0 0 1-1.5 0V5.5h-2.25a.75.75 0 0 1 0-1.5h2.25V1.75a.75.75 0 0 1 .75-.75Z"]
    }
};
class PersonAddIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = personAddIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PersonAddIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PersonAddIconComponent, isStandalone: true, selector: "svg[person-add-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PersonAddIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[person-add-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const personFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.243 4.757a3.757 3.757 0 1 1 5.851 3.119 6.006 6.006 0 0 1 3.9 5.339.75.75 0 0 1-.715.784H2.721a.75.75 0 0 1-.714-.784 6.006 6.006 0 0 1 3.9-5.34 3.753 3.753 0 0 1-1.664-3.118Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 2.5a5.25 5.25 0 0 0-2.519 9.857 9.005 9.005 0 0 0-6.477 8.37.75.75 0 0 0 .727.773H20.27a.75.75 0 0 0 .727-.772 9.005 9.005 0 0 0-6.477-8.37A5.25 5.25 0 0 0 12 2.5Z"]
    }
};
class PersonFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = personFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PersonFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PersonFillIconComponent, isStandalone: true, selector: "svg[person-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PersonFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[person-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const pinIconData = {
    "16": {
        "width": 16,
        "paths": ["m11.294.984 3.722 3.722a1.75 1.75 0 0 1-.504 2.826l-1.327.613a3.089 3.089 0 0 0-1.707 2.084l-.584 2.454c-.317 1.332-1.972 1.8-2.94.832L5.75 11.311 1.78 15.28a.749.749 0 1 1-1.06-1.06l3.969-3.97-2.204-2.204c-.968-.968-.5-2.623.832-2.94l2.454-.584a3.08 3.08 0 0 0 2.084-1.707l.613-1.327a1.75 1.75 0 0 1 2.826-.504ZM6.283 9.723l2.732 2.731a.25.25 0 0 0 .42-.119l.584-2.454a4.586 4.586 0 0 1 2.537-3.098l1.328-.613a.25.25 0 0 0 .072-.404l-3.722-3.722a.25.25 0 0 0-.404.072l-.613 1.328a4.584 4.584 0 0 1-3.098 2.537l-2.454.584a.25.25 0 0 0-.119.42l2.731 2.732Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m16.114 1.553 6.333 6.333a1.75 1.75 0 0 1-.603 2.869l-1.63.633a5.67 5.67 0 0 0-3.395 3.725l-1.131 3.959a1.75 1.75 0 0 1-2.92.757L9 16.061l-5.595 5.594a.749.749 0 1 1-1.06-1.06L7.939 15l-3.768-3.768a1.75 1.75 0 0 1 .757-2.92l3.959-1.131a5.666 5.666 0 0 0 3.725-3.395l.633-1.63a1.75 1.75 0 0 1 2.869-.603ZM5.232 10.171l8.597 8.597a.25.25 0 0 0 .417-.108l1.131-3.959A7.17 7.17 0 0 1 19.67 9.99l1.63-.634a.25.25 0 0 0 .086-.409l-6.333-6.333a.25.25 0 0 0-.409.086l-.634 1.63a7.17 7.17 0 0 1-4.711 4.293L5.34 9.754a.25.25 0 0 0-.108.417Z"]
    }
};
class PinIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = pinIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PinIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PinIconComponent, isStandalone: true, selector: "svg[pin-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PinIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[pin-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const pinSlashIconData = {
    "16": {
        "width": 16,
        "paths": ["m1.655.595 13.75 13.75q.22.219.22.53 0 .311-.22.53-.219.22-.53.22-.311 0-.53-.22L.595 1.655q-.22-.219-.22-.53 0-.311.22-.53.219-.22.53-.22.311 0 .53.22ZM.72 14.22l4.5-4.5q.219-.22.53-.22.311 0 .53.22.22.219.22.53 0 .311-.22.53l-4.5 4.5q-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53Z", "m5.424 6.146-1.759.419q-.143.034-.183.175-.04.141.064.245l5.469 5.469q.104.104.245.064.141-.04.175-.183l.359-1.509q.072-.302.337-.465.264-.163.567-.091.302.072.465.337.162.264.09.567l-.359 1.509q-.238.999-1.226 1.278-.988.28-1.714-.446L2.485 8.046q-.726-.726-.446-1.714.279-.988 1.278-1.226l1.759-.419q.303-.072.567.091.265.163.337.465.072.302-.091.567-.163.264-.465.336ZM7.47 3.47q.155-.156.247-.355l.751-1.627Q8.851.659 9.75.498q.899-.16 1.544.486l3.722 3.722q.646.645.486 1.544-.161.899-.99 1.282l-1.627.751q-.199.092-.355.247-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53.344-.345.787-.549l1.627-.751q.118-.055.141-.183.023-.128-.069-.221l-3.722-3.722q-.092-.092-.221-.069-.128.023-.183.141l-.751 1.627q-.204.443-.549.787-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2.345 20.595 8.47 14.47q.219-.22.53-.22.311 0 .53.22.22.219.22.53 0 .311-.22.53l-6.125 6.125q-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53Z", "m16.72 11.97.358-.358a6.738 6.738 0 0 1 2.326-1.518l1.896-.738a.25.25 0 0 0 .086-.409l-6.333-6.333a.25.25 0 0 0-.409.086l-.521 1.34a8.663 8.663 0 0 1-2.243 3.265.75.75 0 0 1-1.01-1.11 7.132 7.132 0 0 0 1.854-2.699l.521-1.34a1.75 1.75 0 0 1 2.869-.603l6.333 6.333a1.75 1.75 0 0 1-.603 2.869l-1.896.737a5.26 5.26 0 0 0-1.81 1.18l-.358.358a.749.749 0 1 1-1.06-1.06Zm-12.549-.738a1.75 1.75 0 0 1 .757-2.92l3.366-.962.412 1.443-3.366.961a.25.25 0 0 0-.108.417l8.597 8.597a.25.25 0 0 0 .417-.108l.961-3.366 1.443.412-.962 3.366a1.75 1.75 0 0 1-2.92.757Z", "m3.405 2.095 18.75 18.75q.22.219.22.53 0 .311-.22.53-.219.22-.53.22-.311 0-.53-.22L2.345 3.155q-.22-.219-.22-.53 0-.311.22-.53.219-.22.53-.22.311 0 .53.22Z"]
    }
};
class PinSlashIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = pinSlashIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PinSlashIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PinSlashIconComponent, isStandalone: true, selector: "svg[pin-slash-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PinSlashIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[pin-slash-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const pivotColumnIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.217 0 16 .784 16 1.75v5.5a.75.75 0 0 1-1.5 0V6.5h-8v8h.75a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 0 14.25ZM1.5 6.5v7.75c0 .138.112.25.25.25H5v-8Zm5-1.5h8V1.75a.25.25 0 0 0-.25-.25H6.5ZM5 5V1.5H1.75a.25.25 0 0 0-.25.25V5Z", "m11.017 9.89-2.882 2.677a.249.249 0 0 0 0 .366l2.882 2.677a.25.25 0 0 0 .421-.183V13.5H12.5A3.5 3.5 0 0 0 16 10a.75.75 0 0 0-1.5 0 2 2 0 0 1-2 2h-1.062v-1.927a.25.25 0 0 0-.421-.183Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 3.75C2 2.783 2.783 2 3.75 2h16.5c.966 0 1.75.783 1.75 1.75V10a.75.75 0 0 1-1.5 0V8.75H8.75V20.5H10a.75.75 0 0 1 0 1.5H3.75A1.75 1.75 0 0 1 2 20.25Zm6.75-.25v3.75H20.5v-3.5a.25.25 0 0 0-.25-.25Zm-1.5 17V8.75H3.5v11.5c0 .138.112.25.25.25ZM3.5 7.25h3.75V3.5h-3.5a.25.25 0 0 0-.25.25Z", "M21.25 12.312a.75.75 0 0 1 .75.75v2.626a3.75 3.75 0 0 1-3.75 3.75h-3.502l2.032 2.032a.749.749 0 1 1-1.06 1.06l-3.25-3.25a.749.749 0 0 1 0-1.06l3.25-3.25a.749.749 0 1 1 1.06 1.06l-1.907 1.908h3.377a2.25 2.25 0 0 0 2.25-2.25v-2.626a.75.75 0 0 1 .75-.75Z"]
    }
};
class PivotColumnIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = pivotColumnIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PivotColumnIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PivotColumnIconComponent, isStandalone: true, selector: "svg[pivot-column-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PivotColumnIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[pivot-column-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const playIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm4.879-2.773 4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559A.25.25 0 0 1 6 10.559V5.442a.25.25 0 0 1 .379-.215Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.5 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842l-5.576 3.584a.5.5 0 0 1-.77-.42Z", "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z"]
    }
};
class PlayIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = playIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PlayIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PlayIconComponent, isStandalone: true, selector: "svg[play-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PlayIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[play-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const plugIconData = {
    "16": {
        "width": 16,
        "paths": ["M4 8H2.5a1 1 0 0 0-1 1v5.25a.75.75 0 0 1-1.5 0V9a2.5 2.5 0 0 1 2.5-2.5H4V5.133a1.75 1.75 0 0 1 1.533-1.737l2.831-.353.76-.913c.332-.4.825-.63 1.344-.63h.782c.966 0 1.75.784 1.75 1.75V4h2.25a.75.75 0 0 1 0 1.5H13v4h2.25a.75.75 0 0 1 0 1.5H13v.75a1.75 1.75 0 0 1-1.75 1.75h-.782c-.519 0-1.012-.23-1.344-.63l-.761-.912-2.83-.354A1.75 1.75 0 0 1 4 9.867Zm6.276-4.91-.95 1.14a.753.753 0 0 1-.483.265l-3.124.39a.25.25 0 0 0-.219.248v4.734c0 .126.094.233.219.249l3.124.39a.752.752 0 0 1 .483.264l.95 1.14a.25.25 0 0 0 .192.09h.782a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-.782a.25.25 0 0 0-.192.09Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7 11.5H2.938c-.794 0-1.438.644-1.438 1.437v8.313a.75.75 0 0 1-1.5 0v-8.312A2.939 2.939 0 0 1 2.937 10H7V6.151c0-.897.678-1.648 1.57-1.74l6.055-.626 1.006-1.174A1.752 1.752 0 0 1 16.96 2h1.29c.966 0 1.75.784 1.75 1.75V6h3.25a.75.75 0 0 1 0 1.5H20V14h3.25a.75.75 0 0 1 0 1.5H20v2.25a1.75 1.75 0 0 1-1.75 1.75h-1.29a1.75 1.75 0 0 1-1.329-.611l-1.006-1.174-6.055-.627A1.749 1.749 0 0 1 7 15.348Zm9.77-7.913v.001l-1.201 1.4a.75.75 0 0 1-.492.258l-6.353.657a.25.25 0 0 0-.224.249v9.196a.25.25 0 0 0 .224.249l6.353.657c.191.02.368.112.493.258l1.2 1.401a.252.252 0 0 0 .19.087h1.29a.25.25 0 0 0 .25-.25v-14a.25.25 0 0 0-.25-.25h-1.29a.252.252 0 0 0-.19.087Z"]
    }
};
class PlugIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = plugIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PlugIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PlugIconComponent, isStandalone: true, selector: "svg[plug-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PlugIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[plug-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const plusIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.75 4.5a.75.75 0 0 1 .75.75V11h5.75a.75.75 0 0 1 0 1.5H12.5v5.75a.75.75 0 0 1-1.5 0V12.5H5.25a.75.75 0 0 1 0-1.5H11V5.25a.75.75 0 0 1 .75-.75Z"]
    }
};
class PlusIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = plusIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PlusIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PlusIconComponent, isStandalone: true, selector: "svg[plus-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PlusIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[plus-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const plusCircleIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm7.25-3.25v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5a.75.75 0 0 1 1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.75 7.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class PlusCircleIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = plusCircleIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PlusCircleIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PlusCircleIconComponent, isStandalone: true, selector: "svg[plus-circle-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PlusCircleIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[plus-circle-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const projectIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25ZM11.75 3a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 .75-.75Zm-8.25.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-1.5 0ZM8 3a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.25 6a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 1.5 0v-7.5A.75.75 0 0 0 7.25 6ZM12 6a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 6Zm4 .75a.75.75 0 0 1 1.5 0v9.5a.75.75 0 0 1-1.5 0v-9.5Z", "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25Z"]
    }
};
class ProjectIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = projectIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ProjectIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ProjectIconComponent, isStandalone: true, selector: "svg[project-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ProjectIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[project-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const projectRoadmapIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.75 7a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM5 4.75A.75.75 0 0 1 5.75 4h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 4.75ZM6.75 10a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z", "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.75 7a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5ZM7 11.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM9.75 15a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z", "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class ProjectRoadmapIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = projectRoadmapIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ProjectRoadmapIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ProjectRoadmapIconComponent, isStandalone: true, selector: "svg[project-roadmap-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ProjectRoadmapIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[project-roadmap-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const projectSymlinkIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16h-8.5a.75.75 0 0 1 0-1.5h8.5a.25.25 0 0 0 .25-.25V6.5h-13v1.75a.75.75 0 0 1-1.5 0ZM6.5 5h8V1.75a.25.25 0 0 0-.25-.25H6.5Zm-5 0H5V1.5H1.75a.25.25 0 0 0-.25.25Z", "M1.5 13.737a2.25 2.25 0 0 1 2.262-2.25L4 11.49v1.938c0 .218.26.331.42.183l2.883-2.677a.25.25 0 0 0 0-.366L4.42 7.89a.25.25 0 0 0-.42.183V9.99l-.23-.001A3.75 3.75 0 0 0 0 13.738v1.012a.75.75 0 0 0 1.5 0v-1.013Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H9.75a.75.75 0 0 1 0-1.5h10.5a.25.25 0 0 0 .25-.25V9h-17v3A.75.75 0 0 1 2 12ZM9 7.5h11.5V3.75a.25.25 0 0 0-.25-.25H9Zm-5.5 0h4v-4H3.75a.25.25 0 0 0-.25.25Z", "m9.308 14.5-2.104-2.236a.75.75 0 1 1 1.092-1.028l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.75.75 0 1 1-1.092-1.028L9.308 16H6.09a2.59 2.59 0 0 0-2.59 2.59v2.66a.75.75 0 0 1-1.5 0v-2.66a4.09 4.09 0 0 1 4.09-4.09h3.218Z"]
    }
};
class ProjectSymlinkIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = projectSymlinkIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ProjectSymlinkIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ProjectSymlinkIconComponent, isStandalone: true, selector: "svg[project-symlink-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ProjectSymlinkIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[project-symlink-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const projectTemplateIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 1.75v1.562a.75.75 0 1 1-1.5 0V1.75C0 .784.784 0 1.75 0h1.562a.75.75 0 1 1 0 1.5H1.75a.25.25 0 0 0-.25.25ZM6.438 0h3.124a.75.75 0 1 1 0 1.5H6.438a.75.75 0 1 1 0-1.5Zm6.25 0h1.562C15.217 0 16 .784 16 1.75v1.562a.75.75 0 1 1-1.5 0V1.75a.25.25 0 0 0-.25-.25h-1.562a.75.75 0 1 1 0-1.5ZM1.5 6.438v3.124a.75.75 0 1 1-1.5 0V6.438a.75.75 0 1 1 1.5 0Zm14.5 0v3.124a.75.75 0 1 1-1.5 0V6.438a.75.75 0 1 1 1.5 0Zm-14.5 6.25v1.562c0 .138.112.25.25.25h1.562a.75.75 0 1 1 0 1.5H1.75A1.75 1.75 0 0 1 0 14.25v-1.562a.75.75 0 1 1 1.5 0Zm14.5 0v1.562A1.75 1.75 0 0 1 14.25 16h-1.562a.75.75 0 1 1 0-1.5h1.562a.25.25 0 0 0 .25-.25v-1.562a.75.75 0 1 1 1.5 0ZM6.438 14.5h3.124a.75.75 0 1 1 0 1.5H6.438a.75.75 0 1 1 0-1.5ZM6.5 3v1A.75.75 0 0 1 5 4V3a.75.75 0 0 1 1.5 0ZM2.25 5.75A.75.75 0 0 1 3 5h1a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm4.5 0A.75.75 0 0 1 7.5 5h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm-1 1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm.75 4v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0Zm3.5-5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.75 3.5a.25.25 0 0 0-.25.25v2.062a.75.75 0 1 1-1.5 0V3.75C2 2.783 2.783 2 3.75 2h2.062a.75.75 0 1 1 0 1.5Zm13.688-.75a.75.75 0 0 1 .75-.75h2.062c.966 0 1.75.783 1.75 1.75v2.062a.75.75 0 1 1-1.5 0V3.75a.25.25 0 0 0-.25-.25h-2.062a.75.75 0 0 1-.75-.75ZM2.75 17.438a.75.75 0 0 1 .75.75v2.062c0 .138.112.25.25.25h2.062a.75.75 0 1 1 0 1.5H3.75A1.75 1.75 0 0 1 2 20.25v-2.062a.75.75 0 0 1 .75-.75Zm18.5 0a.75.75 0 0 1 .75.75v2.062A1.75 1.75 0 0 1 20.25 22h-2.062a.75.75 0 1 1 0-1.5h2.062a.25.25 0 0 0 .25-.25v-2.062a.75.75 0 0 1 .75-.75Zm-18.5-8.25a.75.75 0 0 1 .75.75v4.124a.75.75 0 1 1-1.5 0V9.938a.75.75 0 0 1 .75-.75ZM9.188 2.75a.75.75 0 0 1 .75-.75h4.124a.75.75 0 1 1 0 1.5H9.938a.75.75 0 0 1-.75-.75Zm0 18.5a.75.75 0 0 1 .75-.75h4.124a.75.75 0 1 1 0 1.5H9.938a.75.75 0 0 1-.75-.75ZM21.25 9.188a.75.75 0 0 1 .75.75v4.124a.75.75 0 1 1-1.5 0V9.938a.75.75 0 0 1 .75-.75ZM3.75 8.25a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Zm5.5 0A.75.75 0 0 1 10 7.5h2A.75.75 0 0 1 12 9h-2a.75.75 0 0 1-.75-.75Zm-1-4.5A.75.75 0 0 1 9 4.5v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm0 5.5A.75.75 0 0 1 9 10v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm0 4.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75ZM14 8.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z"]
    }
};
class ProjectTemplateIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = projectTemplateIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ProjectTemplateIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ProjectTemplateIconComponent, isStandalone: true, selector: "svg[project-template-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ProjectTemplateIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[project-template-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const pulseIconData = {
    "16": {
        "width": 16,
        "paths": ["M6 2c.306 0 .582.187.696.471L10 10.731l1.304-3.26A.751.751 0 0 1 12 7h3.25a.75.75 0 0 1 0 1.5h-2.742l-1.812 4.528a.751.751 0 0 1-1.392 0L6 4.77 4.696 8.03A.75.75 0 0 1 4 8.5H.75a.75.75 0 0 1 0-1.5h2.742l1.812-4.529A.751.751 0 0 1 6 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.002 2.5a.75.75 0 0 1 .691.464l6.302 15.305 2.56-6.301a.75.75 0 0 1 .695-.468h4a.75.75 0 0 1 0 1.5h-3.495l-3.06 7.532a.75.75 0 0 1-1.389.004L8.997 5.21l-3.054 7.329A.75.75 0 0 1 5.25 13H.75a.75.75 0 0 1 0-1.5h4l3.558-8.538a.75.75 0 0 1 .694-.462Z"]
    }
};
class PulseIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = pulseIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PulseIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: PulseIconComponent, isStandalone: true, selector: "svg[pulse-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: PulseIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[pulse-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const questionIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.92 6.085h.001a.749.749 0 1 1-1.342-.67c.169-.339.436-.701.849-.977C6.845 4.16 7.369 4 8 4a2.756 2.756 0 0 1 1.637.525c.503.377.863.965.863 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 0 0-.26.16.952.952 0 0 0-.276.245.75.75 0 0 1-1.248-.832c.184-.264.42-.489.692-.661.103-.067.207-.132.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 0 0 .277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 0 0-.262-.525A1.27 1.27 0 0 0 8 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 0 0-.34.398ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.97 8.265a1.45 1.45 0 0 0-.487.57.75.75 0 0 1-1.341-.67c.2-.402.513-.826.997-1.148C10.627 6.69 11.244 6.5 12 6.5c.658 0 1.369.195 1.934.619a2.45 2.45 0 0 1 1.004 2.006c0 1.033-.513 1.72-1.027 2.215-.19.183-.399.358-.579.508l-.147.123a4.329 4.329 0 0 0-.435.409v1.37a.75.75 0 1 1-1.5 0v-1.473c0-.237.067-.504.247-.736.22-.28.486-.517.718-.714l.183-.153.001-.001c.172-.143.324-.27.47-.412.368-.355.569-.676.569-1.136a.953.953 0 0 0-.404-.806C12.766 8.118 12.384 8 12 8c-.494 0-.814.121-1.03.265ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class QuestionIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = questionIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: QuestionIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: QuestionIconComponent, isStandalone: true, selector: "svg[question-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: QuestionIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[question-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const quoteIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 2.5h10.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5Zm4 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM2.5 7.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 6.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.25Zm5 6.063a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75Zm0 5.937a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75ZM3.75 11a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Z"]
    }
};
class QuoteIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = quoteIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: QuoteIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: QuoteIconComponent, isStandalone: true, selector: "svg[quote-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: QuoteIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[quote-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const readIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.115.65a1.752 1.752 0 0 1 1.77 0l6.25 3.663c.536.314.865.889.865 1.51v6.427A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25V5.823c0-.621.33-1.196.865-1.51Zm1.011 1.293a.252.252 0 0 0-.252 0l-5.72 3.353L6.468 7.76a2.748 2.748 0 0 1 3.066 0l4.312-2.464-5.719-3.353ZM13.15 12.5 8.772 9.06a1.25 1.25 0 0 0-1.544 0L2.85 12.5Zm1.35-5.85-3.687 2.106 3.687 2.897ZM5.187 8.756 1.5 6.65v5.003Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.89 1.767a2.252 2.252 0 0 1 2.22 0l9.75 5.525A2.25 2.25 0 0 1 24 9.249v9.501A2.25 2.25 0 0 1 21.75 21H2.25A2.25 2.25 0 0 1 0 18.75v-9.5c0-.81.435-1.558 1.14-1.958Zm1.48 1.305a.75.75 0 0 0-.74 0l-9.316 5.28 7.41 4.233a3.75 3.75 0 0 1 4.553 0l7.41-4.234-9.317-5.28ZM20.65 19.5l-7.26-5.704a2.25 2.25 0 0 0-2.78 0L3.35 19.5Zm1.85-9.886-6.95 3.971 6.663 5.236c.089.07.161.159.21.26a.745.745 0 0 0 .077-.331ZM8.45 13.585 1.5 9.614v9.136c0 .119.028.23.076.33a.744.744 0 0 1 .21-.259Z"]
    }
};
class ReadIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = readIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ReadIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ReadIconComponent, isStandalone: true, selector: "svg[read-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ReadIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[read-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const redoIconData = {
    "16": {
        "width": 16,
        "paths": ["M14.78 6.28a.749.749 0 0 0 0-1.06l-3.5-3.5a.749.749 0 1 0-1.06 1.06L12.439 5H5.251l-.001.007L5.251 5a.8.8 0 0 0-.171.019A4.501 4.501 0 0 0 5.5 14h1.704a.75.75 0 0 0 0-1.5H5.5a3 3 0 1 1 0-6h6.939L10.22 8.72a.749.749 0 1 0 1.06 1.06l3.5-3.5Z"]
    }
};
class RedoIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = redoIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RedoIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RedoIconComponent, isStandalone: true, selector: "svg[redo-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RedoIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[redo-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const relFilePathIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.94 3.045a.75.75 0 0 0-1.38-.59l-4.5 10.5a.75.75 0 1 0 1.38.59l4.5-10.5ZM5 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M19.564 4.42a.75.75 0 0 0-1.378-.59l-6.75 15.75a.75.75 0 0 0 1.378.59l6.75-15.75ZM7 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"]
    }
};
class RelFilePathIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = relFilePathIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RelFilePathIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RelFilePathIconComponent, isStandalone: true, selector: "svg[rel-file-path-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RelFilePathIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[rel-file-path-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const replyIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.78 1.97a.75.75 0 0 1 0 1.06L3.81 6h6.44A4.75 4.75 0 0 1 15 10.75v2.5a.75.75 0 0 1-1.5 0v-2.5a3.25 3.25 0 0 0-3.25-3.25H3.81l2.97 2.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L1.47 7.28a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.53 5.03a.75.75 0 1 0-1.06-1.06l-6.25 6.25a.75.75 0 0 0 0 1.06l6.25 6.25a.75.75 0 1 0 1.06-1.06L5.56 11.5H17a3.248 3.248 0 0 1 3.25 3.248v4.502a.75.75 0 0 0 1.5 0v-4.502A4.748 4.748 0 0 0 17 10H5.56l4.97-4.97Z"]
    }
};
class ReplyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = replyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ReplyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ReplyIconComponent, isStandalone: true, selector: "svg[reply-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ReplyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[reply-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const repoIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 2.75A2.75 2.75 0 0 1 5.75 0h14.5a.75.75 0 0 1 .75.75v20.5a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h5.25v-4H6A1.5 1.5 0 0 0 4.5 18v.75c0 .716.43 1.334 1.05 1.605a.75.75 0 0 1-.6 1.374A3.251 3.251 0 0 1 3 18.75ZM19.5 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.651A2.989 2.989 0 0 1 6 15h13.5Z", "M7 18.25a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5.01a.25.25 0 0 1-.397.201l-2.206-1.604a.25.25 0 0 0-.294 0L7.397 23.46a.25.25 0 0 1-.397-.2v-5.01Z"]
    }
};
class RepoIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = repoIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RepoIconComponent, isStandalone: true, selector: "svg[repo-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[repo-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const repoCloneIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.5 0A2.5 2.5 0 0 0 1 2.5v9A2.5 2.5 0 0 0 3.5 14h2.75a.75.75 0 0 0 0-1.5H3.5a1 1 0 0 1 0-2h2.75a.75.75 0 0 0 0-1.5H3.5c-.356 0-.694.074-1 .208V2.5a1 1 0 0 1 1-1h8v2.75a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-.75-.75H3.5Z", "M8 8.058C8 7.023 8.75 6 9.887 6h5.363a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-.75.75h-5A2.25 2.25 0 0 1 8 13.75Zm6.5 3.442v-4H9.887c-.07 0-.156.031-.238.125a.663.663 0 0 0-.149.433v3.57c.235-.083.487-.128.75-.128Zm-5 2.25c0 .414.336.75.75.75h4.25V13h-4.25a.75.75 0 0 0-.75.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.375.375a2.5 2.5 0 0 0-2.5 2.5v15.25a2.5 2.5 0 0 0 2.5 2.5h5.187a.75.75 0 1 0 0-1.5H4.375a1 1 0 0 1-1-1v-1.75a1 1 0 0 1 1-1h5.687a.75.75 0 1 0 0-1.5H4.375c-.356 0-.694.074-1 .208V2.875a1 1 0 0 1 1-1h13.25v5.25a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-.75-.75h-14Z", "M12.375 12.087c0-1.396 1.005-2.712 2.456-2.712h8.044a.75.75 0 0 1 .75.75v12.75a.75.75 0 0 1-.75.75h-7.5a3 3 0 0 1-3-3Zm9.75 5.538v-6.75h-7.294c-.433 0-.956.441-.956 1.212v5.939a2.989 2.989 0 0 1 1.5-.401Zm-8.25 3a1.5 1.5 0 0 0 1.5 1.5h6.75v-3h-6.75a1.5 1.5 0 0 0-1.5 1.5Z"]
    }
};
class RepoCloneIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = repoCloneIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoCloneIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RepoCloneIconComponent, isStandalone: true, selector: "svg[repo-clone-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoCloneIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[repo-clone-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const repoDeletedIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 2.5A2.5 2.5 0 0 1 3.5 0h8.75a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.492 2.492 0 0 1 3.5 9h4.75a.75.75 0 0 1 0 1.5H3.5a1 1 0 1 0 0 2h4.75a.75.75 0 0 1 0 1.5H3.5A2.5 2.5 0 0 1 1 11.5v-9Z", "M11.28 10.22a.75.75 0 1 0-1.06 1.06L11.94 13l-1.72 1.72a.75.75 0 1 0 1.06 1.06L13 14.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L14.06 13l1.72-1.72a.75.75 0 1 0-1.06-1.06L13 11.94l-1.72-1.72Z"]
    }
};
class RepoDeletedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = repoDeletedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoDeletedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RepoDeletedIconComponent, isStandalone: true, selector: "svg[repo-deleted-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoDeletedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[repo-deleted-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const repoForkedIconData = {
    "16": {
        "width": 16,
        "paths": ["M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-.878a2.25 2.25 0 1 1 1.5 0v.878a2.25 2.25 0 0 1-2.25 2.25h-1.5v2.128a2.251 2.251 0 1 1-1.5 0V8.5h-1.5A2.25 2.25 0 0 1 3.5 6.25v-.878a2.25 2.25 0 1 1 1.5 0ZM5 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-3 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.75 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM15 4.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-12.5 0a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5ZM12 21a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 12 21Zm6.25-14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 6.5Z", "M6.5 7.75v1A2.25 2.25 0 0 0 8.75 11h6.5a2.25 2.25 0 0 0 2.25-2.25v-1H19v1a3.75 3.75 0 0 1-3.75 3.75h-6.5A3.75 3.75 0 0 1 5 8.75v-1Z", "M11.25 16.25v-5h1.5v5h-1.5Z"]
    }
};
class RepoForkedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = repoForkedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoForkedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RepoForkedIconComponent, isStandalone: true, selector: "svg[repo-forked-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoForkedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[repo-forked-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const repoLockedIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 2.5A2.5 2.5 0 0 1 3.5 0h8.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.492 2.492 0 0 1 3.5 9h2.75a.75.75 0 0 1 0 1.5H3.5a1 1 0 1 0 0 2h2.75a.75.75 0 0 1 0 1.5H3.5A2.5 2.5 0 0 1 1 11.5v-9Z", "M9 10.168V9a3 3 0 1 1 6 0v1.168c.591.281 1 .884 1 1.582v2.5A1.75 1.75 0 0 1 14.25 16h-4.5A1.75 1.75 0 0 1 8 14.25v-2.5c0-.698.409-1.3 1-1.582ZM13.5 10V9a1.5 1.5 0 0 0-3 0v1Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 2.75A2.75 2.75 0 0 1 4.75 0h14.5a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V1.5H4.75c-.69 0-1.25.56-1.25 1.25v12.651A2.987 2.987 0 0 1 5 15h6.25a.75.75 0 0 1 0 1.5H5A1.5 1.5 0 0 0 3.5 18v1.25c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5h-6A2.75 2.75 0 0 1 2 19.25V2.75Z", "M15 14.5a3.5 3.5 0 1 1 7 0V16h.25c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 22.25 24h-7.5A1.75 1.75 0 0 1 13 22.25v-4.5c0-.966.784-1.75 1.75-1.75H15Zm3.5-2a2 2 0 0 0-2 2V16h4v-1.5a2 2 0 0 0-2-2Z"]
    }
};
class RepoLockedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = repoLockedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoLockedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RepoLockedIconComponent, isStandalone: true, selector: "svg[repo-locked-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoLockedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[repo-locked-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const repoPullIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 2.5A2.5 2.5 0 0 1 3.5 0h8.75a.75.75 0 0 1 .75.75V6a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 3.5 9h3a.75.75 0 0 1 0 1.5h-3a1 1 0 0 0 0 2h3a.75.75 0 0 1 0 1.5h-3A2.5 2.5 0 0 1 1 11.5v-9Z", "M12.21 13.479a.75.75 0 1 0 1.061 1.061l2.504-2.505a.75.75 0 0 0 0-1.061L13.271 8.47a.75.75 0 0 0-1.061 1.06l1.224 1.225H8.75a.75.75 0 1 0 0 1.5h4.685l-1.225 1.224Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.875 2.875a2.5 2.5 0 0 1 2.5-2.5h14a.75.75 0 0 1 .75.75v9.125a.75.75 0 0 1-1.5 0V1.875H4.375a1 1 0 0 0-1 1v11.208a2.486 2.486 0 0 1 1-.208h5.937a.75.75 0 1 1 0 1.5H4.375a1 1 0 0 0-1 1v1.75a1 1 0 0 0 1 1h6a.75.75 0 0 1 0 1.5h-6a2.5 2.5 0 0 1-2.5-2.5V2.875Z", "M18.643 20.484a.749.749 0 1 0 1.061 1.06l3.757-3.757a.75.75 0 0 0 0-1.06l-3.757-3.757a.75.75 0 0 0-1.061 1.06l2.476 2.477H13a.75.75 0 0 0 0 1.5h8.12l-2.477 2.477Z"]
    }
};
class RepoPullIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = repoPullIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoPullIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RepoPullIconComponent, isStandalone: true, selector: "svg[repo-pull-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoPullIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[repo-pull-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const repoPushIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 2.5A2.5 2.5 0 0 1 3.5 0h8.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.493 2.493 0 0 1 3.5 9h3.25a.75.75 0 0 1 0 1.5H3.5a1 1 0 0 0 0 2h5.75a.75.75 0 0 1 0 1.5H3.5A2.5 2.5 0 0 1 1 11.5Zm13.23 7.79h-.001l-1.224-1.224v6.184a.75.75 0 0 1-1.5 0V9.066L10.28 10.29a.75.75 0 0 1-1.06-1.061l2.505-2.504a.75.75 0 0 1 1.06 0L15.29 9.23a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4.75 0A2.75 2.75 0 0 0 2 2.75v16.5A2.75 2.75 0 0 0 4.75 22h11a.75.75 0 0 0 0-1.5h-11c-.69 0-1.25-.56-1.25-1.25V18A1.5 1.5 0 0 1 5 16.5h7.25a.75.75 0 0 0 0-1.5H5c-.546 0-1.059.146-1.5.401V2.75c0-.69.56-1.25 1.25-1.25H18.5v7a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-.75-.75H4.75Z", "m20 13.903 2.202 2.359a.75.75 0 0 0 1.096-1.024l-3.5-3.75a.75.75 0 0 0-1.096 0l-3.5 3.75a.75.75 0 1 0 1.096 1.024l2.202-2.36v9.348a.75.75 0 0 0 1.5 0v-9.347Z"]
    }
};
class RepoPushIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = repoPushIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoPushIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RepoPushIconComponent, isStandalone: true, selector: "svg[repo-push-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoPushIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[repo-push-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const repoTemplateIconData = {
    "16": {
        "width": 16,
        "paths": ["M13.25 8a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-.75a.75.75 0 0 1 0-1.5h.75v-.25a.75.75 0 0 1 .75-.75ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2ZM2.75 8a.75.75 0 0 1 .75.75v.268c.083-.012.166-.018.25-.018h.5a.75.75 0 0 1 0 1.5h-.5a.25.25 0 0 0-.25.25v.75c0 .28.114.532.3.714a.75.75 0 1 1-1.05 1.072A2.495 2.495 0 0 1 2 11.5V8.75A.75.75 0 0 1 2.75 8ZM11 .75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V1.5h-.75A.75.75 0 0 1 11 .75Zm-5 0A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 .75Zm0 9A.75.75 0 0 1 6.75 9h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 9.75ZM4.992.662a.75.75 0 0 1-.636.848c-.436.063-.783.41-.846.846a.751.751 0 0 1-1.485-.212A2.501 2.501 0 0 1 4.144.025a.75.75 0 0 1 .848.637ZM2.75 4a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 2.75 4Zm10.5 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.75 0A2.75 2.75 0 0 0 3 2.75v1a.75.75 0 0 0 1.5 0v-1c0-.69.56-1.25 1.25-1.25h1a.75.75 0 0 0 0-1.5h-1Zm4 0a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm7.5 0a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75h-3ZM4.5 6.5a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V6.5Zm16.5 0a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V6.5ZM4.5 13.25a.75.75 0 0 0-1.5 0v5.5a3.25 3.25 0 0 0 1.95 2.98.75.75 0 1 0 .6-1.375A1.75 1.75 0 0 1 4.5 18.75V18A1.5 1.5 0 0 1 6 16.5h.75a.75.75 0 0 0 0-1.5H6c-.546 0-1.059.146-1.5.401V13.25Zm16.5 0a.75.75 0 0 0-1.5 0V15h-2.25a.75.75 0 0 0 0 1.5h2.25v4h-5.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 .75-.75v-8ZM9.75 15a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm-2.353 8.461A.25.25 0 0 1 7 23.26v-5.01a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5.01a.25.25 0 0 1-.397.201l-2.206-1.604a.25.25 0 0 0-.294 0L7.397 23.46Z"]
    }
};
class RepoTemplateIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = repoTemplateIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoTemplateIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RepoTemplateIconComponent, isStandalone: true, selector: "svg[repo-template-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RepoTemplateIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[repo-template-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const reportIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.586a.25.25 0 0 0-.177.073l-3.5 3.5A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.427-3.427A1.75 1.75 0 0 1 11.164 17h9.586a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25ZM12 6a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 12 6Zm0 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    }
};
class ReportIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = reportIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ReportIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ReportIconComponent, isStandalone: true, selector: "svg[report-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ReportIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[report-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const rocketIconData = {
    "16": {
        "width": 16,
        "paths": ["M14.064 0h.186C15.216 0 16 .784 16 1.75v.186a8.752 8.752 0 0 1-2.564 6.186l-.458.459c-.314.314-.641.616-.979.904v3.207c0 .608-.315 1.172-.833 1.49l-2.774 1.707a.749.749 0 0 1-1.11-.418l-.954-3.102a1.214 1.214 0 0 1-.145-.125L3.754 9.816a1.218 1.218 0 0 1-.124-.145L.528 8.717a.749.749 0 0 1-.418-1.11l1.71-2.774A1.748 1.748 0 0 1 3.31 4h3.204c.288-.338.59-.665.904-.979l.459-.458A8.749 8.749 0 0 1 14.064 0ZM8.938 3.623h-.002l-.458.458c-.76.76-1.437 1.598-2.02 2.5l-1.5 2.317 2.143 2.143 2.317-1.5c.902-.583 1.74-1.26 2.499-2.02l.459-.458a7.25 7.25 0 0 0 2.123-5.127V1.75a.25.25 0 0 0-.25-.25h-.186a7.249 7.249 0 0 0-5.125 2.123ZM3.56 14.56c-.732.732-2.334 1.045-3.005 1.148a.234.234 0 0 1-.201-.064.234.234 0 0 1-.064-.201c.103-.671.416-2.273 1.15-3.003a1.502 1.502 0 1 1 2.12 2.12Zm6.94-3.935c-.088.06-.177.118-.266.175l-2.35 1.521.548 1.783 1.949-1.2a.25.25 0 0 0 .119-.213ZM3.678 8.116 5.2 5.766c.058-.09.117-.178.176-.266H3.309a.25.25 0 0 0-.213.119l-1.2 1.95ZM12 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M20.322.75h1.176a1.75 1.75 0 0 1 1.75 1.749v1.177a10.75 10.75 0 0 1-2.925 7.374l-1.228 1.304a23.699 23.699 0 0 1-1.596 1.542v5.038c0 .615-.323 1.184-.85 1.5l-4.514 2.709a.75.75 0 0 1-1.12-.488l-.963-4.572a1.305 1.305 0 0 1-.14-.129L8.04 15.96l-1.994-1.873a1.305 1.305 0 0 1-.129-.14l-4.571-.963a.75.75 0 0 1-.49-1.12l2.71-4.514c.316-.527.885-.85 1.5-.85h5.037a23.668 23.668 0 0 1 1.542-1.594l1.304-1.23A10.753 10.753 0 0 1 20.321.75Zm-6.344 4.018v-.001l-1.304 1.23a22.275 22.275 0 0 0-3.255 3.851l-2.193 3.29 1.859 1.744a.545.545 0 0 1 .034.034l1.743 1.858 3.288-2.192a22.263 22.263 0 0 0 3.854-3.257l1.228-1.303a9.251 9.251 0 0 0 2.517-6.346V2.5a.25.25 0 0 0-.25-.25h-1.177a9.252 9.252 0 0 0-6.344 2.518ZM6.5 21c-1.209 1.209-3.901 1.445-4.743 1.49a.236.236 0 0 1-.18-.067.236.236 0 0 1-.067-.18c.045-.842.281-3.534 1.49-4.743.9-.9 2.6-.9 3.5 0 .9.9.9 2.6 0 3.5Zm-.592-8.588L8.17 9.017c.23-.346.47-.685.717-1.017H5.066a.25.25 0 0 0-.214.121l-2.167 3.612ZM16 15.112c-.333.248-.672.487-1.018.718l-3.393 2.262.678 3.223 3.612-2.167a.25.25 0 0 0 .121-.214ZM17.5 8a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17.5 8Z"]
    }
};
class RocketIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = rocketIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RocketIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RocketIconComponent, isStandalone: true, selector: "svg[rocket-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RocketIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[rocket-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const rowsIconData = {
    "16": {
        "width": 16,
        "paths": ["M16 10.75v2.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-2.5C0 9.784.784 9 1.75 9h12.5c.966 0 1.75.784 1.75 1.75Zm0-8v2.5A1.75 1.75 0 0 1 14.25 7H1.75A1.75 1.75 0 0 1 0 5.25v-2.5C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75Zm-1.75-.25H1.75a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm0 8H1.75a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M22 3.75v5.5A1.75 1.75 0 0 1 20.25 11H3.75A1.75 1.75 0 0 1 2 9.25v-5.5C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75Zm0 11v5.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-5.5c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75ZM20.25 3.5H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm0 11H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Z"]
    }
};
class RowsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = rowsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RowsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RowsIconComponent, isStandalone: true, selector: "svg[rows-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RowsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[rows-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const rssIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.002 2.725a.75.75 0 0 1 .797-.699C8.79 2.42 13.58 7.21 13.974 13.201a.75.75 0 0 1-1.497.098 10.502 10.502 0 0 0-9.776-9.776.747.747 0 0 1-.7-.798ZM2.84 7.05h-.002a7.002 7.002 0 0 1 6.113 6.111.75.75 0 0 1-1.49.178 5.503 5.503 0 0 0-4.8-4.8.75.75 0 0 1 .179-1.489ZM2 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.5 3.25a.75.75 0 0 1 .75-.75C14.053 2.5 22 10.447 22 20.25a.75.75 0 0 1-1.5 0C20.5 11.275 13.225 4 4.25 4a.75.75 0 0 1-.75-.75Zm.75 6.25C10.187 9.5 15 14.313 15 20.25a.75.75 0 0 1-1.5 0A9.25 9.25 0 0 0 4.25 11a.75.75 0 0 1 0-1.5ZM3.5 19a2 2 0 1 1 3.999-.001A2 2 0 0 1 3.5 19Z"]
    }
};
class RssIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = rssIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RssIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RssIconComponent, isStandalone: true, selector: "svg[rss-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RssIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[rss-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const rubyIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.637 2.291A.748.748 0 0 1 4.23 2h7.54c.232 0 .451.107.593.291l3.48 4.5a.75.75 0 0 1-.072.999l-7.25 7a.75.75 0 0 1-1.042 0l-7.25-7a.75.75 0 0 1-.072-.999ZM4.598 3.5 1.754 7.177 8 13.207l6.246-6.03L11.402 3.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.873 3.26A.748.748 0 0 1 6.44 3h11.31c.223 0 .434.099.576.27l5 6a.75.75 0 0 1-.028.992l-10.75 11.5a.75.75 0 0 1-1.096 0l-10.75-11.5a.75.75 0 0 1-.02-1.003l5.19-6Zm.91 1.24L2.258 9.73 12 20.153l9.75-10.43L17.399 4.5Z"]
    }
};
class RubyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = rubyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RubyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: RubyIconComponent, isStandalone: true, selector: "svg[ruby-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: RubyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[ruby-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const screenFullIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 10a.75.75 0 0 1 .75.75v2.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 1 13.25v-2.5a.75.75 0 0 1 .75-.75Zm12.5 0a.75.75 0 0 1 .75.75v2.5A1.75 1.75 0 0 1 13.25 15h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 .75-.75ZM2.75 2.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0v-2.5C1 1.784 1.784 1 2.75 1h2.5a.75.75 0 0 1 0 1.5ZM10 1.75a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.75 15a.75.75 0 0 1 .75.75v3.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 3 19.25v-3.5a.75.75 0 0 1 .75-.75Zm16.5 0a.75.75 0 0 1 .75.75v3.5A1.75 1.75 0 0 1 19.25 21h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 .75-.75ZM4.75 4.5a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0v-3.5C3 3.784 3.784 3 4.75 3h3.5a.75.75 0 0 1 0 1.5ZM15 3.75a.75.75 0 0 1 .75-.75h3.5c.966 0 1.75.784 1.75 1.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1-.75-.75Z"]
    }
};
class ScreenFullIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = screenFullIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ScreenFullIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ScreenFullIconComponent, isStandalone: true, selector: "svg[screen-full-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ScreenFullIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[screen-full-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const screenNormalIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.75 1a.75.75 0 0 1 .75.75v2.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 10 4.25v-2.5a.75.75 0 0 1 .75-.75Zm-5.5 0a.75.75 0 0 1 .75.75v2.5A1.75 1.75 0 0 1 4.25 6h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25v-2.5A.75.75 0 0 1 5.25 1ZM1 10.75a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75Zm9 1c0-.966.784-1.75 1.75-1.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15.75 3a.75.75 0 0 1 .75.75v3.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 15 7.25v-3.5a.75.75 0 0 1 .75-.75Zm-7.5 0a.75.75 0 0 1 .75.75v3.5A1.75 1.75 0 0 1 7.25 9h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25v-3.5A.75.75 0 0 1 8.25 3ZM3 15.75a.75.75 0 0 1 .75-.75h3.5c.966 0 1.75.784 1.75 1.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1-.75-.75Zm12 1c0-.966.784-1.75 1.75-1.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0Z"]
    }
};
class ScreenNormalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = screenNormalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ScreenNormalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ScreenNormalIconComponent, isStandalone: true, selector: "svg[screen-normal-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ScreenNormalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[screen-normal-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const searchIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.68 11.74a6 6 0 0 1-7.922-8.982 6 6 0 0 1 8.982 7.922l3.04 3.04a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM11.5 7a4.499 4.499 0 1 0-8.997 0A4.499 4.499 0 0 0 11.5 7Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.25 2a8.25 8.25 0 0 1 6.34 13.53l5.69 5.69a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-5.69-5.69A8.25 8.25 0 1 1 10.25 2ZM3.5 10.25a6.75 6.75 0 1 0 13.5 0 6.75 6.75 0 0 0-13.5 0Z"]
    }
};
class SearchIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = searchIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SearchIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SearchIconComponent, isStandalone: true, selector: "svg[search-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SearchIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[search-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const serverIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v4c0 .372-.116.717-.314 1 .198.283.314.628.314 1v4a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 12.75v-4c0-.358.109-.707.314-1a1.739 1.739 0 0 1-.314-1v-4C0 1.784.784 1 1.75 1ZM1.5 2.75v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Zm.25 5.75a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25ZM7 4.75A.75.75 0 0 1 7.75 4h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 4.75ZM7.75 10h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM3 4.75A.75.75 0 0 1 3.75 4h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 4.75ZM3.75 10h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.75 6.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM6 7.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 7.25Zm4 9a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-3.25-.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z", "M3.25 2h17.5c.966 0 1.75.784 1.75 1.75v7c0 .372-.116.716-.314 1 .198.284.314.628.314 1v7a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75v-7c0-.358.109-.707.314-1a1.741 1.741 0 0 1-.314-1v-7C1.5 2.784 2.284 2 3.25 2Zm0 10.5a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25Zm0-1.5h17.5a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25H3.25a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25Z"]
    }
};
class ServerIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = serverIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ServerIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ServerIconComponent, isStandalone: true, selector: "svg[server-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ServerIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[server-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const shareIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.75 6.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-6.5a.25.25 0 0 0-.25-.25h-1a.75.75 0 0 1 0-1.5h1c.966 0 1.75.784 1.75 1.75v6.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-6.5C2 5.784 2.784 5 3.75 5h1a.75.75 0 0 1 0 1.5ZM7.823.177a.25.25 0 0 1 .354 0l2.896 2.896a.25.25 0 0 1-.177.427H8.75v5.75a.75.75 0 0 1-1.5 0V3.5H5.104a.25.25 0 0 1-.177-.427Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.5 9.75v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V9.75a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1 0-1.5h2.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25V9.75C4 8.784 4.784 8 5.75 8h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25Zm7.03-8.53 3.25 3.25a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-1.97-1.97v10.69a.75.75 0 0 1-1.5 0V3.56L9.28 5.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25a.75.75 0 0 1 1.06 0Z"]
    }
};
class ShareIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = shareIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShareIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ShareIconComponent, isStandalone: true, selector: "svg[share-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShareIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[share-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const shareAndroidIconData = {
    "16": {
        "width": 16,
        "paths": ["M15 3a3 3 0 0 1-5.175 2.066l-3.92 2.179a2.994 2.994 0 0 1 0 1.51l3.92 2.179a3 3 0 1 1-.73 1.31l-3.92-2.178a3 3 0 1 1 0-4.133l3.92-2.178A3 3 0 1 1 15 3Zm-1.5 10a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 13.5 13Zm-9-5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 4.5 8Zm9-5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 13.5 3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M20 5.5a3.498 3.498 0 0 1-6.062 2.385l-5.112 3.021a3.498 3.498 0 0 1 0 2.188l5.112 3.021a3.5 3.5 0 1 1-.764 1.29l-5.112-3.02a3.499 3.499 0 1 1-3.843-5.642 3.499 3.499 0 0 1 3.843.872l5.112-3.021A3.5 3.5 0 1 1 20 5.5Zm-1.5 13a2 2 0 1 0-3.999-.001 2 2 0 0 0 3.999.001Zm0-13a2 2 0 1 0-3.999-.001A2 2 0 0 0 18.5 5.5ZM5.5 14a2 2 0 1 0 .001-3.999A2 2 0 0 0 5.5 14Z"]
    }
};
class ShareAndroidIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = shareAndroidIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShareAndroidIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ShareAndroidIconComponent, isStandalone: true, selector: "svg[share-android-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShareAndroidIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[share-android-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const shieldIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.467.133a1.748 1.748 0 0 1 1.066 0l5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667Zm.61 1.429a.25.25 0 0 0-.153 0l-5.25 1.68a.25.25 0 0 0-.174.238V7c0 1.358.275 2.666 1.057 3.86.784 1.194 2.121 2.34 4.366 3.297a.196.196 0 0 0 .154 0c2.245-.956 3.582-2.104 4.366-3.298C13.225 9.666 13.5 8.36 13.5 7V3.48a.251.251 0 0 0-.174-.237l-5.25-1.68ZM8.75 4.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 1.5 0ZM9 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M13 15.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.25-8.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z", "M11.46.637a1.748 1.748 0 0 1 1.08 0l8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.77 10.705-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.771 20.704 2 16.19 2 10V4.976c0-.76.49-1.43 1.21-1.664Zm.617 1.426a.253.253 0 0 0-.154 0L3.673 4.74a.25.25 0 0 0-.173.237V10c0 5.461 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.46 20.5 10V4.976a.25.25 0 0 0-.173-.237Z"]
    }
};
class ShieldIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = shieldIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ShieldIconComponent, isStandalone: true, selector: "svg[shield-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[shield-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const shieldCheckIconData = {
    "16": {
        "width": 16,
        "paths": ["m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM11.28 6.28l-3.5 3.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l.97.97 2.97-2.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16.53 9.78a.75.75 0 0 0-1.06-1.06L11 13.19l-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5-5Z", "m12.54.637 8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.771 10.704-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.77 20.705 2 16.19 2 10V4.976c0-.758.489-1.43 1.21-1.664L11.46.637a1.748 1.748 0 0 1 1.08 0Zm-.617 1.426-8.25 2.676a.249.249 0 0 0-.173.237V10c0 5.46 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.461 20.5 10V4.976a.25.25 0 0 0-.173-.237l-8.25-2.676a.253.253 0 0 0-.154 0Z"]
    }
};
class ShieldCheckIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = shieldCheckIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldCheckIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ShieldCheckIconComponent, isStandalone: true, selector: "svg[shield-check-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldCheckIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[shield-check-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const shieldLockIconData = {
    "16": {
        "width": 16,
        "paths": ["m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM9.5 6.5c0 .536-.286 1.032-.75 1.3v2.45a.75.75 0 0 1-1.5 0V7.8A1.5 1.5 0 1 1 9.5 6.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.46 1.137a1.748 1.748 0 0 1 1.08 0l8.25 2.675A1.75 1.75 0 0 1 22 5.476V10.5c0 6.19-3.77 10.705-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.771 21.204 2 16.69 2 10.5V5.476c0-.76.49-1.43 1.21-1.664Zm.617 1.426a.253.253 0 0 0-.154 0L3.673 5.24a.25.25 0 0 0-.173.237V10.5c0 5.461 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0c5.15-1.943 8.43-5.965 8.43-11.426V5.476a.25.25 0 0 0-.173-.237ZM13 12.232V15a1 1 0 0 1-2 0v-2.768a2 2 0 1 1 2 0Z"]
    }
};
class ShieldLockIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = shieldLockIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldLockIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ShieldLockIconComponent, isStandalone: true, selector: "svg[shield-lock-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldLockIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[shield-lock-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const shieldSlashIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.533.133a1.75 1.75 0 0 0-1.066 0l-2.091.67a.75.75 0 0 0 .457 1.428l2.09-.67a.25.25 0 0 1 .153 0l5.25 1.68a.25.25 0 0 1 .174.239V7c0 .233-.008.464-.025.694a.75.75 0 1 0 1.495.112c.02-.27.03-.538.03-.806V3.48a1.75 1.75 0 0 0-1.217-1.667L8.533.133ZM1 2.857l-.69-.5a.75.75 0 1 1 .88-1.214l14.5 10.5a.75.75 0 1 1-.88 1.214l-1.282-.928c-.995 1.397-2.553 2.624-4.864 3.608-.425.181-.905.18-1.329 0-2.447-1.042-4.049-2.356-5.032-3.855C1.32 10.182 1 8.566 1 7Zm1.5 1.086V7c0 1.358.275 2.666 1.057 3.86.784 1.194 2.121 2.34 4.366 3.297.05.02.106.02.153 0 2.127-.905 3.439-1.982 4.237-3.108Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.54 1.137a1.748 1.748 0 0 0-1.08 0L6.018 2.905a.75.75 0 1 0 .464 1.427l5.441-1.768a.239.239 0 0 1 .154 0l8.25 2.675a.249.249 0 0 1 .173.237V10.5c0 1.284-.24 2.83-.696 3.971a.75.75 0 1 0 1.392.557C21.74 13.67 22 11.927 22 10.5V5.476a1.75 1.75 0 0 0-1.21-1.664l-8.25-2.675ZM2.017 4.843l-.974-.748a.751.751 0 0 1 .914-1.19l20.5 15.75a.751.751 0 0 1-.914 1.19l-2.012-1.546-.702.852-.008.009a.07.07 0 0 1-.008.01c-1.603 1.821-3.731 3.223-6.214 4.16a1.699 1.699 0 0 1-1.198-.001C5.771 21.205 2 16.689 2 10.5V5c0-.054.006-.107.017-.157ZM3.5 5.982V10.5c0 5.461 3.281 9.483 8.431 11.426a.193.193 0 0 0 .138 0c2.283-.861 4.192-2.131 5.61-3.738l.662-.803Z"]
    }
};
class ShieldSlashIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = shieldSlashIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldSlashIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ShieldSlashIconComponent, isStandalone: true, selector: "svg[shield-slash-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldSlashIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[shield-slash-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const shieldXIconData = {
    "16": {
        "width": 16,
        "paths": ["m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM6.78 5.22 8 6.44l1.22-1.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 7.5l1.22 1.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 8.56 6.78 9.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 7.5 5.72 6.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.28 7.72a.75.75 0 0 0-1.06 1.06l2.72 2.72-2.72 2.72a.75.75 0 1 0 1.06 1.06L12 12.56l2.72 2.72a.75.75 0 1 0 1.06-1.06l-2.72-2.72 2.72-2.72a.75.75 0 0 0-1.06-1.06L12 10.44 9.28 7.72Z", "m12.54.637 8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.771 10.704-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.77 20.705 2 16.19 2 10V4.976c0-.758.489-1.43 1.21-1.664L11.46.637a1.748 1.748 0 0 1 1.08 0Zm-.617 1.426-8.25 2.676a.249.249 0 0 0-.173.237V10c0 5.46 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.461 20.5 10V4.976a.25.25 0 0 0-.173-.237l-8.25-2.676a.253.253 0 0 0-.154 0Z"]
    }
};
class ShieldXIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = shieldXIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldXIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ShieldXIconComponent, isStandalone: true, selector: "svg[shield-x-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ShieldXIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[shield-x-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const sidebarCollapseIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.823 7.823a.25.25 0 0 1 0 .354l-2.396 2.396A.25.25 0 0 1 4 10.396V5.604a.25.25 0 0 1 .427-.177Z", "M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25H9.5v-13H1.75a.25.25 0 0 0-.25.25ZM11 14.5h3.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H11Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.22 14.47 9.69 12 7.22 9.53a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l3 3a.75.75 0 0 1 0 1.06l-3 3a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Z", "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25H15v-17H3.75a.25.25 0 0 0-.25.25Zm13 16.75h3.75a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H16.5Z"]
    }
};
class SidebarCollapseIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = sidebarCollapseIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SidebarCollapseIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SidebarCollapseIconComponent, isStandalone: true, selector: "svg[sidebar-collapse-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SidebarCollapseIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sidebar-collapse-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const sidebarExpandIconData = {
    "16": {
        "width": 16,
        "paths": ["m4.177 7.823 2.396-2.396A.25.25 0 0 1 7 5.604v4.792a.25.25 0 0 1-.427.177L4.177 8.177a.25.25 0 0 1 0-.354Z", "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25H9.5v-13Zm12.5 13a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H11v13Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.28 9.53 8.81 12l2.47 2.47a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-3-3a.75.75 0 0 1 0-1.06l3-3a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734Z", "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25H15v-17H3.75a.25.25 0 0 0-.25.25Zm13 16.75h3.75a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H16.5Z"]
    }
};
class SidebarExpandIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = sidebarExpandIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SidebarExpandIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SidebarExpandIconComponent, isStandalone: true, selector: "svg[sidebar-expand-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SidebarExpandIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sidebar-expand-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const signInIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 2.75C2 1.784 2.784 1 3.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 2 13.25Zm6.56 4.5h5.69a.75.75 0 0 1 0 1.5H8.56l1.97 1.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L6.22 8.53a.75.75 0 0 1 0-1.06l3.25-3.25a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 3.25c0-.966.784-1.75 1.75-1.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25v17.5c0 .138.112.25.25.25h5.5a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 3 20.75Zm9.994 9.5 3.3 3.484a.75.75 0 0 1-1.088 1.032l-4.5-4.75a.75.75 0 0 1 0-1.032l4.5-4.75a.75.75 0 0 1 1.088 1.032l-3.3 3.484h8.256a.75.75 0 0 1 0 1.5Z"]
    }
};
class SignInIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = signInIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SignInIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SignInIconComponent, isStandalone: true, selector: "svg[sign-in-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SignInIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sign-in-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const signOutIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 2.75C2 1.784 2.784 1 3.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 2 13.25Zm10.44 4.5-1.97-1.97a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.97-1.97H6.75a.75.75 0 0 1 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 3.25c0-.966.784-1.75 1.75-1.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25v17.5c0 .138.112.25.25.25h5.5a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 3 20.75Zm16.006 9.5H10.75a.75.75 0 0 1 0-1.5h8.256l-3.3-3.484a.75.75 0 0 1 1.088-1.032l4.5 4.75a.75.75 0 0 1 0 1.032l-4.5 4.75a.75.75 0 0 1-1.088-1.032Z"]
    }
};
class SignOutIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = signOutIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SignOutIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SignOutIconComponent, isStandalone: true, selector: "svg[sign-out-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SignOutIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sign-out-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const singleSelectIconData = {
    "16": {
        "width": 16,
        "paths": ["m5.06 7.356 2.795 2.833c.08.081.21.081.29 0l2.794-2.833c.13-.131.038-.356-.145-.356H5.206c-.183 0-.275.225-.145.356Z", "M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m7.854 10.854 3.792 3.792a.5.5 0 0 0 .708 0l3.793-3.792a.5.5 0 0 0-.354-.854H8.207a.5.5 0 0 0-.353.854Z", "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class SingleSelectIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = singleSelectIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SingleSelectIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SingleSelectIconComponent, isStandalone: true, selector: "svg[single-select-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SingleSelectIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[single-select-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const skipIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm9.78-2.22-5.5 5.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l5.5-5.5a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M17.28 7.78a.75.75 0 0 0-1.06-1.06l-9.5 9.5a.75.75 0 1 0 1.06 1.06l9.5-9.5Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class SkipIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = skipIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SkipIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SkipIconComponent, isStandalone: true, selector: "svg[skip-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SkipIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[skip-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const skipFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm11.333-2.167a.825.825 0 0 0-1.166-1.166l-5.5 5.5a.825.825 0 0 0 1.166 1.166Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.333-4.167a.825.825 0 0 0-1.166-1.166l-9.5 9.5a.825.825 0 0 0 1.166 1.166Z"]
    }
};
class SkipFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = skipFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SkipFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SkipFillIconComponent, isStandalone: true, selector: "svg[skip-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SkipFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[skip-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const slidersIconData = {
    "16": {
        "width": 16,
        "paths": ["M15 2.75a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75Zm-8.5.75v1.25a.75.75 0 0 0 1.5 0v-4a.75.75 0 0 0-1.5 0V2H1.75a.75.75 0 0 0 0 1.5H6.5Zm1.25 5.25a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0 0 1.5h6ZM15 8a.75.75 0 0 1-.75.75H11.5V10a.75.75 0 1 1-1.5 0V6a.75.75 0 0 1 1.5 0v1.25h2.75A.75.75 0 0 1 15 8Zm-9 5.25v-2a.75.75 0 0 0-1.5 0v1.25H1.75a.75.75 0 0 0 0 1.5H4.5v1.25a.75.75 0 0 0 1.5 0v-2Zm9 0a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75Z"]
    }
};
class SlidersIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = slidersIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SlidersIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SlidersIconComponent, isStandalone: true, selector: "svg[sliders-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SlidersIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sliders-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const smileyIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm3.82 1.636a.75.75 0 0 1 1.038.175l.007.009c.103.118.22.222.35.31.264.178.683.37 1.285.37.602 0 1.02-.192 1.285-.371.13-.088.247-.192.35-.31l.007-.008a.75.75 0 0 1 1.222.87l-.022-.015c.02.013.021.015.021.015v.001l-.001.002-.002.003-.005.007-.014.019a2.066 2.066 0 0 1-.184.213c-.16.166-.338.316-.53.445-.63.418-1.37.638-2.127.629-.946 0-1.652-.308-2.126-.63a3.331 3.331 0 0 1-.715-.657l-.014-.02-.005-.006-.002-.003v-.002h-.001l.613-.432-.614.43a.75.75 0 0 1 .183-1.044ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5.25 2.25.592.416a97.71 97.71 0 0 0-.592-.416Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M8.456 14.494a.75.75 0 0 1 1.068.17 3.08 3.08 0 0 0 .572.492A3.381 3.381 0 0 0 12 15.72c.855 0 1.487-.283 1.904-.562a3.081 3.081 0 0 0 .572-.492l.021-.026a.75.75 0 0 1 1.197.905l-.027.034c-.013.016-.03.038-.052.063-.044.05-.105.119-.184.198a4.569 4.569 0 0 1-.695.566A4.88 4.88 0 0 1 12 17.22a4.88 4.88 0 0 1-2.736-.814 4.57 4.57 0 0 1-.695-.566 3.253 3.253 0 0 1-.236-.261c-.259-.332-.223-.824.123-1.084Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z", "M9 10.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM16.25 12a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"]
    }
};
class SmileyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = smileyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SmileyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SmileyIconComponent, isStandalone: true, selector: "svg[smiley-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SmileyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[smiley-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const sortAscIconData = {
    "16": {
        "width": 16,
        "paths": ["m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M18.5 17.25a.75.75 0 0 1-1.5 0V7.56l-2.22 2.22a.75.75 0 1 1-1.06-1.06l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1-1.06 1.06L18.5 7.56v9.69Zm-15.75.25a.75.75 0 0 1 0-1.5h9.5a.75.75 0 0 1 0 1.5h-9.5Zm0-5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5h-5.5Zm0-5a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5h-3.5Z"]
    }
};
class SortAscIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = sortAscIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SortAscIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SortAscIconComponent, isStandalone: true, selector: "svg[sort-asc-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SortAscIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sort-asc-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const sortDescIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M18.5 16.44V6.75a.75.75 0 0 0-1.5 0v9.69l-2.22-2.22a.75.75 0 1 0-1.06 1.06l3.5 3.5a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22ZM2 7.25a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 2 7.25Zm0 5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"]
    }
};
class SortDescIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = sortDescIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SortDescIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SortDescIconComponent, isStandalone: true, selector: "svg[sort-desc-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SortDescIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sort-desc-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const sparkleFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.53 1.282a.5.5 0 0 1 .94 0l.478 1.306a7.492 7.492 0 0 0 4.464 4.464l1.305.478a.5.5 0 0 1 0 .94l-1.305.478a7.492 7.492 0 0 0-4.464 4.464l-.478 1.305a.5.5 0 0 1-.94 0l-.478-1.305a7.492 7.492 0 0 0-4.464-4.464L1.282 8.47a.5.5 0 0 1 0-.94l1.306-.478a7.492 7.492 0 0 0 4.464-4.464Z"]
    }
};
class SparkleFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = sparkleFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SparkleFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SparkleFillIconComponent, isStandalone: true, selector: "svg[sparkle-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SparkleFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sparkle-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const sponsorTiersIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.586 1C12.268 1 13.5 2.37 13.5 4.25c0 1.745-.996 3.359-2.622 4.831-.166.15-.336.297-.509.438l1.116 5.584a.75.75 0 0 1-.991.852l-2.409-.876a.25.25 0 0 0-.17 0l-2.409.876a.75.75 0 0 1-.991-.852L5.63 9.519a13.78 13.78 0 0 1-.51-.438C3.497 7.609 2.5 5.995 2.5 4.25 2.5 2.37 3.732 1 5.414 1c.963 0 1.843.403 2.474 1.073L8 2.198l.112-.125a3.385 3.385 0 0 1 2.283-1.068L10.586 1Zm-3.621 9.495-.718 3.594 1.155-.42a1.75 1.75 0 0 1 1.028-.051l.168.051 1.154.42-.718-3.592c-.199.13-.37.235-.505.314l-.169.097a.75.75 0 0 1-.72 0 9.54 9.54 0 0 1-.515-.308l-.16-.105ZM10.586 2.5c-.863 0-1.611.58-1.866 1.459-.209.721-1.231.721-1.44 0C7.025 3.08 6.277 2.5 5.414 2.5 4.598 2.5 4 3.165 4 4.25c0 1.23.786 2.504 2.128 3.719.49.443 1.018.846 1.546 1.198l.325.21.076-.047.251-.163a13.341 13.341 0 0 0 1.546-1.198C11.214 6.754 12 5.479 12 4.25c0-1.085-.598-1.75-1.414-1.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16.004 1.25C18.311 1.25 20 3.128 20 5.75c0 2.292-1.23 4.464-3.295 6.485-.481.47-.98.909-1.482 1.31l.265 1.32 1.375 7.5a.75.75 0 0 1-.982.844l-3.512-1.207a.75.75 0 0 0-.488 0L8.37 23.209a.75.75 0 0 1-.982-.844l1.378-7.512.261-1.309c-.5-.4-1-.838-1.481-1.31C5.479 10.215 4.25 8.043 4.25 5.75c0-2.622 1.689-4.5 3.996-4.5 1.55 0 2.947.752 3.832 1.967l.047.067.047-.067a4.726 4.726 0 0 1 3.612-1.962l.22-.005ZM13.89 14.531c-.418.285-.828.542-1.218.77l-.18.103a.75.75 0 0 1-.734 0l-.071-.04-.46-.272c-.282-.173-.573-.36-.868-.562l-.121.605-1.145 6.239 2.3-.79a2.248 2.248 0 0 1 1.284-.054l.18.053 2.299.79-1.141-6.226-.125-.616ZM16.004 2.75c-1.464 0-2.731.983-3.159 2.459-.209.721-1.231.721-1.44 0-.428-1.476-1.695-2.459-3.16-2.459-1.44 0-2.495 1.173-2.495 3 0 1.811 1.039 3.647 2.844 5.412a19.624 19.624 0 0 0 3.734 2.84l-.019-.011-.184-.111.147-.088a19.81 19.81 0 0 0 3.015-2.278l.37-.352C17.46 9.397 18.5 7.561 18.5 5.75c0-1.827-1.055-3-2.496-3Z"]
    }
};
class SponsorTiersIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = sponsorTiersIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SponsorTiersIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SponsorTiersIconComponent, isStandalone: true, selector: "svg[sponsor-tiers-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SponsorTiersIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sponsor-tiers-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const squareIconData = {
    "16": {
        "width": 16,
        "paths": ["M4 5.75C4 4.784 4.784 4 5.75 4h4.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 10.25 12h-4.5A1.75 1.75 0 0 1 4 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h4.5a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M6 7.75C6 6.784 6.784 6 7.75 6h8.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 16.25 18h-8.5A1.75 1.75 0 0 1 6 16.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25Z"]
    }
};
class SquareIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = squareIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SquareIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SquareIconComponent, isStandalone: true, selector: "svg[square-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SquareIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[square-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const squareFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.75 4h4.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 10.25 12h-4.5A1.75 1.75 0 0 1 4 10.25v-4.5C4 4.784 4.784 4 5.75 4Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.75 6h8.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 16.25 18h-8.5A1.75 1.75 0 0 1 6 16.25v-8.5C6 6.784 6.784 6 7.75 6Z"]
    }
};
class SquareFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = squareFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SquareFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SquareFillIconComponent, isStandalone: true, selector: "svg[square-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SquareFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[square-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const squirrelIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.499.75a.75.75 0 0 1 1.5 0v.996C5.9 2.903 6.793 3.65 7.662 4.376l.24.202c-.036-.694.055-1.422.426-2.163C9.1.873 10.794-.045 12.622.26 14.408.558 16 1.94 16 4.25c0 1.278-.954 2.575-2.44 2.734l.146.508.065.22c.203.701.412 1.455.476 2.226.142 1.707-.4 3.03-1.487 3.898C11.714 14.671 10.27 15 8.75 15h-6a.75.75 0 0 1 0-1.5h1.376a4.484 4.484 0 0 1-.563-1.191 3.835 3.835 0 0 1-.05-2.063 4.647 4.647 0 0 1-2.025-.293.75.75 0 0 1 .525-1.406c1.357.507 2.376-.006 2.698-.318l.009-.01a.747.747 0 0 1 1.06 0 .748.748 0 0 1-.012 1.074c-.912.92-.992 1.835-.768 2.586.221.74.745 1.337 1.196 1.621H8.75c1.343 0 2.398-.296 3.074-.836.635-.507 1.036-1.31.928-2.602-.05-.603-.216-1.224-.422-1.93l-.064-.221c-.12-.407-.246-.84-.353-1.29a2.425 2.425 0 0 1-.507-.441 3.075 3.075 0 0 1-.633-1.248.75.75 0 0 1 1.455-.364c.046.185.144.436.31.627.146.168.353.305.712.305.738 0 1.25-.615 1.25-1.25 0-1.47-.95-2.315-2.123-2.51-1.172-.196-2.227.387-2.706 1.345-.46.92-.27 1.774.019 3.062l.042.19a.884.884 0 0 1 .01.05c.348.443.666.949.94 1.553a.75.75 0 1 1-1.365.62c-.553-1.217-1.32-1.94-2.3-2.768L6.7 5.527c-.814-.68-1.75-1.462-2.692-2.619a3.737 3.737 0 0 0-1.023.88c-.406.495-.663 1.036-.722 1.508.116.122.306.21.591.239.388.038.797-.06 1.032-.19a.75.75 0 0 1 .728 1.31c-.515.287-1.23.439-1.906.373-.682-.067-1.473-.38-1.879-1.193L.75 5.677V5.5c0-.984.48-1.94 1.077-2.664.46-.559 1.05-1.055 1.673-1.353V.75Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M18.377 3.49c-1.862-.31-3.718.62-4.456 2.095-.428.857-.691 1.624-.728 2.361-.035.71.138 1.444.67 2.252.644.854 1.199 1.913 1.608 3.346a.75.75 0 1 1-1.442.412c-.353-1.236-.82-2.135-1.372-2.865l-.008-.01c-.53-.698-1.14-1.242-1.807-1.778a50.724 50.724 0 0 0-.667-.524C9.024 7.884 7.71 6.863 6.471 5.16c-.59.287-1.248.798-1.806 1.454-.665.78-1.097 1.66-1.158 2.446.246.36.685.61 1.246.715.643.12 1.278.015 1.633-.182a.75.75 0 1 1 .728 1.311c-.723.402-1.728.516-2.637.346-.916-.172-1.898-.667-2.398-1.666L2 9.427V9.25c0-1.323.678-2.615 1.523-3.607.7-.824 1.59-1.528 2.477-1.917V2.75a.75.75 0 1 1 1.5 0v1.27c1.154 1.67 2.363 2.612 3.568 3.551.207.162.415.323.621.489.001-.063.003-.126.006-.188.052-1.034.414-2.017.884-2.958 1.06-2.118 3.594-3.313 6.044-2.904 1.225.204 2.329.795 3.125 1.748C22.546 4.713 23 5.988 23 7.5c0 1.496-.913 3.255-2.688 3.652.838 1.699 1.438 3.768 1.181 5.697-.269 2.017-1.04 3.615-2.582 4.675C17.409 22.558 15.288 23 12.5 23H4.75a.75.75 0 0 1 0-1.5h2.322c-.58-.701-.998-1.578-1.223-2.471-.327-1.3-.297-2.786.265-4.131-.92.091-1.985-.02-3.126-.445a.75.75 0 1 1 .524-1.406c1.964.733 3.428.266 4.045-.19.068-.06.137-.12.208-.18a.745.745 0 0 1 .861-.076.746.746 0 0 1 .32.368.752.752 0 0 1-.173.819c-.077.076-.16.15-.252.221-1.322 1.234-1.62 3.055-1.218 4.654.438 1.737 1.574 2.833 2.69 2.837H12.5c2.674 0 4.429-.433 5.56-1.212 1.094-.752 1.715-1.904 1.946-3.637.236-1.768-.445-3.845-1.407-5.529a.576.576 0 0 1-.012-.02 3.557 3.557 0 0 1-1.553-.94c-.556-.565-.89-1.243-1.012-1.73a.75.75 0 0 1 1.456-.364c.057.231.26.67.626 1.043.35.357.822.623 1.443.623 1.172 0 1.953-1.058 1.953-2.234 0-1.205-.357-2.127-.903-2.78-.547-.654-1.318-1.08-2.22-1.23Z"]
    }
};
class SquirrelIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = squirrelIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SquirrelIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SquirrelIconComponent, isStandalone: true, selector: "svg[squirrel-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SquirrelIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[squirrel-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const stackIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.122.392a1.75 1.75 0 0 1 1.756 0l5.003 2.902c.83.481.83 1.68 0 2.162L8.878 8.358a1.75 1.75 0 0 1-1.756 0L2.119 5.456a1.251 1.251 0 0 1 0-2.162ZM8.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685 4.63 2.685a.248.248 0 0 0 .25 0l4.63-2.685ZM1.601 7.789a.75.75 0 0 1 1.025-.273l5.249 3.044a.248.248 0 0 0 .25 0l5.249-3.044a.75.75 0 0 1 .752 1.298l-5.248 3.044a1.75 1.75 0 0 1-1.756 0L1.874 8.814A.75.75 0 0 1 1.6 7.789Zm0 3.5a.75.75 0 0 1 1.025-.273l5.249 3.044a.248.248 0 0 0 .25 0l5.249-3.044a.75.75 0 0 1 .752 1.298l-5.248 3.044a1.75 1.75 0 0 1-1.756 0l-5.248-3.044a.75.75 0 0 1-.273-1.025Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.063 1.456a1.749 1.749 0 0 1 1.874 0l8.383 5.316a1.751 1.751 0 0 1 0 2.956l-8.383 5.316a1.749 1.749 0 0 1-1.874 0L2.68 9.728a1.751 1.751 0 0 1 0-2.956Zm1.071 1.267a.25.25 0 0 0-.268 0L3.483 8.039a.25.25 0 0 0 0 .422l8.383 5.316a.25.25 0 0 0 .268 0l8.383-5.316a.25.25 0 0 0 0-.422Z", "M1.867 12.324a.75.75 0 0 1 1.035-.232l8.964 5.685a.25.25 0 0 0 .268 0l8.964-5.685a.75.75 0 0 1 .804 1.267l-8.965 5.685a1.749 1.749 0 0 1-1.874 0l-8.965-5.685a.75.75 0 0 1-.231-1.035Z", "M1.867 16.324a.75.75 0 0 1 1.035-.232l8.964 5.685a.25.25 0 0 0 .268 0l8.964-5.685a.75.75 0 0 1 .804 1.267l-8.965 5.685a1.749 1.749 0 0 1-1.874 0l-8.965-5.685a.75.75 0 0 1-.231-1.035Z"]
    }
};
class StackIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = stackIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StackIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: StackIconComponent, isStandalone: true, selector: "svg[stack-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StackIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[stack-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const starIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Zm0 2.445L6.615 5.5a.75.75 0 0 1-.564.41l-3.097.45 2.24 2.184a.75.75 0 0 1 .216.664l-.528 3.084 2.769-1.456a.75.75 0 0 1 .698 0l2.77 1.456-.53-3.084a.75.75 0 0 1 .216-.664l2.24-2.183-3.096-.45a.75.75 0 0 1-.564-.41L8 2.694Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 .25a.75.75 0 0 1 .673.418l3.058 6.197 6.839.994a.75.75 0 0 1 .415 1.279l-4.948 4.823 1.168 6.811a.751.751 0 0 1-1.088.791L12 18.347l-6.117 3.216a.75.75 0 0 1-1.088-.79l1.168-6.812-4.948-4.823a.75.75 0 0 1 .416-1.28l6.838-.993L11.328.668A.75.75 0 0 1 12 .25Zm0 2.445L9.44 7.882a.75.75 0 0 1-.565.41l-5.725.832 4.143 4.038a.748.748 0 0 1 .215.664l-.978 5.702 5.121-2.692a.75.75 0 0 1 .698 0l5.12 2.692-.977-5.702a.748.748 0 0 1 .215-.664l4.143-4.038-5.725-.831a.75.75 0 0 1-.565-.41L12 2.694Z"]
    }
};
class StarIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = starIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StarIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: StarIconComponent, isStandalone: true, selector: "svg[star-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StarIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[star-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const starFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m12.672.668 3.059 6.197 6.838.993a.75.75 0 0 1 .416 1.28l-4.948 4.823 1.168 6.812a.75.75 0 0 1-1.088.79L12 18.347l-6.116 3.216a.75.75 0 0 1-1.088-.791l1.168-6.811-4.948-4.823a.749.749 0 0 1 .416-1.279l6.838-.994L11.327.668a.75.75 0 0 1 1.345 0Z"]
    }
};
class StarFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = starFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StarFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: StarFillIconComponent, isStandalone: true, selector: "svg[star-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StarFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[star-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const stopIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.47.22A.749.749 0 0 1 5 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 0 1-.22.53l-4.25 4.25A.749.749 0 0 1 11 16H5a.749.749 0 0 1-.53-.22L.22 11.53A.749.749 0 0 1 0 11V5c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5ZM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 12 7Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", "M7.328 1.47a.749.749 0 0 1 .53-.22h8.284c.199 0 .389.079.53.22l5.858 5.858c.141.14.22.33.22.53v8.284a.749.749 0 0 1-.22.53l-5.858 5.858a.749.749 0 0 1-.53.22H7.858a.749.749 0 0 1-.53-.22L1.47 16.672a.749.749 0 0 1-.22-.53V7.858c0-.199.079-.389.22-.53Zm.84 1.28L2.75 8.169v7.662l5.419 5.419h7.662l5.419-5.418V8.168L15.832 2.75Z"]
    }
};
class StopIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = stopIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StopIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: StopIconComponent, isStandalone: true, selector: "svg[stop-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StopIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[stop-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const stopwatchIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.75.75A.75.75 0 0 1 6.5 0h3a.75.75 0 0 1 0 1.5h-.75v1l-.001.041a6.724 6.724 0 0 1 3.464 1.435l.007-.006.75-.75a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-.75.75-.006.007a6.75 6.75 0 1 1-10.548 0L2.72 5.03l-.75-.75a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l.75.75.007.006A6.72 6.72 0 0 1 7.25 2.541V1.5H6.5a.75.75 0 0 1-.75-.75ZM8 14.5a5.25 5.25 0 1 0-.001-10.501A5.25 5.25 0 0 0 8 14.5Zm.389-6.7 1.33-1.33a.75.75 0 1 1 1.061 1.06L9.45 8.861A1.503 1.503 0 0 1 8 10.75a1.499 1.499 0 1 1 .389-2.95Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.25 0h3.5a.75.75 0 0 1 0 1.5h-1v1.278a9.954 9.954 0 0 1 5.636 2.276L19.72 3.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.315 1.316A9.959 9.959 0 0 1 22 12.75c0 5.523-4.477 10-10 10s-10-4.477-10-10a9.959 9.959 0 0 1 2.535-6.654L3.22 4.78a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.335 1.334a9.958 9.958 0 0 1 5.635-2.276V1.5h-1a.75.75 0 0 1 0-1.5ZM12 21.25a8.5 8.5 0 1 0-.001-17.001A8.5 8.5 0 0 0 12 21.25Zm4.03-12.53a.75.75 0 0 1 0 1.06l-2.381 2.382a1.75 1.75 0 1 1-1.06-1.06l2.38-2.382a.75.75 0 0 1 1.061 0Z"]
    }
};
class StopwatchIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = stopwatchIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StopwatchIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: StopwatchIconComponent, isStandalone: true, selector: "svg[stopwatch-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StopwatchIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[stopwatch-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const strikethroughIconData = {
    "16": {
        "width": 16,
        "paths": ["M11.055 8.5c.524.536.815 1.257.811 2.007a3.133 3.133 0 0 1-1.12 2.408C9.948 13.597 8.748 14 7.096 14c-1.706 0-3.104-.607-3.902-1.377a.751.751 0 0 1 1.042-1.079c.48.463 1.487.956 2.86.956 1.422 0 2.232-.346 2.676-.726.435-.372.594-.839.594-1.267 0-.472-.208-.857-.647-1.197-.448-.346-1.116-.623-1.951-.81H1.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5ZM7.581 3.25c-2.036 0-2.778 1.082-2.778 1.786 0 .055.002.107.006.157a.75.75 0 0 1-1.496.114 3.506 3.506 0 0 1-.01-.271c0-1.832 1.75-3.286 4.278-3.286 1.418 0 2.721.58 3.514 1.093a.75.75 0 1 1-.814 1.26c-.64-.414-1.662-.853-2.7-.853Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m16.533 12.5.054.043c.93.75 1.538 1.77 1.538 3.066a4.13 4.13 0 0 1-1.479 3.177c-1.058.904-2.679 1.464-4.974 1.464-2.35 0-4.252-.837-5.318-1.865a.75.75 0 1 1 1.042-1.08c.747.722 2.258 1.445 4.276 1.445 2.065 0 3.296-.504 3.999-1.105a2.63 2.63 0 0 0 .954-2.036c0-.764-.337-1.38-.979-1.898-.649-.523-1.598-.931-2.76-1.211H3.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5ZM12.36 5C9.37 5 8.105 6.613 8.105 7.848c0 .411.072.744.193 1.02a.75.75 0 0 1-1.373.603 3.988 3.988 0 0 1-.32-1.623c0-2.363 2.271-4.348 5.755-4.348 1.931 0 3.722.794 4.814 1.5a.75.75 0 1 1-.814 1.26c-.94-.607-2.448-1.26-4-1.26Z"]
    }
};
class StrikethroughIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = strikethroughIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StrikethroughIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: StrikethroughIconComponent, isStandalone: true, selector: "svg[strikethrough-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: StrikethroughIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[strikethrough-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const sunIconData = {
    "16": {
        "width": 16,
        "paths": ["M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm5.657-8.157a.75.75 0 0 1 0 1.061l-1.061 1.06a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.06-1.06a.75.75 0 0 1 1.06 0Zm-9.193 9.193a.75.75 0 0 1 0 1.06l-1.06 1.061a.75.75 0 1 1-1.061-1.06l1.06-1.061a.75.75 0 0 1 1.061 0ZM8 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 8 0ZM3 8a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 3 8Zm13 0a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 16 8Zm-8 5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 8 13Zm3.536-1.464a.75.75 0 0 1 1.06 0l1.061 1.06a.75.75 0 0 1-1.06 1.061l-1.061-1.06a.75.75 0 0 1 0-1.061ZM2.343 2.343a.75.75 0 0 1 1.061 0l1.06 1.061a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-1.06-1.06a.75.75 0 0 1 0-1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 1 0 0 11Zm-5.657.157a.75.75 0 0 1 0 1.06l-1.768 1.768a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.767-1.768a.75.75 0 0 1 1.061 0ZM3.515 3.515a.75.75 0 0 1 1.06 0l1.768 1.768a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L3.515 4.575a.75.75 0 0 1 0-1.06ZM12 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 12 0ZM4 12a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 4 12Zm8 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 12 20Zm12-8a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 24 12Zm-6.343 5.657a.75.75 0 0 1 1.06 0l1.768 1.768a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-1.768-1.767a.75.75 0 0 1 0-1.061Zm2.828-14.142a.75.75 0 0 1 0 1.06l-1.768 1.768a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l1.767-1.768a.75.75 0 0 1 1.061 0Z"]
    }
};
class SunIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = sunIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SunIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SunIconComponent, isStandalone: true, selector: "svg[sun-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SunIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sun-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const syncIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.705 8.005a.75.75 0 0 1 .834.656 5.5 5.5 0 0 0 9.592 2.97l-1.204-1.204a.25.25 0 0 1 .177-.427h3.646a.25.25 0 0 1 .25.25v3.646a.25.25 0 0 1-.427.177l-1.38-1.38A7.002 7.002 0 0 1 1.05 8.84a.75.75 0 0 1 .656-.834ZM8 2.5a5.487 5.487 0 0 0-4.131 1.869l1.204 1.204A.25.25 0 0 1 4.896 6H1.25A.25.25 0 0 1 1 5.75V2.104a.25.25 0 0 1 .427-.177l1.38 1.38A7.002 7.002 0 0 1 14.95 7.16a.75.75 0 0 1-1.49.178A5.5 5.5 0 0 0 8 2.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3.38 8A9.502 9.502 0 0 1 12 2.5a9.502 9.502 0 0 1 9.215 7.182.75.75 0 1 0 1.456-.364C21.473 4.539 17.15 1 12 1a10.995 10.995 0 0 0-9.5 5.452V4.75a.75.75 0 0 0-1.5 0V8.5a1 1 0 0 0 1 1h3.75a.75.75 0 0 0 0-1.5H3.38Zm-.595 6.318a.75.75 0 0 0-1.455.364C2.527 19.461 6.85 23 12 23c4.052 0 7.592-2.191 9.5-5.451v1.701a.75.75 0 0 0 1.5 0V15.5a1 1 0 0 0-1-1h-3.75a.75.75 0 0 0 0 1.5h2.37A9.502 9.502 0 0 1 12 21.5c-4.446 0-8.181-3.055-9.215-7.182Z"]
    }
};
class SyncIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = syncIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SyncIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: SyncIconComponent, isStandalone: true, selector: "svg[sync-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: SyncIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[sync-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const tabIconData = {
    "24": {
        "width": 24,
        "paths": ["M22 4.25a.75.75 0 0 0-1.5 0v15a.75.75 0 0 0 1.5 0v-15Zm-9.72 14.28a.75.75 0 1 1-1.06-1.06l4.97-4.97H1.75a.75.75 0 0 1 0-1.5h14.44l-4.97-4.97a.75.75 0 0 1 1.06-1.06l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25Z"]
    }
};
class TabIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = tabIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TabIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TabIconComponent, isStandalone: true, selector: "svg[tab-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TabIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[tab-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const tabExternalIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.25 4a.25.25 0 0 0-.25.25v9a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h.75V4.25c0-.966.784-1.75 1.75-1.75h9.5c.966 0 1.75.784 1.75 1.75v8.25h.75a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75v-9a.25.25 0 0 0-.25-.25h-9.5Z", "m7.97 7.97-2.75 2.75a.75.75 0 1 0 1.06 1.06l2.75-2.75 1.543 1.543a.25.25 0 0 0 .427-.177V6.25a.25.25 0 0 0-.25-.25H6.604a.25.25 0 0 0-.177.427L7.97 7.97Z"]
    }
};
class TabExternalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = tabExternalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TabExternalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TabExternalIconComponent, isStandalone: true, selector: "svg[tab-external-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TabExternalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[tab-external-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const tableIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25ZM6.5 6.5v8h7.75a.25.25 0 0 0 .25-.25V6.5Zm8-1.5V1.75a.25.25 0 0 0-.25-.25H6.5V5Zm-13 1.5v7.75c0 .138.112.25.25.25H5v-8ZM5 5V1.5H1.75a.25.25 0 0 0-.25.25V5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25ZM9 9v11.5h11.25a.25.25 0 0 0 .25-.25V9Zm11.5-1.5V3.75a.25.25 0 0 0-.25-.25H9v4ZM3.5 9v11.25c0 .138.112.25.25.25H7.5V9Zm4-1.5v-4H3.75a.25.25 0 0 0-.25.25V7.5Z"]
    }
};
class TableIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = tableIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TableIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TableIconComponent, isStandalone: true, selector: "svg[table-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TableIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[table-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const tagIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 7.775V2.75C1 1.784 1.784 1 2.75 1h5.025c.464 0 .91.184 1.238.513l6.25 6.25a1.75 1.75 0 0 1 0 2.474l-5.026 5.026a1.75 1.75 0 0 1-2.474 0l-6.25-6.25A1.752 1.752 0 0 1 1 7.775Zm1.5 0c0 .066.026.13.073.177l6.25 6.25a.25.25 0 0 0 .354 0l5.025-5.025a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.177-.073H2.75a.25.25 0 0 0-.25.25ZM6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.75 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z", "M2.5 1h8.44a1.5 1.5 0 0 1 1.06.44l10.25 10.25a1.5 1.5 0 0 1 0 2.12l-8.44 8.44a1.5 1.5 0 0 1-2.12 0L1.44 12A1.497 1.497 0 0 1 1 10.94V2.5A1.5 1.5 0 0 1 2.5 1Zm0 1.5v8.44l10.25 10.25 8.44-8.44L10.94 2.5Z"]
    }
};
class TagIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = tagIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TagIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TagIconComponent, isStandalone: true, selector: "svg[tag-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TagIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[tag-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const tasklistIconData = {
    "16": {
        "width": 16,
        "paths": ["M2 2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm4.655 8.595a.75.75 0 0 1 0 1.06L4.03 14.28a.75.75 0 0 1-1.06 0l-1.5-1.5a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l.97.97 2.095-2.095a.75.75 0 0 1 1.06 0ZM9.75 2.5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm0 5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm0 5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm-7.25-9v3h3v-3Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M3 6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm1.5 4.5h4v-4h-4Zm8.25-5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm0 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm0 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm-2.97-2.53a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 2.97-2.97a.75.75 0 0 1 1.06 0Z"]
    }
};
class TasklistIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = tasklistIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TasklistIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TasklistIconComponent, isStandalone: true, selector: "svg[tasklist-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TasklistIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[tasklist-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const telescopeIconData = {
    "16": {
        "width": 16,
        "paths": ["M14.184 1.143v-.001l1.422 2.464a1.75 1.75 0 0 1-.757 2.451L3.104 11.713a1.75 1.75 0 0 1-2.275-.702l-.447-.775a1.75 1.75 0 0 1 .53-2.32L11.682.573a1.748 1.748 0 0 1 2.502.57Zm-4.709 9.32h-.001l2.644 3.863a.75.75 0 1 1-1.238.848l-1.881-2.75v2.826a.75.75 0 0 1-1.5 0v-2.826l-1.881 2.75a.75.75 0 1 1-1.238-.848l2.049-2.992a.746.746 0 0 1 .293-.253l1.809-.87a.749.749 0 0 1 .944.252ZM9.436 3.92h-.001l-4.97 3.39.942 1.63 5.42-2.61Zm3.091-2.108h.001l-1.85 1.26 1.505 2.605 2.016-.97a.247.247 0 0 0 .13-.151.247.247 0 0 0-.022-.199l-1.422-2.464a.253.253 0 0 0-.161-.119.254.254 0 0 0-.197.038ZM1.756 9.157a.25.25 0 0 0-.075.33l.447.775a.25.25 0 0 0 .325.1l1.598-.769-.83-1.436-1.465 1Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M.408 15.13a2 2 0 0 1 .59-2.642L17.038 1.33a1.999 1.999 0 0 1 2.85.602l2.828 4.644a2 2 0 0 1-.851 2.847l-17.762 8.43a2 2 0 0 1-2.59-.807Zm5.263-4.066 1.987 3.44 8.712-4.135-2.857-4.76Zm12.06-1.34.001-.001 3.49-1.656a.498.498 0 0 0 .212-.712l-2.826-4.644a.503.503 0 0 0-.713-.151l-3.148 2.19Zm-13.295 2.2L1.854 13.72a.5.5 0 0 0-.147.66l1.105 1.915a.5.5 0 0 0 .648.201l2.838-1.347ZM17.155 22.87a.75.75 0 0 0 .226-1.036l-4-6.239a.75.75 0 0 0-.941-.278l-2.75 1.25a.75.75 0 0 0-.318.274l-3.25 4.989a.75.75 0 0 0 1.256.819l3.131-4.806.51-.232v5.64a.75.75 0 1 0 1.5 0v-6.22l3.6 5.613a.75.75 0 0 0 1.036.226Z"]
    }
};
class TelescopeIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = telescopeIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TelescopeIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TelescopeIconComponent, isStandalone: true, selector: "svg[telescope-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TelescopeIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[telescope-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const telescopeFillIconData = {
    "16": {
        "width": 16,
        "paths": ["M11.905.42a1.5 1.5 0 0 1 2.144.49l1.692 2.93a1.5 1.5 0 0 1-.649 2.102L2.895 11.815a1.5 1.5 0 0 1-1.95-.602l-.68-1.176a1.5 1.5 0 0 1 .455-1.99L11.905.422Zm-3.374 9.79a.75.75 0 0 1 .944.253l2.644 3.864a.751.751 0 0 1-1.238.847L9 12.424v2.826a.75.75 0 0 1-1.5 0v-2.826l-1.881 2.75a.75.75 0 1 1-1.238-.848l2.048-2.992a.752.752 0 0 1 .293-.252l1.81-.871Zm2.476-3.965v-.001l1.356-.653-1.52-2.631-1.243.848ZM3.279 8.119l.835 1.445 1.355-.653-.947-1.64Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M17.155 22.87a.75.75 0 0 0 .226-1.036l-4-6.239a.75.75 0 0 0-.941-.277l-2.75 1.25a.75.75 0 0 0-.318.273l-3.25 4.989a.75.75 0 0 0 1.256.819l3.131-4.806.51-.232v5.64a.75.75 0 1 0 1.5 0v-6.22l3.6 5.613a.75.75 0 0 0 1.036.226ZM.408 15.13a2 2 0 0 1 .59-2.642L17.038 1.33a1.999 1.999 0 0 1 2.85.602l2.828 4.644a2 2 0 0 1-.851 2.847l-17.762 8.43a2 2 0 0 1-2.59-.807Zm13.105-9.521 2.857 4.76 1.361-.646-2.984-4.973Zm-7.842 5.455-1.235.86 1.862 3.225 1.36-.645Z"]
    }
};
class TelescopeFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = telescopeFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TelescopeFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TelescopeFillIconComponent, isStandalone: true, selector: "svg[telescope-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TelescopeFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[telescope-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const terminalIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM7.25 8a.749.749 0 0 1-.22.53l-2.25 2.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L5.44 8 3.72 6.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l2.25 2.25c.141.14.22.331.22.53Zm1.5 1.5h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.25 12a.75.75 0 0 1-.22.53l-2.75 2.75a.75.75 0 0 1-1.06-1.06L7.44 12 5.22 9.78a.75.75 0 1 1 1.06-1.06l2.75 2.75c.141.14.22.331.22.53Zm2 2a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z", "M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class TerminalIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = terminalIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TerminalIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TerminalIconComponent, isStandalone: true, selector: "svg[terminal-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TerminalIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[terminal-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const threeBarsIconData = {
    "16": {
        "width": 16,
        "paths": ["M1 2.75A.75.75 0 0 1 1.75 2h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 2.75Zm0 5A.75.75 0 0 1 1.75 7h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 7.75ZM1.75 12h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5Z"]
    }
};
class ThreeBarsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = threeBarsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ThreeBarsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ThreeBarsIconComponent, isStandalone: true, selector: "svg[three-bars-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ThreeBarsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[three-bars-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const thumbsdownIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.083 15.986c-.763-.087-1.499-.295-2.011-.884-.504-.581-.655-1.378-.655-2.299 0-.468.087-1.12.157-1.638l.015-.112H3.167c-.603 0-1.174-.086-1.669-.334a2.415 2.415 0 0 1-1.136-1.2c-.454-.998-.438-2.447-.188-4.316l.04-.306C.32 4.108.41 3.424.526 2.864c.132-.63.316-1.209.669-1.672C1.947.205 3.211.053 4.917.053c1.848 0 3.234.332 4.388.652l.474.133c.658.187 1.201.341 1.726.415a1.75 1.75 0 0 1 1.662-1.2h1c.966 0 1.75.784 1.75 1.75v7.5a1.75 1.75 0 0 1-1.75 1.75h-1a1.75 1.75 0 0 1-1.514-.872c-.259.105-.59.268-.919.508-.671.491-1.317 1.285-1.317 2.614v.5c0 1.201-.994 2.336-2.334 2.183Zm4.334-13.232c-.706-.089-1.39-.284-2.072-.479l-.441-.125c-1.096-.304-2.335-.597-3.987-.597-1.794 0-2.28.222-2.529.548-.147.193-.275.505-.393 1.07-.105.502-.188 1.124-.295 1.93l-.04.3c-.25 1.882-.19 2.933.067 3.497a.923.923 0 0 0 .443.48c.208.104.52.175.997.175h1.75c.685 0 1.295.577 1.205 1.335-.022.192-.049.39-.075.586-.066.488-.13.97-.13 1.329 0 .808.144 1.15.288 1.316.137.157.401.303 1.048.377.307.035.664-.237.664-.693v-.5c0-1.922.978-3.127 1.932-3.825a5.878 5.878 0 0 1 1.568-.809Zm1.75 6.798h1a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.596 21.957c-1.301.092-2.303-.986-2.303-2.206v-1.053c0-2.666-1.813-3.785-2.774-4.2a1.884 1.884 0 0 0-.523-.13A1.75 1.75 0 0 1 5.25 16h-1.5A1.75 1.75 0 0 1 2 14.25V3.75C2 2.784 2.784 2 3.75 2h1.5a1.75 1.75 0 0 1 1.742 1.58c.838-.06 1.667-.296 2.69-.586l.602-.17C11.748 2.419 13.497 2 15.828 2c2.188 0 3.693.204 4.583 1.372.422.554.65 1.255.816 2.05.148.708.262 1.57.396 2.58l.051.39c.319 2.386.328 4.18-.223 5.394-.293.644-.743 1.125-1.355 1.431-.59.296-1.284.404-2.036.404h-2.05l.056.429c.025.18.05.372.076.572.06.483.117 1.006.117 1.438 0 1.245-.222 2.253-.92 2.942-.684.674-1.668.879-2.743.955ZM7 5.082v7.779c.383.025.759.113 1.113.26 1.192.514 3.68 2.027 3.68 5.577v1.053c0 .436.347.734.698.71 1.021-.072 1.52-.258 1.795-.528.26-.256.473-.748.473-1.873 0-.328-.045-.768-.105-1.25l-.07-.527c-.04-.297-.079-.59-.105-.834-.082-.758.53-1.328 1.211-1.328h2.37c.625 0 1.06-.092 1.365-.245.285-.142.5-.359.66-.711.355-.78.422-2.176.102-4.574l-.05-.385c-.137-1.027-.243-1.827-.379-2.477-.152-.73-.324-1.165-.54-1.448-.386-.507-1.113-.781-3.39-.781-2.136 0-3.736.379-5.142.771-.191.052-.38.106-.568.16-1.039.296-2.059.587-3.118.651ZM3.75 3.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"]
    }
};
class ThumbsdownIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = thumbsdownIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ThumbsdownIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ThumbsdownIconComponent, isStandalone: true, selector: "svg[thumbsdown-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ThumbsdownIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[thumbsdown-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const thumbsupIconData = {
    "16": {
        "width": 16,
        "paths": ["M8.834.066c.763.087 1.5.295 2.01.884.505.581.656 1.378.656 2.3 0 .467-.087 1.119-.157 1.637L11.328 5h1.422c.603 0 1.174.085 1.668.333.508.254.911.679 1.137 1.2.453.998.438 2.447.188 4.316l-.04.306c-.105.79-.195 1.473-.313 2.033-.131.63-.315 1.209-.668 1.672C13.97 15.847 12.706 16 11 16c-1.848 0-3.234-.333-4.388-.653-.165-.045-.323-.09-.475-.133-.658-.186-1.2-.34-1.725-.415A1.75 1.75 0 0 1 2.75 16h-1A1.75 1.75 0 0 1 0 14.25v-7.5C0 5.784.784 5 1.75 5h1a1.75 1.75 0 0 1 1.514.872c.258-.105.59-.268.918-.508C5.853 4.874 6.5 4.079 6.5 2.75v-.5c0-1.202.994-2.337 2.334-2.184ZM4.5 13.3c.705.088 1.39.284 2.072.478l.441.125c1.096.305 2.334.598 3.987.598 1.794 0 2.28-.223 2.528-.549.147-.193.276-.505.394-1.07.105-.502.188-1.124.295-1.93l.04-.3c.25-1.882.189-2.933-.068-3.497a.921.921 0 0 0-.442-.48c-.208-.104-.52-.174-.997-.174H11c-.686 0-1.295-.577-1.206-1.336.023-.192.05-.39.076-.586.065-.488.13-.97.13-1.328 0-.809-.144-1.15-.288-1.316-.137-.158-.402-.304-1.048-.378C8.357 1.521 8 1.793 8 2.25v.5c0 1.922-.978 3.128-1.933 3.825a5.831 5.831 0 0 1-1.567.81ZM2.75 6.5h-1a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12.596 2.043c1.075.076 2.059.281 2.743.956.698.688.92 1.696.92 2.941 0 .432-.057.955-.117 1.438-.026.2-.051.392-.076.572l-.056.429h2.05c.752 0 1.446.108 2.036.404.612.306 1.062.787 1.355 1.431.551 1.214.542 3.008.223 5.394l-.051.39c-.134 1.01-.248 1.872-.396 2.58-.166.795-.394 1.496-.816 2.05-.89 1.168-2.395 1.372-4.583 1.372-2.331 0-4.08-.418-5.544-.824l-.602-.17c-1.023-.29-1.852-.526-2.69-.586A1.75 1.75 0 0 1 5.25 22h-1.5A1.75 1.75 0 0 1 2 20.25V9.75C2 8.784 2.784 8 3.75 8h1.5a1.75 1.75 0 0 1 1.746 1.633 1.85 1.85 0 0 0 .523-.131c.961-.415 2.774-1.534 2.774-4.2V4.249c0-1.22 1.002-2.298 2.303-2.206ZM7 18.918c1.059.064 2.079.355 3.118.652l.568.16c1.406.39 3.006.77 5.142.77 2.277 0 3.004-.274 3.39-.781.216-.283.388-.718.54-1.448.136-.65.242-1.45.379-2.477l.05-.384c.32-2.4.253-3.795-.102-4.575-.16-.352-.375-.568-.66-.711-.305-.153-.74-.245-1.365-.245h-2.37c-.681 0-1.293-.57-1.211-1.328.026-.243.065-.537.105-.834l.07-.527c.06-.482.105-.921.105-1.25 0-1.125-.213-1.617-.473-1.873-.275-.27-.774-.455-1.795-.528-.351-.024-.698.274-.698.71v1.053c0 3.55-2.488 5.063-3.68 5.577-.372.16-.754.232-1.113.26ZM3.75 20.5h1.5a.25.25 0 0 0 .25-.25V9.75a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25Z"]
    }
};
class ThumbsupIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = thumbsupIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ThumbsupIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ThumbsupIconComponent, isStandalone: true, selector: "svg[thumbsup-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ThumbsupIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[thumbsup-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const toolsIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.433 2.304A4.492 4.492 0 0 0 3.5 6c0 1.598.832 3.002 2.09 3.802.518.328.929.923.902 1.64v.008l-.164 3.337a.75.75 0 1 1-1.498-.073l.163-3.33c.002-.085-.05-.216-.207-.316A5.996 5.996 0 0 1 2 6a5.993 5.993 0 0 1 2.567-4.92 1.482 1.482 0 0 1 1.673-.04c.462.296.76.827.76 1.423v2.82c0 .082.041.16.11.206l.75.51a.25.25 0 0 0 .28 0l.75-.51A.249.249 0 0 0 9 5.282V2.463c0-.596.298-1.127.76-1.423a1.482 1.482 0 0 1 1.673.04A5.993 5.993 0 0 1 14 6a5.996 5.996 0 0 1-2.786 5.068c-.157.1-.209.23-.207.315l.163 3.33a.752.752 0 0 1-1.094.714.75.75 0 0 1-.404-.64l-.164-3.345c-.027-.717.384-1.312.902-1.64A4.495 4.495 0 0 0 12.5 6a4.492 4.492 0 0 0-1.933-3.696c-.024.017-.067.067-.067.16v2.818a1.75 1.75 0 0 1-.767 1.448l-.75.51a1.75 1.75 0 0 1-1.966 0l-.75-.51A1.75 1.75 0 0 1 5.5 5.282V2.463c0-.092-.043-.142-.067-.159Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.875 2.292a.114.114 0 0 0-.032.018A7.239 7.239 0 0 0 4.75 8.25a7.248 7.248 0 0 0 3.654 6.297c.57.327.982.955.941 1.682v.002l-.317 6.058a.75.75 0 1 1-1.498-.078l.317-6.062v-.004c.006-.09-.047-.215-.188-.296A8.749 8.749 0 0 1 3.25 8.25a8.738 8.738 0 0 1 3.732-7.169 1.547 1.547 0 0 1 1.709-.064c.484.292.809.835.809 1.46v4.714a.25.25 0 0 0 .119.213l2.25 1.385c.08.05.182.05.262 0l2.25-1.385a.25.25 0 0 0 .119-.213V2.478c0-.626.325-1.169.81-1.461a1.547 1.547 0 0 1 1.708.064 8.741 8.741 0 0 1 3.732 7.17 8.747 8.747 0 0 1-4.41 7.598c-.14.081-.193.206-.188.296v.004l.318 6.062a.75.75 0 1 1-1.498.078l-.317-6.058v-.002c-.041-.727.37-1.355.94-1.682A7.247 7.247 0 0 0 19.25 8.25a7.239 7.239 0 0 0-3.093-5.94.114.114 0 0 0-.032-.018l-.01-.001c-.003 0-.014 0-.031.01-.036.022-.084.079-.084.177V7.19c0 .608-.315 1.172-.833 1.49l-2.25 1.385a1.75 1.75 0 0 1-1.834 0l-2.25-1.384A1.752 1.752 0 0 1 8 7.192V2.477c0-.098-.048-.155-.084-.176a.068.068 0 0 0-.031-.011l-.01.001Z"]
    }
};
class ToolsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = toolsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ToolsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ToolsIconComponent, isStandalone: true, selector: "svg[tools-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ToolsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[tools-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const trackedByClosedCompletedIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 8a6.5 6.5 0 1 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z", "m8.677 12.427 2.896 2.896a.25.25 0 0 0 .427-.177V13h3.25a.75.75 0 0 0 0-1.5H12V9.354a.25.25 0 0 0-.427-.177l-2.896 2.896a.25.25 0 0 0 0 .354ZM11.28 6.78a.749.749 0 1 0-1.06-1.06L7.25 8.689 5.78 7.22a.749.749 0 1 0-1.06 1.06l2 2a.749.749 0 0 0 1.06 0l3.5-3.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 2.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5.75.75 0 0 1 0 1.5C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11a.75.75 0 0 1-1.5 0A9.5 9.5 0 0 0 12 2.5Z", "m13.759 17.48 3.728 3.314a.308.308 0 0 0 .513-.23V18h4.25a.75.75 0 0 0 0-1.5H18v-2.564a.308.308 0 0 0-.513-.23l-3.728 3.314a.307.307 0 0 0 0 .46Zm3.521-8.2a.749.749 0 1 0-1.06-1.06l-5.97 5.969-2.47-2.469a.749.749 0 1 0-1.06 1.06l3 3a.749.749 0 0 0 1.06 0l6.5-6.5Z"]
    }
};
class TrackedByClosedCompletedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = trackedByClosedCompletedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TrackedByClosedCompletedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TrackedByClosedCompletedIconComponent, isStandalone: true, selector: "svg[tracked-by-closed-completed-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TrackedByClosedCompletedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[tracked-by-closed-completed-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const trackedByClosedNotPlannedIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.5 8a6.5 6.5 0 1 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z", "m8.677 12.427 2.896 2.896a.25.25 0 0 0 .427-.177V13h3.25a.75.75 0 0 0 0-1.5H12V9.354a.25.25 0 0 0-.427-.177l-2.896 2.896a.25.25 0 0 0 0 .354ZM11.28 5.78a.749.749 0 1 0-1.06-1.06l-5.5 5.5a.749.749 0 1 0 1.06 1.06l5.5-5.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 2.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5.75.75 0 0 1 0 1.5C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11a.75.75 0 0 1-1.5 0A9.5 9.5 0 0 0 12 2.5Z", "m13.759 17.48 3.728 3.314a.308.308 0 0 0 .513-.23V18h4.25a.75.75 0 0 0 0-1.5H18v-2.564a.308.308 0 0 0-.513-.23l-3.728 3.314a.307.307 0 0 0 0 .46Zm3.521-9.7a.749.749 0 1 0-1.06-1.06l-9.5 9.5a.749.749 0 1 0 1.06 1.06l9.5-9.5Z"]
    }
};
class TrackedByClosedNotPlannedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = trackedByClosedNotPlannedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TrackedByClosedNotPlannedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TrackedByClosedNotPlannedIconComponent, isStandalone: true, selector: "svg[tracked-by-closed-not-planned-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TrackedByClosedNotPlannedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[tracked-by-closed-not-planned-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const trashIconData = {
    "16": {
        "width": 16,
        "paths": ["M11 1.75V3h2.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75ZM4.496 6.675l.66 6.6a.25.25 0 0 0 .249.225h5.19a.25.25 0 0 0 .249-.225l.66-6.6a.75.75 0 0 1 1.492.149l-.66 6.6A1.748 1.748 0 0 1 10.595 15h-5.19a1.75 1.75 0 0 1-1.741-1.575l-.66-6.6a.75.75 0 1 1 1.492-.15ZM6.5 1.75V3h3V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M16 1.75V3h5.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H8V1.75C8 .784 8.784 0 9.75 0h4.5C15.216 0 16 .784 16 1.75Zm-6.5 0V3h5V1.75a.25.25 0 0 0-.25-.25h-4.5a.25.25 0 0 0-.25.25ZM4.997 6.178a.75.75 0 1 0-1.493.144L4.916 20.92a1.75 1.75 0 0 0 1.742 1.58h10.684a1.75 1.75 0 0 0 1.742-1.581l1.413-14.597a.75.75 0 0 0-1.494-.144l-1.412 14.596a.25.25 0 0 1-.249.226H6.658a.25.25 0 0 1-.249-.226L4.997 6.178Z", "M9.206 7.501a.75.75 0 0 1 .793.705l.5 8.5A.75.75 0 1 1 9 16.794l-.5-8.5a.75.75 0 0 1 .705-.793Zm6.293.793A.75.75 0 1 0 14 8.206l-.5 8.5a.75.75 0 0 0 1.498.088l.5-8.5Z"]
    }
};
class TrashIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = trashIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TrashIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TrashIconComponent, isStandalone: true, selector: "svg[trash-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TrashIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[trash-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const triangleDownIconData = {
    "16": {
        "width": 16,
        "paths": ["m4.427 7.427 3.396 3.396a.25.25 0 0 0 .354 0l3.396-3.396A.25.25 0 0 0 11.396 7H4.604a.25.25 0 0 0-.177.427Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.646 15.146 5.854 9.354a.5.5 0 0 1 .353-.854h11.586a.5.5 0 0 1 .353.854l-5.793 5.792a.5.5 0 0 1-.707 0Z"]
    }
};
class TriangleDownIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = triangleDownIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TriangleDownIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TriangleDownIconComponent, isStandalone: true, selector: "svg[triangle-down-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TriangleDownIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[triangle-down-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const triangleLeftIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.573 4.427 6.177 7.823a.25.25 0 0 0 0 .354l3.396 3.396a.25.25 0 0 0 .427-.177V4.604a.25.25 0 0 0-.427-.177Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m8.854 11.646 5.792-5.792a.5.5 0 0 1 .854.353v11.586a.5.5 0 0 1-.854.353l-5.792-5.792a.5.5 0 0 1 0-.708Z"]
    }
};
class TriangleLeftIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = triangleLeftIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TriangleLeftIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TriangleLeftIconComponent, isStandalone: true, selector: "svg[triangle-left-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TriangleLeftIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[triangle-left-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const triangleRightIconData = {
    "16": {
        "width": 16,
        "paths": ["m6.427 4.427 3.396 3.396a.25.25 0 0 1 0 .354l-3.396 3.396A.25.25 0 0 1 6 11.396V4.604a.25.25 0 0 1 .427-.177Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m15.146 12.354-5.792 5.792a.5.5 0 0 1-.854-.353V6.207a.5.5 0 0 1 .854-.353l5.792 5.792a.5.5 0 0 1 0 .708Z"]
    }
};
class TriangleRightIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = triangleRightIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TriangleRightIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TriangleRightIconComponent, isStandalone: true, selector: "svg[triangle-right-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TriangleRightIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[triangle-right-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const triangleUpIconData = {
    "16": {
        "width": 16,
        "paths": ["m4.427 9.573 3.396-3.396a.25.25 0 0 1 .354 0l3.396 3.396a.25.25 0 0 1-.177.427H4.604a.25.25 0 0 1-.177-.427Z"]
    },
    "24": {
        "width": 24,
        "paths": ["m12.354 8.854 5.792 5.792a.5.5 0 0 1-.353.854H6.207a.5.5 0 0 1-.353-.854l5.792-5.792a.5.5 0 0 1 .708 0Z"]
    }
};
class TriangleUpIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = triangleUpIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TriangleUpIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TriangleUpIconComponent, isStandalone: true, selector: "svg[triangle-up-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TriangleUpIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[triangle-up-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const trophyIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.217 6.962A3.75 3.75 0 0 1 0 3.25v-.5C0 1.784.784 1 1.75 1h1.356c.228-.585.796-1 1.462-1h6.864c.647 0 1.227.397 1.462 1h1.356c.966 0 1.75.784 1.75 1.75v.5a3.75 3.75 0 0 1-3.217 3.712 5.014 5.014 0 0 1-2.771 3.117l.144 1.446c.005.05.03.12.114.204.086.087.217.17.373.227.283.103.618.274.89.568.285.31.467.723.467 1.226v.75h1.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H4v-.75c0-.503.182-.916.468-1.226.27-.294.606-.465.889-.568.139-.048.266-.126.373-.227.084-.085.109-.153.114-.204l.144-1.446a5.015 5.015 0 0 1-2.77-3.117ZM4.5 1.568V5.5a3.5 3.5 0 1 0 7 0V1.568a.068.068 0 0 0-.068-.068H4.568a.068.068 0 0 0-.068.068Zm2.957 8.902-.12 1.204c-.093.925-.858 1.47-1.467 1.691a.766.766 0 0 0-.3.176c-.037.04-.07.093-.07.21v.75h5v-.75c0-.117-.033-.17-.07-.21a.766.766 0 0 0-.3-.176c-.609-.221-1.374-.766-1.466-1.69l-.12-1.204a5.064 5.064 0 0 1-1.087 0ZM13 2.5v2.872a2.25 2.25 0 0 0 1.5-2.122v-.5a.25.25 0 0 0-.25-.25H13Zm-10 0H1.75a.25.25 0 0 0-.25.25v.5c0 .98.626 1.813 1.5 2.122Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.09 10.121A5.251 5.251 0 0 1 1 5V3.75C1 2.784 1.784 2 2.75 2h2.364c.236-.586.81-1 1.48-1h10.812c.67 0 1.244.414 1.48 1h2.489c.966 0 1.75.784 1.75 1.75V5a5.252 5.252 0 0 1-4.219 5.149 7.01 7.01 0 0 1-4.644 5.478l.231 3.003a.5.5 0 0 0 .034.031c.079.065.303.203.836.282.838.124 1.637.81 1.637 1.807v.75h2.25a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5H7v-.75c0-.996.8-1.683 1.637-1.807.533-.08.757-.217.836-.282a.5.5 0 0 0 .034-.031l.231-3.003A7.012 7.012 0 0 1 5.09 10.12ZM6.5 2.594V9a5.5 5.5 0 1 0 11 0V2.594a.094.094 0 0 0-.094-.094H6.594a.094.094 0 0 0-.094.094Zm4.717 13.363-.215 2.793-.001.021-.003.043a1.212 1.212 0 0 1-.022.147c-.05.237-.194.567-.553.86-.348.286-.853.5-1.566.605a.478.478 0 0 0-.274.136.264.264 0 0 0-.083.188v.75h7v-.75a.264.264 0 0 0-.083-.188.478.478 0 0 0-.274-.136c-.713-.105-1.218-.32-1.567-.604-.358-.294-.502-.624-.552-.86a1.22 1.22 0 0 1-.025-.19l-.001-.022-.215-2.793a7.069 7.069 0 0 1-1.566 0ZM19 8.578A3.751 3.751 0 0 0 21.625 5V3.75a.25.25 0 0 0-.25-.25H19ZM5 3.5H2.75a.25.25 0 0 0-.25.25V5A3.752 3.752 0 0 0 5 8.537Z"]
    }
};
class TrophyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = trophyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TrophyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TrophyIconComponent, isStandalone: true, selector: "svg[trophy-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TrophyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[trophy-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const typographyIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.71 10H2.332l-.874 2.498a.75.75 0 0 1-1.415-.496l3.39-9.688a1.217 1.217 0 0 1 2.302.018l3.227 9.681a.75.75 0 0 1-1.423.474Zm3.13-4.358C10.53 4.374 11.87 4 13 4c1.5 0 3 .939 3 2.601v5.649a.75.75 0 0 1-1.448.275C13.995 12.82 13.3 13 12.5 13c-.77 0-1.514-.231-2.078-.709-.577-.488-.922-1.199-.922-2.041 0-.694.265-1.411.887-1.944C11 7.78 11.88 7.5 13 7.5h1.5v-.899c0-.54-.5-1.101-1.5-1.101-.869 0-1.528.282-1.84.858a.75.75 0 1 1-1.32-.716ZM6.21 8.5 4.574 3.594 2.857 8.5Zm8.29.5H13c-.881 0-1.375.22-1.637.444-.253.217-.363.5-.363.806 0 .408.155.697.39.896.249.21.63.354 1.11.354.732 0 1.26-.209 1.588-.449.35-.257.412-.495.412-.551Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.414 15H3.586l-1.631 4.505a.75.75 0 1 1-1.41-.51l5.08-14.03a1.463 1.463 0 0 1 2.75 0l5.08 14.03a.75.75 0 1 1-1.411.51Zm4.532-5.098c.913-1.683 2.703-2.205 4.284-2.205 1.047 0 2.084.312 2.878.885.801.577 1.392 1.455 1.392 2.548v8.12a.75.75 0 0 1-1.5 0v-.06l-.044.025c-.893.52-2.096.785-3.451.785-1.051 0-2.048-.315-2.795-.948-.76-.643-1.217-1.578-1.217-2.702 0-.919.349-1.861 1.168-2.563.81-.694 2-1.087 3.569-1.087H22v-1.57c0-.503-.263-.967-.769-1.332-.513-.37-1.235-.6-2.001-.6-1.319 0-2.429.43-2.966 1.42a.75.75 0 0 1-1.318-.716ZM9.87 13.5 7 5.572 4.13 13.5Zm12.13.7h-2.77c-1.331 0-2.134.333-2.593.726a1.822 1.822 0 0 0-.644 1.424c0 .689.267 1.203.686 1.557.43.365 1.065.593 1.826.593 1.183 0 2.102-.235 2.697-.581.582-.34.798-.74.798-1.134Z"]
    }
};
class TypographyIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = typographyIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TypographyIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: TypographyIconComponent, isStandalone: true, selector: "svg[typography-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: TypographyIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[typography-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const undoIconData = {
    "16": {
        "width": 16,
        "paths": ["M1.22 6.28a.749.749 0 0 1 0-1.06l3.5-3.5a.749.749 0 1 1 1.06 1.06L3.561 5h7.188l.001.007L10.749 5c.058 0 .116.007.171.019A4.501 4.501 0 0 1 10.5 14H8.796a.75.75 0 0 1 0-1.5H10.5a3 3 0 1 0 0-6H3.561L5.78 8.72a.749.749 0 1 1-1.06 1.06l-3.5-3.5Z"]
    }
};
class UndoIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = undoIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UndoIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: UndoIconComponent, isStandalone: true, selector: "svg[undo-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UndoIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[undo-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const unfoldIconData = {
    "16": {
        "width": 16,
        "paths": ["m8.177.677 2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25a.75.75 0 0 1-1.5 0V4H5.104a.25.25 0 0 1-.177-.427L7.823.677a.25.25 0 0 1 .354 0ZM7.25 10.75a.75.75 0 0 1 1.5 0V12h2.146a.25.25 0 0 1 .177.427l-2.896 2.896a.25.25 0 0 1-.354 0l-2.896-2.896A.25.25 0 0 1 5.104 12H7.25v-1.25Zm-5-2a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M12 23a.749.749 0 0 1-.53-.22l-3.25-3.25a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215L12 21.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-3.25 3.25A.749.749 0 0 1 12 23Z", "M11.47 1.22a.75.75 0 0 1 1.06 0l3.25 3.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L12 2.81 9.28 5.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042ZM12 22.25a.75.75 0 0 1-.75-.75v-5.75a.75.75 0 0 1 1.5 0v5.75a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z", "M12 1.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 12 1.5Z"]
    }
};
class UnfoldIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = unfoldIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnfoldIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: UnfoldIconComponent, isStandalone: true, selector: "svg[unfold-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnfoldIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[unfold-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const unlinkIconData = {
    "16": {
        "width": 16,
        "paths": ["M12.914 5.914a2 2 0 0 0-2.828-2.828l-.837.837a.75.75 0 1 1-1.06-1.061l.836-.837a3.5 3.5 0 1 1 4.95 4.95l-.195.194a.75.75 0 0 1-1.06-1.06l.194-.195Zm-1.87 3.482a.759.759 0 0 1-.07.079c-.63.63-1.468 1.108-2.343 1.263-.89.159-1.86-.017-2.606-.763a.75.75 0 1 1 1.06-1.06c.329.327.767.438 1.284.347.493-.088 1.018-.36 1.445-.752l-1.247-.897a.709.709 0 0 1-.01-.008l-.295-.212c-.94-.597-1.984-.499-2.676.193l-2.5 2.5a2 2 0 1 0 2.828 2.828l.837-.836a.75.75 0 0 1 1.06 1.06l-.836.837a3.5 3.5 0 0 1-4.95-4.95l2.5-2.5a3.472 3.472 0 0 1 1.354-.848L2.312 3.109a.75.75 0 0 1 .876-1.218l5.93 4.27c.115.074.226.155.335.24l6.235 4.49a.75.75 0 0 1-.876 1.218l-3.768-2.713Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M20.347 3.653a3.936 3.936 0 0 0-5.567 0l-1.75 1.75a.75.75 0 0 1-1.06-1.06l1.75-1.75a5.436 5.436 0 0 1 7.688 7.687l-1.564 1.564a.75.75 0 0 1-1.06-1.06l1.563-1.564a3.936 3.936 0 0 0 0-5.567ZM9.786 12.369a.75.75 0 0 1 1.053.125c.096.122.2.24.314.353 1.348 1.348 3.386 1.587 4.89.658l-3.922-2.858a.745.745 0 0 1-.057-.037c-1.419-1.013-3.454-.787-4.784.543L3.653 14.78a3.936 3.936 0 0 0 5.567 5.567l3-3a.75.75 0 1 1 1.06 1.06l-3 3a5.436 5.436 0 1 1-7.688-7.687l3.628-3.628a5.517 5.517 0 0 1 3.014-1.547l-7.05-5.136a.75.75 0 0 1 .883-1.213l20.25 14.75a.75.75 0 0 1-.884 1.213l-5.109-3.722c-2.155 1.709-5.278 1.425-7.232-.53a5.491 5.491 0 0 1-.431-.485.75.75 0 0 1 .125-1.053Z"]
    }
};
class UnlinkIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = unlinkIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnlinkIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: UnlinkIconComponent, isStandalone: true, selector: "svg[unlink-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnlinkIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[unlink-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const unlockIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.5 4v2h7A1.5 1.5 0 0 1 14 7.5v6a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5v-6A1.5 1.5 0 0 1 3.499 6H4V4a4 4 0 0 1 7.371-2.154.75.75 0 0 1-1.264.808A2.5 2.5 0 0 0 5.5 4Zm-2 3.5v6h9v-6h-9Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M7.5 7.25V9h11a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 19.5v-8A2.5 2.5 0 0 1 5.5 9H6V7.25C6 3.845 8.503 1 12 1c2.792 0 4.971 1.825 5.718 4.31a.75.75 0 1 1-1.436.432C15.71 3.84 14.079 2.5 12 2.5c-2.578 0-4.5 2.08-4.5 4.75Zm-3 4.25v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1Z"]
    }
};
class UnlockIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = unlockIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnlockIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: UnlockIconComponent, isStandalone: true, selector: "svg[unlock-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnlockIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[unlock-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const unmuteIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.563 2.069A.75.75 0 0 1 8 2.75v10.5a.751.751 0 0 1-1.238.57L3.472 11H1.75A1.75 1.75 0 0 1 0 9.25v-2.5C0 5.784.784 5 1.75 5h1.723l3.289-2.82a.75.75 0 0 1 .801-.111ZM6.5 4.38 4.238 6.319a.748.748 0 0 1-.488.181h-2a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2c.179 0 .352.064.488.18L6.5 11.62Zm6.096-2.038a.75.75 0 0 1 1.06 0 8 8 0 0 1 0 11.314.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042 6.5 6.5 0 0 0 0-9.193.75.75 0 0 1 0-1.06Zm-1.06 2.121-.001.001a5 5 0 0 1 0 7.07.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734 3.5 3.5 0 0 0 0-4.95.75.75 0 1 1 1.061-1.061Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M11.553 3.064A.75.75 0 0 1 12 3.75v16.5a.75.75 0 0 1-1.255.555L5.46 16H2.75A1.75 1.75 0 0 1 1 14.25v-4.5C1 8.784 1.784 8 2.75 8h2.71l5.285-4.805a.752.752 0 0 1 .808-.13ZM10.5 5.445l-4.245 3.86a.748.748 0 0 1-.505.195h-3a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h3c.187 0 .367.069.505.195l4.245 3.86Zm8.218-1.223a.75.75 0 0 1 1.06 0c4.296 4.296 4.296 11.26 0 15.556a.75.75 0 0 1-1.06-1.06 9.5 9.5 0 0 0 0-13.436.75.75 0 0 1 0-1.06Z", "M16.243 7.757a.75.75 0 1 0-1.061 1.061 4.5 4.5 0 0 1 0 6.364.75.75 0 0 0 1.06 1.06 6 6 0 0 0 0-8.485Z"]
    }
};
class UnmuteIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = unmuteIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnmuteIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: UnmuteIconComponent, isStandalone: true, selector: "svg[unmute-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnmuteIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[unmute-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const unreadIconData = {
    "16": {
        "width": 16,
        "paths": ["M10.5 3.5H1.75a.25.25 0 0 0-.25.25v.32L8 7.88l3.02-1.77a.75.75 0 0 1 .758 1.295L8.379 9.397a.75.75 0 0 1-.758 0L1.5 5.809v6.441c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4.5a.75.75 0 0 1 1.5 0v4.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25V4.513a.75.75 0 0 1 0-.027V3.75C0 2.784.784 2 1.75 2h8.75a.75.75 0 0 1 0 1.5Z", "M14 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1.75 4.5a.25.25 0 0 0-.25.25v.852l10.36 7a.25.25 0 0 0 .28 0l5.69-3.845A.75.75 0 0 1 18.67 10l-5.69 3.845c-.592.4-1.368.4-1.96 0L1.5 7.412V19.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25v-8.5a.75.75 0 0 1 1.5 0v8.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25V4.75C0 3.784.784 3 1.75 3h15.5a.75.75 0 0 1 0 1.5H1.75Z", "M24 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"]
    }
};
class UnreadIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = unreadIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnreadIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: UnreadIconComponent, isStandalone: true, selector: "svg[unread-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnreadIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[unread-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const unverifiedIconData = {
    "16": {
        "width": 16,
        "paths": ["M6.415.52a2.677 2.677 0 0 1 3.17 0l.928.68c.153.113.33.186.518.215l1.138.175a2.678 2.678 0 0 1 2.241 2.24l.175 1.138c.029.187.102.365.215.518l.68.928a2.677 2.677 0 0 1 0 3.17l-.68.928a1.186 1.186 0 0 0-.215.518l-.175 1.138a2.678 2.678 0 0 1-2.241 2.241l-1.138.175a1.186 1.186 0 0 0-.518.215l-.928.68a2.677 2.677 0 0 1-3.17 0l-.928-.68a1.186 1.186 0 0 0-.518-.215L3.83 14.41a2.678 2.678 0 0 1-2.24-2.24l-.175-1.138a1.186 1.186 0 0 0-.215-.518l-.68-.928a2.677 2.677 0 0 1 0-3.17l.68-.928a1.17 1.17 0 0 0 .215-.518l.175-1.14a2.678 2.678 0 0 1 2.24-2.24l1.138-.175c.187-.029.365-.102.518-.215l.928-.68Zm2.282 1.209a1.18 1.18 0 0 0-1.394 0l-.928.68a2.67 2.67 0 0 1-1.18.489l-1.136.174a1.18 1.18 0 0 0-.987.987l-.174 1.137a2.67 2.67 0 0 1-.489 1.18l-.68.927c-.305.415-.305.98 0 1.394l.68.928c.256.348.423.752.489 1.18l.174 1.136c.078.51.478.909.987.987l1.137.174c.427.066.831.233 1.18.489l.927.68c.415.305.98.305 1.394 0l.928-.68a2.67 2.67 0 0 1 1.18-.489l1.136-.174c.51-.078.909-.478.987-.987l.174-1.137c.066-.427.233-.831.489-1.18l.68-.927c.305-.415.305-.98 0-1.394l-.68-.928a2.67 2.67 0 0 1-.489-1.18l-.174-1.136a1.18 1.18 0 0 0-.987-.987l-1.137-.174a2.67 2.67 0 0 1-1.18-.489ZM6.92 6.085h.001a.75.75 0 0 1-1.342-.67c.169-.339.436-.701.849-.977C6.846 4.16 7.369 4 8 4a2.76 2.76 0 0 1 1.638.525c.502.377.862.965.862 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 0 0-.26.16.952.952 0 0 0-.276.245.75.75 0 0 1-1.248-.832c.184-.264.42-.489.692-.661.109-.073.22-.139.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 0 0 .277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 0 0-.262-.525A1.27 1.27 0 0 0 8 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 0 0-.34.398ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M13 16.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-2.517-7.665c.112-.223.268-.424.488-.57C11.186 8.12 11.506 8 12 8c.384 0 .766.118 1.034.319a.953.953 0 0 1 .403.806c0 .48-.218.81-.62 1.186a9.293 9.293 0 0 1-.409.354 19.8 19.8 0 0 0-.294.249c-.246.213-.524.474-.738.795l-.126.19V13.5a.75.75 0 0 0 1.5 0v-1.12c.09-.1.203-.208.347-.333.063-.055.14-.119.222-.187.166-.14.358-.3.52-.452.536-.5 1.098-1.2 1.098-2.283a2.45 2.45 0 0 0-1.003-2.006C13.37 6.695 12.658 6.5 12 6.5c-.756 0-1.373.191-1.861.517a2.944 2.944 0 0 0-.997 1.148.75.75 0 0 0 1.341.67Z", "M9.864 1.2a3.61 3.61 0 0 1 4.272 0l1.375 1.01c.274.2.593.333.929.384l1.686.259a3.61 3.61 0 0 1 3.021 3.02l.259 1.687c.051.336.183.655.384.929l1.01 1.375a3.61 3.61 0 0 1 0 4.272l-1.01 1.375a2.106 2.106 0 0 0-.384.929l-.259 1.686a3.61 3.61 0 0 1-3.02 3.021l-1.687.259a2.106 2.106 0 0 0-.929.384l-1.375 1.01a3.61 3.61 0 0 1-4.272 0l-1.375-1.01a2.106 2.106 0 0 0-.929-.384l-1.686-.259a3.61 3.61 0 0 1-3.021-3.02l-.259-1.687a2.106 2.106 0 0 0-.384-.929L1.2 14.136a3.61 3.61 0 0 1 0-4.272l1.01-1.375c.201-.274.333-.593.384-.929l.259-1.686a3.61 3.61 0 0 1 3.02-3.021l1.687-.259c.336-.051.655-.183.929-.384Zm3.384 1.209a2.11 2.11 0 0 0-2.496 0l-1.376 1.01a3.61 3.61 0 0 1-1.589.658l-1.686.258a2.111 2.111 0 0 0-1.766 1.766l-.258 1.686a3.614 3.614 0 0 1-.658 1.59l-1.01 1.375a2.11 2.11 0 0 0 0 2.496l1.01 1.376a3.61 3.61 0 0 1 .658 1.589l.258 1.686a2.11 2.11 0 0 0 1.766 1.765l1.686.26a3.613 3.613 0 0 1 1.59.657l1.375 1.01a2.11 2.11 0 0 0 2.496 0l1.376-1.01a3.61 3.61 0 0 1 1.589-.658l1.686-.258a2.11 2.11 0 0 0 1.765-1.766l.26-1.686a3.613 3.613 0 0 1 .657-1.59l1.01-1.375a2.11 2.11 0 0 0 0-2.496l-1.01-1.376a3.61 3.61 0 0 1-.658-1.589l-.258-1.686a2.111 2.111 0 0 0-1.766-1.766l-1.686-.258a3.614 3.614 0 0 1-1.59-.658Z"]
    }
};
class UnverifiedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = unverifiedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnverifiedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: UnverifiedIconComponent, isStandalone: true, selector: "svg[unverified-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UnverifiedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[unverified-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const uploadIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z", "M11.78 4.72a.749.749 0 1 1-1.06 1.06L8.75 3.811V9.5a.75.75 0 0 1-1.5 0V3.811L5.28 5.78a.749.749 0 1 1-1.06-1.06l3.25-3.25a.749.749 0 0 1 1.06 0l3.25 3.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M4 20.25V18a.75.75 0 0 1 1.5 0v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25Z", "M5.22 9.53a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 1 1-1.06 1.06l-4.97-4.969V16.75a.75.75 0 0 1-1.5 0V4.561L6.28 9.53a.749.749 0 0 1-1.06 0Z"]
    }
};
class UploadIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = uploadIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UploadIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: UploadIconComponent, isStandalone: true, selector: "svg[upload-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: UploadIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[upload-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const verifiedIconData = {
    "16": {
        "width": 16,
        "paths": ["m9.585.52.929.68c.153.112.331.186.518.215l1.138.175a2.678 2.678 0 0 1 2.24 2.24l.174 1.139c.029.187.103.365.215.518l.68.928a2.677 2.677 0 0 1 0 3.17l-.68.928a1.174 1.174 0 0 0-.215.518l-.175 1.138a2.678 2.678 0 0 1-2.241 2.241l-1.138.175a1.17 1.17 0 0 0-.518.215l-.928.68a2.677 2.677 0 0 1-3.17 0l-.928-.68a1.174 1.174 0 0 0-.518-.215L3.83 14.41a2.678 2.678 0 0 1-2.24-2.24l-.175-1.138a1.17 1.17 0 0 0-.215-.518l-.68-.928a2.677 2.677 0 0 1 0-3.17l.68-.928c.112-.153.186-.331.215-.518l.175-1.14a2.678 2.678 0 0 1 2.24-2.24l1.139-.175c.187-.029.365-.103.518-.215l.928-.68a2.677 2.677 0 0 1 3.17 0ZM7.303 1.728l-.927.68a2.67 2.67 0 0 1-1.18.489l-1.137.174a1.179 1.179 0 0 0-.987.987l-.174 1.136a2.677 2.677 0 0 1-.489 1.18l-.68.928a1.18 1.18 0 0 0 0 1.394l.68.927c.256.348.424.753.489 1.18l.174 1.137c.078.509.478.909.987.987l1.136.174a2.67 2.67 0 0 1 1.18.489l.928.68c.414.305.979.305 1.394 0l.927-.68a2.67 2.67 0 0 1 1.18-.489l1.137-.174a1.18 1.18 0 0 0 .987-.987l.174-1.136a2.67 2.67 0 0 1 .489-1.18l.68-.928a1.176 1.176 0 0 0 0-1.394l-.68-.927a2.686 2.686 0 0 1-.489-1.18l-.174-1.137a1.179 1.179 0 0 0-.987-.987l-1.136-.174a2.677 2.677 0 0 1-1.18-.489l-.928-.68a1.176 1.176 0 0 0-1.394 0ZM11.28 6.78l-3.75 3.75a.75.75 0 0 1-1.06 0L4.72 8.78a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L7 8.94l3.22-3.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M17.03 9.78a.75.75 0 0 0-1.06-1.06l-5.47 5.47-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6-6Z", "m14.136 1.2 1.375 1.01c.274.201.593.333.929.384l1.687.259a3.61 3.61 0 0 1 3.02 3.021l.259 1.686c.051.336.183.655.384.929l1.01 1.375a3.61 3.61 0 0 1 0 4.272l-1.01 1.375a2.106 2.106 0 0 0-.384.929l-.259 1.687a3.61 3.61 0 0 1-3.021 3.02l-1.686.259a2.106 2.106 0 0 0-.929.384l-1.375 1.01a3.61 3.61 0 0 1-4.272 0l-1.375-1.01a2.106 2.106 0 0 0-.929-.384l-1.687-.259a3.61 3.61 0 0 1-3.02-3.021l-.259-1.686a2.117 2.117 0 0 0-.384-.929L1.2 14.136a3.61 3.61 0 0 1 0-4.272l1.01-1.375c.201-.274.333-.593.384-.929l.259-1.687a3.61 3.61 0 0 1 3.021-3.02l1.686-.259c.336-.051.655-.183.929-.384L9.864 1.2a3.61 3.61 0 0 1 4.272 0Zm-3.384 1.209-1.375 1.01a3.614 3.614 0 0 1-1.59.658l-1.686.258a2.111 2.111 0 0 0-1.766 1.766l-.258 1.686a3.61 3.61 0 0 1-.658 1.589l-1.01 1.376a2.11 2.11 0 0 0 0 2.496l1.01 1.375c.344.469.57 1.015.658 1.59l.258 1.686c.14.911.855 1.626 1.766 1.766l1.686.258a3.61 3.61 0 0 1 1.589.658l1.376 1.01a2.11 2.11 0 0 0 2.496 0l1.375-1.01a3.613 3.613 0 0 1 1.59-.657l1.686-.26a2.11 2.11 0 0 0 1.766-1.765l.258-1.686a3.61 3.61 0 0 1 .658-1.589l1.01-1.376a2.11 2.11 0 0 0 0-2.496l-1.01-1.375a3.613 3.613 0 0 1-.657-1.59l-.26-1.686a2.11 2.11 0 0 0-1.765-1.766l-1.686-.258a3.61 3.61 0 0 1-1.589-.658l-1.376-1.01a2.11 2.11 0 0 0-2.496 0Z"]
    }
};
class VerifiedIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = verifiedIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: VerifiedIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: VerifiedIconComponent, isStandalone: true, selector: "svg[verified-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: VerifiedIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[verified-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const versionsIconData = {
    "16": {
        "width": 16,
        "paths": ["M7.75 14A1.75 1.75 0 0 1 6 12.25v-8.5C6 2.784 6.784 2 7.75 2h6.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14Zm-.25-1.75c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.25.25ZM4.9 3.508a.75.75 0 0 1-.274 1.025.249.249 0 0 0-.126.217v6.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.75 1.75 0 0 1 3 11.25v-6.5c0-.649.353-1.214.874-1.516a.75.75 0 0 1 1.025.274ZM1.625 5.533h.001a.249.249 0 0 0-.126.217v4.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 0 10.25v-4.5a1.748 1.748 0 0 1 .873-1.516.75.75 0 1 1 .752 1.299Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2Zm-.5-2a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5ZM6.17 4.165a.75.75 0 0 1-.335 1.006c-.228.114-.295.177-.315.201a.035.035 0 0 0-.008.016.423.423 0 0 0-.012.112v13c0 .07.008.102.012.112a.03.03 0 0 0 .008.016c.02.024.087.087.315.201a.749.749 0 1 1-.67 1.342c-.272-.136-.58-.315-.81-.598C4.1 19.259 4 18.893 4 18.5v-13c0-.393.1-.759.355-1.073.23-.283.538-.462.81-.598a.75.75 0 0 1 1.006.336ZM2.15 5.624a.75.75 0 0 1-.274 1.025c-.15.087-.257.17-.32.245C1.5 6.96 1.5 6.99 1.5 7v10c0 .01 0 .04.056.106.063.074.17.158.32.245a.75.75 0 0 1-.752 1.298C.73 18.421 0 17.907 0 17V7c0-.907.73-1.42 1.124-1.65a.75.75 0 0 1 1.025.274Z"]
    }
};
class VersionsIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = versionsIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: VersionsIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: VersionsIconComponent, isStandalone: true, selector: "svg[versions-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: VersionsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[versions-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const videoIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25Z", "M6 10.559V5.442a.25.25 0 0 1 .379-.215l4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559A.25.25 0 0 1 6 10.559Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z", "M9 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842L9.77 16.005a.5.5 0 0 1-.77-.42Z"]
    }
};
class VideoIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = videoIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: VideoIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: VideoIconComponent, isStandalone: true, selector: "svg[video-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: VideoIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[video-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const webhookIconData = {
    "16": {
        "width": 16,
        "paths": ["M5.5 4.25a2.25 2.25 0 0 1 4.5 0 .75.75 0 0 0 1.5 0 3.75 3.75 0 1 0-6.14 2.889l-2.272 4.258a.75.75 0 0 0 1.324.706L7 7.25a.75.75 0 0 0-.309-1.015A2.25 2.25 0 0 1 5.5 4.25Z", "M7.364 3.607a.75.75 0 0 1 1.03.257l2.608 4.349a3.75 3.75 0 1 1-.628 6.785.75.75 0 0 1 .752-1.299 2.25 2.25 0 1 0-.033-3.88.75.75 0 0 1-1.03-.256L7.107 4.636a.75.75 0 0 1 .257-1.03Z", "M2.9 8.776A.75.75 0 0 1 2.625 9.8 2.25 2.25 0 1 0 6 11.75a.75.75 0 0 1 .75-.751h5.5a.75.75 0 0 1 0 1.5H7.425a3.751 3.751 0 1 1-5.55-3.998.75.75 0 0 1 1.024.274Z"]
    }
};
class WebhookIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = webhookIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: WebhookIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: WebhookIconComponent, isStandalone: true, selector: "svg[webhook-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: WebhookIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[webhook-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const workflowIconData = {
    "16": {
        "width": 16,
        "paths": ["M0 1.75C0 .784.784 0 1.75 0h3.5C6.216 0 7 .784 7 1.75v3.5A1.75 1.75 0 0 1 5.25 7H4v4a1 1 0 0 0 1 1h4v-1.25C9 9.784 9.784 9 10.75 9h3.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 14.25 16h-3.5A1.75 1.75 0 0 1 9 14.25v-.75H5A2.5 2.5 0 0 1 2.5 11V7h-.75A1.75 1.75 0 0 1 0 5.25Zm1.75-.25a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Zm9 9a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1 3a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H7v4.063C7 16.355 7.644 17 8.438 17H12.5v-2.5a2 2 0 0 1 2-2H21a2 2 0 0 1 2 2V21a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2v-2.5H8.437A2.939 2.939 0 0 1 5.5 15.562V11.5H3a2 2 0 0 1-2-2Zm2-.5a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5ZM14.5 14a.5.5 0 0 0-.5.5V21a.5.5 0 0 0 .5.5H21a.5.5 0 0 0 .5-.5v-6.5a.5.5 0 0 0-.5-.5Z"]
    }
};
class WorkflowIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = workflowIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: WorkflowIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: WorkflowIconComponent, isStandalone: true, selector: "svg[workflow-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: WorkflowIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[workflow-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const xIconData = {
    "12": {
        "width": 12,
        "paths": ["M2.22 2.22a.749.749 0 0 1 1.06 0L6 4.939 8.72 2.22a.749.749 0 1 1 1.06 1.06L7.061 6 9.78 8.72a.749.749 0 1 1-1.06 1.06L6 7.061 3.28 9.78a.749.749 0 1 1-1.06-1.06L4.939 6 2.22 3.28a.749.749 0 0 1 0-1.06Z"]
    },
    "16": {
        "width": 16,
        "paths": ["M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M5.72 5.72a.75.75 0 0 1 1.06 0L12 10.94l5.22-5.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L13.06 12l5.22 5.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 13.06l-5.22 5.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.94 12 5.72 6.78a.75.75 0 0 1 0-1.06Z"]
    }
};
class XIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = xIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: XIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: XIconComponent, isStandalone: true, selector: "svg[x-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: XIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[x-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const xCircleIconData = {
    "16": {
        "width": 16,
        "paths": ["M2.344 2.343h-.001a8 8 0 0 1 11.314 11.314A8.002 8.002 0 0 1 .234 10.089a8 8 0 0 1 2.11-7.746Zm1.06 10.253a6.5 6.5 0 1 0 9.108-9.275 6.5 6.5 0 0 0-9.108 9.275ZM6.03 4.97 8 6.94l1.97-1.97a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l1.97 1.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-1.97 1.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L6.94 8 4.97 6.03a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M9.036 7.976a.75.75 0 0 0-1.06 1.06L10.939 12l-2.963 2.963a.75.75 0 1 0 1.06 1.06L12 13.06l2.963 2.964a.75.75 0 0 0 1.061-1.06L13.061 12l2.963-2.964a.75.75 0 1 0-1.06-1.06L12 10.939 9.036 7.976Z", "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"]
    }
};
class XCircleIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = xCircleIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: XCircleIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: XCircleIconComponent, isStandalone: true, selector: "svg[x-circle-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: XCircleIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[x-circle-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const xCircleFillIconData = {
    "12": {
        "width": 12,
        "paths": ["M1.757 10.243a6.001 6.001 0 1 1 8.488-8.486 6.001 6.001 0 0 1-8.488 8.486ZM6 4.763l-2-2L2.763 4l2 2-2 2L4 9.237l2-2 2 2L9.237 8l-2-2 2-2L8 2.763Z"]
    },
    "16": {
        "width": 16,
        "paths": ["M2.343 13.657A8 8 0 1 1 13.658 2.343 8 8 0 0 1 2.343 13.657ZM6.03 4.97a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L6.94 8 4.97 9.97a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L8 9.06l1.97 1.97a.749.749 0 0 0 1.275-.326.749.749 0 0 0-.215-.734L9.06 8l1.97-1.97a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L8 6.94Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm8.036-4.024a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L10.939 12l-2.963 2.963a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L12 13.06l2.963 2.964a.75.75 0 0 0 1.061-1.06L13.061 12l2.963-2.964a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L12 10.939Z"]
    }
};
class XCircleFillIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = xCircleFillIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: XCircleFillIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: XCircleFillIconComponent, isStandalone: true, selector: "svg[x-circle-fill-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: XCircleFillIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[x-circle-fill-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const zapIconData = {
    "16": {
        "width": 16,
        "paths": ["M9.504.43a1.516 1.516 0 0 1 2.437 1.713L10.415 5.5h2.123c1.57 0 2.346 1.909 1.22 3.004l-7.34 7.142a1.249 1.249 0 0 1-.871.354h-.302a1.25 1.25 0 0 1-1.157-1.723L5.633 10.5H3.462c-1.57 0-2.346-1.909-1.22-3.004L9.503.429Zm1.047 1.074L3.286 8.571A.25.25 0 0 0 3.462 9H6.75a.75.75 0 0 1 .694 1.034l-1.713 4.188 6.982-6.793A.25.25 0 0 0 12.538 7H9.25a.75.75 0 0 1-.683-1.06l2.008-4.418.003-.006a.036.036 0 0 0-.004-.009l-.006-.006-.008-.001c-.003 0-.006.002-.009.004Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M15.716 1.329a1.341 1.341 0 0 1 2.109 1.55L15.147 9h4.161c1.623 0 2.372 2.016 1.143 3.075L8.102 22.721a1.148 1.148 0 0 1-1.81-1.317L8.996 15H4.674c-1.619 0-2.37-2.008-1.148-3.07l12.19-10.6Zm.452 1.595L4.51 13.061a.25.25 0 0 0 .164.439h5.45a.749.749 0 0 1 .692 1.041l-2.559 6.066 11.215-9.668a.25.25 0 0 0-.164-.439H14a.75.75 0 0 1-.687-1.05Z"]
    }
};
class ZapIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = zapIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ZapIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ZapIconComponent, isStandalone: true, selector: "svg[zap-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ZapIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[zap-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const zoomInIconData = {
    "16": {
        "width": 16,
        "paths": ["M3.75 7.5a.75.75 0 0 1 .75-.75h2.25V4.5a.75.75 0 0 1 1.5 0v2.25h2.25a.75.75 0 0 1 0 1.5H8.25v2.25a.75.75 0 0 1-1.5 0V8.25H4.5a.75.75 0 0 1-.75-.75Z", "M7.5 0a7.5 7.5 0 0 1 5.807 12.247l2.473 2.473a.749.749 0 1 1-1.06 1.06l-2.473-2.473A7.5 7.5 0 1 1 7.5 0Zm-6 7.5a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M10.5 5.75a.75.75 0 0 1 .75.75v3.25h3.25a.75.75 0 0 1 0 1.5h-3.25v3.25a.75.75 0 0 1-1.5 0v-3.25H6.5a.75.75 0 0 1 0-1.5h3.25V6.5a.75.75 0 0 1 .75-.75Z", "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 1 1-1.06 1.06l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"]
    }
};
class ZoomInIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = zoomInIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ZoomInIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ZoomInIconComponent, isStandalone: true, selector: "svg[zoom-in-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ZoomInIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[zoom-in-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });
const zoomOutIconData = {
    "16": {
        "width": 16,
        "paths": ["M4.5 6.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5Z", "M0 7.5a7.5 7.5 0 1 1 13.307 4.747l2.473 2.473a.749.749 0 1 1-1.06 1.06l-2.473-2.473A7.5 7.5 0 0 1 0 7.5Zm7.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"]
    },
    "24": {
        "width": 24,
        "paths": ["M14.5 11.25a.75.75 0 0 0 0-1.5h-8a.75.75 0 0 0 0 1.5h8Z", "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 1 1-1.06 1.06l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"]
    }
};
class ZoomOutIconComponent extends OpOcticonComponentBase {
    constructor() {
        super(...arguments);
        this.SVGData = zoomOutIconData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ZoomOutIconComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: ZoomOutIconComponent, isStandalone: true, selector: "svg[zoom-out-icon]", usesInheritance: true, ngImport: i0, template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: ZoomOutIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'svg[zoom-out-icon]',
                    standalone: true,
                    imports: [NgIf, NgFor],
                    template: `
    <title *ngIf="title">{{title}}</title>

    <ng-template ngFor let-path [ngForOf]="paths">
      <svg:path [attr.d]="path"></svg:path>
    </ng-template>
  `,
                }]
        }] });

/*
 * Public API Surface of octicons-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccessibilityIconComponent, AccessibilityInsetIconComponent, AlertFillIconComponent, AlertIconComponent, AppsIconComponent, ArchiveIconComponent, ArrowBothIconComponent, ArrowDownIconComponent, ArrowDownLeftIconComponent, ArrowDownRightIconComponent, ArrowLeftIconComponent, ArrowRightIconComponent, ArrowSwitchIconComponent, ArrowUpIconComponent, ArrowUpLeftIconComponent, ArrowUpRightIconComponent, BeakerIconComponent, BellFillIconComponent, BellIconComponent, BellSlashIconComponent, BlockedIconComponent, BoldIconComponent, BookIconComponent, BookmarkFillIconComponent, BookmarkIconComponent, BookmarkSlashFillIconComponent, BookmarkSlashIconComponent, BriefcaseIconComponent, BroadcastIconComponent, BrowserIconComponent, BugIconComponent, CacheIconComponent, CalendarIconComponent, CheckCircleFillIconComponent, CheckCircleIconComponent, CheckIconComponent, CheckboxIconComponent, ChecklistIconComponent, ChevronDownIconComponent, ChevronLeftIconComponent, ChevronRightIconComponent, ChevronUpIconComponent, CircleIconComponent, CircleSlashIconComponent, ClockFillIconComponent, ClockIconComponent, CloudIconComponent, CloudOfflineIconComponent, CodeIconComponent, CodeOfConductIconComponent, CodeReviewIconComponent, CodeSquareIconComponent, CodescanCheckmarkIconComponent, CodescanIconComponent, CodespacesIconComponent, ColumnsIconComponent, CommandPaletteIconComponent, CommentDiscussionIconComponent, CommentIconComponent, CommitIconComponent, ContainerIconComponent, CopilotErrorIconComponent, CopilotIconComponent, CopilotWarningIconComponent, CopyIconComponent, CpuIconComponent, CreditCardIconComponent, CrossReferenceIconComponent, DashIconComponent, DatabaseIconComponent, DependabotIconComponent, DesktopDownloadIconComponent, DeviceCameraIconComponent, DeviceCameraVideoIconComponent, DeviceDesktopIconComponent, DeviceMobileIconComponent, DevicesIconComponent, DiamondIconComponent, DiffAddedIconComponent, DiffIconComponent, DiffIgnoredIconComponent, DiffModifiedIconComponent, DiffRemovedIconComponent, DiffRenamedIconComponent, DiscussionClosedIconComponent, DiscussionDuplicateIconComponent, DiscussionOutdatedIconComponent, DotFillIconComponent, DotIconComponent, DownloadIconComponent, DuplicateIconComponent, EllipsisIconComponent, EyeClosedIconComponent, EyeIconComponent, FeedDiscussionIconComponent, FeedForkedIconComponent, FeedHeartIconComponent, FeedIssueClosedIconComponent, FeedIssueDraftIconComponent, FeedIssueOpenIconComponent, FeedIssueReopenIconComponent, FeedMergedIconComponent, FeedPersonIconComponent, FeedPlusIconComponent, FeedPublicIconComponent, FeedPullRequestClosedIconComponent, FeedPullRequestDraftIconComponent, FeedPullRequestOpenIconComponent, FeedRepoIconComponent, FeedRocketIconComponent, FeedStarIconComponent, FeedTagIconComponent, FeedTrophyIconComponent, FileAddedIconComponent, FileBadgeIconComponent, FileBinaryIconComponent, FileCodeIconComponent, FileDiffIconComponent, FileDirectoryFillIconComponent, FileDirectoryIconComponent, FileDirectoryOpenFillIconComponent, FileDirectorySymlinkIconComponent, FileIconComponent, FileMediaIconComponent, FileMovedIconComponent, FileRemovedIconComponent, FileSubmoduleIconComponent, FileSymlinkFileIconComponent, FileZipIconComponent, FilterIconComponent, FilterRemoveIconComponent, FiscalHostIconComponent, FlameIconComponent, FoldDownIconComponent, FoldIconComponent, FoldUpIconComponent, GearIconComponent, GiftIconComponent, GitBranchIconComponent, GitCommitIconComponent, GitCompareIconComponent, GitMergeIconComponent, GitMergeQueueIconComponent, GitPullRequestClosedIconComponent, GitPullRequestDraftIconComponent, GitPullRequestIconComponent, GlobeIconComponent, GoalIconComponent, GrabberIconComponent, GraphIconComponent, HashIconComponent, HeadingIconComponent, HeartFillIconComponent, HeartIconComponent, HistoryIconComponent, HomeFillIconComponent, HomeIconComponent, HorizontalRuleIconComponent, HourglassIconComponent, HubotIconComponent, IdBadgeIconComponent, ImageIconComponent, InboxIconComponent, InfinityIconComponent, InfoIconComponent, IssueClosedIconComponent, IssueDraftIconComponent, IssueOpenedIconComponent, IssueReopenedIconComponent, IssueTrackedByIconComponent, IssueTracksIconComponent, ItalicIconComponent, IterationsIconComponent, KebabHorizontalIconComponent, KeyAsteriskIconComponent, KeyIconComponent, LawIconComponent, LightBulbIconComponent, LinkExternalIconComponent, LinkIconComponent, ListOrderedIconComponent, ListUnorderedIconComponent, LocationIconComponent, LockIconComponent, LogIconComponent, LogoGistIconComponent, LogoGithubIconComponent, MailIconComponent, MarkGithubIconComponent, MarkdownIconComponent, MegaphoneIconComponent, MentionIconComponent, MeterIconComponent, MilestoneIconComponent, MirrorIconComponent, MoonIconComponent, MortarBoardIconComponent, MoveToBottomIconComponent, MoveToEndIconComponent, MoveToStartIconComponent, MoveToTopIconComponent, MultiSelectIconComponent, MuteIconComponent, NoEntryFillIconComponent, NoEntryIconComponent, NorthStarIconComponent, NoteIconComponent, NumberIconComponent, OpArrowInIconComponent, OpAttachmentaddIconComponent, OpBacklogsIconComponent, OpBaselineIconComponent, OpBcfIconComponent, OpBoardsIconComponent, OpBookEditIconComponent, OpBudgetIconComponent, OpCalendarAlertIconComponent, OpCartIconComponent, OpColumnsLeftIconComponent, OpColumnsRightIconComponent, OpCopyToProjectIconComponent, OpCostReportsIconComponent, OpCursorRectangleSelectIconComponent, OpCursorSelectIconComponent, OpCustomFieldsIconComponent, OpEnterpriseAddonsIconComponent, OpEraseIconComponent, OpFileAtomIconComponent, OpFileBcfIconComponent, OpFileCheckIconComponent, OpFileCommentIconComponent, OpFileCsvIconComponent, OpFileDocIconComponent, OpFileDownloadIconComponent, OpFileEditIconComponent, OpFileFormIconComponent, OpFilePresentationIconComponent, OpFileSheetIconComponent, OpFileTextIconComponent, OpFileXlsDescriptionsIconComponent, OpGlossarIconComponent, OpGridMenuIconComponent, OpGroupIconComponent, OpHierarchyIconComponent, OpIfcIconComponent, OpInboxInIconComponent, OpIndentIconComponent, OpInputDisabledIconComponent, OpInstallationServicesIconComponent, OpKebabVerticalIconComponent, OpLinkAddIconComponent, OpListSelectAllIconComponent, OpLogoGitlabIconComponent, OpLogoGooglePlusIconComponent, OpLogoNextcloudIconComponent, OpLogoOpenprojectIconComponent, OpLogoSlackIconComponent, OpMailSentIconComponent, OpMarkNextcloudIconComponent, OpMentionCommentIconComponent, OpMoveIconComponent, OpNoHierarchyIconComponent, OpOutdentIconComponent, OpPdfDescriptionIconComponent, OpPdfIconComponent, OpPersonAccountableIconComponent, OpPersonAssignedIconComponent, OpPersonMissingIconComponent, OpPersonRemoveIconComponent, OpPhoneIconComponent, OpPrinterIconComponent, OpReadAllIconComponent, OpRelationFollowsIconComponent, OpRelationNewChildIconComponent, OpRelationsIconComponent, OpReloadIconComponent, OpResizerBottomRightIconComponent, OpResizerVerticalLinesIconComponent, OpSaveIconComponent, OpScissorsIconComponent, OpServerKeyIconComponent, OpShortcutsIconComponent, OpSortByIconComponent, OpStopwatchStartIconComponent, OpStopwatchStopIconComponent, OpTeamPlannerIconComponent, OpTriangleDeltaIconComponent, OpViewCardsIconComponent, OpViewFullscreenIconComponent, OpViewListIconComponent, OpViewModalIconComponent, OpViewSplitIconComponent, OpViewSplitModalIconComponent, OpViewTimelineIconComponent, OpWorkPackagesIconComponent, OpXlsIconComponent, OpXlsRelationsIconComponent, OrganizationIconComponent, PackageDependenciesIconComponent, PackageDependentsIconComponent, PackageIconComponent, PaintbrushIconComponent, PaperAirplaneIconComponent, PaperclipIconComponent, PasskeyFillIconComponent, PasteIconComponent, PencilIconComponent, PeopleIconComponent, PersonAddIconComponent, PersonFillIconComponent, PersonIconComponent, PinIconComponent, PinSlashIconComponent, PivotColumnIconComponent, PlayIconComponent, PlugIconComponent, PlusCircleIconComponent, PlusIconComponent, ProjectIconComponent, ProjectRoadmapIconComponent, ProjectSymlinkIconComponent, ProjectTemplateIconComponent, PulseIconComponent, QuestionIconComponent, QuoteIconComponent, ReadIconComponent, RedoIconComponent, RelFilePathIconComponent, ReplyIconComponent, RepoCloneIconComponent, RepoDeletedIconComponent, RepoForkedIconComponent, RepoIconComponent, RepoLockedIconComponent, RepoPullIconComponent, RepoPushIconComponent, RepoTemplateIconComponent, ReportIconComponent, RocketIconComponent, RowsIconComponent, RssIconComponent, RubyIconComponent, ScreenFullIconComponent, ScreenNormalIconComponent, SearchIconComponent, ServerIconComponent, ShareAndroidIconComponent, ShareIconComponent, ShieldCheckIconComponent, ShieldIconComponent, ShieldLockIconComponent, ShieldSlashIconComponent, ShieldXIconComponent, SidebarCollapseIconComponent, SidebarExpandIconComponent, SignInIconComponent, SignOutIconComponent, SingleSelectIconComponent, SkipFillIconComponent, SkipIconComponent, SlidersIconComponent, SmileyIconComponent, SortAscIconComponent, SortDescIconComponent, SparkleFillIconComponent, SponsorTiersIconComponent, SquareFillIconComponent, SquareIconComponent, SquirrelIconComponent, StackIconComponent, StarFillIconComponent, StarIconComponent, StopIconComponent, StopwatchIconComponent, StrikethroughIconComponent, SunIconComponent, SyncIconComponent, TabExternalIconComponent, TabIconComponent, TableIconComponent, TagIconComponent, TasklistIconComponent, TelescopeFillIconComponent, TelescopeIconComponent, TerminalIconComponent, ThreeBarsIconComponent, ThumbsdownIconComponent, ThumbsupIconComponent, ToolsIconComponent, TrackedByClosedCompletedIconComponent, TrackedByClosedNotPlannedIconComponent, TrashIconComponent, TriangleDownIconComponent, TriangleLeftIconComponent, TriangleRightIconComponent, TriangleUpIconComponent, TrophyIconComponent, TypographyIconComponent, UndoIconComponent, UnfoldIconComponent, UnlinkIconComponent, UnlockIconComponent, UnmuteIconComponent, UnreadIconComponent, UnverifiedIconComponent, UploadIconComponent, VerifiedIconComponent, VersionsIconComponent, VideoIconComponent, WebhookIconComponent, WorkflowIconComponent, XCircleFillIconComponent, XCircleIconComponent, XIconComponent, ZapIconComponent, ZoomInIconComponent, ZoomOutIconComponent, accessibilityIconData, accessibilityInsetIconData, alertFillIconData, alertIconData, appsIconData, archiveIconData, arrowBothIconData, arrowDownIconData, arrowDownLeftIconData, arrowDownRightIconData, arrowLeftIconData, arrowRightIconData, arrowSwitchIconData, arrowUpIconData, arrowUpLeftIconData, arrowUpRightIconData, beakerIconData, bellFillIconData, bellIconData, bellSlashIconData, blockedIconData, boldIconData, bookIconData, bookmarkFillIconData, bookmarkIconData, bookmarkSlashFillIconData, bookmarkSlashIconData, briefcaseIconData, broadcastIconData, browserIconData, bugIconData, cacheIconData, calendarIconData, checkCircleFillIconData, checkCircleIconData, checkIconData, checkboxIconData, checklistIconData, chevronDownIconData, chevronLeftIconData, chevronRightIconData, chevronUpIconData, circleIconData, circleSlashIconData, clockFillIconData, clockIconData, closestNaturalHeight, cloudIconData, cloudOfflineIconData, codeIconData, codeOfConductIconData, codeReviewIconData, codeSquareIconData, codescanCheckmarkIconData, codescanIconData, codespacesIconData, columnsIconData, commandPaletteIconData, commentDiscussionIconData, commentIconData, commitIconData, containerIconData, copilotErrorIconData, copilotIconData, copilotWarningIconData, copyIconData, cpuIconData, creditCardIconData, crossReferenceIconData, dashIconData, databaseIconData, dependabotIconData, desktopDownloadIconData, deviceCameraIconData, deviceCameraVideoIconData, deviceDesktopIconData, deviceMobileIconData, devicesIconData, diamondIconData, diffAddedIconData, diffIconData, diffIgnoredIconData, diffModifiedIconData, diffRemovedIconData, diffRenamedIconData, discussionClosedIconData, discussionDuplicateIconData, discussionOutdatedIconData, dotFillIconData, dotIconData, downloadIconData, duplicateIconData, ellipsisIconData, eyeClosedIconData, eyeIconData, feedDiscussionIconData, feedForkedIconData, feedHeartIconData, feedIssueClosedIconData, feedIssueDraftIconData, feedIssueOpenIconData, feedIssueReopenIconData, feedMergedIconData, feedPersonIconData, feedPlusIconData, feedPublicIconData, feedPullRequestClosedIconData, feedPullRequestDraftIconData, feedPullRequestOpenIconData, feedRepoIconData, feedRocketIconData, feedStarIconData, feedTagIconData, feedTrophyIconData, fileAddedIconData, fileBadgeIconData, fileBinaryIconData, fileCodeIconData, fileDiffIconData, fileDirectoryFillIconData, fileDirectoryIconData, fileDirectoryOpenFillIconData, fileDirectorySymlinkIconData, fileIconData, fileMediaIconData, fileMovedIconData, fileRemovedIconData, fileSubmoduleIconData, fileSymlinkFileIconData, fileZipIconData, filterIconData, filterRemoveIconData, fiscalHostIconData, flameIconData, foldDownIconData, foldIconData, foldUpIconData, gearIconData, giftIconData, gitBranchIconData, gitCommitIconData, gitCompareIconData, gitMergeIconData, gitMergeQueueIconData, gitPullRequestClosedIconData, gitPullRequestDraftIconData, gitPullRequestIconData, globeIconData, goalIconData, grabberIconData, graphIconData, hashIconData, headingIconData, heartFillIconData, heartIconData, historyIconData, homeFillIconData, homeIconData, horizontalRuleIconData, hourglassIconData, hubotIconData, idBadgeIconData, imageIconData, inboxIconData, infinityIconData, infoIconData, issueClosedIconData, issueDraftIconData, issueOpenedIconData, issueReopenedIconData, issueTrackedByIconData, issueTracksIconData, italicIconData, iterationsIconData, kebabHorizontalIconData, keyAsteriskIconData, keyIconData, lawIconData, lightBulbIconData, linkExternalIconData, linkIconData, listOrderedIconData, listUnorderedIconData, locationIconData, lockIconData, logIconData, logoGistIconData, logoGithubIconData, mailIconData, markGithubIconData, markdownIconData, megaphoneIconData, mentionIconData, meterIconData, milestoneIconData, mirrorIconData, moonIconData, mortarBoardIconData, moveToBottomIconData, moveToEndIconData, moveToStartIconData, moveToTopIconData, multiSelectIconData, muteIconData, noEntryFillIconData, noEntryIconData, northStarIconData, noteIconData, numberIconData, opArrowInIconData, opAttachmentaddIconData, opBacklogsIconData, opBaselineIconData, opBcfIconData, opBoardsIconData, opBookEditIconData, opBudgetIconData, opCalendarAlertIconData, opCartIconData, opColumnsLeftIconData, opColumnsRightIconData, opCopyToProjectIconData, opCostReportsIconData, opCursorRectangleSelectIconData, opCursorSelectIconData, opCustomFieldsIconData, opEnterpriseAddonsIconData, opEraseIconData, opFileAtomIconData, opFileBcfIconData, opFileCheckIconData, opFileCommentIconData, opFileCsvIconData, opFileDocIconData, opFileDownloadIconData, opFileEditIconData, opFileFormIconData, opFilePresentationIconData, opFileSheetIconData, opFileTextIconData, opFileXlsDescriptionsIconData, opGlossarIconData, opGridMenuIconData, opGroupIconData, opHierarchyIconData, opIfcIconData, opInboxInIconData, opIndentIconData, opInputDisabledIconData, opInstallationServicesIconData, opKebabVerticalIconData, opLinkAddIconData, opListSelectAllIconData, opLogoGitlabIconData, opLogoGooglePlusIconData, opLogoNextcloudIconData, opLogoOpenprojectIconData, opLogoSlackIconData, opMailSentIconData, opMarkNextcloudIconData, opMentionCommentIconData, opMoveIconData, opNoHierarchyIconData, opOutdentIconData, opPdfDescriptionIconData, opPdfIconData, opPersonAccountableIconData, opPersonAssignedIconData, opPersonMissingIconData, opPersonRemoveIconData, opPhoneIconData, opPrinterIconData, opReadAllIconData, opRelationFollowsIconData, opRelationNewChildIconData, opRelationsIconData, opReloadIconData, opResizerBottomRightIconData, opResizerVerticalLinesIconData, opSaveIconData, opScissorsIconData, opServerKeyIconData, opShortcutsIconData, opSortByIconData, opStopwatchStartIconData, opStopwatchStopIconData, opTeamPlannerIconData, opTriangleDeltaIconData, opViewCardsIconData, opViewFullscreenIconData, opViewListIconData, opViewModalIconData, opViewSplitIconData, opViewSplitModalIconData, opViewTimelineIconData, opWorkPackagesIconData, opXlsIconData, opXlsRelationsIconData, organizationIconData, packageDependenciesIconData, packageDependentsIconData, packageIconData, paintbrushIconData, paperAirplaneIconData, paperclipIconData, passkeyFillIconData, pasteIconData, pencilIconData, peopleIconData, personAddIconData, personFillIconData, personIconData, pinIconData, pinSlashIconData, pivotColumnIconData, playIconData, plugIconData, plusCircleIconData, plusIconData, projectIconData, projectRoadmapIconData, projectSymlinkIconData, projectTemplateIconData, pulseIconData, questionIconData, quoteIconData, readIconData, redoIconData, relFilePathIconData, replyIconData, repoCloneIconData, repoDeletedIconData, repoForkedIconData, repoIconData, repoLockedIconData, repoPullIconData, repoPushIconData, repoTemplateIconData, reportIconData, rocketIconData, rowsIconData, rssIconData, rubyIconData, screenFullIconData, screenNormalIconData, searchIconData, serverIconData, shareAndroidIconData, shareIconData, shieldCheckIconData, shieldIconData, shieldLockIconData, shieldSlashIconData, shieldXIconData, sidebarCollapseIconData, sidebarExpandIconData, signInIconData, signOutIconData, singleSelectIconData, sizeMap, skipFillIconData, skipIconData, slidersIconData, smileyIconData, sortAscIconData, sortDescIconData, sparkleFillIconData, sponsorTiersIconData, squareFillIconData, squareIconData, squirrelIconData, stackIconData, starFillIconData, starIconData, stopIconData, stopwatchIconData, strikethroughIconData, sunIconData, syncIconData, tabExternalIconData, tabIconData, tableIconData, tagIconData, tasklistIconData, telescopeFillIconData, telescopeIconData, terminalIconData, threeBarsIconData, thumbsdownIconData, thumbsupIconData, toDOMString, toolsIconData, trackedByClosedCompletedIconData, trackedByClosedNotPlannedIconData, trashIconData, triangleDownIconData, triangleLeftIconData, triangleRightIconData, triangleUpIconData, trophyIconData, typographyIconData, undoIconData, unfoldIconData, unlinkIconData, unlockIconData, unmuteIconData, unreadIconData, unverifiedIconData, uploadIconData, verifiedIconData, versionsIconData, videoIconData, webhookIconData, workflowIconData, xCircleFillIconData, xCircleIconData, xIconData, zapIconData, zoomInIconData, zoomOutIconData };
